export type Maybe<T> = T;
export type InputMaybe<T> = T;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: unknown; output: unknown; }
  Email: { input: unknown; output: unknown; }
  JSON: { input: unknown; output: unknown; }
  Time: { input: unknown; output: unknown; }
  Upload: { input: unknown; output: unknown; }
};

export type ActiveQuestionnaire = {
  __typename?: 'ActiveQuestionnaire';
  answers?: Maybe<Array<Maybe<ActiveQuestionnaireAnswer>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ActiveQuestionnaireAnswer = {
  __typename?: 'ActiveQuestionnaireAnswer';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ActiveQuestionnaireAnswerForm = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveQuestionnaireForm = {
  answers?: InputMaybe<Array<InputMaybe<ActiveQuestionnaireAnswerForm>>>;
};

export type ActiveQuestionnaireMutations = {
  __typename?: 'ActiveQuestionnaireMutations';
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type ActiveQuestionnaireMutationsUpdateArgs = {
  form?: InputMaybe<ActiveQuestionnaireForm>;
};

export type ActiveQuestionnaireQueries = {
  __typename?: 'ActiveQuestionnaireQueries';
  find?: Maybe<ActiveQuestionnaire>;
};

export type AddProductAnalyticForm = {
  action: PurchaseProductAnalyticAction;
  productId: Scalars['String']['input'];
  source: PurchaseProductAnalyticSource;
};

export type AddPurchaseProductCategoryForm = {
  categoryId?: InputMaybe<Array<Scalars['Int']['input']>>;
  typeId: Scalars['String']['input'];
};

export type AddPurchaseProductForm = {
  bgImage?: InputMaybe<Scalars['Upload']['input']>;
  bundling?: InputMaybe<Array<InputMaybe<PurchaseProductBundlingFormEdit>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<PurchaseProductDiscountForm>;
  imageApp?: InputMaybe<Scalars['Upload']['input']>;
  imageWeb?: InputMaybe<Scalars['Upload']['input']>;
  images?: InputMaybe<Array<InputMaybe<PurchaseProductImageFormAdd>>>;
  internationalDiscount?: InputMaybe<PurchaseProductDiscountForm>;
  internationalPrice?: InputMaybe<Scalars['Int']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeHomeService?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsell?: Scalars['Boolean']['input'];
  keyword?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantType?: InputMaybe<MerchantType>;
  order?: InputMaybe<Scalars['Int']['input']>;
  periodFrom?: InputMaybe<Scalars['Date']['input']>;
  periodTo?: InputMaybe<Scalars['Date']['input']>;
  preOrderExpiredAt?: InputMaybe<Scalars['Date']['input']>;
  preOrderFullfillmentDate?: InputMaybe<Scalars['String']['input']>;
  preOrderFullfillmentDuration?: InputMaybe<Scalars['Int']['input']>;
  preOrderFullfillmentInterval?: InputMaybe<PurchaseProductpreOrderFullfillmentInterval>;
  preOrderType?: InputMaybe<PurchaseProductPreorderType>;
  price: Scalars['Int']['input'];
  productGroupId?: InputMaybe<Scalars['String']['input']>;
  purchaseType: PurchaseProductPurchaseType;
  reportTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requirement?: InputMaybe<PurchaseProductRequirementForm>;
  serviceMethods: Array<InputMaybe<PurchaseProductServiceMethod>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  showOnInternationalShop?: InputMaybe<Scalars['Boolean']['input']>;
  showOnShop?: InputMaybe<Scalars['Boolean']['input']>;
  subscription?: InputMaybe<SubscriptionForm>;
  title: Scalars['String']['input'];
  totalDiscount?: InputMaybe<Scalars['Float']['input']>;
  totalInternationalDiscount?: InputMaybe<Scalars['Float']['input']>;
  totalInternationalPrice?: InputMaybe<Scalars['Int']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unlockProductId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unlockRequirementPrice?: InputMaybe<Array<InputMaybe<AddPurchaseProductUnlockForm>>>;
  upsell?: InputMaybe<PurchaseProductUpsellFormEdit>;
  upsellEligiblePurchaseTypes?: InputMaybe<Array<InputMaybe<PurchaseProductPurchaseType>>>;
  upsellProductId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type AddPurchaseProductGroupForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AddPurchaseProductKitReportForm = {
  id?: InputMaybe<Scalars['String']['input']>;
  productKitId?: InputMaybe<Scalars['String']['input']>;
  reportAccessType?: InputMaybe<UserReportAccessType>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AddPurchaseProductReportForm = {
  categoryId: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  price: Scalars['Int']['input'];
  status: PurchaseProductReportStatus;
  traitsId?: InputMaybe<Array<Scalars['Int']['input']>>;
  typeId: Scalars['String']['input'];
};

export type AddPurchaseProductUnlockForm = {
  chipType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AdminMutations = {
  __typename?: 'AdminMutations';
  User?: Maybe<AdminUserMutations>;
};

export type AdminQueries = {
  __typename?: 'AdminQueries';
  User?: Maybe<AdminUserQueries>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  access?: Maybe<Array<Maybe<AdminUserAccess>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<AdminUserRole>;
  status?: Maybe<AdminUserStatus>;
  type?: Maybe<AdminUserType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AdminUserAccess = {
  __typename?: 'AdminUserAccess';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role?: Maybe<AdminUserAccessRole>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AdminUserAccessForm = {
  modules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<AdminUserAccessRole>;
};

export enum AdminUserAccessRole {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type AdminUserForm = {
  access?: InputMaybe<Array<InputMaybe<AdminUserAccessForm>>>;
  password?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AdminUserRole>;
  status?: InputMaybe<AdminUserStatus>;
  type?: InputMaybe<AdminUserType>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserMutations = {
  __typename?: 'AdminUserMutations';
  add?: Maybe<AdminUser>;
  edit?: Maybe<AdminUser>;
};


export type AdminUserMutationsAddArgs = {
  form?: InputMaybe<AdminUserForm>;
};


export type AdminUserMutationsEditArgs = {
  form?: InputMaybe<AdminUserForm>;
  id: Scalars['String']['input'];
};

export type AdminUserQueries = {
  __typename?: 'AdminUserQueries';
  findAll?: Maybe<AdminUserQueryResult>;
  findOne?: Maybe<AdminUser>;
  profile?: Maybe<AdminUser>;
};


export type AdminUserQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminUserQuerySortBy>;
  where?: InputMaybe<AdminUserQueryFilter>;
};


export type AdminUserQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type AdminUserQueryFilter = {
  roles?: InputMaybe<Array<InputMaybe<AdminUserRole>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserQueryResult = {
  __typename?: 'AdminUserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<AdminUser>>>;
};

export type AdminUserQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  username?: InputMaybe<SortDirection>;
};

export enum AdminUserRole {
  Editor = 'EDITOR',
  EditorViewer = 'EDITOR_VIEWER',
  Master = 'MASTER',
  Viewer = 'VIEWER'
}

export enum AdminUserStatus {
  Active = 'ACTIVE',
  NotActive = 'NOT_ACTIVE'
}

export enum AdminUserType {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  User = 'USER'
}

export type AgeRange = {
  __typename?: 'AgeRange';
  max?: Maybe<Scalars['Int']['output']>;
  min: Scalars['Int']['output'];
};

export type AlcoholHabits = {
  __typename?: 'AlcoholHabits';
  alcoholStatus?: Maybe<Scalars['String']['output']>;
  amountOfAlcohol?: Maybe<Scalars['String']['output']>;
  startConsumeAlcohol?: Maybe<Scalars['String']['output']>;
  typeOfAlcohol?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AlcoholHabitsForm = {
  alcoholStatus?: InputMaybe<Scalars['String']['input']>;
  amountOfAlcohol?: InputMaybe<Scalars['String']['input']>;
  startConsumeAlcohol?: InputMaybe<Scalars['String']['input']>;
  typeOfAlcohol?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AntarAjaOrderResult = {
  __typename?: 'AntarAjaOrderResult';
  expectFinish?: Maybe<Scalars['String']['output']>;
  expectStart?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  waybillNumber?: Maybe<Scalars['String']['output']>;
};

export type AntarAjaPickupResult = {
  __typename?: 'AntarAjaPickupResult';
  expectFinish?: Maybe<Scalars['String']['output']>;
  expectStart?: Maybe<Scalars['String']['output']>;
  waybillNumber?: Maybe<Scalars['String']['output']>;
};

export enum AnterAjaDeliveryType {
  Order = 'ORDER',
  Pickup = 'PICKUP'
}

export type AnterAjaMutation = {
  __typename?: 'AnterAjaMutation';
  requestOrder?: Maybe<AntarAjaOrderResult>;
  requestPickup?: Maybe<AntarAjaPickupResult>;
};


export type AnterAjaMutationRequestOrderArgs = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  shipmentCode?: InputMaybe<Scalars['String']['input']>;
};


export type AnterAjaMutationRequestPickupArgs = {
  productKitId?: InputMaybe<Scalars['String']['input']>;
  shipmentCode?: InputMaybe<Scalars['String']['input']>;
};

export type AnterAjaQueries = {
  __typename?: 'AnterAjaQueries';
  anterAjaCode?: Maybe<Scalars['String']['output']>;
  serviceRates?: Maybe<ServiceRateResult>;
  tracking?: Maybe<TrackingResult>;
};


export type AnterAjaQueriesAnterAjaCodeArgs = {
  postalCode?: InputMaybe<Scalars['String']['input']>;
};


export type AnterAjaQueriesServiceRatesArgs = {
  deliveryType: AnterAjaDeliveryType;
  destination?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};


export type AnterAjaQueriesTrackingArgs = {
  waybillNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AnterAjaServicesRate = {
  __typename?: 'AnterAjaServicesRate';
  etd?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  rates?: Maybe<Scalars['Int']['output']>;
};

export type AnterAjaTracking = {
  __typename?: 'AnterAjaTracking';
  hubName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['Int']['output']>;
};

export type AppSubscription = {
  __typename?: 'AppSubscription';
  abbreviation?: Maybe<Scalars['String']['output']>;
  chatQuota?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyPrice?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  extensions?: Maybe<Array<Maybe<SubscriptionExtension>>>;
  hasReportAccess?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internationalPrice?: Maybe<Scalars['Int']['output']>;
  isEligibleToManualSubscription?: Maybe<Scalars['Boolean']['output']>;
  isEligibleToUpgrade?: Maybe<Scalars['Boolean']['output']>;
  isGrantable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Scalars['String']['output']>;
  planIncludes?: Maybe<Scalars['String']['output']>;
  planIncludesV2?: Maybe<Array<Maybe<PlanIncludeItem>>>;
  position?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  reportAccess?: Maybe<Array<Maybe<SubscriptionReportAccess>>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showOnInternationalShop?: Maybe<Scalars['Boolean']['output']>;
  showOnShop?: Maybe<Scalars['Boolean']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalDailyPrice?: Maybe<Scalars['Int']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  totalInternationalDiscount?: Maybe<Scalars['Float']['output']>;
  totalInternationalPrice?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<SubscriptionType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  upgrades?: Maybe<Array<Maybe<SubscriptionUpgradeEligibility>>>;
};

export type Banner = {
  __typename?: 'Banner';
  actionLink?: Maybe<Scalars['String']['output']>;
  actionTargetId?: Maybe<Scalars['String']['output']>;
  actionTargetType?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<BannerActionType>;
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  desktopImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mobileImage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tabletImage?: Maybe<Scalars['String']['output']>;
};

export enum BannerActionType {
  RedirectToPage = 'REDIRECT_TO_PAGE',
  RedirectToUrl = 'REDIRECT_TO_URL'
}

export type BannerForm = {
  actionLink?: InputMaybe<Scalars['String']['input']>;
  actionTargetId?: InputMaybe<Scalars['String']['input']>;
  actionTargetType?: InputMaybe<Scalars['String']['input']>;
  actionType?: InputMaybe<BannerActionType>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  desktopImage: Scalars['Upload']['input'];
  mobileImage: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  tabletImage: Scalars['Upload']['input'];
};

export type BannerFormEdit = {
  actionLink?: InputMaybe<Scalars['String']['input']>;
  actionTargetId?: InputMaybe<Scalars['String']['input']>;
  actionTargetType?: InputMaybe<Scalars['String']['input']>;
  actionType?: InputMaybe<BannerActionType>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  desktopImage?: InputMaybe<Scalars['Upload']['input']>;
  mobileImage?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tabletImage?: InputMaybe<Scalars['Upload']['input']>;
};

export type BannerFormEditOrder = {
  id: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type BannerMutations = {
  __typename?: 'BannerMutations';
  add?: Maybe<Banner>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Banner>;
  editOrder?: Maybe<Scalars['Boolean']['output']>;
};


export type BannerMutationsAddArgs = {
  form?: InputMaybe<BannerForm>;
};


export type BannerMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type BannerMutationsEditArgs = {
  form?: InputMaybe<BannerFormEdit>;
  id: Scalars['Int']['input'];
};


export type BannerMutationsEditOrderArgs = {
  forms?: InputMaybe<Array<InputMaybe<BannerFormEditOrder>>>;
};

export type BannerQueries = {
  __typename?: 'BannerQueries';
  findAll?: Maybe<BannerResult>;
  findOne?: Maybe<Banner>;
  maxOrder?: Maybe<Scalars['Int']['output']>;
  minOrder?: Maybe<Scalars['Int']['output']>;
};


export type BannerQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BannerQuerySortBy>;
  where?: InputMaybe<BannerQueryFilter>;
};


export type BannerQueriesFindOneArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerQueryFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerQuerySortBy = {
  active?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type BannerResult = {
  __typename?: 'BannerResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Banner>>>;
};

export type BioinformaticCategory = {
  __typename?: 'BioinformaticCategory';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  panel?: Maybe<BioinformaticPanel>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticCategoryQueries = {
  __typename?: 'BioinformaticCategoryQueries';
  findAll?: Maybe<BioinformaticCategoryQueryResult>;
  findOne?: Maybe<BioinformaticCategory>;
};


export type BioinformaticCategoryQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type BioinformaticCategoryQueryResult = {
  __typename?: 'BioinformaticCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticCategory>>>;
};

export type BioinformaticGene = {
  __typename?: 'BioinformaticGene';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticGeneQueries = {
  __typename?: 'BioinformaticGeneQueries';
  findAll?: Maybe<BioinformaticGeneQueryResult>;
  findOne?: Maybe<BioinformaticGene>;
};


export type BioinformaticGeneQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type BioinformaticGeneQueryResult = {
  __typename?: 'BioinformaticGeneQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticGene>>>;
};

export type BioinformaticMapper = {
  __typename?: 'BioinformaticMapper';
  bioinformaticPanel?: Maybe<Scalars['String']['output']>;
  bioinformaticTrait?: Maybe<Scalars['String']['output']>;
  dnaCategory?: Maybe<Scalars['String']['output']>;
  dnaPanel?: Maybe<Scalars['String']['output']>;
  dnaScoreType?: Maybe<Scalars['String']['output']>;
  dnaSubCategory?: Maybe<Scalars['String']['output']>;
  dnaTrait?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  reversedScore?: Maybe<Scalars['Boolean']['output']>;
  sex?: Maybe<ReportMapperSex>;
  sourceVendorBioIt?: Maybe<VendorBioIt>;
  sourceVendorBioItId?: Maybe<Scalars['String']['output']>;
  vendorBioIt?: Maybe<VendorBioIt>;
  vendorBioItId?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticMapperImportNutriGeneticResult = {
  __typename?: 'BioinformaticMapperImportNutriGeneticResult';
  errorExcelColumnKey?: Maybe<Scalars['String']['output']>;
  errorExcelRow?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BioinformaticMapperMutations = {
  __typename?: 'BioinformaticMapperMutations';
  export?: Maybe<Scalars['String']['output']>;
  exportExcel360?: Maybe<Scalars['Boolean']['output']>;
  exportExcelNutrigenetic?: Maybe<Scalars['Boolean']['output']>;
  exportExcelOncorisk?: Maybe<Scalars['Boolean']['output']>;
  exportExcelSportgenomic?: Maybe<Scalars['Boolean']['output']>;
  import?: Maybe<Scalars['Boolean']['output']>;
  importGeneral?: Maybe<Scalars['Boolean']['output']>;
  importNutriGenetic?: Maybe<BioinformaticMapperImportNutriGeneticResult>;
  importSportgenomic?: Maybe<BioinformaticMapperImportNutriGeneticResult>;
  importThreeSixty?: Maybe<Scalars['Boolean']['output']>;
  init?: Maybe<Scalars['Boolean']['output']>;
};


export type BioinformaticMapperMutationsExportArgs = {
  where?: InputMaybe<BioinformaticMapperQueryFilter>;
};


export type BioinformaticMapperMutationsExportExcel360Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticMapperSortBy>;
  where?: InputMaybe<BioinformaticMapperQueryFilter>;
};


export type BioinformaticMapperMutationsExportExcelNutrigeneticArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticMapperSortBy>;
  where?: InputMaybe<BioinformaticMapperQueryFilter>;
};


export type BioinformaticMapperMutationsExportExcelOncoriskArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticMapperSortBy>;
  where?: InputMaybe<BioinformaticMapperQueryFilter>;
};


export type BioinformaticMapperMutationsExportExcelSportgenomicArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticMapperSortBy>;
  where?: InputMaybe<BioinformaticMapperQueryFilter>;
};


export type BioinformaticMapperMutationsImportArgs = {
  file: Scalars['Upload']['input'];
  ownedByAsaren?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  reportType: Scalars['String']['input'];
};


export type BioinformaticMapperMutationsImportGeneralArgs = {
  file: Scalars['Upload']['input'];
  reportType: Scalars['String']['input'];
  vendorBioItId?: InputMaybe<Scalars['String']['input']>;
};


export type BioinformaticMapperMutationsImportNutriGeneticArgs = {
  file: Scalars['Upload']['input'];
  ownedByAsaren?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};


export type BioinformaticMapperMutationsImportSportgenomicArgs = {
  file: Scalars['Upload']['input'];
  ownedByAsaren?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};


export type BioinformaticMapperMutationsImportThreeSixtyArgs = {
  file: Scalars['Upload']['input'];
  vendorBioItId?: InputMaybe<Scalars['String']['input']>;
};

export type BioinformaticMapperQueries = {
  __typename?: 'BioinformaticMapperQueries';
  findAll?: Maybe<BioinformaticMapperQueryResult>;
};


export type BioinformaticMapperQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticMapperSortBy>;
  where?: InputMaybe<BioinformaticMapperQueryFilter>;
};

export type BioinformaticMapperQueryFilter = {
  bioinformaticPanel?: InputMaybe<Scalars['String']['input']>;
  bioinformaticTrait?: InputMaybe<Scalars['String']['input']>;
  dnaCategory?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaPanel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaScoreType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaSubCategory?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaTrait?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  ownedByAsaren?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reversedScore?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  sex?: InputMaybe<Array<InputMaybe<ReportMapperSex>>>;
  sourceVendorBioItIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorBioItId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorBioItIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BioinformaticMapperQueryResult = {
  __typename?: 'BioinformaticMapperQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticMapper>>>;
};

export type BioinformaticMapperQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type BioinformaticMapperSortBy = {
  bioinformaticPanel?: InputMaybe<SortDirection>;
  bioinformaticTrait?: InputMaybe<SortDirection>;
  dnaCategory?: InputMaybe<SortDirection>;
  dnaPanel?: InputMaybe<SortDirection>;
  dnaScoreType?: InputMaybe<SortDirection>;
  dnaSubCategory?: InputMaybe<SortDirection>;
  dnaTrait?: InputMaybe<SortDirection>;
  sex?: InputMaybe<SortDirection>;
};

export type BioinformaticMutations = {
  __typename?: 'BioinformaticMutations';
  Mapper?: Maybe<BioinformaticMapperMutations>;
  init?: Maybe<Scalars['Boolean']['output']>;
  syncUsers?: Maybe<Scalars['Boolean']['output']>;
};

export type BioinformaticPanel = {
  __typename?: 'BioinformaticPanel';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticPanelQueries = {
  __typename?: 'BioinformaticPanelQueries';
  findAll?: Maybe<BioinformaticPanelQueryResult>;
  findOne?: Maybe<BioinformaticPanel>;
};


export type BioinformaticPanelQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BioinformaticPanelQueryFilter>;
};


export type BioinformaticPanelQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type BioinformaticPanelQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BioinformaticPanelQueryResult = {
  __typename?: 'BioinformaticPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticPanel>>>;
};

export type BioinformaticQueries = {
  __typename?: 'BioinformaticQueries';
  Category?: Maybe<BioinformaticCategoryQueries>;
  Gene?: Maybe<BioinformaticGeneQueries>;
  Mapper?: Maybe<BioinformaticMapperQueries>;
  Panel?: Maybe<BioinformaticPanelQueries>;
  Report?: Maybe<BioinformaticReportQueries>;
  Score?: Maybe<BioinformaticScoreQueries>;
  Trait?: Maybe<BioinformaticTraitQueries>;
  User?: Maybe<BioinformaticUserQueries>;
};

export type BioinformaticReport = {
  __typename?: 'BioinformaticReport';
  category?: Maybe<BioinformaticCategory>;
  customFilter?: Maybe<Array<Maybe<BioinformaticReportCustomFilter>>>;
  dnaCategory?: Maybe<DnaCategory>;
  dnaPanel?: Maybe<DnaPanel>;
  dnaScoreType?: Maybe<DnaScoreType>;
  dnaScoreTypeGuideline?: Maybe<DnaScoreTypeGuideline>;
  dnaSubCategory?: Maybe<DnaSubCategory>;
  dnaTrait?: Maybe<DnaTrait>;
  fetchNote?: Maybe<Scalars['String']['output']>;
  fetchStatus?: Maybe<Scalars['String']['output']>;
  genes?: Maybe<Array<Maybe<BioinformaticGene>>>;
  genotypes?: Maybe<Array<Maybe<BioinformaticReportGenoType>>>;
  id?: Maybe<Scalars['String']['output']>;
  isHigherBetter?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageCode>;
  mappedScore?: Maybe<Scalars['Int']['output']>;
  panel?: Maybe<BioinformaticPanel>;
  response?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Array<Maybe<BioinformaticReportResponse>>>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sourceVendorBioIt?: Maybe<VendorBioIt>;
  sourceVendorBioItId?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<BioinformaticTrait>;
  traitLogo?: Maybe<Scalars['String']['output']>;
  traitScore?: Maybe<BioinformaticScore>;
  user?: Maybe<BioinformaticUser>;
  vendorBioIt?: Maybe<VendorBioIt>;
  vendorBioItId?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticReportByCategory = {
  __typename?: 'BioinformaticReportByCategory';
  average?: Maybe<Scalars['Float']['output']>;
  dnaCategory?: Maybe<DnaCategory>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<BioinformaticReport>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticReportByCategoryFilter = {
  fetchStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  sourceVendorBioItId?: InputMaybe<Scalars['String']['input']>;
  vendorBioItId?: InputMaybe<Scalars['String']['input']>;
};

export type BioinformaticReportByCategoryQueryResult = {
  __typename?: 'BioinformaticReportByCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticReportByCategory>>>;
};

export type BioinformaticReportByCategorySortBy = {
  average?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type BioinformaticReportByPanel = {
  __typename?: 'BioinformaticReportByPanel';
  average?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<BioinformaticReport>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticReportByPanelFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
};

export type BioinformaticReportByPanelQueryResult = {
  __typename?: 'BioinformaticReportByPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticReportByPanel>>>;
};

export type BioinformaticReportByPanelSortBy = {
  average?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type BioinformaticReportCustomFilter = {
  __typename?: 'BioinformaticReportCustomFilter';
  label?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type BioinformaticReportFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaCategories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dnaPanels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaScoreTypeGuidelines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaSubCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fetchStatus?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  panels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profile?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sourceVendorBioItId?: InputMaybe<Scalars['String']['input']>;
  traits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorBioItId?: InputMaybe<Scalars['String']['input']>;
};

export type BioinformaticReportGenoType = {
  __typename?: 'BioinformaticReportGenoType';
  gene?: Maybe<BioinformaticGene>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BioinformaticReportQueries = {
  __typename?: 'BioinformaticReportQueries';
  countTraitByScore?: Maybe<CountTraitByScoreResult>;
  countTraitByScoreV2?: Maybe<CountTraitByScoreV2Result>;
  findAll?: Maybe<BioinformaticReportQueryResult>;
  findByCategory?: Maybe<BioinformaticReportByCategoryQueryResult>;
  findByPanel?: Maybe<BioinformaticReportByPanelQueryResult>;
  findOne?: Maybe<BioinformaticReport>;
};


export type BioinformaticReportQueriesCountTraitByScoreArgs = {
  reportType: Scalars['String']['input'];
};


export type BioinformaticReportQueriesCountTraitByScoreV2Args = {
  reportType: Scalars['String']['input'];
};


export type BioinformaticReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticReportQuerySortBy>;
  where?: InputMaybe<BioinformaticReportFilter>;
};


export type BioinformaticReportQueriesFindByCategoryArgs = {
  sort?: InputMaybe<BioinformaticReportByCategorySortBy>;
  where?: InputMaybe<BioinformaticReportByCategoryFilter>;
};


export type BioinformaticReportQueriesFindByPanelArgs = {
  sort?: InputMaybe<BioinformaticReportByPanelSortBy>;
  where?: InputMaybe<BioinformaticReportByPanelFilter>;
};


export type BioinformaticReportQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BioinformaticReportQueryResult = {
  __typename?: 'BioinformaticReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticReport>>>;
};

export type BioinformaticReportQuerySortBy = {
  favourable?: InputMaybe<SortDirection>;
  score?: InputMaybe<SortDirection>;
  subCategoryAndTrait?: InputMaybe<SortDirection>;
  traitName?: InputMaybe<SortDirection>;
};

export type BioinformaticReportResponse = {
  __typename?: 'BioinformaticReportResponse';
  language?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticScore = {
  __typename?: 'BioinformaticScore';
  donts?: Maybe<Scalars['String']['output']>;
  dos?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interpretation?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  shortInterpretation?: Maybe<Scalars['String']['output']>;
  symptoms?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
  trait?: Maybe<BioinformaticTrait>;
};

export type BioinformaticScoreQueries = {
  __typename?: 'BioinformaticScoreQueries';
  findAll?: Maybe<BioinformaticScoreQueryResult>;
  findOne?: Maybe<BioinformaticScore>;
};


export type BioinformaticScoreQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type BioinformaticScoreQueryResult = {
  __typename?: 'BioinformaticScoreQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticScore>>>;
};

export type BioinformaticTrait = {
  __typename?: 'BioinformaticTrait';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BioinformaticTraitQueries = {
  __typename?: 'BioinformaticTraitQueries';
  findAll?: Maybe<BioinformaticTraitQueryResult>;
  findOne?: Maybe<BioinformaticTrait>;
};


export type BioinformaticTraitQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BioinformaticTraitQueryFilter>;
};


export type BioinformaticTraitQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type BioinformaticTraitQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BioinformaticTraitQueryResult = {
  __typename?: 'BioinformaticTraitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticTrait>>>;
};

export type BioinformaticUser = {
  __typename?: 'BioinformaticUser';
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<BioinformaticReportQueryResult>;
};


export type BioinformaticUserReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BioinformaticReportFilter>;
};

export type BioinformaticUserFilter = {
  profiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BioinformaticUserQueries = {
  __typename?: 'BioinformaticUserQueries';
  findAll?: Maybe<BioinformaticUserQueryResult>;
  findOne?: Maybe<BioinformaticUser>;
};


export type BioinformaticUserQueriesFindAllArgs = {
  where?: InputMaybe<BioinformaticUserFilter>;
};

export type BioinformaticUserQueryResult = {
  __typename?: 'BioinformaticUserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticUser>>>;
};

export type BooleanWithMessage = {
  __typename?: 'BooleanWithMessage';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CancerRiskAssessment = {
  __typename?: 'CancerRiskAssessment';
  analysisStatus: GeneAnalysisStatus;
  associatedGenes: Array<Scalars['String']['output']>;
  cancerType: CancerType;
  confidenceInterval: ConfidenceInterval;
  evidenceLevel: Scalars['String']['output'];
  lifetimeRisk: Scalars['Float']['output'];
  recommendations: Array<Scalars['String']['output']>;
  relativeRisk: Scalars['Float']['output'];
  riskLevel: OncoRiskLevel;
  riskScore: Scalars['Int']['output'];
  variants: Array<GeneticVariant>;
};

export enum CancerType {
  Bladder = 'BLADDER',
  Breast = 'BREAST',
  Colorectal = 'COLORECTAL',
  Gastric = 'GASTRIC',
  Kidney = 'KIDNEY',
  Liver = 'LIVER',
  Lung = 'LUNG',
  Melanoma = 'MELANOMA',
  Ovarian = 'OVARIAN',
  Pancreatic = 'PANCREATIC',
  Prostate = 'PROSTATE',
  Thyroid = 'THYROID'
}

export type Card = {
  __typename?: 'Card';
  dInteractome?: Maybe<DnaInteractome>;
  dTrait?: Maybe<DnaTrait>;
  dnaInteractomeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CareerJobForm = {
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CareerMutations = {
  __typename?: 'CareerMutations';
  submit?: Maybe<Scalars['Boolean']['output']>;
};


export type CareerMutationsSubmitArgs = {
  form: SubmitCareerForm;
};

export type ChannelQueries = {
  __typename?: 'ChannelQueries';
  ChannelUser?: Maybe<ChannelUserQueries>;
};

export type ChannelUserChatQueries = {
  __typename?: 'ChannelUserChatQueries';
  findDefaultDailyOutlookConfig?: Maybe<Config>;
  findDefaultHealthScoreAgeLogConfig?: Maybe<Config>;
  findDefaultNetCaloriesConfig?: Maybe<Config>;
  findDefaultNourishPlusAndMealPlanConfig?: Maybe<Config>;
  findDefaultTrainingPlanInsightConfig?: Maybe<Config>;
};


export type ChannelUserChatQueriesFindDefaultTrainingPlanInsightConfigArgs = {
  date: Scalars['String']['input'];
};

export type ChannelUserQueries = {
  __typename?: 'ChannelUserQueries';
  ChannelUserChat?: Maybe<ChannelUserChatQueries>;
};

export type CheckAvailabilityUnlockProductQuery = {
  specific?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckAvailabilityUnlockProductQueryResult = {
  __typename?: 'CheckAvailabilityUnlockProductQueryResult';
  ANCESTRY?: Maybe<Scalars['ID']['output']>;
  DNA_360?: Maybe<Scalars['ID']['output']>;
  DNA_PREMIUM?: Maybe<Scalars['ID']['output']>;
  HORMONE?: Maybe<Scalars['ID']['output']>;
  NUTRIGENETIC?: Maybe<Scalars['ID']['output']>;
  ONCORISK?: Maybe<Scalars['ID']['output']>;
  PRODIGY?: Maybe<Scalars['ID']['output']>;
  SKIN?: Maybe<Scalars['ID']['output']>;
  SPORTGENOMIC?: Maybe<Scalars['ID']['output']>;
};

export type CheckAvailableKitResult = {
  __typename?: 'CheckAvailableKitResult';
  available?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum CheckEmailAvailabilityCode {
  Unused = 'UNUSED',
  Used = 'USED'
}

export type CheckEmailAvailabilityQueryFilter = {
  email: Scalars['String']['input'];
  forPartnerRole: Scalars['String']['input'];
  forPartnerUserType?: InputMaybe<PartnerUserType>;
};

export type CheckEmailAvailabilityResult = {
  __typename?: 'CheckEmailAvailabilityResult';
  code?: Maybe<CheckEmailAvailabilityCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ClinicalData = {
  __typename?: 'ClinicalData';
  clinicalDataResult?: Maybe<Array<Maybe<ClinicalDataResult>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ClinicalDataForm = {
  clinicalDataResult?: InputMaybe<Array<InputMaybe<ClinicalDataResultForm>>>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalDataMutations = {
  __typename?: 'ClinicalDataMutations';
  createOrUpdate?: Maybe<ClinicalData>;
};


export type ClinicalDataMutationsCreateOrUpdateArgs = {
  form?: InputMaybe<ClinicalDataForm>;
};

export type ClinicalDataQueries = {
  __typename?: 'ClinicalDataQueries';
  findAll?: Maybe<ClinicalDataQueryResult>;
};


export type ClinicalDataQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ClinicalDataQuerySortBy>;
  where?: InputMaybe<ClinicalDataQueryFilter>;
};

export type ClinicalDataQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClinicalDataQueryResult = {
  __typename?: 'ClinicalDataQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ClinicalData>>>;
};

export type ClinicalDataQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  profileId?: InputMaybe<SortDirection>;
};

export type ClinicalDataResult = {
  __typename?: 'ClinicalDataResult';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  referenceValue?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userClinicalDataId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ClinicalDataResultForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceValue?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalDataResultMutations = {
  __typename?: 'ClinicalDataResultMutations';
  createOrUpdate?: Maybe<ClinicalDataResult>;
};


export type ClinicalDataResultMutationsCreateOrUpdateArgs = {
  form?: InputMaybe<ClinicalDataResultForm>;
};

export type ClinicalDataResultQueries = {
  __typename?: 'ClinicalDataResultQueries';
  findAll?: Maybe<ClinicalDataResultQueryResult>;
};


export type ClinicalDataResultQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ClinicalDataResultQuerySortBy>;
  where?: InputMaybe<ClinicalDataResultQueryFilter>;
};

export type ClinicalDataResultQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userClinicalDataId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClinicalDataResultQueryResult = {
  __typename?: 'ClinicalDataResultQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ClinicalDataResult>>>;
};

export type ClinicalDataResultQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type ComplicationTrait = {
  __typename?: 'ComplicationTrait';
  bReport?: Maybe<BioinformaticReport>;
  bioinformaticReportId?: Maybe<Scalars['String']['output']>;
  dInteractome?: Maybe<DnaInteractome>;
  dTrait?: Maybe<DnaTrait>;
  dnaInteractomeId?: Maybe<Scalars['String']['output']>;
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type ConfidenceInterval = {
  __typename?: 'ConfidenceInterval';
  lower: Scalars['Float']['output'];
  upper: Scalars['Float']['output'];
};

export type Config = {
  __typename?: 'Config';
  channelId?: Maybe<Scalars['String']['output']>;
  codeForGenerate?: Maybe<Scalars['String']['output']>;
  codeForRegenerate?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
};

export type Consent = {
  __typename?: 'Consent';
  activationId?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<ConsentAttachment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  guardian?: Maybe<ConsentGuardian>;
  guardianId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ConsentAttachment = {
  __typename?: 'ConsentAttachment';
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ConsentForm = {
  activationId?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  guardianId?: InputMaybe<Scalars['String']['input']>;
};

export type ConsentGuardian = {
  __typename?: 'ConsentGuardian';
  birthday?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  guardianProfileId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identityNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  relationship?: Maybe<Relationship>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ConsentGuardianForm = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  guardianProfileId?: InputMaybe<Scalars['String']['input']>;
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Relationship>;
};

export type ConsentGuardianMutations = {
  __typename?: 'ConsentGuardianMutations';
  add?: Maybe<ConsentGuardian>;
  edit?: Maybe<ConsentGuardian>;
};


export type ConsentGuardianMutationsAddArgs = {
  form?: InputMaybe<ConsentGuardianForm>;
};


export type ConsentGuardianMutationsEditArgs = {
  form?: InputMaybe<ConsentGuardianForm>;
  id: Scalars['String']['input'];
};

export type ConsentGuardianQueries = {
  __typename?: 'ConsentGuardianQueries';
  findAll?: Maybe<ConsentGuardianQueryResult>;
  findOne?: Maybe<ConsentGuardian>;
};


export type ConsentGuardianQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConsentGuardianQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type ConsentGuardianQueryResult = {
  __typename?: 'ConsentGuardianQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ConsentGuardian>>>;
};

export type ConsentMutations = {
  __typename?: 'ConsentMutations';
  Guardian?: Maybe<ConsentGuardianMutations>;
};

export type ConsentQueries = {
  __typename?: 'ConsentQueries';
  Guardian?: Maybe<ConsentGuardianQueries>;
  findAll?: Maybe<ConsentQueryResult>;
  findOne?: Maybe<Consent>;
  findOneByActivation?: Maybe<Consent>;
};


export type ConsentQueriesFindAllArgs = {
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type ConsentQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type ConsentQueriesFindOneByActivationArgs = {
  id: Scalars['ID']['input'];
};

export type ConsentQueryResult = {
  __typename?: 'ConsentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Consent>>>;
};

export type ConsultationIncome = {
  __typename?: 'ConsultationIncome';
  company?: Maybe<Scalars['Int']['output']>;
  counselor?: Maybe<Scalars['Int']['output']>;
};

export type ConsultationIncomeForm = {
  company?: InputMaybe<Scalars['Int']['input']>;
  counselor?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentManagementImportForm = {
  file: Scalars['Upload']['input'];
};

export type ContentManagementImportResult = {
  __typename?: 'ContentManagementImportResult';
  errors?: Maybe<Array<Maybe<ContentManagementImportResultError>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ContentManagementImportResultError = {
  __typename?: 'ContentManagementImportResultError';
  key?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ContentManagementMutations = {
  __typename?: 'ContentManagementMutations';
  export?: Maybe<Scalars['Boolean']['output']>;
  import?: Maybe<ContentManagementImportResult>;
  update?: Maybe<Trait>;
};


export type ContentManagementMutationsExportArgs = {
  include?: InputMaybe<ContentManagementRelationship>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TraitSortBy>;
  where?: InputMaybe<TraitQueryFilter>;
};


export type ContentManagementMutationsImportArgs = {
  form: ContentManagementImportForm;
};


export type ContentManagementMutationsUpdateArgs = {
  req?: InputMaybe<TraitForm>;
};

export type ContentManagementQueries = {
  __typename?: 'ContentManagementQueries';
  findAll?: Maybe<TraitQueryResult>;
  findAllScoreType?: Maybe<ContentMangementScoreTypeQueryResult>;
};


export type ContentManagementQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  include?: InputMaybe<ContentManagementRelationship>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TraitSortBy>;
  where?: InputMaybe<TraitQueryFilter>;
};


export type ContentManagementQueriesFindAllScoreTypeArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ContentMangementScoreTypeQuerySortBy>;
  where?: InputMaybe<ContentMangementScoreTypeQueryFilter>;
};

export type ContentManagementRelationship = {
  dnaScoreType?: InputMaybe<Scalars['Boolean']['input']>;
  dnaTraitScore?: InputMaybe<Scalars['Boolean']['input']>;
  dnaTraitScoreTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  dnaTraitTranslation?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContentManagementStatus {
  Completed = 'COMPLETED',
  Missing = 'MISSING'
}

export type ContentMangementScoreType = {
  __typename?: 'ContentMangementScoreType';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ContentMangementScoreTypeQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ContentMangementScoreTypeQueryResult = {
  __typename?: 'ContentMangementScoreTypeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ContentMangementScoreType>>>;
};

export type ContentMangementScoreTypeQuerySortBy = {
  name?: InputMaybe<SortDirection>;
};

export type CounselorNotification = {
  __typename?: 'CounselorNotification';
  counselorBookId?: Maybe<Scalars['Int']['output']>;
  counselorId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CounselorNotificationMutations = {
  __typename?: 'CounselorNotificationMutations';
  delete?: Maybe<Scalars['Boolean']['output']>;
};

export type CounselorNotificationQueries = {
  __typename?: 'CounselorNotificationQueries';
  findAll?: Maybe<Scalars['Boolean']['output']>;
};

export type CountTraitByScore = {
  __typename?: 'CountTraitByScore';
  count?: Maybe<Scalars['Int']['output']>;
  scoreTypeGuideline?: Maybe<DnaScoreTypeGuideline>;
};

export type CountTraitByScoreResult = {
  __typename?: 'CountTraitByScoreResult';
  results?: Maybe<Array<Maybe<CountTraitByScore>>>;
};

export type CountTraitByScoreV2 = {
  __typename?: 'CountTraitByScoreV2';
  count?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<CountTraitByScoreV2Detail>;
};

export type CountTraitByScoreV2Detail = {
  __typename?: 'CountTraitByScoreV2Detail';
  dnaScoreTypeGuidelineId?: Maybe<Scalars['String']['output']>;
  dnaScoreTypeId?: Maybe<Scalars['String']['output']>;
  mappedScore?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Array<Maybe<BioinformaticReportResponse>>>;
  riskLevel?: Maybe<Scalars['String']['output']>;
};

export type CountTraitByScoreV2Result = {
  __typename?: 'CountTraitByScoreV2Result';
  results?: Maybe<Array<Maybe<CountTraitByScoreV2>>>;
};

export type Country = {
  __typename?: 'Country';
  currency?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
};

export type CountryForm = {
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneCode?: InputMaybe<Scalars['String']['input']>;
};

export type CountryMutations = {
  __typename?: 'CountryMutations';
  add?: Maybe<Country>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Country>;
};


export type CountryMutationsAddArgs = {
  form?: InputMaybe<CountryForm>;
};


export type CountryMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type CountryMutationsEditArgs = {
  form?: InputMaybe<CountryForm>;
  id: Scalars['String']['input'];
};

export type CountryQueries = {
  __typename?: 'CountryQueries';
  cities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  countries?: Maybe<Array<Maybe<Place>>>;
  districts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  findAll?: Maybe<CountryQueryResult>;
  findOne?: Maybe<Country>;
  postalCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  provinces?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CountryQueriesCitiesArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};


export type CountryQueriesCountriesArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type CountryQueriesDistrictsArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};


export type CountryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CountryQuerySortBy>;
  where?: InputMaybe<CountryQueryFilter>;
};


export type CountryQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type CountryQueriesPostalCodesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};


export type CountryQueriesProvincesArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type CountryQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CountryQueryResult = {
  __typename?: 'CountryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Country>>>;
};

export type CountryQuerySortBy = {
  name?: InputMaybe<SortDirection>;
};

export type CreateKitActivationQuestionnaireAnswerForm = {
  ethnic?: InputMaybe<Array<InputMaybe<ProfileEthnicityGroupForm>>>;
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  parentalMedicalHistory?: InputMaybe<ParentalMedicalHistoryInput>;
  physicalActivityLevel?: InputMaybe<PhysicalActivityLevelInput>;
};

export type CreateOnboardingQuestionnaireForm = {
  alcoholHabits?: InputMaybe<AlcoholHabitsForm>;
  exerciseLevelPerWeek?: InputMaybe<Scalars['String']['input']>;
  exerciseLevelPerWeekCompleted?: InputMaybe<Scalars['String']['input']>;
  healthMedicalHistories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sleepHabits?: InputMaybe<SleepHabitsForm>;
  smokingHabits?: InputMaybe<SmokingHabitsForm>;
};

export type CreateOnboardingQuestionnaireFormV3 = {
  allergyHistories?: InputMaybe<Scalars['String']['input']>;
  currentHealthGoals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  healthMedicalHistories?: InputMaybe<Scalars['String']['input']>;
  lifestyleHabits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateProdigyPanelForm = {
  localization?: InputMaybe<Array<InputMaybe<ProdigyPanelLocalizationForm>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Currency = {
  __typename?: 'Currency';
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['String']['output']>;
};

export type CurrencyQueries = {
  __typename?: 'CurrencyQueries';
  findAll?: Maybe<CurrencyQueryResult>;
};


export type CurrencyQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CurrencyQuerySortBy>;
  where?: InputMaybe<CurrencyQueryFilter>;
};

export type CurrencyQueryFilter = {
  currency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rate?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyQueryResult = {
  __typename?: 'CurrencyQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Currency>>>;
};

export type CurrencyQuerySortBy = {
  currency?: InputMaybe<SortDirection>;
  rate?: InputMaybe<SortDirection>;
};

export type DnaAttachment = {
  __typename?: 'DNAAttachment';
  attachment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DnaAttachmentType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaAttachmentQueries = {
  __typename?: 'DNAAttachmentQueries';
  findAll?: Maybe<DnaAttachmentQueryResult>;
};


export type DnaAttachmentQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaAttachmentQuerySortBy>;
  where?: InputMaybe<DnaAttachmentQueryFilter>;
};

export type DnaAttachmentQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<DnaAttachmentType>>>;
};

export type DnaAttachmentQueryResult = {
  __typename?: 'DNAAttachmentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaAttachment>>>;
};

export type DnaAttachmentQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum DnaAttachmentType {
  DnaGeneTranslation = 'DNA_GENE_TRANSLATION',
  DnaReportTranslation = 'DNA_REPORT_TRANSLATION'
}

export type DnaMutations = {
  __typename?: 'DNAMutations';
  Category?: Maybe<DnaCategoryMutations>;
  HealthGuideline?: Maybe<DnaHealthGuidelineMutations>;
  HormoneGuideline?: Maybe<DnaHormoneGuidelineMutations>;
  Interactome?: Maybe<DnaInteractomeMutations>;
  MasterDictionary?: Maybe<MasterDictionaryMutations>;
  NutritionGuideline?: Maybe<DnaNutritionGuidelineMutations>;
  Owner?: Maybe<DnaOwnerMutations>;
  Panel?: Maybe<DnaPanelMutations>;
  PersonalizedReport?: Maybe<DnaPersonalizedReportMutations>;
  ProdigyGuideline?: Maybe<DnaProdigyGuidelineMutations>;
  Report?: Maybe<DnaReportMutations>;
  ScoreType?: Maybe<DnaScoreTypeMutations>;
  Search?: Maybe<DnaSearchMutations>;
  Skin?: Maybe<DnaSkinMutations>;
  SportGuideline?: Maybe<DnaSportGuidelineMutations>;
  Trait?: Maybe<DnaTraitMutations>;
};

export type DnaOwner = {
  __typename?: 'DNAOwner';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partnership?: Maybe<Partnership>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaOwnerForm = {
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaOwnerMutations = {
  __typename?: 'DNAOwnerMutations';
  add?: Maybe<DnaOwner>;
};


export type DnaOwnerMutationsAddArgs = {
  form?: InputMaybe<DnaOwnerForm>;
};

export type DnaOwnerQueries = {
  __typename?: 'DNAOwnerQueries';
  findAll?: Maybe<DnaOwnerQueryResult>;
  findOne?: Maybe<DnaOwner>;
};


export type DnaOwnerQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaOwnerQuerySortBy>;
  where?: InputMaybe<DnaOwnerQueryFilter>;
};


export type DnaOwnerQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type DnaOwnerQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type DnaOwnerQueryResult = {
  __typename?: 'DNAOwnerQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaOwner>>>;
};

export type DnaOwnerQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type DnaQueries = {
  __typename?: 'DNAQueries';
  Attachment?: Maybe<DnaAttachmentQueries>;
  Category?: Maybe<DnaCategoryQueries>;
  Gene?: Maybe<DnaGeneQueries>;
  Guideline?: Maybe<GuidelineQueries>;
  HealthGuideline?: Maybe<DnaHealthGuidelineQueries>;
  HormoneGuideline?: Maybe<DnaHormoneGuidelineQueries>;
  Interactome?: Maybe<DnaInteractomeQueries>;
  MasterDictionary?: Maybe<MasterDictionaryQueries>;
  NutritionGuideline?: Maybe<DnaNutritionGuidelineQueries>;
  Owner?: Maybe<DnaOwnerQueries>;
  Panel?: Maybe<DnaPanelQueries>;
  Pdf?: Maybe<DnaPdfQueries>;
  PersonalityGuideline?: Maybe<DnaPersonalityGuidelineQueries>;
  PersonalizedReport?: Maybe<DnaPersonalizedReportQueries>;
  ProdigyGuideline?: Maybe<DnaProdigyGuidelineQueries>;
  Report?: Maybe<DnaReportQueries>;
  Score?: Maybe<DnaScoreQueries>;
  ScoreType?: Maybe<DnaScoreTypeQueries>;
  Search?: Maybe<DnaSearchQueries>;
  Skin?: Maybe<DnaSkinQueries>;
  SportGuideline?: Maybe<DnaSportGuidelineQueries>;
  Trait?: Maybe<DnaTraitQueries>;
  User?: Maybe<DnaUserQueries>;
};

export type DnaReport = {
  __typename?: 'DNAReport';
  accessedAt?: Maybe<Scalars['Date']['output']>;
  agreeDisclaimerAt?: Maybe<Scalars['Date']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  attachmentLanguage_ID?: Maybe<Scalars['String']['output']>;
  bioinformaticUserId?: Maybe<Scalars['String']['output']>;
  dnaUser?: Maybe<DnaUser>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<DnaReportFiles>>>;
  id?: Maybe<Scalars['String']['output']>;
  kit?: Maybe<PurchaseProductKit>;
  kitId?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageCode>;
  notificationStatus?: Maybe<DnaReportNotificationStatus>;
  profile?: Maybe<UserProfile>;
  profileId?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  vendorBioItId?: Maybe<Scalars['String']['output']>;
};

export type DnaReportFiles = {
  __typename?: 'DNAReportFiles';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  generationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  protected?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DnaReportFormEdit = {
  accessedAt?: InputMaybe<Scalars['Date']['input']>;
  language?: InputMaybe<LanguageCode>;
  notificationStatus?: InputMaybe<DnaReportNotificationStatus>;
};

export enum DnaReportHistoryStatus {
  EmailSent = 'EMAIL_SENT',
  PushNotifSent = 'PUSH_NOTIF_SENT',
  ReportGenerated = 'REPORT_GENERATED',
  ReportMapped = 'REPORT_MAPPED'
}

export type DnaReportMutations = {
  __typename?: 'DNAReportMutations';
  Type?: Maybe<DnaReportTypeMutations>;
  add?: Maybe<DnaReport>;
  agreeDisclaimer?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<DnaReport>;
  importDNAGeneTranslation?: Maybe<Scalars['Boolean']['output']>;
  importDNAReportTranslation?: Maybe<Scalars['Boolean']['output']>;
  notifyUsers?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaReportMutationsAgreeDisclaimerArgs = {
  agreeDisclaimerAt: Scalars['Date']['input'];
  dnaReportId: Scalars['String']['input'];
};


export type DnaReportMutationsEditArgs = {
  form?: InputMaybe<DnaReportFormEdit>;
  where?: InputMaybe<DnaReportQueryFilterEdit>;
};


export type DnaReportMutationsImportDnaGeneTranslationArgs = {
  file: Scalars['Upload']['input'];
};


export type DnaReportMutationsImportDnaReportTranslationArgs = {
  file: Scalars['Upload']['input'];
};


export type DnaReportMutationsNotifyUsersArgs = {
  file: Scalars['Upload']['input'];
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DnaReportNotificationStatus {
  FirstNotified = 'FIRST_NOTIFIED',
  NotificationCompleted = 'NOTIFICATION_COMPLETED',
  WaitingForNotified = 'WAITING_FOR_NOTIFIED'
}

export type DnaReportQueries = {
  __typename?: 'DNAReportQueries';
  DnaReportUser?: Maybe<DnaReportUserQueries>;
  Type?: Maybe<DnaReportTypeQueries>;
  download?: Maybe<Scalars['String']['output']>;
  find?: Maybe<DnaReport>;
  findAll?: Maybe<DnaReportQueryResult>;
  findOne?: Maybe<DnaReport>;
};


export type DnaReportQueriesFindArgs = {
  where?: InputMaybe<DnaReportQueryFilter>;
};


export type DnaReportQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaReportQueryFilter>;
};


export type DnaReportQueriesFindOneArgs = {
  reportType?: InputMaybe<ReportType>;
};

export type DnaReportQueryFilter = {
  allowToRelease?: InputMaybe<Scalars['Boolean']['input']>;
  generatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  haveAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  haveProtectedAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaReportQueryFilterEdit = {
  reportType?: InputMaybe<ReportType>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaReportQueryResult = {
  __typename?: 'DNAReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaReport>>>;
};

export type DnaSearch = {
  __typename?: 'DNASearch';
  id?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DnaSearchType>;
};

export type DnaSearchCategoryQueryResult = {
  __typename?: 'DNASearchCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaCategory>>>;
};

export type DnaSearchMutations = {
  __typename?: 'DNASearchMutations';
  openCategory?: Maybe<DnaSearch>;
  openReport?: Maybe<DnaSearch>;
  recordOpenReport?: Maybe<DnaSearch>;
};


export type DnaSearchMutationsOpenCategoryArgs = {
  asarenDNACategoryId: Scalars['Int']['input'];
};


export type DnaSearchMutationsOpenReportArgs = {
  bioinformaticReportId: Scalars['String']['input'];
};


export type DnaSearchMutationsRecordOpenReportArgs = {
  bioinformaticReportId: Scalars['String']['input'];
};

export type DnaSearchQueries = {
  __typename?: 'DNASearchQueries';
  searchCategory?: Maybe<DnaSearchCategoryQueryResult>;
  searchReport?: Maybe<DnaSearchReportQueryResult>;
};


export type DnaSearchQueriesSearchCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DnaSearchReportFilter>;
};


export type DnaSearchQueriesSearchReportArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DnaSearchReportFilter>;
};

export type DnaSearchReportFilter = {
  asarenDNACategoryId?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  reportType: ReportType;
};

export type DnaSearchReportQueryResult = {
  __typename?: 'DNASearchReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BioinformaticReport>>>;
};

export enum DnaSearchType {
  Category = 'CATEGORY',
  Report = 'REPORT'
}

export type DnaTraitDetailQueryFilter = {
  dnaTraitId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaTraitQueryFilter = {
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contentManagementStatus?: InputMaybe<ContentManagementStatus>;
  dnaPanelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaScoreTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaSubCategoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  uspStatus?: InputMaybe<ContentManagementStatus>;
};

export type DateRangeFilter = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRangeInput = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export enum Day {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DetailUserFtueAvailabilityData = {
  __typename?: 'DetailUserFtueAvailabilityData';
  detailFtue?: Maybe<FtueFeature>;
  status: UserFtueStatus;
};

export type DnaCategory = {
  __typename?: 'DnaCategory';
  backgroundColor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cover?: Maybe<Scalars['String']['output']>;
  customFilter?: Maybe<Array<Maybe<BioinformaticReportCustomFilter>>>;
  dPanel?: Maybe<DnaPanel>;
  description?: Maybe<Scalars['String']['output']>;
  dnaPanelId?: Maybe<Scalars['String']['output']>;
  dnaSubCategory?: Maybe<Array<Maybe<DnaSubCategory>>>;
  favourableImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  infoImageAsset?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objectImage?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<DnaCategoryTranslation>;
  unfavourableImage?: Maybe<Scalars['String']['output']>;
};

export type DnaCategoryBaseOnReportQueryFilter = {
  clientProfileId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportType: Scalars['String']['input'];
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaCategoryForm = {
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cover?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dnaPanelId?: InputMaybe<Scalars['String']['input']>;
  favourableImage?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  infoImageAsset?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectImage?: InputMaybe<Scalars['Upload']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  translation?: InputMaybe<DnaCategoryTranslationForm>;
  unfavourableImage?: InputMaybe<Scalars['Upload']['input']>;
};

export type DnaCategoryMutations = {
  __typename?: 'DnaCategoryMutations';
  DnaSubCategory?: Maybe<DnaSubCategoryMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaCategory>>>;
  export?: Maybe<Scalars['String']['output']>;
  exportExcel360?: Maybe<Scalars['Boolean']['output']>;
  exportExcelNutrigenetic?: Maybe<Scalars['Boolean']['output']>;
  exportExcelOncorisk?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<DnaCategory>;
};


export type DnaCategoryMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaCategoryForm>>;
};


export type DnaCategoryMutationsExportArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
};


export type DnaCategoryMutationsExportExcel360Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaCategorySortBy>;
  where?: InputMaybe<DnaCategoryQueryFilter>;
};


export type DnaCategoryMutationsExportExcelNutrigeneticArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaCategorySortBy>;
  where?: InputMaybe<DnaCategoryQueryFilter>;
};


export type DnaCategoryMutationsExportExcelOncoriskArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaCategorySortBy>;
  where?: InputMaybe<DnaCategoryQueryFilter>;
};


export type DnaCategoryMutationsUpdateArgs = {
  form: DnaCategoryForm;
  id: Scalars['Int']['input'];
};

export type DnaCategoryOverviewScoreUser = {
  __typename?: 'DnaCategoryOverviewScoreUser';
  count?: Maybe<Scalars['Int']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type DnaCategoryOverviewScoreUserQueryFilter = {
  dnaCategoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<Scalars['String']['input']>;
};

export type DnaCategoryQueries = {
  __typename?: 'DnaCategoryQueries';
  DnaSubCategory?: Maybe<DnaSubCategoryQueries>;
  findAll?: Maybe<DnaCategoryQueryResult>;
  findAllBaseOnUserReport?: Maybe<DnaCategoryQueryResult>;
  findAllCategoryOverviewScoreUser?: Maybe<Array<Maybe<DnaCategoryOverviewScoreUser>>>;
  findOne?: Maybe<DnaCategory>;
};


export type DnaCategoryQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaCategorySortBy>;
  where?: InputMaybe<DnaCategoryQueryFilter>;
};


export type DnaCategoryQueriesFindAllBaseOnUserReportArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DnaCategoryBaseOnReportQueryFilter>;
};


export type DnaCategoryQueriesFindAllCategoryOverviewScoreUserArgs = {
  where?: InputMaybe<DnaCategoryOverviewScoreUserQueryFilter>;
};


export type DnaCategoryQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type DnaCategoryQueryFilter = {
  affiliatedWithPanel?: InputMaybe<Scalars['Boolean']['input']>;
  clientProfileId?: InputMaybe<Scalars['String']['input']>;
  dnaPanelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<UserGender>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaCategoryQueryResult = {
  __typename?: 'DnaCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaCategory>>>;
};

export type DnaCategorySortBy = {
  name?: InputMaybe<SortDirection>;
  panelName?: InputMaybe<SortDirection>;
};

export type DnaCategoryTranslation = {
  __typename?: 'DnaCategoryTranslation';
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dnaCategoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  langCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type DnaCategoryTranslationForm = {
  cover?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  langCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type DnaCategoryWithReport = {
  __typename?: 'DnaCategoryWithReport';
  backgroundColor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dnaPanelId?: Maybe<Scalars['String']['output']>;
  favourableImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objectImage?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<ReportType>;
  reports?: Maybe<Array<Maybe<BioinformaticReport>>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  unfavourableImage?: Maybe<Scalars['String']['output']>;
};

export type DnaCategoryWithReportQueryFilter = {
  dnaCategoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dnaPanelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
};

export type DnaCategoryWithReportQueryResult = {
  __typename?: 'DnaCategoryWithReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaCategoryWithReport>>>;
};

export type DnaGene = {
  __typename?: 'DnaGene';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DnaGeneQueries = {
  __typename?: 'DnaGeneQueries';
  findAll?: Maybe<DnaGeneQueryResult>;
  findOne?: Maybe<DnaGene>;
};


export type DnaGeneQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type DnaGeneQueryResult = {
  __typename?: 'DnaGeneQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaGene>>>;
};

export type DnaHealthGuideline = {
  __typename?: 'DnaHealthGuideline';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  hGuidelineDisease?: Maybe<Array<Maybe<DnaHealthGuidelineDisease>>>;
  hGuidelineSummary?: Maybe<Array<Maybe<DnaHealthGuidelineSummary>>>;
  id?: Maybe<Scalars['String']['output']>;
  questionnaireSubmittedAt?: Maybe<Scalars['Date']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHealthGuidelineDisease = {
  __typename?: 'DnaHealthGuidelineDisease';
  createdAt?: Maybe<Scalars['Date']['output']>;
  diseaseType?: Maybe<Scalars['String']['output']>;
  healthGuidelineId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHealthGuidelineDiseaseInsight = {
  __typename?: 'DnaHealthGuidelineDiseaseInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  hGuidelineDiseaseInsightDetail?: Maybe<Array<Maybe<DnaHealthGuidelineDiseaseInsightDetail>>>;
  hGuidelineDiseaseInsightTranslation?: Maybe<Array<Maybe<DnaHealthGuidelineDiseaseInsightTranslation>>>;
  healthGuidelineDiseaseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHealthGuidelineDiseaseInsightDetail = {
  __typename?: 'DnaHealthGuidelineDiseaseInsightDetail';
  area?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hGuidelineDiseaseInsightDetailTranslation?: Maybe<Array<Maybe<DnaHealthGuidelineDiseaseInsightDetailTranslation>>>;
  healthGuidelineDiseaseInsightId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHealthGuidelineDiseaseInsightDetailTranslation = {
  __typename?: 'DnaHealthGuidelineDiseaseInsightDetailTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  healthGuidelineDiseaseInsightDetailId?: Maybe<Scalars['String']['output']>;
  healthGuidelineId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHealthGuidelineDiseaseInsightQueries = {
  __typename?: 'DnaHealthGuidelineDiseaseInsightQueries';
  findByUser?: Maybe<Array<Maybe<DnaHealthGuidelineDiseaseInsight>>>;
};


export type DnaHealthGuidelineDiseaseInsightQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<DnaHealthGuidelineDiseaseInsightQueryFilter>;
};

export type DnaHealthGuidelineDiseaseInsightQueryFilter = {
  dnaCategoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<Scalars['String']['input']>;
};

export type DnaHealthGuidelineDiseaseInsightTranslation = {
  __typename?: 'DnaHealthGuidelineDiseaseInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  healthGuidelineDiseaseInsightId?: Maybe<Scalars['String']['output']>;
  healthGuidelineId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHealthGuidelineDiseaseMutations = {
  __typename?: 'DnaHealthGuidelineDiseaseMutations';
  updateIsRelevant?: Maybe<DnaHealthGuidelineDisease>;
};


export type DnaHealthGuidelineDiseaseMutationsUpdateIsRelevantArgs = {
  form: DnaHealthGuidelineDiseaseRelevantForm;
};

export type DnaHealthGuidelineDiseaseQueries = {
  __typename?: 'DnaHealthGuidelineDiseaseQueries';
  Insight?: Maybe<DnaHealthGuidelineDiseaseInsightQueries>;
};

export type DnaHealthGuidelineDiseaseRelevantForm = {
  dnaCategoryId?: InputMaybe<Scalars['String']['input']>;
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DnaHealthGuidelineMutations = {
  __typename?: 'DnaHealthGuidelineMutations';
  Disease?: Maybe<DnaHealthGuidelineDiseaseMutations>;
};

export type DnaHealthGuidelineQueries = {
  __typename?: 'DnaHealthGuidelineQueries';
  Disease?: Maybe<DnaHealthGuidelineDiseaseQueries>;
  findByUser?: Maybe<DnaHealthGuideline>;
};


export type DnaHealthGuidelineQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<DnaHealthGuidelineQueryFilter>;
};

export type DnaHealthGuidelineQueryFilter = {
  reportType?: InputMaybe<Scalars['String']['input']>;
};

export type DnaHealthGuidelineSummary = {
  __typename?: 'DnaHealthGuidelineSummary';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  healthGuidelineId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuideline = {
  __typename?: 'DnaHormoneGuideline';
  createdAt?: Maybe<Scalars['Date']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  failedGenerationReason?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  generationTimeoutAt?: Maybe<Scalars['Date']['output']>;
  generationType?: Maybe<GenerationType>;
  hormoneGuidelineCycle?: Maybe<DnaHormoneGuidelineCycle>;
  hormoneGuidelineInformation?: Maybe<DnaHormoneGuidelineInformation>;
  hormoneGuidelineInsight?: Maybe<Array<Maybe<DnaHormoneGuidelineInsight>>>;
  hormoneGuidelinePerimenopause?: Maybe<DnaHormoneGuidelinePerimenopause>;
  hormoneGuidelineSymptom?: Maybe<Array<Maybe<DnaHormoneGuidelineSymptom>>>;
  id?: Maybe<Scalars['String']['output']>;
  isFailedGeneration?: Maybe<Scalars['Boolean']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  questionnaireSubmittedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export enum DnaHormoneGuidelineActionType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type DnaHormoneGuidelineCycle = {
  __typename?: 'DnaHormoneGuidelineCycle';
  activeCyclePhase?: Maybe<DnaHormoneGuidelineCyclePhase>;
  conditionCycleLengthStatus?: Maybe<Scalars['String']['output']>;
  conditionCycleLengthValue?: Maybe<Scalars['Int']['output']>;
  conditionPeriodLengthStatus?: Maybe<Scalars['String']['output']>;
  conditionPeriodLengthValue?: Maybe<Scalars['Int']['output']>;
  conditionPeriodStartStatus?: Maybe<Scalars['String']['output']>;
  conditionPeriodStartValue?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  descriptionActiveCyclePhase?: Maybe<Scalars['String']['output']>;
  endAtCycle?: Maybe<Scalars['String']['output']>;
  endAtPeriod?: Maybe<Scalars['String']['output']>;
  hormoneGuidelineCycleLog?: Maybe<Array<Maybe<DnaHormoneGuidelineCycleLog>>>;
  hormoneGuidelineCyclePhase?: Maybe<Array<Maybe<DnaHormoneGuidelineCyclePhase>>>;
  hormoneGuidelineId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdatePeriod?: Maybe<Scalars['Date']['output']>;
  nextPredictedPeriodeEndDate?: Maybe<Scalars['String']['output']>;
  nextPredictedPeriodeStartDate?: Maybe<Scalars['String']['output']>;
  startAtCycle?: Maybe<Scalars['String']['output']>;
  startAtPeriod?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelineCycleForm = {
  endAtPeriod?: InputMaybe<Scalars['String']['input']>;
  startAtPeriod?: InputMaybe<Scalars['String']['input']>;
};

export type DnaHormoneGuidelineCycleGeneration = {
  __typename?: 'DnaHormoneGuidelineCycleGeneration';
  action?: Maybe<Scalars['String']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  generationType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
};

export type DnaHormoneGuidelineCycleLog = {
  __typename?: 'DnaHormoneGuidelineCycleLog';
  after?: Maybe<Scalars['JSON']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  hormoneGuidelineCycleId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelineCycleLogForm = {
  after?: InputMaybe<Scalars['JSON']['input']>;
  before?: InputMaybe<Scalars['JSON']['input']>;
  hormoneGuidelineCycleId: Scalars['String']['input'];
};

export type DnaHormoneGuidelineCycleMutations = {
  __typename?: 'DnaHormoneGuidelineCycleMutations';
  finishPeriod?: Maybe<DnaHormoneGuidelineCycle>;
  finishPeriodReportless?: Maybe<DnaHormoneGuidelineCycle>;
  startCycleReportless?: Maybe<DnaHormoneGuidelineCycle>;
  startPeriod?: Maybe<DnaHormoneGuidelineCycleStartPeriodResponse>;
  startPeriodReportless?: Maybe<DnaHormoneGuidelineCycle>;
  update?: Maybe<DnaHormoneGuidelineCycle>;
  updateCycleReportless?: Maybe<DnaHormoneGuidelineCycle>;
};


export type DnaHormoneGuidelineCycleMutationsFinishPeriodArgs = {
  id: Scalars['String']['input'];
};


export type DnaHormoneGuidelineCycleMutationsFinishPeriodReportlessArgs = {
  endDate: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type DnaHormoneGuidelineCycleMutationsStartCycleReportlessArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type DnaHormoneGuidelineCycleMutationsStartPeriodArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type DnaHormoneGuidelineCycleMutationsStartPeriodReportlessArgs = {
  id: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type DnaHormoneGuidelineCycleMutationsUpdateArgs = {
  form: DnaHormoneGuidelineCycleForm;
  id: Scalars['String']['input'];
};


export type DnaHormoneGuidelineCycleMutationsUpdateCycleReportlessArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type DnaHormoneGuidelineCyclePhase = {
  __typename?: 'DnaHormoneGuidelineCyclePhase';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  hormoneGuidelineCycleId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  pregnancyChance?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelineCyclePhaseForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hormoneGuidelineCycleId: Scalars['String']['input'];
  insight?: InputMaybe<Scalars['String']['input']>;
  pregnancyChance?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type DnaHormoneGuidelineCycleQueries = {
  __typename?: 'DnaHormoneGuidelineCycleQueries';
  findAllByProfile?: Maybe<DnaHormoneGuidelineCycle>;
  findUserHistory?: Maybe<Array<Maybe<DnaHormoneGuidelineCycle>>>;
};


export type DnaHormoneGuidelineCycleQueriesFindAllByProfileArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DnaHormoneGuidelineCycleQueriesFindUserHistoryArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type DnaHormoneGuidelineCycleStartPeriodResponse = {
  __typename?: 'DnaHormoneGuidelineCycleStartPeriodResponse';
  cycleId?: Maybe<Scalars['String']['output']>;
  endPeriod?: Maybe<Scalars['String']['output']>;
  generation?: Maybe<DnaHormoneGuidelineCycleGeneration>;
  kitcode?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  questionnaireId?: Maybe<Scalars['String']['output']>;
  startPeriod?: Maybe<Scalars['String']['output']>;
};

export type DnaHormoneGuidelineEvent = {
  __typename?: 'DnaHormoneGuidelineEvent';
  action?: Maybe<DnaHormoneGuidelineActionType>;
  data?: Maybe<DnaHormoneGuideline>;
};

export type DnaHormoneGuidelineInformation = {
  __typename?: 'DnaHormoneGuidelineInformation';
  ageMomAtPerimenopause?: Maybe<Scalars['Int']['output']>;
  averageCycle?: Maybe<Scalars['String']['output']>;
  commonSymptoms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  descriptionMenstrualPastYear?: Maybe<Scalars['String']['output']>;
  diagnosedConditions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  experienceDetail?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hormonalContraception?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  painfulPeriodLevel?: Maybe<Scalars['String']['output']>;
  periodFlow?: Maybe<Scalars['String']['output']>;
  sleepAroundCycle?: Maybe<Scalars['String']['output']>;
  typicalMenstrualPeriod?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userHasMenopause?: Maybe<Scalars['Boolean']['output']>;
};

export type DnaHormoneGuidelineInformationForm = {
  ageMomAtPerimenopause?: InputMaybe<Scalars['Int']['input']>;
  averageCycle?: InputMaybe<Scalars['String']['input']>;
  commonSymptoms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionMenstrualPastYear?: InputMaybe<Scalars['String']['input']>;
  diagnosedConditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experienceDetail?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hormonalContraception?: InputMaybe<Scalars['String']['input']>;
  painfulPeriodLevel?: InputMaybe<Scalars['String']['input']>;
  periodFlow?: InputMaybe<Scalars['String']['input']>;
  sleepAroundCycle?: InputMaybe<Scalars['String']['input']>;
  typicalMenstrualPeriod?: InputMaybe<Scalars['String']['input']>;
  userHasMenopause?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DnaHormoneGuidelineInformationMutations = {
  __typename?: 'DnaHormoneGuidelineInformationMutations';
  update?: Maybe<DnaHormoneGuidelineInformation>;
};


export type DnaHormoneGuidelineInformationMutationsUpdateArgs = {
  form: DnaHormoneGuidelineInformationForm;
  id: Scalars['String']['input'];
};

export type DnaHormoneGuidelineInsight = {
  __typename?: 'DnaHormoneGuidelineInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  failedGenerationReason?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  generationTimeoutAt?: Maybe<Scalars['Date']['output']>;
  generationType?: Maybe<GenerationType>;
  hormoneGuidelineId?: Maybe<Scalars['String']['output']>;
  hormoneGuidelineInsightDetail?: Maybe<Array<Maybe<DnaHormoneGuidelineInsightDetail>>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  isFailedGeneration?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelineInsightDetail = {
  __typename?: 'DnaHormoneGuidelineInsightDetail';
  createdAt?: Maybe<Scalars['Date']['output']>;
  hormoneGuidelineInsightId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelineInsightDetailForm = {
  hormoneGuidelineInsightId: Scalars['String']['input'];
  insights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DnaHormoneGuidelineInsightQueries = {
  __typename?: 'DnaHormoneGuidelineInsightQueries';
  findByUser?: Maybe<Array<Maybe<DnaHormoneGuidelineInsight>>>;
};


export type DnaHormoneGuidelineInsightQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaHormoneGuidelineMutations = {
  __typename?: 'DnaHormoneGuidelineMutations';
  Cycle?: Maybe<DnaHormoneGuidelineCycleMutations>;
  Information?: Maybe<DnaHormoneGuidelineInformationMutations>;
  Symptom?: Maybe<DnaHormoneGuidelineSymptomMutations>;
};

export type DnaHormoneGuidelinePerimenopause = {
  __typename?: 'DnaHormoneGuidelinePerimenopause';
  ageAtPerimenopause?: Maybe<Scalars['Int']['output']>;
  ageMomAtPerimenopause?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentStage?: Maybe<DnaHormoneGuidelinePerimenopauseStage>;
  currentStatus?: Maybe<DnaHormoneGuidelinePerimenopauseStageCode>;
  cycleId?: Maybe<Scalars['String']['output']>;
  descriptionMenstrualPastYear?: Maybe<Scalars['String']['output']>;
  descriptionSignificationSymptoms?: Maybe<Scalars['String']['output']>;
  experienceDetail?: Maybe<Scalars['String']['output']>;
  failedGenerationReason?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  generationTimeoutAt?: Maybe<Scalars['Date']['output']>;
  generationType?: Maybe<GenerationType>;
  hormoneGuidelineId?: Maybe<Scalars['String']['output']>;
  hormoneGuidelinePerimenopauseInsight?: Maybe<Array<Maybe<DnaHormoneGuidelinePerimenopauseInsight>>>;
  id?: Maybe<Scalars['String']['output']>;
  insightSignificationSymptoms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isFailedGeneration?: Maybe<Scalars['Boolean']['output']>;
  nextStage?: Maybe<DnaHormoneGuidelinePerimenopauseStage>;
  nextStatus?: Maybe<DnaHormoneGuidelinePerimenopauseStageCode>;
  profileId?: Maybe<Scalars['String']['output']>;
  questionnaireSubmittedAt?: Maybe<Scalars['Date']['output']>;
  stages?: Maybe<Array<Maybe<DnaHormoneGuidelinePerimenopauseStage>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export enum DnaHormoneGuidelinePerimenopauseActionType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type DnaHormoneGuidelinePerimenopauseEvent = {
  __typename?: 'DnaHormoneGuidelinePerimenopauseEvent';
  action?: Maybe<DnaHormoneGuidelinePerimenopauseActionType>;
  data?: Maybe<DnaHormoneGuidelinePerimenopause>;
};

export type DnaHormoneGuidelinePerimenopauseForm = {
  ageAtPerimenopause?: InputMaybe<Scalars['Int']['input']>;
  ageMomAtPerimenopause?: InputMaybe<Scalars['Int']['input']>;
  descriptionMenstrualPastYear?: InputMaybe<Scalars['String']['input']>;
  descriptionSignificationSymptoms?: InputMaybe<Scalars['String']['input']>;
  experienceDetail?: InputMaybe<Scalars['String']['input']>;
  generationType?: InputMaybe<Scalars['String']['input']>;
  hormoneGuidelineId: Scalars['String']['input'];
  insightSignificationSymptoms?: InputMaybe<Scalars['String']['input']>;
  questionnaireSubmittedAt?: InputMaybe<Scalars['Date']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type DnaHormoneGuidelinePerimenopauseInsight = {
  __typename?: 'DnaHormoneGuidelinePerimenopauseInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  hormoneGuidelinePerimenopauseId?: Maybe<Scalars['String']['output']>;
  hormoneGuidelinePerimenopauseInsightTranslation?: Maybe<Array<Maybe<DnaHormoneGuidelinePerimenopauseInsightTranslation>>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelinePerimenopauseInsightForm = {
  hormoneGuidelinePerimenopauseId: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  insights?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DnaHormoneGuidelinePerimenopauseInsightTranslation = {
  __typename?: 'DnaHormoneGuidelinePerimenopauseInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  hormoneGuidelinePerimenopauseInsightId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelinePerimenopauseInsightTranslationForm = {
  hormoneGuidelinePerimenopauseInsightId: Scalars['String']['input'];
  insight?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DnaHormoneGuidelinePerimenopauseQueries = {
  __typename?: 'DnaHormoneGuidelinePerimenopauseQueries';
  findByGuideline?: Maybe<DnaHormoneGuidelinePerimenopause>;
};


export type DnaHormoneGuidelinePerimenopauseQueriesFindByGuidelineArgs = {
  hormoneGuidelineId: Scalars['String']['input'];
};

export type DnaHormoneGuidelinePerimenopauseStage = {
  __typename?: 'DnaHormoneGuidelinePerimenopauseStage';
  code?: Maybe<DnaHormoneGuidelinePerimenopauseStageCode>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  generationDate?: Maybe<Scalars['Date']['output']>;
  hormoneGuidelinePerimenopauseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isGenerated?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  predictedAge?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DnaHormoneGuidelinePerimenopauseStageCode {
  Early = 'EARLY',
  Late = 'LATE',
  Meno = 'MENO',
  Mid = 'MID',
  Post = 'POST',
  Pre = 'PRE'
}

export type DnaHormoneGuidelineQueries = {
  __typename?: 'DnaHormoneGuidelineQueries';
  Cycle?: Maybe<DnaHormoneGuidelineCycleQueries>;
  Insight?: Maybe<DnaHormoneGuidelineInsightQueries>;
  Perimenopause?: Maybe<DnaHormoneGuidelinePerimenopauseQueries>;
  Symptom?: Maybe<DnaHormoneGuidelineSymptomQueries>;
  findAll?: Maybe<Array<Maybe<DnaHormoneGuideline>>>;
  findByUser?: Maybe<DnaHormoneGuideline>;
};


export type DnaHormoneGuidelineQueriesFindAllArgs = {
  generationType?: InputMaybe<GuidelineStatusReportGenerationType>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<DnaHormoneGuidelineSortBy>;
};


export type DnaHormoneGuidelineQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<DnaHormoneGuidelineQueryFilter>;
};

export type DnaHormoneGuidelineQueryFilter = {
  date?: InputMaybe<Scalars['String']['input']>;
  generationType?: InputMaybe<GuidelineStatusReportGenerationType>;
};

export type DnaHormoneGuidelineSortBy = {
  createdAt?: InputMaybe<SortDirection>;
  questionnaireSubmittedAt?: InputMaybe<SortDirection>;
};

export type DnaHormoneGuidelineSymptom = {
  __typename?: 'DnaHormoneGuidelineSymptom';
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  hormoneGuidelineId?: Maybe<Scalars['String']['output']>;
  hormoneGuidelineSymptomDetail?: Maybe<Array<Maybe<DnaHormoneGuidelineSymptomDetail>>>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelineSymptomDetail = {
  __typename?: 'DnaHormoneGuidelineSymptomDetail';
  createdAt?: Maybe<Scalars['Date']['output']>;
  hormoneGuidelineSymptomId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  masterHormoneSymptom?: Maybe<MasterHormoneSymptom>;
  masterSymptomId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaHormoneGuidelineSymptomDetailInput = {
  hormoneGuidelineSymptomId: Scalars['String']['input'];
  masterSymptomId: Scalars['String']['input'];
};

export type DnaHormoneGuidelineSymptomInput = {
  date: Scalars['String']['input'];
  hormoneGuidelineId?: InputMaybe<Scalars['String']['input']>;
  masterSymptomIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaHormoneGuidelineSymptomMutations = {
  __typename?: 'DnaHormoneGuidelineSymptomMutations';
  createOrUpdate?: Maybe<DnaHormoneGuidelineSymptom>;
};


export type DnaHormoneGuidelineSymptomMutationsCreateOrUpdateArgs = {
  request: DnaHormoneGuidelineSymptomInput;
};

export type DnaHormoneGuidelineSymptomQueries = {
  __typename?: 'DnaHormoneGuidelineSymptomQueries';
  findAllByDate?: Maybe<DnaHormoneGuidelineSymptom>;
  findAllMasterData?: Maybe<Array<Maybe<MasterHormoneSymptom>>>;
};


export type DnaHormoneGuidelineSymptomQueriesFindAllByDateArgs = {
  date: Scalars['String']['input'];
};


export type DnaHormoneGuidelineSymptomQueriesFindAllMasterDataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DnaInteractome = {
  __typename?: 'DnaInteractome';
  bReport?: Maybe<BioinformaticReport>;
  bioinformaticReportId?: Maybe<Scalars['String']['output']>;
  dInteractomeArticle?: Maybe<Array<Maybe<InteractomeArticle>>>;
  dInteractomeCard?: Maybe<Array<Maybe<Card>>>;
  dInteractomeComplicationTrait?: Maybe<Array<Maybe<ComplicationTrait>>>;
  dInteractomeCounselor?: Maybe<Array<Maybe<InteractomeCounselor>>>;
  dInteractomeRiskTrait?: Maybe<Array<Maybe<RiskTrait>>>;
  dTrait?: Maybe<DnaTrait>;
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type DnaInteractomeArticleDelete = {
  id: Scalars['String']['input'];
};

export type DnaInteractomeArticleEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaInteractomeArticleForm = {
  articleId?: InputMaybe<Scalars['Int']['input']>;
  dnaInteractomeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DnaInteractomeArticleMutations = {
  __typename?: 'DnaInteractomeArticleMutations';
  changePosition?: Maybe<Array<Maybe<InteractomeArticle>>>;
  createOrUpdate?: Maybe<Array<Maybe<InteractomeArticle>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaInteractomeArticleMutationsChangePositionArgs = {
  forms: Array<InputMaybe<DnaInteractomeArticleEditOrder>>;
};


export type DnaInteractomeArticleMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaInteractomeArticleForm>>;
};


export type DnaInteractomeArticleMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaInteractomeArticleDelete>>;
};

export type DnaInteractomeArticleQueries = {
  __typename?: 'DnaInteractomeArticleQueries';
  findAll?: Maybe<DnaInteractomeArticleQueryResult>;
};


export type DnaInteractomeArticleQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaInteractomeArticleQueryFilter>;
};

export type DnaInteractomeArticleQueryFilter = {
  articleId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dnaInteractomeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type DnaInteractomeArticleQueryResult = {
  __typename?: 'DnaInteractomeArticleQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<InteractomeArticle>>>;
};

export type DnaInteractomeCardDelete = {
  id: Scalars['String']['input'];
};

export type DnaInteractomeCardEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaInteractomeCardForm = {
  dnaInteractomeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  language: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type DnaInteractomeCardMutations = {
  __typename?: 'DnaInteractomeCardMutations';
  changePosition?: Maybe<Array<Maybe<Card>>>;
  createOrUpdate?: Maybe<Array<Maybe<Card>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaInteractomeCardMutationsChangePositionArgs = {
  forms: Array<InputMaybe<DnaInteractomeCardEditOrder>>;
};


export type DnaInteractomeCardMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaInteractomeCardForm>>;
};


export type DnaInteractomeCardMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaInteractomeCardDelete>>;
};

export type DnaInteractomeCardQueries = {
  __typename?: 'DnaInteractomeCardQueries';
  findAll?: Maybe<DnaInteractomeCardQueryResult>;
};


export type DnaInteractomeCardQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaInteractomeCardQueryFilter>;
};

export type DnaInteractomeCardQueryFilter = {
  dnaInteractomeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DnaInteractomeCardQueryResult = {
  __typename?: 'DnaInteractomeCardQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Card>>>;
};

export type DnaInteractomeComplicationTraitDelete = {
  id: Scalars['String']['input'];
};

export type DnaInteractomeComplicationTraitEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaInteractomeComplicationTraitForm = {
  dnaInteractomeId: Scalars['String']['input'];
  dnaTraitId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaInteractomeComplicationTraitMutations = {
  __typename?: 'DnaInteractomeComplicationTraitMutations';
  changePosition?: Maybe<Array<Maybe<ComplicationTrait>>>;
  createOrUpdate?: Maybe<Array<Maybe<ComplicationTrait>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaInteractomeComplicationTraitMutationsChangePositionArgs = {
  forms: Array<InputMaybe<DnaInteractomeComplicationTraitEditOrder>>;
};


export type DnaInteractomeComplicationTraitMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaInteractomeComplicationTraitForm>>;
};


export type DnaInteractomeComplicationTraitMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaInteractomeComplicationTraitDelete>>;
};

export type DnaInteractomeComplicationTraitQueries = {
  __typename?: 'DnaInteractomeComplicationTraitQueries';
  findAll?: Maybe<DnaInteractomeComplicationTraitQueryResult>;
};


export type DnaInteractomeComplicationTraitQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaInteractomeComplicationTraitQueryFilter>;
};

export type DnaInteractomeComplicationTraitQueryFilter = {
  dnaInteractomeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaTraitId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaInteractomeComplicationTraitQueryResult = {
  __typename?: 'DnaInteractomeComplicationTraitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ComplicationTrait>>>;
};

export type DnaInteractomeCounselorDelete = {
  id: Scalars['String']['input'];
};

export type DnaInteractomeCounselorEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaInteractomeCounselorForm = {
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  dnaInteractomeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DnaInteractomeCounselorMutations = {
  __typename?: 'DnaInteractomeCounselorMutations';
  changePosition?: Maybe<Array<Maybe<InteractomeCounselor>>>;
  createOrUpdate?: Maybe<Array<Maybe<InteractomeCounselor>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaInteractomeCounselorMutationsChangePositionArgs = {
  forms: Array<InputMaybe<DnaInteractomeCounselorEditOrder>>;
};


export type DnaInteractomeCounselorMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaInteractomeCounselorForm>>;
};


export type DnaInteractomeCounselorMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaInteractomeCounselorDelete>>;
};

export type DnaInteractomeCounselorQueries = {
  __typename?: 'DnaInteractomeCounselorQueries';
  findAll?: Maybe<DnaInteractomeCounselorQueryResult>;
};


export type DnaInteractomeCounselorQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaInteractomeCounselorQueryFilter>;
};

export type DnaInteractomeCounselorQueryFilter = {
  counselorId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dnaInteractomeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaInteractomeCounselorQueryResult = {
  __typename?: 'DnaInteractomeCounselorQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<InteractomeCounselor>>>;
};

export type DnaInteractomeEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaInteractomeForm = {
  dnaTraitId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  position: Scalars['Int']['input'];
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaInteractomeMutations = {
  __typename?: 'DnaInteractomeMutations';
  Card?: Maybe<DnaInteractomeCardMutations>;
  ComplicationTrait?: Maybe<DnaInteractomeComplicationTraitMutations>;
  InteractomeArticle?: Maybe<DnaInteractomeArticleMutations>;
  InteractomeCounselor?: Maybe<DnaInteractomeCounselorMutations>;
  RiskTrait?: Maybe<DnaInteractomeRiskTraitMutations>;
  changePosition?: Maybe<Array<Maybe<DnaInteractome>>>;
  createOrUpdate?: Maybe<Array<Maybe<DnaInteractome>>>;
};


export type DnaInteractomeMutationsChangePositionArgs = {
  forms: Array<InputMaybe<DnaInteractomeEditOrder>>;
};


export type DnaInteractomeMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaInteractomeForm>>;
};

export type DnaInteractomeQueries = {
  __typename?: 'DnaInteractomeQueries';
  Card?: Maybe<DnaInteractomeCardQueries>;
  ComplicationTrait?: Maybe<DnaInteractomeComplicationTraitQueries>;
  InteractomeArticle?: Maybe<DnaInteractomeArticleQueries>;
  InteractomeCounselor?: Maybe<DnaInteractomeCounselorQueries>;
  RiskTrait?: Maybe<DnaInteractomeRiskTraitQueries>;
  findAll?: Maybe<DnaInteractomeQueryResult>;
  findRelatedByRiskTrait?: Maybe<DnaInteractomeQueryResult>;
};


export type DnaInteractomeQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaInteractomeQueryFilter>;
};


export type DnaInteractomeQueriesFindRelatedByRiskTraitArgs = {
  dnaInteractomeRiskTraitId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaInteractomeQueryFilter = {
  dnaTraitId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaInteractomeQueryResult = {
  __typename?: 'DnaInteractomeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaInteractome>>>;
};

export type DnaInteractomeRiskTraitDelete = {
  id: Scalars['String']['input'];
};

export type DnaInteractomeRiskTraitEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaInteractomeRiskTraitForm = {
  dnaInteractomeId: Scalars['String']['input'];
  dnaTraitId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaInteractomeRiskTraitMutations = {
  __typename?: 'DnaInteractomeRiskTraitMutations';
  changePosition?: Maybe<Array<Maybe<RiskTrait>>>;
  createOrUpdate?: Maybe<Array<Maybe<RiskTrait>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaInteractomeRiskTraitMutationsChangePositionArgs = {
  forms: Array<InputMaybe<DnaInteractomeRiskTraitEditOrder>>;
};


export type DnaInteractomeRiskTraitMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaInteractomeRiskTraitForm>>;
};


export type DnaInteractomeRiskTraitMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaInteractomeRiskTraitDelete>>;
};

export type DnaInteractomeRiskTraitQueries = {
  __typename?: 'DnaInteractomeRiskTraitQueries';
  findAll?: Maybe<DnaInteractomeRiskTraitQueryResult>;
};


export type DnaInteractomeRiskTraitQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaInteractomeRiskTraitQueryFilter>;
};

export type DnaInteractomeRiskTraitQueryFilter = {
  dnaInteractomeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaTraitId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaInteractomeRiskTraitQueryResult = {
  __typename?: 'DnaInteractomeRiskTraitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<RiskTrait>>>;
};

export type DnaNutritionGuideline = {
  __typename?: 'DnaNutritionGuideline';
  allergy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentHealthGoals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currentMedicalConditions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cycleId?: Maybe<Scalars['String']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  exercisePerWeek?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationErrorMessage?: Maybe<Scalars['String']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  goals?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFailGeneration?: Maybe<Scalars['Boolean']['output']>;
  isNourishPlus?: Maybe<Scalars['Boolean']['output']>;
  nGuidelineCalculation?: Maybe<DnaNutritionGuidelineCalculation>;
  nGuidelineGeneticOverview?: Maybe<Array<Maybe<DnaNutritionGuidelineGeneticOverview>>>;
  nGuidelineSummary?: Maybe<Array<Maybe<DnaNutritionGuidelineSummary>>>;
  personalMedicalHistory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  physicalActivityLevel?: Maybe<Scalars['String']['output']>;
  physicalActivityLevelRecommendation?: Maybe<Scalars['String']['output']>;
  previousGeneratedAt?: Maybe<Scalars['Date']['output']>;
  previousWeight?: Maybe<Scalars['Float']['output']>;
  questionnaireSubmittedAt?: Maybe<Scalars['Date']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  targetBestBodyDurationMonths?: Maybe<Scalars['Float']['output']>;
  tipsContent?: Maybe<Scalars['String']['output']>;
  tipsCtaText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightGoal?: Maybe<Scalars['Float']['output']>;
  weightProgress?: Maybe<Scalars['Float']['output']>;
  years?: Maybe<Scalars['Float']['output']>;
};

export enum DnaNutritionGuidelineActionType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type DnaNutritionGuidelineCalculation = {
  __typename?: 'DnaNutritionGuidelineCalculation';
  basalMetabolicRate?: Maybe<Scalars['Float']['output']>;
  bodyMassIndex?: Maybe<Scalars['Float']['output']>;
  bodyMassIndexType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idealCaloricIntakeUnit?: Maybe<Scalars['String']['output']>;
  idealCaloricIntakeValue?: Maybe<Scalars['Float']['output']>;
  macronutrientGramCarbohydrates?: Maybe<Scalars['Float']['output']>;
  macronutrientGramFat?: Maybe<Scalars['Float']['output']>;
  macronutrientGramProtein?: Maybe<Scalars['Float']['output']>;
  macronutrientPercentageCarbohydrates?: Maybe<Scalars['Float']['output']>;
  macronutrientPercentageFat?: Maybe<Scalars['Float']['output']>;
  macronutrientPercentageProtein?: Maybe<Scalars['Float']['output']>;
  nutritionGuidelineId?: Maybe<Scalars['String']['output']>;
  totalEnergyExpenditure?: Maybe<Scalars['Float']['output']>;
  totalPhysicalActivityLevel?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  valueDailyPhysicalActivityLevel?: Maybe<Scalars['Float']['output']>;
  valueExerciseLevelPerWeek?: Maybe<Scalars['Float']['output']>;
};

export type DnaNutritionGuidelineCalculationQueries = {
  __typename?: 'DnaNutritionGuidelineCalculationQueries';
  findByUser?: Maybe<DnaNutritionGuidelineCalculation>;
};

export type DnaNutritionGuidelineEvent = {
  __typename?: 'DnaNutritionGuidelineEvent';
  action?: Maybe<DnaNutritionGuidelineActionType>;
  data?: Maybe<DnaNutritionGuideline>;
};

export type DnaNutritionGuidelineFoodGroup = {
  __typename?: 'DnaNutritionGuidelineFoodGroup';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exampleServingSize?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  nGuidelineFoodGroupTranslation?: Maybe<DnaNutritionGuidelineFoodGroupTranslation>;
  position?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineFoodGroupTranslation = {
  __typename?: 'DnaNutritionGuidelineFoodGroupTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineFoodGroupId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineFoodRestriction = {
  __typename?: 'DnaNutritionGuidelineFoodRestriction';
  createdAt?: Maybe<Scalars['Date']['output']>;
  evidence?: Maybe<Scalars['String']['output']>;
  foodCategory?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nGuidelineFoodRestrictionTranslation?: Maybe<Array<Maybe<DnaNutritionGuidelineFoodRestrictionTranslation>>>;
  nGuidelineFoodRestrictionType?: Maybe<Array<Maybe<DnaNutritionGuidelineFoodRestrictionType>>>;
  nutritionGuidelineId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DnaNutritionGuidelineFoodRestrictionInclude {
  RpxNutritionGuidelineRestrictionTranslation = 'RPX_NUTRITION_GUIDELINE_RESTRICTION_TRANSLATION',
  RpxNutritionGuidelineRestrictionType = 'RPX_NUTRITION_GUIDELINE_RESTRICTION_TYPE'
}

export type DnaNutritionGuidelineFoodRestrictionQueries = {
  __typename?: 'DnaNutritionGuidelineFoodRestrictionQueries';
  findByUser?: Maybe<DnaNutritionGuidelineFoodRestrictionQueryResult>;
};


export type DnaNutritionGuidelineFoodRestrictionQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<DnaNutritionGuidelineFoodRestrictionInclude>>>;
};

export type DnaNutritionGuidelineFoodRestrictionQueryResult = {
  __typename?: 'DnaNutritionGuidelineFoodRestrictionQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaNutritionGuidelineFoodRestriction>>>;
};

export type DnaNutritionGuidelineFoodRestrictionTranslation = {
  __typename?: 'DnaNutritionGuidelineFoodRestrictionTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineFoodRestrictionId?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineFoodRestrictionType = {
  __typename?: 'DnaNutritionGuidelineFoodRestrictionType';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exampleFoods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  foodType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nGuidelineFoodRestrictionTypeTranslation?: Maybe<Array<Maybe<DnaNutritionGuidelineFoodRestrictionTypeTranslation>>>;
  nutritionGuidelineFoodRestrictionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineFoodRestrictionTypeTranslation = {
  __typename?: 'DnaNutritionGuidelineFoodRestrictionTypeTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineFoodRestrictionTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineFoodSource = {
  __typename?: 'DnaNutritionGuidelineFoodSource';
  createdAt?: Maybe<Scalars['Date']['output']>;
  exampleFoods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exampleIndonesianFoods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  nGuidelineFoodGroup?: Maybe<DnaNutritionGuidelineFoodGroup>;
  nutritionGuidelineFoodGroupId?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  valueServingSize?: Maybe<Scalars['Float']['output']>;
};

export enum DnaNutritionGuidelineFoodSourceInclude {
  RpxNutritionGuidelineFoodGroup = 'RPX_NUTRITION_GUIDELINE_FOOD_GROUP'
}

export type DnaNutritionGuidelineFoodSourceQueries = {
  __typename?: 'DnaNutritionGuidelineFoodSourceQueries';
  findByUser?: Maybe<DnaNutritionGuidelineFoodSourceQueryResult>;
};


export type DnaNutritionGuidelineFoodSourceQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<DnaNutritionGuidelineFoodSourceInclude>>>;
};

export type DnaNutritionGuidelineFoodSourceQueryResult = {
  __typename?: 'DnaNutritionGuidelineFoodSourceQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaNutritionGuidelineFoodSource>>>;
};

export type DnaNutritionGuidelineGeneticOverview = {
  __typename?: 'DnaNutritionGuidelineGeneticOverview';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nGuidelineGeneticOverviewTranslation?: Maybe<Array<Maybe<DnaNutritionGuidelineGeneticOverviewTranslation>>>;
  nutritionGuidelineId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineGeneticOverviewTranslation = {
  __typename?: 'DnaNutritionGuidelineGeneticOverviewTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineGeneticOverviewId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DnaNutritionGuidelineInclude {
  RpxNutritionGuidelineGeneticOverview = 'RPX_NUTRITION_GUIDELINE_GENETIC_OVERVIEW',
  RpxNutritionGuidelineSummary = 'RPX_NUTRITION_GUIDELINE_SUMMARY'
}

export type DnaNutritionGuidelineMealPlan = {
  __typename?: 'DnaNutritionGuidelineMealPlan';
  createdAt?: Maybe<Scalars['Date']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mealType?: Maybe<Scalars['String']['output']>;
  nGuidelineMealPlanItem?: Maybe<Array<Maybe<DnaNutritionGuidelineMealPlanItem>>>;
  nGuidelineMealPlanRecommendation?: Maybe<Array<Maybe<DnaNutritionGuidelineMealPlanRecommendation>>>;
  nutritionGuidelineId?: Maybe<Scalars['String']['output']>;
  timeRecommendation?: Maybe<Scalars['String']['output']>;
  totalCalories?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DnaNutritionGuidelineMealPlanInclude {
  RpxNutritionGuidelineMealPlanItem = 'RPX_NUTRITION_GUIDELINE_MEAL_PLAN_ITEM',
  RpxNutritionGuidelineMealPlanRecommendation = 'RPX_NUTRITION_GUIDELINE_MEAL_PLAN_RECOMMENDATION'
}

export type DnaNutritionGuidelineMealPlanItem = {
  __typename?: 'DnaNutritionGuidelineMealPlanItem';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineMealPlanId?: Maybe<Scalars['String']['output']>;
  nutritionType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineMealPlanQueries = {
  __typename?: 'DnaNutritionGuidelineMealPlanQueries';
  findByUser?: Maybe<DnaNutritionGuidelineMealPlanQueryResult>;
};


export type DnaNutritionGuidelineMealPlanQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<DnaNutritionGuidelineMealPlanInclude>>>;
};

export type DnaNutritionGuidelineMealPlanQueryResult = {
  __typename?: 'DnaNutritionGuidelineMealPlanQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaNutritionGuidelineMealPlan>>>;
};

export type DnaNutritionGuidelineMealPlanRecommendation = {
  __typename?: 'DnaNutritionGuidelineMealPlanRecommendation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  menuRecommendationNote?: Maybe<Scalars['String']['output']>;
  menuRecommendationTitle?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineMealPlanId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  totalCalories?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineMutations = {
  __typename?: 'DnaNutritionGuidelineMutations';
  Summary?: Maybe<DnaNutritionGuidelineSummaryMutations>;
};

export type DnaNutritionGuidelineQueries = {
  __typename?: 'DnaNutritionGuidelineQueries';
  Calculation?: Maybe<DnaNutritionGuidelineCalculationQueries>;
  FoodRestriction?: Maybe<DnaNutritionGuidelineFoodRestrictionQueries>;
  FoodSource?: Maybe<DnaNutritionGuidelineFoodSourceQueries>;
  MealPlan?: Maybe<DnaNutritionGuidelineMealPlanQueries>;
  Summary?: Maybe<DnaNutritionGuidelineSummaryQueries>;
  featuredProducts?: Maybe<Array<Maybe<PurchaseProduct>>>;
  findByUser?: Maybe<DnaNutritionGuideline>;
};


export type DnaNutritionGuidelineQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<DnaNutritionGuidelineInclude>>>;
};

export type DnaNutritionGuidelineSummary = {
  __typename?: 'DnaNutritionGuidelineSummary';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  nutritionGuidelineId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaNutritionGuidelineSummaryForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  nutritionGuidelineId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DnaNutritionGuidelineSummaryMutations = {
  __typename?: 'DnaNutritionGuidelineSummaryMutations';
  update?: Maybe<DnaNutritionGuidelineSummary>;
};


export type DnaNutritionGuidelineSummaryMutationsUpdateArgs = {
  form: DnaNutritionGuidelineSummaryForm;
  id: Scalars['String']['input'];
};

export type DnaNutritionGuidelineSummaryQueries = {
  __typename?: 'DnaNutritionGuidelineSummaryQueries';
  findByUser?: Maybe<DnaNutritionGuidelineSummaryQueryResult>;
};

export type DnaNutritionGuidelineSummaryQueryResult = {
  __typename?: 'DnaNutritionGuidelineSummaryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaNutritionGuidelineSummary>>>;
};

export type DnaPanel = {
  __typename?: 'DnaPanel';
  code?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dCategory?: Maybe<Array<Maybe<DnaCategory>>>;
  dPanelFigure?: Maybe<Array<Maybe<DnaPanelFigure>>>;
  dPanelTranslation?: Maybe<Array<Maybe<DnaPanelTranslation>>>;
  description?: Maybe<Scalars['String']['output']>;
  favourableDescription?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unfavourableDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPanelEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaPanelFigure = {
  __typename?: 'DnaPanelFigure';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dPanel?: Maybe<DnaPanel>;
  dPanelFigurePin?: Maybe<Array<Maybe<DnaPanelFigurePin>>>;
  dnaPanelId?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type DnaPanelFigureForm = {
  dnaPanelId: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaPanelFigureMutations = {
  __typename?: 'DnaPanelFigureMutations';
  DnaPanelFigurePin?: Maybe<DnaPanelFigurePinMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaPanelFigure>>>;
};


export type DnaPanelFigureMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaPanelFigureForm>>;
};

export type DnaPanelFigurePin = {
  __typename?: 'DnaPanelFigurePin';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dPanelFigure?: Maybe<DnaPanelFigure>;
  dPanelPinCategory?: Maybe<Array<Maybe<DnaPanelPinFigureCategory>>>;
  dnaPanelFigureId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPanelFigurePinDelete = {
  id: Scalars['String']['input'];
};

export type DnaPanelFigurePinForm = {
  dnaPanelFigureId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['String']['input'];
  long: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type DnaPanelFigurePinMutations = {
  __typename?: 'DnaPanelFigurePinMutations';
  DnaPanelPinFigureCategory?: Maybe<DnaPanelPinFigureCategoryMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaPanelFigurePin>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaPanelFigurePinMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaPanelFigurePinForm>>;
};


export type DnaPanelFigurePinMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaPanelFigurePinDelete>>;
};

export type DnaPanelFigurePinQueries = {
  __typename?: 'DnaPanelFigurePinQueries';
  DnaPanelPinFigureCategory?: Maybe<DnaPanelPinFigureCategoryQueries>;
  findAll?: Maybe<DnaPanelFigurePinQueryResult>;
};


export type DnaPanelFigurePinQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelFigurePinQueryFilter>;
};

export type DnaPanelFigurePinQueryFilter = {
  dnaPanelFigureId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaPanelFigurePinQueryResult = {
  __typename?: 'DnaPanelFigurePinQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPanelFigurePin>>>;
};

export type DnaPanelFigureQueries = {
  __typename?: 'DnaPanelFigureQueries';
  DnaPanelFigurePin?: Maybe<DnaPanelFigurePinQueries>;
  findAll?: Maybe<DnaPanelFigureQueryResult>;
};


export type DnaPanelFigureQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelFigureQueryFilter>;
};

export type DnaPanelFigureQueryFilter = {
  dnaPanelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPanelFigureQueryResult = {
  __typename?: 'DnaPanelFigureQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPanelFigure>>>;
};

export type DnaPanelForm = {
  dPanelTranslation?: InputMaybe<Array<InputMaybe<DnaPanelTranslationForm>>>;
  description: Scalars['String']['input'];
  favourableDescription: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  unfavourableDescription: Scalars['String']['input'];
};

export type DnaPanelMutations = {
  __typename?: 'DnaPanelMutations';
  DnaPanelFigure?: Maybe<DnaPanelFigureMutations>;
  DnaPanelTranslation?: Maybe<DnaPanelTranslationMutations>;
  changePosition?: Maybe<Array<Maybe<DnaPanel>>>;
  createOrUpdate?: Maybe<Array<Maybe<DnaPanel>>>;
  exportExcel360?: Maybe<Scalars['Boolean']['output']>;
  exportExcelNutrigenetic?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaPanelMutationsChangePositionArgs = {
  forms: Array<InputMaybe<DnaPanelEditOrder>>;
};


export type DnaPanelMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaPanelForm>>;
};


export type DnaPanelMutationsExportExcel360Args = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelQueryFilter>;
};


export type DnaPanelMutationsExportExcelNutrigeneticArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelQueryFilter>;
};

export type DnaPanelPinFigureCategory = {
  __typename?: 'DnaPanelPinFigureCategory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dCategory?: Maybe<DnaCategory>;
  dPanelFigurePin?: Maybe<DnaPanelFigurePin>;
  dnaCategoryId?: Maybe<Scalars['Int']['output']>;
  dnaPanelFigurePinId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPanelPinFigureCategoryDelete = {
  id: Scalars['String']['input'];
};

export type DnaPanelPinFigureCategoryForm = {
  dnaCategoryId: Scalars['Int']['input'];
  dnaPanelFigurePinId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
};

export type DnaPanelPinFigureCategoryMutations = {
  __typename?: 'DnaPanelPinFigureCategoryMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaPanelPinFigureCategory>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaPanelPinFigureCategoryMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaPanelPinFigureCategoryForm>>;
};


export type DnaPanelPinFigureCategoryMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaPanelPinFigureCategoryDelete>>;
};

export type DnaPanelPinFigureCategoryQueries = {
  __typename?: 'DnaPanelPinFigureCategoryQueries';
  findAll?: Maybe<DnaPanelPinFigureCategoryQueryResult>;
};


export type DnaPanelPinFigureCategoryQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelPinFigureCategoryQueryFilter>;
};

export type DnaPanelPinFigureCategoryQueryFilter = {
  dnaCategoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dnaPanelFigurePinId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type DnaPanelPinFigureCategoryQueryResult = {
  __typename?: 'DnaPanelPinFigureCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPanelPinFigureCategory>>>;
};

export type DnaPanelQueries = {
  __typename?: 'DnaPanelQueries';
  DnaPanelFigure?: Maybe<DnaPanelFigureQueries>;
  DnaPanelTranslation?: Maybe<DnaPanelTranslationQueries>;
  findAll?: Maybe<DnaPanelQueryResult>;
};


export type DnaPanelQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelQueryFilter>;
};

export type DnaPanelQueryFilter = {
  code?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isRelatedToMapper?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPanelQueryResult = {
  __typename?: 'DnaPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPanel>>>;
};

export type DnaPanelTranslation = {
  __typename?: 'DnaPanelTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dPanel?: Maybe<Array<Maybe<DnaPanel>>>;
  description?: Maybe<Scalars['String']['output']>;
  dnaPanelId?: Maybe<Scalars['String']['output']>;
  favourableDescription?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unfavourableDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPanelTranslationEditOrder = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type DnaPanelTranslationForm = {
  description: Scalars['String']['input'];
  dnaPanelId?: InputMaybe<Scalars['String']['input']>;
  favourableDescription: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  unfavourableDescription: Scalars['String']['input'];
};

export type DnaPanelTranslationMutations = {
  __typename?: 'DnaPanelTranslationMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaPanelTranslation>>>;
};


export type DnaPanelTranslationMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaPanelTranslationForm>>;
};

export type DnaPanelTranslationQueries = {
  __typename?: 'DnaPanelTranslationQueries';
  findAll?: Maybe<DnaPanelTranslationQueryResult>;
};


export type DnaPanelTranslationQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelTranslationQueryFilter>;
};

export type DnaPanelTranslationQueryFilter = {
  dnaPanelId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type DnaPanelTranslationQueryResult = {
  __typename?: 'DnaPanelTranslationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPanelTranslation>>>;
};

export type DnaPanelWithReport = {
  __typename?: 'DnaPanelWithReport';
  code?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  favourableDescription?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<BioinformaticReport>>>;
  unfavourableDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPanelWithReportQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
};

export type DnaPanelWithReportQueryResult = {
  __typename?: 'DnaPanelWithReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPanelWithReport>>>;
};

export type DnaPdf = {
  __typename?: 'DnaPdf';
  createdAt?: Maybe<Scalars['Date']['output']>;
  files?: Maybe<Array<Maybe<DnaPdfFiles>>>;
  id?: Maybe<Scalars['String']['output']>;
  latestGeneratedAt?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserProfile>;
};

export type DnaPdfFiles = {
  __typename?: 'DnaPdfFiles';
  generatedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  protected?: Maybe<Scalars['Boolean']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DnaPdfQueries = {
  __typename?: 'DnaPdfQueries';
  findAll?: Maybe<DnaPdfQueryResult>;
};


export type DnaPdfQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPdfQueryFilter>;
};

export type DnaPdfQueryFilter = {
  allowToRelease?: InputMaybe<Scalars['Boolean']['input']>;
  generatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  haveAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  haveProtectedAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPdfQueryResult = {
  __typename?: 'DnaPdfQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPdf>>>;
};

export type DnaPersonalityGuideline = {
  __typename?: 'DnaPersonalityGuideline';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastGeneratedAt?: Maybe<Scalars['Date']['output']>;
  pGuidelineCareerPath?: Maybe<Array<Maybe<DnaPersonalityGuidelineCareerPath>>>;
  pGuidelineRelationship?: Maybe<DnaPersonalityGuidelineRelationshipCompatibility>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineCareerPath = {
  __typename?: 'DnaPersonalityGuidelineCareerPath';
  createdAt?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  jobField?: Maybe<Scalars['String']['output']>;
  pGuidelineCareerPathTranslation?: Maybe<Array<Maybe<DnaPersonalityGuidelineCareerPathTranslation>>>;
  personalityGuidelineId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineCareerPathQueries = {
  __typename?: 'DnaPersonalityGuidelineCareerPathQueries';
  findByUser?: Maybe<DnaPersonalityGuidelineCareerPathQueryResult>;
};


export type DnaPersonalityGuidelineCareerPathQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPersonalityGuidelineCareerPathQueryResult = {
  __typename?: 'DnaPersonalityGuidelineCareerPathQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPersonalityGuidelineCareerPath>>>;
};

export type DnaPersonalityGuidelineCareerPathTranslation = {
  __typename?: 'DnaPersonalityGuidelineCareerPathTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  jobField?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  personalityGuidelineCareerPathId?: Maybe<Scalars['String']['output']>;
  personalityGuidelineId?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineQueries = {
  __typename?: 'DnaPersonalityGuidelineQueries';
  CareerPath?: Maybe<DnaPersonalityGuidelineCareerPathQueries>;
  RelationshipCompatibility?: Maybe<DnaPersonalityGuidelineRelationshipCompatibilityQueries>;
  findByUser?: Maybe<DnaPersonalityGuideline>;
};


export type DnaPersonalityGuidelineQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPersonalityGuidelineRelationshipCompatibility = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibility';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pGuidelineRelationshipInsight?: Maybe<Array<Maybe<DnaPersonalityGuidelineRelationshipCompatibilityInsight>>>;
  pGuidelineRelationshipScore?: Maybe<Array<Maybe<DnaPersonalityGuidelineRelationshipCompatibilityScore>>>;
  pGuidelineRelationshipTranslation?: Maybe<Array<Maybe<DnaPersonalityGuidelineRelationshipCompatibilityTranslation>>>;
  personalityGuidelineId?: Maybe<Scalars['String']['output']>;
  topPersonality?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityInsight = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  pGuidelineRelationshipInsightDetail?: Maybe<Array<Maybe<DnaPersonalityGuidelineRelationshipCompatibilityInsightDetail>>>;
  pGuidelineRelationshipInsightTranslation?: Maybe<Array<Maybe<DnaPersonalityGuidelineRelationshipCompatibilityInsightTranslation>>>;
  personalityGuidelineRelationshipId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityInsightDetail = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityInsightDetail';
  createdAt?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  pGuidelineRelationshipInsightDetailTranslation?: Maybe<Array<Maybe<DnaPersonalityGuidelineRelationshipCompatibilityInsightDetailTranslation>>>;
  personalityGuidelineRelationshipInsightId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityInsightDetailTranslation = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityInsightDetailTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  personalityGuidelineRelationshipInsighDetailtId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityInsightTranslation = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  personalityGuidelineId?: Maybe<Scalars['String']['output']>;
  personalityGuidelineRelationshipInsightId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityQueries = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityQueries';
  findByUser?: Maybe<DnaPersonalityGuidelineRelationshipCompatibility>;
};


export type DnaPersonalityGuidelineRelationshipCompatibilityQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityScore = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityScore';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  pGuidelineRelationshipScoreTranslation?: Maybe<Array<Maybe<DnaPersonalityGuidelineRelationshipCompatibilityScoreTranslation>>>;
  personalityGuidelineRelationshipId?: Maybe<Scalars['String']['output']>;
  personalityName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityScoreTranslation = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityScoreTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  personalityGuidelineId?: Maybe<Scalars['String']['output']>;
  personalityGuidelineRelationshipScoreId?: Maybe<Scalars['String']['output']>;
  personalityName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalityGuidelineRelationshipCompatibilityTranslation = {
  __typename?: 'DnaPersonalityGuidelineRelationshipCompatibilityTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  personalityGuidelineId?: Maybe<Scalars['String']['output']>;
  personalityGuidelineRelationshipId?: Maybe<Scalars['String']['output']>;
  topPersonality?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalizedReport = {
  __typename?: 'DnaPersonalizedReport';
  blankPage?: Maybe<Array<Maybe<DnaPersonalizedReportBlankPage>>>;
  category?: Maybe<Array<Maybe<DnaPersonalizedReportCategory>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  footerDescription?: Maybe<Scalars['String']['output']>;
  generationType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  isCustomized?: Maybe<Scalars['Boolean']['output']>;
  isPageNumberRemoved?: Maybe<Scalars['Boolean']['output']>;
  isReportPrinted?: Maybe<Scalars['Boolean']['output']>;
  logoPointer?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Array<Maybe<DnaPersonalizedReportPage>>>;
  partnershipId?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalizedReportBlankPage = {
  __typename?: 'DnaPersonalizedReportBlankPage';
  blankPage?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  personalizedReportId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalizedReportBlankPageDelete = {
  id: Scalars['String']['input'];
};

export type DnaPersonalizedReportBlankPageForm = {
  blankPage?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['String']['input'];
  personalizedReportId: Scalars['String']['input'];
};

export type DnaPersonalizedReportBlankPageMutations = {
  __typename?: 'DnaPersonalizedReportBlankPageMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaPersonalizedReportBlankPage>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaPersonalizedReportBlankPageMutationsCreateOrUpdateArgs = {
  forms?: InputMaybe<Array<InputMaybe<DnaPersonalizedReportBlankPageForm>>>;
};


export type DnaPersonalizedReportBlankPageMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaPersonalizedReportBlankPageDelete>>;
};

export type DnaPersonalizedReportBlankPageQueries = {
  __typename?: 'DnaPersonalizedReportBlankPageQueries';
  findAll?: Maybe<DnaPersonalizedReportBlankPageQueryResult>;
};


export type DnaPersonalizedReportBlankPageQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPersonalizedReportBlankPageQueryFilter>;
};

export type DnaPersonalizedReportBlankPageQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedReportId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPersonalizedReportBlankPageQueryResult = {
  __typename?: 'DnaPersonalizedReportBlankPageQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPersonalizedReportBlankPage>>>;
};

export type DnaPersonalizedReportCategory = {
  __typename?: 'DnaPersonalizedReportCategory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaCategoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  personalizedReportId?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalizedReportCategoryDelete = {
  id: Scalars['String']['input'];
};

export type DnaPersonalizedReportCategoryForm = {
  dnaCategoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedReportId?: InputMaybe<Scalars['String']['input']>;
  pointer?: InputMaybe<Scalars['String']['input']>;
};

export type DnaPersonalizedReportCategoryMutations = {
  __typename?: 'DnaPersonalizedReportCategoryMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaPersonalizedReportCategory>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaPersonalizedReportCategoryMutationsCreateOrUpdateArgs = {
  forms?: InputMaybe<Array<InputMaybe<DnaPersonalizedReportCategoryForm>>>;
};


export type DnaPersonalizedReportCategoryMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaPersonalizedReportCategoryDelete>>;
};

export type DnaPersonalizedReportCategoryQueries = {
  __typename?: 'DnaPersonalizedReportCategoryQueries';
  findAll?: Maybe<DnaPersonalizedReportCategoryQueryResult>;
};


export type DnaPersonalizedReportCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPersonalizedReportCategoryQueryFilter>;
};

export type DnaPersonalizedReportCategoryQueryFilter = {
  dnaCategoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedReportId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPersonalizedReportCategoryQueryResult = {
  __typename?: 'DnaPersonalizedReportCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPersonalizedReportCategory>>>;
};

export type DnaPersonalizedReportDelete = {
  id: Scalars['String']['input'];
};

export type DnaPersonalizedReportForm = {
  customName?: InputMaybe<Scalars['String']['input']>;
  footerDescription?: InputMaybe<Scalars['String']['input']>;
  generationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  isPageNumberRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isReportPrinted?: InputMaybe<Scalars['Boolean']['input']>;
  logoPointer?: InputMaybe<Scalars['String']['input']>;
  partnershipId: Scalars['String']['input'];
  reportType: Scalars['String']['input'];
};

export type DnaPersonalizedReportMutations = {
  __typename?: 'DnaPersonalizedReportMutations';
  BlankPage?: Maybe<DnaPersonalizedReportBlankPageMutations>;
  Category?: Maybe<DnaPersonalizedReportCategoryMutations>;
  Page?: Maybe<DnaPersonalizedReportPageMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaPersonalizedReport>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaPersonalizedReportMutationsCreateOrUpdateArgs = {
  forms?: InputMaybe<Array<InputMaybe<DnaPersonalizedReportForm>>>;
};


export type DnaPersonalizedReportMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaPersonalizedReportDelete>>;
};

export type DnaPersonalizedReportPage = {
  __typename?: 'DnaPersonalizedReportPage';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  personalizedReportId?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaPersonalizedReportPageDelete = {
  id: Scalars['String']['input'];
};

export type DnaPersonalizedReportPageForm = {
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['String']['input'];
  personalizedReportId: Scalars['String']['input'];
  pointer?: InputMaybe<Scalars['String']['input']>;
};

export type DnaPersonalizedReportPageMutations = {
  __typename?: 'DnaPersonalizedReportPageMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaPersonalizedReportPage>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaPersonalizedReportPageMutationsCreateOrUpdateArgs = {
  forms?: InputMaybe<Array<InputMaybe<DnaPersonalizedReportPageForm>>>;
};


export type DnaPersonalizedReportPageMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaPersonalizedReportPageDelete>>;
};

export type DnaPersonalizedReportPageQueries = {
  __typename?: 'DnaPersonalizedReportPageQueries';
  findAll?: Maybe<DnaPersonalizedReportPageQueryResult>;
};


export type DnaPersonalizedReportPageQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPersonalizedReportPageQueryFilter>;
};

export type DnaPersonalizedReportPageQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedReportId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPersonalizedReportPageQueryResult = {
  __typename?: 'DnaPersonalizedReportPageQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPersonalizedReportPage>>>;
};

export type DnaPersonalizedReportQueries = {
  __typename?: 'DnaPersonalizedReportQueries';
  BlankPage?: Maybe<DnaPersonalizedReportBlankPageQueries>;
  Category?: Maybe<DnaPersonalizedReportCategoryQueries>;
  Page?: Maybe<DnaPersonalizedReportPageQueries>;
  findAll?: Maybe<DnaPersonalizedReportQueryResult>;
};


export type DnaPersonalizedReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPersonalizedReportQueryFilter>;
};

export type DnaPersonalizedReportQueryFilter = {
  partnershipId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaPersonalizedReportQueryResult = {
  __typename?: 'DnaPersonalizedReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaPersonalizedReport>>>;
};

export type DnaProdigyGuideline = {
  __typename?: 'DnaProdigyGuideline';
  achievedMilestone?: Maybe<Array<Maybe<ProdigyMilestoneItem>>>;
  allowRegenerateAt?: Maybe<Scalars['Date']['output']>;
  childCondition?: Maybe<Scalars['String']['output']>;
  childDifficulty?: Maybe<Scalars['String']['output']>;
  childExpectation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  extracurricularActivities?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  generationStatus?: Maybe<TrainingReadinessGenerationStatus>;
  generationTimeoutAt?: Maybe<Scalars['Date']['output']>;
  generationType?: Maybe<GenerationType>;
  growthProfile?: Maybe<Array<Maybe<ProdigyGrowthProfile>>>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastWeekActivityOpinion?: Maybe<Scalars['String']['output']>;
  milestone?: Maybe<Array<Maybe<ProdigyMilestone>>>;
  milestoneCount?: Maybe<Scalars['Int']['output']>;
  milestoneMissed?: Maybe<Scalars['Int']['output']>;
  missedMilestone?: Maybe<Array<Maybe<ProdigyMilestoneItem>>>;
  mostRecordedTopics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nextMonthTopics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  proGuidelineCgadActivity?: Maybe<Array<Maybe<DnaProdigyGuidelineCgadActivity>>>;
  proGuidelineChildInsight?: Maybe<Array<Maybe<DnaProdigyGuidelineChildInsight>>>;
  proGuidelineParentingApproach?: Maybe<Array<Maybe<DnaProdigyGuidelineParentingApproach>>>;
  questionnaireSubmittedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weeklyActivity?: Maybe<Array<Maybe<ProdigyWeeklyActivity>>>;
  weeklyActivityCount?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export enum DnaProdigyGuidelineActionType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type DnaProdigyGuidelineCgadActivity = {
  __typename?: 'DnaProdigyGuidelineCgadActivity';
  createdAt?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  proGuidelineCgadActivityTranslation?: Maybe<Array<Maybe<DnaProdigyGuidelineCgadActivityTranslation>>>;
  prodigyGuidelineId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineCgadActivityTranslation = {
  __typename?: 'DnaProdigyGuidelineCgadActivityTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prodigyGuidelineCgadActivityId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineChildInsight = {
  __typename?: 'DnaProdigyGuidelineChildInsight';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  proGuidelineChildInsightTranslation?: Maybe<Array<Maybe<DnaProdigyGuidelineChildInsightTranslation>>>;
  prodigyGuidelineId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineChildInsightTranslation = {
  __typename?: 'DnaProdigyGuidelineChildInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  prodigyGuidelineChildInsightId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineEvent = {
  __typename?: 'DnaProdigyGuidelineEvent';
  action?: Maybe<DnaProdigyGuidelineActionType>;
  data?: Maybe<DnaProdigyGuideline>;
};

export type DnaProdigyGuidelineMutations = {
  __typename?: 'DnaProdigyGuidelineMutations';
  Milestone?: Maybe<ProdigyMilestoneMutations>;
  WeeklyActivity?: Maybe<ProdigyWeeklyActivityMutations>;
};

export type DnaProdigyGuidelineParentingApproach = {
  __typename?: 'DnaProdigyGuidelineParentingApproach';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  proGuidelineParentingApproachInsight?: Maybe<Array<Maybe<DnaProdigyGuidelineParentingApproachInsight>>>;
  proGuidelineParentingApproachTranslation?: Maybe<Array<Maybe<DnaProdigyGuidelineParentingApproachTranslation>>>;
  prodigyGuidelineId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineParentingApproachInsight = {
  __typename?: 'DnaProdigyGuidelineParentingApproachInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  proGuidelineParentingApproachInsightTranslation?: Maybe<Array<Maybe<DnaProdigyGuidelineParentingApproachInsightTranslation>>>;
  prodigyGuidelineParentingApproachId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineParentingApproachInsightTranslation = {
  __typename?: 'DnaProdigyGuidelineParentingApproachInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  prodigyGuidelineParentingApproachInsightId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineParentingApproachQueries = {
  __typename?: 'DnaProdigyGuidelineParentingApproachQueries';
  findByUser?: Maybe<DnaProdigyGuidelineParentingApproachQueryResult>;
};


export type DnaProdigyGuidelineParentingApproachQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaProdigyGuidelineParentingApproachQueryResult = {
  __typename?: 'DnaProdigyGuidelineParentingApproachQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaProdigyGuidelineParentingApproach>>>;
};

export type DnaProdigyGuidelineParentingApproachTranslation = {
  __typename?: 'DnaProdigyGuidelineParentingApproachTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  prodigyGuidelineParentingApproachId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaProdigyGuidelineQueries = {
  __typename?: 'DnaProdigyGuidelineQueries';
  GrowthProfile?: Maybe<ProdigyGrowthProfileQueries>;
  Milestone?: Maybe<ProdigyMilestoneQueries>;
  ParentingApproach?: Maybe<DnaProdigyGuidelineParentingApproachQueries>;
  WeeklyActivity?: Maybe<ProdigyWeeklyActivityQueries>;
  findAllMilestone?: Maybe<Array<Maybe<DnaProdigyGuideline>>>;
  findByUser?: Maybe<DnaProdigyGuideline>;
};


export type DnaProdigyGuidelineQueriesFindAllMilestoneArgs = {
  generationType?: InputMaybe<GuidelineStatusReportGenerationType>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<DnaProdigyGuidelineSortBy>;
};


export type DnaProdigyGuidelineQueriesFindByUserArgs = {
  generationType?: InputMaybe<GuidelineStatusReportGenerationType>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaProdigyGuidelineSortBy = {
  questionnaireSubmittedAt?: InputMaybe<SortDirection>;
};

export type DnaReportFigureFilter = {
  profileId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<PurchaseProductType>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaReportType = {
  __typename?: 'DnaReportType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  figure?: Maybe<ReportTypeFigure>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDNA?: Maybe<Scalars['Boolean']['output']>;
  isHaveGuidelineReport?: Maybe<Scalars['Boolean']['output']>;
  kitRelated?: Maybe<KitRelated>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  reportHasReleased?: Maybe<Scalars['Boolean']['output']>;
  reportTypeSetting?: Maybe<Array<Maybe<DnaReportTypeSetting>>>;
  unlockProductId?: Maybe<Scalars['String']['output']>;
  unlockPurchaseStatus?: Maybe<UnlockPurchaseStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userHasActivated?: Maybe<Scalars['Boolean']['output']>;
  vendorBioItIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DnaReportTypeMutations = {
  __typename?: 'DnaReportTypeMutations';
  ReportTypeFigure?: Maybe<ReportTypeFigureMutations>;
};

export type DnaReportTypeQueries = {
  __typename?: 'DnaReportTypeQueries';
  ReportTypeFigure?: Maybe<ReportTypeFigureQueries>;
  findAll?: Maybe<DnaReportTypeQueryResult>;
};


export type DnaReportTypeQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaReportTypeQuerySortBy>;
  where?: InputMaybe<DnaReportTypeQueryFilter>;
};

export type DnaReportTypeQueryFilter = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDNA?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withCount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DnaReportTypeQueryResult = {
  __typename?: 'DnaReportTypeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaReportType>>>;
};

export type DnaReportTypeQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type DnaReportTypeSetting = {
  __typename?: 'DnaReportTypeSetting';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  val?: Maybe<Scalars['String']['output']>;
};

export type DnaReportTypeSortBy = {
  bioinformaticPanel?: InputMaybe<SortDirection>;
  bioinformaticTrait?: InputMaybe<SortDirection>;
  dnaCategory?: InputMaybe<SortDirection>;
  dnaPanel?: InputMaybe<SortDirection>;
  dnaScoreType?: InputMaybe<SortDirection>;
  dnaSubCategory?: InputMaybe<SortDirection>;
  dnaTrait?: InputMaybe<SortDirection>;
  sex?: InputMaybe<SortDirection>;
};

export type DnaReportTypeSubMenu = {
  __typename?: 'DnaReportTypeSubMenu';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaReportUser = {
  __typename?: 'DnaReportUser';
  category?: Maybe<DnaCategory>;
  customFilter?: Maybe<Array<Maybe<DnaReportUserCustomFilter>>>;
  dnaCategory?: Maybe<DnaCategory>;
  dnaPanel?: Maybe<DnaPanel>;
  dnaScoreType?: Maybe<DnaScoreType>;
  dnaScoreTypeGuideline?: Maybe<DnaScoreTypeGuideline>;
  dnaSubCategory?: Maybe<DnaSubCategory>;
  dnaTrait?: Maybe<DnaTrait>;
  genes?: Maybe<Array<Maybe<DnaGene>>>;
  genotypes?: Maybe<Array<Maybe<DnaReportUserGenoType>>>;
  id?: Maybe<Scalars['String']['output']>;
  isHigherBetter?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageCode>;
  mappedScore?: Maybe<Scalars['Int']['output']>;
  panel?: Maybe<DnaPanel>;
  response?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Array<Maybe<DnaReportUserResponse>>>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sourceVendorBioIt?: Maybe<VendorBioIt>;
  sourceVendorBioItId?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<DnaTrait>;
  traitLogo?: Maybe<Scalars['String']['output']>;
  traitScore?: Maybe<DnaScore>;
  user?: Maybe<DnaUser>;
  vendorBioIt?: Maybe<VendorBioIt>;
  vendorBioItId?: Maybe<Scalars['String']['output']>;
};

export type DnaReportUserByCategory = {
  __typename?: 'DnaReportUserByCategory';
  average?: Maybe<Scalars['Float']['output']>;
  dnaCategory?: Maybe<DnaCategory>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<DnaReportUser>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type DnaReportUserByCategoryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<PurchaseProductType>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  sourceVendorBioItId?: InputMaybe<Scalars['String']['input']>;
  vendorBioItId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaReportUserByCategoryQueryResult = {
  __typename?: 'DnaReportUserByCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaReportUserByCategory>>>;
};

export type DnaReportUserByCategorySortBy = {
  average?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type DnaReportUserByPanel = {
  __typename?: 'DnaReportUserByPanel';
  average?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<DnaReportUser>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type DnaReportUserByPanelFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<PurchaseProductType>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaReportUserByPanelQueryResult = {
  __typename?: 'DnaReportUserByPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaReportUserByPanel>>>;
};

export type DnaReportUserByPanelSortBy = {
  average?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type DnaReportUserCustomFilter = {
  __typename?: 'DnaReportUserCustomFilter';
  label?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type DnaReportUserFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaCategories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dnaPanels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaScoreTypeGuidelines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaSubCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  panels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profile?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<PurchaseProductType>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sourceVendorBioItId?: InputMaybe<Scalars['String']['input']>;
  traits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorBioItId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaReportUserGenoType = {
  __typename?: 'DnaReportUserGenoType';
  gene?: Maybe<DnaGene>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DnaReportUserQueries = {
  __typename?: 'DnaReportUserQueries';
  findAll?: Maybe<DnaReportUserQueryResult>;
  findByCategory?: Maybe<DnaReportUserByCategoryQueryResult>;
  findByPanel?: Maybe<DnaReportUserByPanelQueryResult>;
  findFigure?: Maybe<DnaReportType>;
  findOne?: Maybe<DnaReportUser>;
};


export type DnaReportUserQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaReportUserQuerySortBy>;
  where?: InputMaybe<DnaReportUserFilter>;
};


export type DnaReportUserQueriesFindByCategoryArgs = {
  sort?: InputMaybe<DnaReportUserByCategorySortBy>;
  where?: InputMaybe<DnaReportUserByCategoryFilter>;
};


export type DnaReportUserQueriesFindByPanelArgs = {
  sort?: InputMaybe<DnaReportUserByPanelSortBy>;
  where?: InputMaybe<DnaReportUserByPanelFilter>;
};


export type DnaReportUserQueriesFindFigureArgs = {
  where?: InputMaybe<DnaReportFigureFilter>;
};


export type DnaReportUserQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<PurchaseProductType>;
};

export type DnaReportUserQueryResult = {
  __typename?: 'DnaReportUserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaReportUser>>>;
};

export type DnaReportUserQuerySortBy = {
  favourable?: InputMaybe<SortDirection>;
  subCategoryAndTrait?: InputMaybe<SortDirection>;
};

export type DnaReportUserResponse = {
  __typename?: 'DnaReportUserResponse';
  language?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type DnaScore = {
  __typename?: 'DnaScore';
  donts?: Maybe<Scalars['String']['output']>;
  dos?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interpretation?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  shortInterpretation?: Maybe<Scalars['String']['output']>;
  symptoms?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type DnaScoreQueries = {
  __typename?: 'DnaScoreQueries';
  findAll?: Maybe<DnaScoreQueryResult>;
  findOne?: Maybe<DnaScore>;
};


export type DnaScoreQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type DnaScoreQueryResult = {
  __typename?: 'DnaScoreQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaScore>>>;
};

export type DnaScoreType = {
  __typename?: 'DnaScoreType';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dScoreTypeGuideline?: Maybe<Array<Maybe<DnaScoreTypeGuideline>>>;
  id?: Maybe<Scalars['String']['output']>;
  isHigherBetter?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  responseCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaScoreTypeForm = {
  id?: InputMaybe<Scalars['String']['input']>;
  isHigherBetter: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  responseCount: Scalars['Int']['input'];
};

export type DnaScoreTypeGuideline = {
  __typename?: 'DnaScoreTypeGuideline';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dScoreType?: Maybe<DnaScoreType>;
  dScoreTypeGuidelineResponse?: Maybe<Array<Maybe<DnaScoreTypeGuidelineResponse>>>;
  dnaScoreTypeId?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mappedScore?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  responseId?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaScoreTypeGuidelineForm = {
  dnaScoreTypeId: Scalars['String']['input'];
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mappedScore: Scalars['Int']['input'];
  response: Scalars['String']['input'];
  responseId?: InputMaybe<Scalars['String']['input']>;
  riskLevel: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type DnaScoreTypeGuidelineMutations = {
  __typename?: 'DnaScoreTypeGuidelineMutations';
  DnaScoreTypeGuidelineResponse?: Maybe<DnaScoreTypeGuidelineResponseMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaScoreTypeGuideline>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaScoreTypeGuidelineMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaScoreTypeGuidelineForm>>;
};


export type DnaScoreTypeGuidelineMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaScoreTypeGuidelinenDelete>>;
};

export type DnaScoreTypeGuidelineQueries = {
  __typename?: 'DnaScoreTypeGuidelineQueries';
  DnaScoreTypeGuidelineResponse?: Maybe<DnaScoreTypeGuidelineResponseQueries>;
  findAll?: Maybe<DnaScoreTypeGuidelineQueryResult>;
};


export type DnaScoreTypeGuidelineQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaScoreTypeGuidelineQueryFilter>;
};

export type DnaScoreTypeGuidelineQueryFilter = {
  dnaScoreTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type DnaScoreTypeGuidelineQueryResult = {
  __typename?: 'DnaScoreTypeGuidelineQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaScoreTypeGuideline>>>;
};

export type DnaScoreTypeGuidelineResponse = {
  __typename?: 'DnaScoreTypeGuidelineResponse';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dScoreTypeGuideline?: Maybe<DnaScoreTypeGuideline>;
  dnaScoreTypeGuidelineId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  parameterBar?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaScoreTypeGuidelineResponseForm = {
  dnaScoreTypeGuidelineId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  parameterBar: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export type DnaScoreTypeGuidelineResponseMutations = {
  __typename?: 'DnaScoreTypeGuidelineResponseMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaScoreTypeGuidelineResponse>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaScoreTypeGuidelineResponseMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaScoreTypeGuidelineResponseForm>>;
};


export type DnaScoreTypeGuidelineResponseMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaScoreTypeGuidelineResponsenDelete>>;
};

export type DnaScoreTypeGuidelineResponseQueries = {
  __typename?: 'DnaScoreTypeGuidelineResponseQueries';
  findAll?: Maybe<DnaScoreTypeGuidelineResponseQueryResult>;
};


export type DnaScoreTypeGuidelineResponseQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaScoreTypeGuidelineResponseQueryFilter>;
};

export type DnaScoreTypeGuidelineResponseQueryFilter = {
  dnaScoreTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaScoreTypeGuidelineResponseQueryResult = {
  __typename?: 'DnaScoreTypeGuidelineResponseQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaScoreTypeGuidelineResponse>>>;
};

export type DnaScoreTypeGuidelineResponsenDelete = {
  id: Scalars['String']['input'];
};

export type DnaScoreTypeGuidelinenDelete = {
  id: Scalars['String']['input'];
};

export type DnaScoreTypeMutations = {
  __typename?: 'DnaScoreTypeMutations';
  DnaScoreTypeGuideline?: Maybe<DnaScoreTypeGuidelineMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaScoreType>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaScoreTypeMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaScoreTypeForm>>;
};


export type DnaScoreTypeMutationsDeleteArgs = {
  forms: Array<InputMaybe<DnaScoreTypenDelete>>;
};

export type DnaScoreTypeQueries = {
  __typename?: 'DnaScoreTypeQueries';
  DnaScoreTypeGuideline?: Maybe<DnaScoreTypeGuidelineQueries>;
  findAll?: Maybe<DnaScoreTypeQueryResult>;
};


export type DnaScoreTypeQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaScoreTypeQueryFilter>;
};

export type DnaScoreTypeQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHigherBetter?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  responseCount?: InputMaybe<Scalars['Int']['input']>;
};

export type DnaScoreTypeQueryResult = {
  __typename?: 'DnaScoreTypeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaScoreType>>>;
};

export type DnaScoreTypenDelete = {
  id: Scalars['String']['input'];
};

export enum DnaSkinFaceAnalyzeActionType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type DnaSkinFaceAnalyzeProcess = {
  __typename?: 'DnaSkinFaceAnalyzeProcess';
  createdAt?: Maybe<Scalars['Date']['output']>;
  failGenerationReason?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  generationTimeoutAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFailGeneration?: Maybe<Scalars['Boolean']['output']>;
  skinFaceScanProcess?: Maybe<DnaSkinFaceScanProcess>;
  skinFaceScanProcessId?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['Date']['output']>;
  summaryHighlight?: Maybe<Array<Maybe<FaceBluePrintSummaryHighlight>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinFaceAnalyzeProcessEvent = {
  __typename?: 'DnaSkinFaceAnalyzeProcessEvent';
  action?: Maybe<DnaSkinFaceScanActionType>;
  data?: Maybe<DnaSkinFaceAnalyzeProcess>;
};

export type DnaSkinFaceAnalyzeProcessMutations = {
  __typename?: 'DnaSkinFaceAnalyzeProcessMutations';
  attempt?: Maybe<Scalars['Boolean']['output']>;
  submit?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaSkinFaceAnalyzeProcessMutationsAttemptArgs = {
  skinFaceScanProcessId: Scalars['String']['input'];
};


export type DnaSkinFaceAnalyzeProcessMutationsSubmitArgs = {
  id: Scalars['String']['input'];
};

export type DnaSkinFaceAnalyzeProcessQueries = {
  __typename?: 'DnaSkinFaceAnalyzeProcessQueries';
  checkEligibilitySkinFaceScanAndAnalyze?: Maybe<DnaSkinFaceEligibilityResult>;
  findLatestByUser?: Maybe<DnaSkinFaceAnalyzeProcess>;
};

export type DnaSkinFaceEligibilityResult = {
  __typename?: 'DnaSkinFaceEligibilityResult';
  latestDataSkinFaceAnalyzeProcess?: Maybe<DnaSkinFaceAnalyzeProcess>;
  latestDataSkinFaceScanProcess?: Maybe<DnaSkinFaceScanProcess>;
  status?: Maybe<StatusEligibilitySkinFaceType>;
};

export enum DnaSkinFaceScanActionType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type DnaSkinFaceScanProcess = {
  __typename?: 'DnaSkinFaceScanProcess';
  createdAt?: Maybe<Scalars['Date']['output']>;
  failGenerationReason?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  generationTimeoutAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFailGeneration?: Maybe<Scalars['Boolean']['output']>;
  kitcode?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  scanAttempt?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinFaceScanProcessEvent = {
  __typename?: 'DnaSkinFaceScanProcessEvent';
  action?: Maybe<DnaSkinFaceScanActionType>;
  data?: Maybe<DnaSkinFaceScanProcess>;
};

export type DnaSkinFaceScanProcessMutations = {
  __typename?: 'DnaSkinFaceScanProcessMutations';
  attempt?: Maybe<Scalars['Boolean']['output']>;
  attemptByPointer?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaSkinFaceScanProcessMutationsAttemptArgs = {
  faceImage: Scalars['Upload']['input'];
};


export type DnaSkinFaceScanProcessMutationsAttemptByPointerArgs = {
  pointer: Scalars['String']['input'];
};

export type DnaSkinGuideline = {
  __typename?: 'DnaSkinGuideline';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  facePointer?: Maybe<Scalars['String']['output']>;
  generationEndAt?: Maybe<Scalars['Date']['output']>;
  generationStartAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isLatest?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  skinFaceAnalyzeProcessId?: Maybe<Scalars['String']['output']>;
  skinGuidelineAllergySensitivity?: Maybe<Array<Maybe<DnaSkinGuidelineAllergySensitivity>>>;
  skinGuidelineFaceBlueprint?: Maybe<Array<Maybe<DnaSkinGuidelineFaceBlueprint>>>;
  skinGuidelineInsight?: Maybe<Array<Maybe<DnaSkinGuidelineInsight>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineAllergySensitivity = {
  __typename?: 'DnaSkinGuidelineAllergySensitivity';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  iconTrait?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  skinGuidelineAllergySensitivityInsight?: Maybe<Array<Maybe<DnaSkinGuidelineAllergySensitivityInsight>>>;
  skinGuidelineAllergySensitivityTranslation?: Maybe<Array<Maybe<DnaSkinGuidelineAllergySensitivityTranslation>>>;
  skinGuidelineId?: Maybe<Scalars['String']['output']>;
  summaryInsight?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineAllergySensitivityInsight = {
  __typename?: 'DnaSkinGuidelineAllergySensitivityInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  skinGuidelineAllergySensitivityId?: Maybe<Scalars['String']['output']>;
  skinGuidelineAllergySensitivityInsightTranslation?: Maybe<Array<Maybe<DnaSkinGuidelineAllergySensitivityInsightTranslation>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DnaSkinGuidelineAllergySensitivityInsightType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineAllergySensitivityInsightTranslation = {
  __typename?: 'DnaSkinGuidelineAllergySensitivityInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  skinGuidelineAllergySensitivityInsightId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DnaSkinGuidelineAllergySensitivityInsightType {
  ImpactToSkin = 'IMPACT_TO_SKIN',
  ThingsToAvoid = 'THINGS_TO_AVOID'
}

export type DnaSkinGuidelineAllergySensitivityQueries = {
  __typename?: 'DnaSkinGuidelineAllergySensitivityQueries';
  findByUser?: Maybe<DnaSkinGuidelineAllergySensitivityQueryResult>;
};


export type DnaSkinGuidelineAllergySensitivityQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaSkinGuidelineAllergySensitivityQueryResult = {
  __typename?: 'DnaSkinGuidelineAllergySensitivityQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaSkinGuidelineAllergySensitivity>>>;
};

export type DnaSkinGuidelineAllergySensitivityTranslation = {
  __typename?: 'DnaSkinGuidelineAllergySensitivityTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  skinGuidelineAllergySensitivityId?: Maybe<Scalars['String']['output']>;
  summaryInsight?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineFaceBlueprint = {
  __typename?: 'DnaSkinGuidelineFaceBlueprint';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  faceHighlightPointer?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  scoreStatus?: Maybe<DnaSkinScoreSkinStatus>;
  skinCharacteristic?: Maybe<Scalars['String']['output']>;
  skinGuidelineFaceBlueprintInsight?: Maybe<Array<Maybe<DnaSkinGuidelineFaceBlueprintInsight>>>;
  skinGuidelineFaceBlueprintTranslation?: Maybe<Array<Maybe<DnaSkinGuidelineFaceBlueprintTranslation>>>;
  skinGuidelineId?: Maybe<Scalars['String']['output']>;
  skinType?: Maybe<Scalars['String']['output']>;
  summaryInsight?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineFaceBlueprintInsight = {
  __typename?: 'DnaSkinGuidelineFaceBlueprintInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  skinGuidelineFaceBlueprintInsightId?: Maybe<Scalars['String']['output']>;
  skinGuidelineFaceBlueprintInsightTranslation?: Maybe<Array<Maybe<DnaSkinGuidelineFaceBlueprintInsightTranslation>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DnaSkinGuidelineFaceBlueprintInsightType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineFaceBlueprintInsightTranslation = {
  __typename?: 'DnaSkinGuidelineFaceBlueprintInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  skinGuidelineFaceBlueprintInsightId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DnaSkinGuidelineFaceBlueprintInsightType {
  ActionPlan = 'ACTION_PLAN',
  Avoidance = 'AVOIDANCE',
  Suggestion = 'SUGGESTION'
}

export type DnaSkinGuidelineFaceBlueprintQueries = {
  __typename?: 'DnaSkinGuidelineFaceBlueprintQueries';
  findByUser?: Maybe<DnaSkinGuidelineFaceBlueprintQueryResult>;
};


export type DnaSkinGuidelineFaceBlueprintQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaSkinGuidelineFaceBlueprintQueryResult = {
  __typename?: 'DnaSkinGuidelineFaceBlueprintQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaSkinGuidelineFaceBlueprint>>>;
};

export type DnaSkinGuidelineFaceBlueprintTranslation = {
  __typename?: 'DnaSkinGuidelineFaceBlueprintTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  skinCharacteristic?: Maybe<Scalars['String']['output']>;
  skinGuidelineFaceBlueprintId?: Maybe<Scalars['String']['output']>;
  skinType?: Maybe<Scalars['String']['output']>;
  summaryInsight?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineInsight = {
  __typename?: 'DnaSkinGuidelineInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  iconTrait?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  skinGuidelineId?: Maybe<Scalars['String']['output']>;
  skinGuidelineInsightDetail?: Maybe<Array<Maybe<DnaSkinGuidelineInsightDetail>>>;
  skinGuidelineInsightTranslation?: Maybe<Array<Maybe<DnaSkinGuidelineInsightTranslation>>>;
  summaryInsight?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineInsightDetail = {
  __typename?: 'DnaSkinGuidelineInsightDetail';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  skinGuidelineInsightId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DnaSkinGuidelineInsightDetailType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineInsightDetailTranslation = {
  __typename?: 'DnaSkinGuidelineInsightDetailTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insight?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  skinGuidelineInsightDetailId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DnaSkinGuidelineInsightDetailType {
  MitigationPlan = 'MITIGATION_PLAN',
  PotentialTrigger = 'POTENTIAL_TRIGGER'
}

export type DnaSkinGuidelineInsightQueries = {
  __typename?: 'DnaSkinGuidelineInsightQueries';
  findByUser?: Maybe<DnaSkinGuidelineInsightQueryResult>;
};


export type DnaSkinGuidelineInsightQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaSkinGuidelineInsightQueryResult = {
  __typename?: 'DnaSkinGuidelineInsightQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaSkinGuidelineInsight>>>;
};

export type DnaSkinGuidelineInsightTranslation = {
  __typename?: 'DnaSkinGuidelineInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  skinGuidelineInsightId?: Maybe<Scalars['String']['output']>;
  summaryInsight?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSkinGuidelineQueries = {
  __typename?: 'DnaSkinGuidelineQueries';
  AllergySensitivity?: Maybe<DnaSkinGuidelineAllergySensitivityQueries>;
  FaceBlueprint?: Maybe<DnaSkinGuidelineFaceBlueprintQueries>;
  Insight?: Maybe<DnaSkinGuidelineInsightQueries>;
  findByUser?: Maybe<DnaSkinGuideline>;
};


export type DnaSkinGuidelineQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaSkinMutations = {
  __typename?: 'DnaSkinMutations';
  FaceAnalyze?: Maybe<DnaSkinFaceAnalyzeProcessMutations>;
  FaceScan?: Maybe<DnaSkinFaceScanProcessMutations>;
};

export type DnaSkinQueries = {
  __typename?: 'DnaSkinQueries';
  FaceAnalyze?: Maybe<DnaSkinFaceAnalyzeProcessQueries>;
  Guideline?: Maybe<DnaSkinGuidelineQueries>;
};

export enum DnaSkinScoreSkinStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  None = 'NONE'
}

export type DnaSportGuideline = {
  __typename?: 'DnaSportGuideline';
  allowRegenerateAt?: Maybe<Scalars['Date']['output']>;
  availableExerciseTimePerSession?: Maybe<Scalars['String']['output']>;
  avoidedExercise?: Maybe<Scalars['String']['output']>;
  bodyMassIndex?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentCondition?: Maybe<Scalars['String']['output']>;
  dnaReportId?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  endGenerationAt?: Maybe<Scalars['Date']['output']>;
  exerciseGoal?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exerciseLevel?: Maybe<Scalars['String']['output']>;
  fitnessGoals?: Maybe<Scalars['String']['output']>;
  generationStatus?: Maybe<Scalars['String']['output']>;
  generationType?: Maybe<GenerationType>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  injuryHistory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isGeneralExerciseRelevant?: Maybe<Scalars['Boolean']['output']>;
  isMyExerciseRelevant?: Maybe<Scalars['Boolean']['output']>;
  medicalHistory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  physicalActivityLevel?: Maybe<Scalars['String']['output']>;
  preferedExercise?: Maybe<Scalars['String']['output']>;
  preferedRecovery?: Maybe<Scalars['String']['output']>;
  questionnaireSubmittedAt?: Maybe<Scalars['Date']['output']>;
  recommendedMETPerWeek?: Maybe<Scalars['Float']['output']>;
  sGuidelineExercise?: Maybe<Array<Maybe<DnaSportGuidelineExercise>>>;
  sGuidelineSummary?: Maybe<Array<Maybe<DnaSportGuidelineSummary>>>;
  startGenerationAt?: Maybe<Scalars['Date']['output']>;
  trainingPlan?: Maybe<TrainingPlan>;
  trainingReadiness?: Maybe<TrainingReadiness>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type DnaSportGuidelineExercise = {
  __typename?: 'DnaSportGuidelineExercise';
  createdAt?: Maybe<Scalars['Date']['output']>;
  exerciseDescription?: Maybe<Scalars['String']['output']>;
  exerciseDescriptionId?: Maybe<Scalars['String']['output']>;
  exerciseIcon?: Maybe<Scalars['String']['output']>;
  exerciseMETValue?: Maybe<Scalars['Float']['output']>;
  exerciseName?: Maybe<Scalars['String']['output']>;
  exerciseNameId?: Maybe<Scalars['String']['output']>;
  exerciseType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isGeneralEquivalent?: Maybe<Scalars['Boolean']['output']>;
  sGuidelineExerciseInsight?: Maybe<Array<Maybe<DnaSportGuidelineExerciseInsight>>>;
  sportGuidelineId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSportGuidelineExerciseInsight = {
  __typename?: 'DnaSportGuidelineExerciseInsight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  sGuidelineExerciseInsightTranslation?: Maybe<Array<Maybe<DnaSportGuidelineExerciseInsightTranslation>>>;
  sportGuidelineExerciseId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSportGuidelineExerciseInsightTranslation = {
  __typename?: 'DnaSportGuidelineExerciseInsightTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  sportGuidelineExerciseInsightId?: Maybe<Scalars['String']['output']>;
  sportGuidelineId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSportGuidelineExerciseQueries = {
  __typename?: 'DnaSportGuidelineExerciseQueries';
  findByUser?: Maybe<Array<Maybe<DnaSportGuidelineExercise>>>;
};


export type DnaSportGuidelineExerciseQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<DnaSportGuidelineQueryFilter>;
};

export enum DnaSportGuidelineExerciseStatusType {
  High = 'HIGH',
  Light = 'LIGHT',
  Moderate = 'MODERATE'
}

export enum DnaSportGuidelineExerciseType {
  General = 'GENERAL',
  LessAdvices = 'LESS_ADVICES',
  Recommended = 'RECOMMENDED'
}

export type DnaSportGuidelineMutations = {
  __typename?: 'DnaSportGuidelineMutations';
  TrainingPlan?: Maybe<TrainingPlanMutations>;
  TrainingReadiness?: Maybe<TrainingReadinessMutations>;
  updateIsRelevant?: Maybe<DnaSportGuideline>;
};


export type DnaSportGuidelineMutationsUpdateIsRelevantArgs = {
  form: DnaSportGuidelineRelevantForm;
};

export type DnaSportGuidelineQueries = {
  __typename?: 'DnaSportGuidelineQueries';
  Exercise?: Maybe<DnaSportGuidelineExerciseQueries>;
  TrainingPlan?: Maybe<TrainingPlanQueries>;
  TrainingReadiness?: Maybe<TrainingReadinessQueries>;
  findByUser?: Maybe<DnaSportGuideline>;
};


export type DnaSportGuidelineQueriesFindByUserArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaSportGuidelineQueryFilter = {
  exerciseType?: InputMaybe<Array<InputMaybe<DnaSportGuidelineExerciseStatusType>>>;
  type?: InputMaybe<Array<InputMaybe<DnaSportGuidelineExerciseType>>>;
};

export type DnaSportGuidelineRelevantForm = {
  id?: InputMaybe<Scalars['String']['input']>;
  isGeneralExerciseRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  isMyExerciseRelevant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DnaSportGuidelineSummary = {
  __typename?: 'DnaSportGuidelineSummary';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  sGuidelineSummaryTranslation?: Maybe<Array<Maybe<DnaSportGuidelineSummaryTranslation>>>;
  sportGuidelineId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSportGuidelineSummaryTranslation = {
  __typename?: 'DnaSportGuidelineSummaryTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  sportGuidelineId?: Maybe<Scalars['String']['output']>;
  sportGuidelineSummaryId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSubCategory = {
  __typename?: 'DnaSubCategory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dCategory?: Maybe<DnaCategory>;
  dSubCategoryTranslation?: Maybe<Array<Maybe<DnaSubCategoryTranslation>>>;
  dTrait?: Maybe<Array<Maybe<DnaTrait>>>;
  dnaCategoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSubCategoryForm = {
  dSubCategoryTranslation?: InputMaybe<Array<InputMaybe<DnaSubCategoryTranslationForm>>>;
  dnaCategoryId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type DnaSubCategoryMutations = {
  __typename?: 'DnaSubCategoryMutations';
  DnaSubCategoryTranslation?: Maybe<DnaSubCategoryTranslationMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaSubCategory>>>;
  exportExcel360?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaSubCategoryMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaSubCategoryForm>>;
};


export type DnaSubCategoryMutationsExportExcel360Args = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortObject?: InputMaybe<DnaSubCategoryQuerySortBy>;
  where?: InputMaybe<DnaSubCategoryQueryFilter>;
};

export type DnaSubCategoryQueries = {
  __typename?: 'DnaSubCategoryQueries';
  DnaSubCategoryTranslation?: Maybe<DnaSubCategoryTranslationQueries>;
  findAll?: Maybe<DnaSubCategoryQueryResult>;
};


export type DnaSubCategoryQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortObject?: InputMaybe<DnaSubCategoryQuerySortBy>;
  where?: InputMaybe<DnaSubCategoryQueryFilter>;
};

export type DnaSubCategoryQueryFilter = {
  dnaCategoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dnaPanelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaSubCategoryQueryResult = {
  __typename?: 'DnaSubCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaSubCategory>>>;
};

export type DnaSubCategoryQuerySortBy = {
  categoryName?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  panelName?: InputMaybe<SortDirection>;
};

export type DnaSubCategoryTranslation = {
  __typename?: 'DnaSubCategoryTranslation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dSubCategory?: Maybe<DnaSubCategory>;
  dnaSubCategoryId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DnaSubCategoryTranslationForm = {
  dnaSubCategoryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DnaSubCategoryTranslationMutations = {
  __typename?: 'DnaSubCategoryTranslationMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaSubCategoryTranslation>>>;
};


export type DnaSubCategoryTranslationMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaSubCategoryTranslationForm>>;
};

export type DnaSubCategoryTranslationQueries = {
  __typename?: 'DnaSubCategoryTranslationQueries';
  findAll?: Maybe<DnaSubCategoryTranslationQueryResult>;
};


export type DnaSubCategoryTranslationQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaSubCategoryTranslationQueryFilter>;
};

export type DnaSubCategoryTranslationQueryFilter = {
  dnaSubCategoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type DnaSubCategoryTranslationQueryResult = {
  __typename?: 'DnaSubCategoryTranslationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaSubCategoryTranslation>>>;
};

export type DnaTrait = {
  __typename?: 'DnaTrait';
  category?: Maybe<DnaCategory>;
  causes?: Maybe<Scalars['String']['output']>;
  contentManagementStatus?: Maybe<Scalars['String']['output']>;
  dScoreType?: Maybe<DnaScoreType>;
  dSubCategory?: Maybe<DnaSubCategory>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Array<Maybe<DnaTraitDetail>>>;
  dnaSubCategoryId?: Maybe<Scalars['String']['output']>;
  funFact?: Maybe<Scalars['String']['output']>;
  guidelineType?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  symptom?: Maybe<Scalars['String']['output']>;
  tips?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<DnaTraitTranslation>;
  uspStatus?: Maybe<Scalars['String']['output']>;
  whenToSeeDoctor?: Maybe<Scalars['String']['output']>;
};

export type DnaTraitDetail = {
  __typename?: 'DnaTraitDetail';
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<Maybe<DnaTraitDetailContent>>>;
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  translation?: Maybe<Array<Maybe<DnaTraitDetailTranslation>>>;
  type?: Maybe<DnaTraitDetailType>;
};

export type DnaTraitDetailContent = {
  __typename?: 'DnaTraitDetailContent';
  key?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DnaTraitDetailContentForm = {
  key?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DnaTraitDetailContentInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DnaTraitDetailForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Array<InputMaybe<DnaTraitDetailContentForm>>>;
  dnaTraitId?: InputMaybe<Scalars['Int']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  translation?: InputMaybe<Array<InputMaybe<DnaTraitDetailTranslationForm>>>;
  type?: InputMaybe<DnaTraitDetailType>;
};

export type DnaTraitDetailMutations = {
  __typename?: 'DnaTraitDetailMutations';
  createOrUpdate?: Maybe<Array<Maybe<DnaTraitDetail>>>;
  export?: Maybe<Scalars['Boolean']['output']>;
  import?: Maybe<Scalars['Boolean']['output']>;
};


export type DnaTraitDetailMutationsCreateOrUpdateArgs = {
  forms?: InputMaybe<Array<InputMaybe<DnaTraitDetailForm>>>;
};


export type DnaTraitDetailMutationsExportArgs = {
  ownedByAsaren?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  reportType: Scalars['String']['input'];
};


export type DnaTraitDetailMutationsImportArgs = {
  file: Scalars['Upload']['input'];
  ownedByAsaren?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  reportType: Scalars['String']['input'];
};

export type DnaTraitDetailQueries = {
  __typename?: 'DnaTraitDetailQueries';
  findAll?: Maybe<DnaTraitDetailQueryResult>;
};


export type DnaTraitDetailQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaTraitDetailSortBy>;
  where?: InputMaybe<DnaTraitDetailQueryFilter>;
};

export type DnaTraitDetailQueryResult = {
  __typename?: 'DnaTraitDetailQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaTraitDetail>>>;
};

export type DnaTraitDetailSortBy = {
  code?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type DnaTraitDetailTranslation = {
  __typename?: 'DnaTraitDetailTranslation';
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<Maybe<DnaTraitDetailContent>>>;
  dnaTraitDetailId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  langCode?: Maybe<Scalars['String']['output']>;
};

export type DnaTraitDetailTranslationForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Array<InputMaybe<DnaTraitDetailContentForm>>>;
  dnaTraitDetailId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  langCode?: InputMaybe<Scalars['String']['input']>;
};

export enum DnaTraitDetailType {
  EarlyScreening = 'EARLY_SCREENING',
  PreventiveCare = 'PREVENTIVE_CARE',
  Reference = 'REFERENCE'
}

export type DnaTraitForm = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dnaSubCategoryId?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<DnaTraitTranslationForm>;
  whenToSeeDoctor?: InputMaybe<Scalars['String']['input']>;
};

export type DnaTraitMutations = {
  __typename?: 'DnaTraitMutations';
  DnaTraitDetail?: Maybe<DnaTraitDetailMutations>;
  DnaTraitScore?: Maybe<DnaTraitScoreMutations>;
  createOrUpdate?: Maybe<Array<Maybe<DnaTrait>>>;
  export?: Maybe<Scalars['String']['output']>;
  exportExcel360?: Maybe<Scalars['Boolean']['output']>;
  exportExcelNutrigenetic?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<DnaTrait>;
};


export type DnaTraitMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<DnaTraitForm>>;
};


export type DnaTraitMutationsExportArgs = {
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
};


export type DnaTraitMutationsExportExcel360Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaTraitSortBy>;
  where?: InputMaybe<DnaTraitQueryFilter>;
};


export type DnaTraitMutationsExportExcelNutrigeneticArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaTraitSortBy>;
  where?: InputMaybe<DnaTraitQueryFilter>;
};


export type DnaTraitMutationsUpdateArgs = {
  form: DnaTraitForm;
  id: Scalars['Int']['input'];
};

export type DnaTraitQueries = {
  __typename?: 'DnaTraitQueries';
  DnaTraitDetail?: Maybe<DnaTraitDetailQueries>;
  DnaTraitScore?: Maybe<DnaTraitScoreQueries>;
  findAll?: Maybe<DnaTraitQueryResult>;
  findOne?: Maybe<DnaTrait>;
};


export type DnaTraitQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DnaTraitSortBy>;
  where?: InputMaybe<DnaTraitQueryFilter>;
};


export type DnaTraitQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type DnaTraitQueryResult = {
  __typename?: 'DnaTraitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaTrait>>>;
};

export type DnaTraitScore = {
  __typename?: 'DnaTraitScore';
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  donts?: Maybe<Scalars['String']['output']>;
  dos?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interpretation?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  shortInterpretation?: Maybe<Scalars['String']['output']>;
  symptoms?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
  translation?: Maybe<Array<Maybe<DnaTraitScoreTranslation>>>;
};

export type DnaTraitScoreForm = {
  dnaTraitId?: InputMaybe<Scalars['Int']['input']>;
  donts?: InputMaybe<Scalars['String']['input']>;
  dos?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  shortInterpretation?: InputMaybe<Scalars['String']['input']>;
  symptoms?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
  translation?: InputMaybe<DnaTraitScoreTranslationForm>;
};

export type DnaTraitScoreMutations = {
  __typename?: 'DnaTraitScoreMutations';
  DnaTraitScoreTranslation?: Maybe<DnaTraitScoreTranslationMutations>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type DnaTraitScoreQueries = {
  __typename?: 'DnaTraitScoreQueries';
  DnaTraitScoreTranslation?: Maybe<DnaTraitScoreTranslationQueries>;
  findAll?: Maybe<Scalars['Boolean']['output']>;
};

export type DnaTraitScoreTranslation = {
  __typename?: 'DnaTraitScoreTranslation';
  dnaTraitScoreId?: Maybe<Scalars['String']['output']>;
  donts?: Maybe<Scalars['String']['output']>;
  dos?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interpretation?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  shortInterpretation?: Maybe<Scalars['String']['output']>;
  symptoms?: Maybe<Scalars['String']['output']>;
};

export type DnaTraitScoreTranslationForm = {
  dnaTraitScoreId?: InputMaybe<Scalars['String']['input']>;
  donts?: InputMaybe<Scalars['String']['input']>;
  dos?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  shortInterpretation?: InputMaybe<Scalars['String']['input']>;
  symptoms?: InputMaybe<Scalars['String']['input']>;
};

export type DnaTraitScoreTranslationMutations = {
  __typename?: 'DnaTraitScoreTranslationMutations';
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type DnaTraitScoreTranslationQueries = {
  __typename?: 'DnaTraitScoreTranslationQueries';
  findAll?: Maybe<Scalars['Boolean']['output']>;
};

export type DnaTraitSortBy = {
  contentManagementStatus?: InputMaybe<SortDirection>;
  dnaScoreType?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  uspStatus?: InputMaybe<SortDirection>;
};

export type DnaTraitTranslation = {
  __typename?: 'DnaTraitTranslation';
  description?: Maybe<Scalars['String']['output']>;
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  langCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  symptom?: Maybe<Scalars['String']['output']>;
  whenToSeeDoctor?: Maybe<Scalars['String']['output']>;
};

export type DnaTraitTranslationForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  langCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  whenToSeeDoctor?: InputMaybe<Scalars['String']['input']>;
};

export type DnaUser = {
  __typename?: 'DnaUser';
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  vendorBioItIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DnaUserFilter = {
  profiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DnaUserQueries = {
  __typename?: 'DnaUserQueries';
  findAll?: Maybe<DnaUserQueryResult>;
  findOne?: Maybe<DnaUser>;
};


export type DnaUserQueriesFindAllArgs = {
  where?: InputMaybe<DnaUserFilter>;
};

export type DnaUserQueryResult = {
  __typename?: 'DnaUserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DnaUser>>>;
};

export enum EhrAndMcuType {
  EhrLab = 'EHR_LAB',
  Mcu = 'MCU'
}

export type EhrLab = {
  __typename?: 'EHRLab';
  attachments?: Maybe<Array<Maybe<EhrLabAttachment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ehrLabPatient?: Maybe<EhrLabPatient>;
  ehrOrder?: Maybe<EhrOrder>;
  id?: Maybe<Scalars['String']['output']>;
  laboratorium?: Maybe<Scalars['String']['output']>;
  ocr?: Maybe<EhrLabOcr>;
  ownerProfile?: Maybe<UserProfile>;
  ownerProfileId?: Maybe<Scalars['String']['output']>;
  resultName?: Maybe<Scalars['String']['output']>;
  resultType?: Maybe<EhrLabResultType>;
  resultTypeId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<EhrLabSource>;
  takenAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type EhrLabAndMcu = {
  __typename?: 'EHRLabAndMCU';
  ehr?: Maybe<EhrLab>;
  id?: Maybe<Scalars['String']['output']>;
  mcu?: Maybe<Mcu>;
  type?: Maybe<EhrAndMcuType>;
};

export type EhrLabAndMcuQueryResult = {
  __typename?: 'EHRLabAndMCUQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EhrLabAndMcu>>>;
};

export type EhrLabAndMcuQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  takenAt?: InputMaybe<SortDirection>;
};

export type EhrLabAttachment = {
  __typename?: 'EHRLabAttachment';
  ehrLabId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<OcrProcessResult>>>;
  takenAt?: Maybe<Scalars['String']['output']>;
};

export type EhrLabAttachmentForm = {
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
};

export type EhrLabAttachmentFormCreateOrEdit = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  ehrLabId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};

export type EhrLabAttachmentMutations = {
  __typename?: 'EHRLabAttachmentMutations';
  createOrEdit?: Maybe<EhrLabAttachment>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  syncResultExistingMCU?: Maybe<Scalars['Boolean']['output']>;
};


export type EhrLabAttachmentMutationsCreateOrEditArgs = {
  form?: InputMaybe<EhrLabAttachmentFormCreateOrEdit>;
};


export type EhrLabAttachmentMutationsDeleteArgs = {
  id: Array<InputMaybe<Scalars['String']['input']>>;
};


export type EhrLabAttachmentMutationsSyncResultExistingMcuArgs = {
  form?: InputMaybe<EhrLabAttachmentSyncResultForm>;
};

export type EhrLabAttachmentOcrProcess = {
  __typename?: 'EHRLabAttachmentOcrProcess';
  data?: Maybe<Array<Maybe<OcrMeasurement>>>;
  deviceId?: Maybe<Scalars['String']['output']>;
  ehrLabAttachmentId?: Maybe<Scalars['String']['output']>;
  ehrLabId?: Maybe<Scalars['String']['output']>;
  ownerProfileId?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EhrLabAttachmentQueries = {
  __typename?: 'EHRLabAttachmentQueries';
  findAllWithOcr?: Maybe<EhrLabAttachmentQueryResult>;
  findOneAttachment?: Maybe<EhrLabAttachment>;
};


export type EhrLabAttachmentQueriesFindAllWithOcrArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type EhrLabAttachmentQueriesFindOneAttachmentArgs = {
  id: Scalars['String']['input'];
};

export type EhrLabAttachmentQueryResult = {
  __typename?: 'EHRLabAttachmentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EhrLabAttachment>>>;
};

export type EhrLabAttachmentSyncResultForm = {
  profileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedEHRLabAttachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  syncAllData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EhrLabForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  ehrOrderId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  laboratorium?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resultName?: InputMaybe<Scalars['String']['input']>;
  resultTypeId?: InputMaybe<Scalars['Int']['input']>;
  takenAt?: InputMaybe<Scalars['Date']['input']>;
};

export type EhrLabMutations = {
  __typename?: 'EHRLabMutations';
  Attachment?: Maybe<EhrLabAttachmentMutations>;
  OCR?: Maybe<EhrLabOcrMutations>;
  ResultType?: Maybe<EhrLabResultTypeMutations>;
  add?: Maybe<EhrLab>;
  edit?: Maybe<EhrLab>;
};


export type EhrLabMutationsAddArgs = {
  form?: InputMaybe<EhrLabForm>;
};


export type EhrLabMutationsEditArgs = {
  form?: InputMaybe<EhrLabForm>;
  id: Scalars['String']['input'];
};

export type EhrLabOcr = {
  __typename?: 'EHRLabOcr';
  createdAt?: Maybe<Scalars['Date']['output']>;
  ehrLabAttachmentId?: Maybe<Scalars['ID']['output']>;
  ehrLabId?: Maybe<Scalars['ID']['output']>;
  generateAt?: Maybe<Scalars['Date']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type EhrLabOcrForm = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  ehrLabId?: InputMaybe<Scalars['ID']['input']>;
  ehrOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type EhrLabOcrMutations = {
  __typename?: 'EHRLabOcrMutations';
  add?: Maybe<Scalars['Boolean']['output']>;
};


export type EhrLabOcrMutationsAddArgs = {
  form?: InputMaybe<EhrLabOcrForm>;
};

export type EhrLabPatient = {
  __typename?: 'EHRLabPatient';
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type EhrLabQueries = {
  __typename?: 'EHRLabQueries';
  Attachment?: Maybe<EhrLabAttachmentQueries>;
  ResultType?: Maybe<EhrLabResultTypeQueries>;
  findAll?: Maybe<EhrLabQueryResult>;
  findAllEHRAndMCU?: Maybe<EhrLabAndMcuQueryResult>;
  findAllEHRMCUAndEHRLab?: Maybe<EhrmcuAndEhrLabQueryResult>;
  findOne?: Maybe<EhrLab>;
};


export type EhrLabQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EhrLabQuerySortBy>;
  where?: InputMaybe<EhrLabQueryFilter>;
};


export type EhrLabQueriesFindAllEhrAndMcuArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EhrLabAndMcuQuerySortBy>;
};


export type EhrLabQueriesFindAllEhrmcuAndEhrLabArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EhrmcuAndEhrLabQuerySortyBy>;
  where?: InputMaybe<EhrmcuAndEhrLabQueryFilter>;
};


export type EhrLabQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type EhrLabQueryFilter = {
  ehrOrderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  resultTypeId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  takenAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EhrLabQueryResult = {
  __typename?: 'EHRLabQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EhrLab>>>;
};

export type EhrLabQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  laboratorium?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
};

export type EhrLabResultType = {
  __typename?: 'EHRLabResultType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type EhrLabResultTypeForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EhrLabResultTypeMutations = {
  __typename?: 'EHRLabResultTypeMutations';
  add?: Maybe<EhrLabResultType>;
  edit?: Maybe<EhrLabResultType>;
};


export type EhrLabResultTypeMutationsAddArgs = {
  form?: InputMaybe<EhrLabResultTypeForm>;
};


export type EhrLabResultTypeMutationsEditArgs = {
  form?: InputMaybe<EhrLabResultTypeForm>;
  id: Scalars['Int']['input'];
};

export type EhrLabResultTypeQueries = {
  __typename?: 'EHRLabResultTypeQueries';
  findAll?: Maybe<EhrLabResultTypeQueryResult>;
  findOne?: Maybe<EhrLabResultType>;
};


export type EhrLabResultTypeQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EhrLabResultTypeQuerySortBy>;
  where?: InputMaybe<EhrLabResultTypeQueryFilter>;
};


export type EhrLabResultTypeQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type EhrLabResultTypeQueryFilter = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type EhrLabResultTypeQueryResult = {
  __typename?: 'EHRLabResultTypeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EhrLabResultType>>>;
};

export type EhrLabResultTypeQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum EhrLabSource {
  ManualUploadByAdmin = 'MANUAL_UPLOAD_BY_ADMIN',
  ManualUploadByUser = 'MANUAL_UPLOAD_BY_USER'
}

export type EhrmcuAndEhrLabQueryFilter = {
  ehrLabId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ehrOrderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  resultTypeId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  takenAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EhrmcuAndEhrLabQueryResult = {
  __typename?: 'EHRMCUAndEHRLabQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EhrOrderAndEhrLab>>>;
};

export type EhrmcuAndEhrLabQuerySortyBy = {
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  laboratorium?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
};

export type EhrMutations = {
  __typename?: 'EHRMutations';
  Lab?: Maybe<EhrLabMutations>;
  Order?: Maybe<EhrOrderMutations>;
};

export type EhrOrder = {
  __typename?: 'EHROrder';
  buyerProfile?: Maybe<UserProfile>;
  buyerProfileId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creationType?: Maybe<EhrOrderCreationType>;
  ehrLabResultType?: Maybe<EhrLabResultType>;
  ehrLabResultTypeId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  order?: Maybe<PurchaseOrder>;
  orderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EhrOrderStatus>;
  type?: Maybe<PurchaseOrderType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visitedAt?: Maybe<Scalars['Date']['output']>;
};

export type EhrOrderAndEhrLab = {
  __typename?: 'EHROrderAndEHRLab';
  createdAt?: Maybe<Scalars['Date']['output']>;
  ehrLab?: Maybe<EhrLab>;
  ehrLabId?: Maybe<Scalars['String']['output']>;
  ehrOrder?: Maybe<EhrOrder>;
  ehrOrderId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ownerProfileId?: Maybe<Scalars['String']['output']>;
  resultType?: Maybe<EhrLabResultType>;
  resultTypeId?: Maybe<Scalars['Int']['output']>;
  takenAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<EhrOrderAndEhrLabType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum EhrOrderAndEhrLabType {
  EhrLab = 'EHR_LAB',
  EhrOrder = 'EHR_ORDER'
}

export enum EhrOrderCreationType {
  Manual = 'MANUAL',
  Regular = 'REGULAR'
}

export type EhrOrderForm = {
  buyerProfileId?: InputMaybe<Scalars['ID']['input']>;
  ehrLabResultTypeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EhrOrderStatus>;
  type?: InputMaybe<PurchaseOrderType>;
  visitedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type EhrOrderMutations = {
  __typename?: 'EHROrderMutations';
  addManual?: Maybe<EhrOrder>;
};


export type EhrOrderMutationsAddManualArgs = {
  form?: InputMaybe<EhrOrderForm>;
};

export type EhrOrderQueries = {
  __typename?: 'EHROrderQueries';
  findAll?: Maybe<EhrOrderQueryResult>;
  findOne?: Maybe<EhrOrder>;
};


export type EhrOrderQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EhrOrderQuerySortBy>;
  where?: InputMaybe<EhrOrderQueryFilter>;
};


export type EhrOrderQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type EhrOrderQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<EhrOrderStatus>>>;
  visitedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EhrOrderQueryResult = {
  __typename?: 'EHROrderQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EhrOrder>>>;
};

export type EhrOrderQuerySortBy = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<SortDirection>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<Scalars['String']['input']>;
  visitedAt?: InputMaybe<SortDirection>;
};

export enum EhrOrderStatus {
  Complete = 'COMPLETE',
  WaitingForResult = 'WAITING_FOR_RESULT',
  WaitingForVisit = 'WAITING_FOR_VISIT'
}

export type EhrQueries = {
  __typename?: 'EHRQueries';
  Lab?: Maybe<EhrLabQueries>;
  Order?: Maybe<EhrOrderQueries>;
};

export type EditOrderPurchaseProductForm = {
  id: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type EditPurchaseOrderShipmentForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type EditPurchaseOrderShipmentWaybillForm = {
  courierId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  waybill: Scalars['String']['input'];
};

export type EditPurchaseProductCategoryForm = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type EditPurchaseProductForm = {
  bgImage?: InputMaybe<Scalars['Upload']['input']>;
  bundling?: InputMaybe<Array<InputMaybe<PurchaseProductBundlingFormEdit>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<PurchaseProductDiscountForm>;
  imageApp?: InputMaybe<Scalars['Upload']['input']>;
  imageWeb?: InputMaybe<Scalars['Upload']['input']>;
  images?: InputMaybe<Array<InputMaybe<PurchaseProductImageFormEdit>>>;
  internationalDiscount?: InputMaybe<PurchaseProductDiscountForm>;
  internationalPrice?: InputMaybe<Scalars['Int']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeHomeService?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantType?: InputMaybe<MerchantType>;
  order?: InputMaybe<Scalars['Int']['input']>;
  periodFrom?: InputMaybe<Scalars['Date']['input']>;
  periodTo?: InputMaybe<Scalars['Date']['input']>;
  preOrderExpiredAt?: InputMaybe<Scalars['Date']['input']>;
  preOrderFullfillmentDate?: InputMaybe<Scalars['String']['input']>;
  preOrderFullfillmentDuration?: InputMaybe<Scalars['Int']['input']>;
  preOrderFullfillmentInterval?: InputMaybe<PurchaseProductpreOrderFullfillmentInterval>;
  preOrderType?: InputMaybe<PurchaseProductPreorderType>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productGroupId?: InputMaybe<Scalars['String']['input']>;
  purchaseType?: InputMaybe<PurchaseProductPurchaseType>;
  reportTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requirement?: InputMaybe<PurchaseProductRequirementForm>;
  serviceMethods?: InputMaybe<Array<InputMaybe<PurchaseProductServiceMethod>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  showOnInternationalShop?: InputMaybe<Scalars['Boolean']['input']>;
  showOnShop?: InputMaybe<Scalars['Boolean']['input']>;
  subscription?: InputMaybe<SubscriptionForm>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalDiscount?: InputMaybe<Scalars['Float']['input']>;
  totalInternationalDiscount?: InputMaybe<Scalars['Float']['input']>;
  totalInternationalPrice?: InputMaybe<Scalars['Int']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unlockProductId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unlockRequirementPrice?: InputMaybe<Array<InputMaybe<EditPurchaseProductUnlockForm>>>;
  upsell?: InputMaybe<PurchaseProductUpsellFormEdit>;
  upsellEligiblePurchaseTypes?: InputMaybe<Array<InputMaybe<PurchaseProductPurchaseType>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type EditPurchaseProductGroupForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditPurchaseProductPickupForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type EditPurchaseProductReportForm = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PurchaseProductReportStatus>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type EditPurchaseProductUnlockForm = {
  chipType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EnvironmentalRiskFactors = {
  __typename?: 'EnvironmentalRiskFactors';
  alcoholConsumption: Scalars['String']['output'];
  chemicals: Array<Scalars['String']['output']>;
  radiation: Scalars['Boolean']['output'];
  smoking: Scalars['Boolean']['output'];
};

export type Ethnicity = {
  __typename?: 'Ethnicity';
  id?: Maybe<Scalars['ID']['output']>;
  island?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type EthnicityMutations = {
  __typename?: 'EthnicityMutations';
  importExcel?: Maybe<Scalars['Boolean']['output']>;
};


export type EthnicityMutationsImportExcelArgs = {
  file: Scalars['Upload']['input'];
};

export type EthnicityQueries = {
  __typename?: 'EthnicityQueries';
  find?: Maybe<Array<Maybe<Ethnicity>>>;
};

export type Event = {
  __typename?: 'Event';
  category?: Maybe<EventCategory>;
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type EventCategory = {
  __typename?: 'EventCategory';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EventCategoryQueries = {
  __typename?: 'EventCategoryQueries';
  findAll?: Maybe<EventCategoryResults>;
};


export type EventCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategoryResults = {
  __typename?: 'EventCategoryResults';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EventCategory>>>;
};

export type EventMutations = {
  __typename?: 'EventMutations';
  Track?: Maybe<EventTrackMutations>;
};

export type EventQueries = {
  __typename?: 'EventQueries';
  Category?: Maybe<EventCategoryQueries>;
  Track?: Maybe<EventTrackQueries>;
  findAll?: Maybe<EventQueryResults>;
  findOne?: Maybe<Event>;
};


export type EventQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EventQuerySortBy>;
  where?: InputMaybe<EventQueryFilter>;
};


export type EventQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type EventQueryFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<Platform>>>;
};

export type EventQueryResults = {
  __typename?: 'EventQueryResults';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Event>>>;
};

export type EventQuerySortBy = {
  category?: InputMaybe<SortDirection>;
  count?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  platform?: InputMaybe<SortDirection>;
};

export type EventTrack = {
  __typename?: 'EventTrack';
  createdAt?: Maybe<Scalars['Date']['output']>;
  event?: Maybe<Event>;
  id?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
};

export type EventTrackAddForm = {
  category: Scalars['String']['input'];
  event: Scalars['String']['input'];
  platform: Platform;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type EventTrackMutations = {
  __typename?: 'EventTrackMutations';
  add?: Maybe<Scalars['Boolean']['output']>;
  exportExcel?: Maybe<Scalars['String']['output']>;
};


export type EventTrackMutationsAddArgs = {
  form: EventTrackAddForm;
};


export type EventTrackMutationsExportExcelArgs = {
  sort?: InputMaybe<EventTrackQuerySortBy>;
  where?: InputMaybe<EventTrackQueryFilter>;
};

export type EventTrackQueries = {
  __typename?: 'EventTrackQueries';
  findAll?: Maybe<EventTrackQueryResult>;
};


export type EventTrackQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EventTrackQuerySortBy>;
  where?: InputMaybe<EventTrackQueryFilter>;
};

export type EventTrackQueryFilter = {
  eventId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventTrackQueryResult = {
  __typename?: 'EventTrackQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EventTrack>>>;
};

export type EventTrackQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
};

export type ExecutedDataInput = {
  kitCode?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<ReportType>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FaceBluePrintSummaryHighlight = {
  __typename?: 'FaceBluePrintSummaryHighlight';
  code?: Maybe<Scalars['String']['output']>;
  faceHighlightPointer?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scoreStatus?: Maybe<DnaSkinScoreSkinStatus>;
  skinCharacteristic?: Maybe<Scalars['String']['output']>;
  skinType?: Maybe<Scalars['String']['output']>;
  summaryInsight?: Maybe<Scalars['String']['output']>;
};

export type FeedbackChoice = {
  __typename?: 'FeedbackChoice';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeedbackForm = {
  __typename?: 'FeedbackForm';
  choices?: Maybe<Array<Maybe<FeedbackChoice>>>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  ratingEnabled?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export type FindWeeklyReportResult = {
  __typename?: 'FindWeeklyReportResult';
  date?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
};

export type FindWeeklyReportResultFilter = {
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type FtueFeature = {
  __typename?: 'FtueFeature';
  code?: Maybe<FtueFeatureCode>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ftuePages?: Maybe<Array<Maybe<FtuePage>>>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  mediaPointer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum FtueFeatureCode {
  DailyActivity = 'DAILY_ACTIVITY',
  DailyJournal = 'DAILY_JOURNAL',
  KitActivation = 'KIT_ACTIVATION'
}

export type FtuePage = {
  __typename?: 'FtuePage';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ftueFeatureId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  mediaPointer?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<FtuePageMediaType>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum FtuePageMediaType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type GeneAnalysisResult = {
  __typename?: 'GeneAnalysisResult';
  analysisStatus: GeneAnalysisStatus;
  associatedCancers: Array<CancerType>;
  functionalImpact: Scalars['String']['output'];
  geneName: Scalars['String']['output'];
  penetrance: Scalars['Float']['output'];
  variants: Array<GeneticVariant>;
};

export enum GeneAnalysisStatus {
  Detected = 'DETECTED',
  Inconclusive = 'INCONCLUSIVE',
  NotDetected = 'NOT_DETECTED',
  VariantOfUncertainSignificance = 'VARIANT_OF_UNCERTAIN_SIGNIFICANCE'
}

export enum GenerationType {
  Plus = 'PLUS',
  Regular = 'REGULAR'
}

export type GeneticRiskFactors = {
  __typename?: 'GeneticRiskFactors';
  familyHistory: Scalars['Boolean']['output'];
  hereditarySyndromes: Array<Scalars['String']['output']>;
  riskGenes: Array<Scalars['String']['output']>;
};

export type GeneticVariant = {
  __typename?: 'GeneticVariant';
  altAllele: Scalars['String']['output'];
  chromosome: Scalars['String']['output'];
  clinicalSignificance: Scalars['String']['output'];
  cosmicId?: Maybe<Scalars['String']['output']>;
  dbSnpId?: Maybe<Scalars['String']['output']>;
  geneName: Scalars['String']['output'];
  genotype: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  refAllele: Scalars['String']['output'];
  variantName: Scalars['String']['output'];
  zygosity: Scalars['String']['output'];
};

export type GuidelineQueries = {
  __typename?: 'GuidelineQueries';
  guidelines?: Maybe<Array<Maybe<GuidelineStatus>>>;
};


export type GuidelineQueriesGuidelinesArgs = {
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export type GuidelineStatus = {
  __typename?: 'GuidelineStatus';
  generationType?: Maybe<GuidelineStatusReportGenerationType>;
  id?: Maybe<Scalars['ID']['output']>;
  reportType?: Maybe<ReportType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum GuidelineStatusReportGenerationType {
  Plus = 'PLUS',
  Regular = 'REGULAR'
}

export enum Health_Score_Report_Recommendation_Category {
  AntiInflammation = 'ANTI_INFLAMMATION',
  BloodPressureManagement = 'BLOOD_PRESSURE_MANAGEMENT',
  DetoxAndCleansing = 'DETOX_AND_CLEANSING',
  Diet = 'DIET',
  EnergyAndVitality = 'ENERGY_AND_VITALITY',
  Exercise = 'EXERCISE',
  FocusAndProductivity = 'FOCUS_AND_PRODUCTIVITY',
  Hydration = 'HYDRATION',
  Lifestyle = 'LIFESTYLE',
  Longetivirt = 'LONGETIVIRT',
  PostureImprovement = 'POSTURE_IMPROVEMENT',
  SleepOptimization = 'SLEEP_OPTIMIZATION',
  StressReduction = 'STRESS_REDUCTION'
}

export enum Health_Score_Report_Recommendation_Sub_Category {
  AntiInflammation = 'ANTI_INFLAMMATION',
  Balance = 'BALANCE',
  BloodPressureManagement = 'BLOOD_PRESSURE_MANAGEMENT',
  Cardio = 'CARDIO',
  DetoxAndCleansing = 'DETOX_AND_CLEANSING',
  EnergyAndVitality = 'ENERGY_AND_VITALITY',
  FocusAndProductivity = 'FOCUS_AND_PRODUCTIVITY',
  Hydration = 'HYDRATION',
  Longetivirt = 'LONGETIVIRT',
  Macronutrient = 'MACRONUTRIENT',
  Micronutrient = 'MICRONUTRIENT',
  Mobility = 'MOBILITY',
  PostureImprovement = 'POSTURE_IMPROVEMENT',
  Sleep = 'SLEEP',
  SleepOptimization = 'SLEEP_OPTIMIZATION',
  Strength = 'STRENGTH',
  StressManagement = 'STRESS_MANAGEMENT',
  StressReduction = 'STRESS_REDUCTION'
}

export enum Health_Score_Report_Recommendation_Type {
  Donts = 'DONTS',
  Dos = 'DOS'
}

export type HealthAllergy = {
  __typename?: 'HealthAllergy';
  antidote?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HealthAllergyForm = {
  antidote?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<HealthAllergyType>>>;
};

export type HealthAllergyMutations = {
  __typename?: 'HealthAllergyMutations';
  add?: Maybe<HealthAllergy>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthAllergy>;
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type HealthAllergyMutationsAddArgs = {
  form?: InputMaybe<HealthAllergyForm>;
};


export type HealthAllergyMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthAllergyMutationsEditArgs = {
  form?: InputMaybe<HealthAllergyForm>;
  id: Scalars['Int']['input'];
};


export type HealthAllergyMutationsUpdateArgs = {
  form?: InputMaybe<Array<InputMaybe<HealthAllergyForm>>>;
};

export type HealthAllergyQueries = {
  __typename?: 'HealthAllergyQueries';
  findAll?: Maybe<HealthAllergyQueryResult>;
  findOne?: Maybe<HealthAllergy>;
};


export type HealthAllergyQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthAllergyQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthAllergyQueryResult = {
  __typename?: 'HealthAllergyQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthAllergy>>>;
};

export enum HealthAllergyType {
  Conditional = 'CONDITIONAL',
  Drug = 'DRUG',
  Food = 'FOOD'
}

export type HealthArticle = {
  __typename?: 'HealthArticle';
  category?: Maybe<HealthArticleCategory>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeyphrase?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  nViewers?: Maybe<Scalars['Int']['output']>;
  relatedSubCategories?: Maybe<Array<Maybe<HealthArticleSubCategory>>>;
  slug?: Maybe<Scalars['String']['output']>;
  subCategories?: Maybe<Array<Maybe<HealthArticleSubCategory>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  viewers?: Maybe<Array<Maybe<HealthArticleViewer>>>;
};

export type HealthArticleCategory = {
  __typename?: 'HealthArticleCategory';
  id?: Maybe<Scalars['Int']['output']>;
  isAssociated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subcategories?: Maybe<Array<Maybe<HealthArticleSubCategory>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type HealthArticleCategoryForm = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleCategoryMutations = {
  __typename?: 'HealthArticleCategoryMutations';
  add?: Maybe<HealthArticleCategory>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthArticleCategory>;
};


export type HealthArticleCategoryMutationsAddArgs = {
  form?: InputMaybe<HealthArticleCategoryForm>;
};


export type HealthArticleCategoryMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthArticleCategoryMutationsEditArgs = {
  form?: InputMaybe<HealthArticleCategoryForm>;
  id: Scalars['Int']['input'];
};

export type HealthArticleCategoryQueries = {
  __typename?: 'HealthArticleCategoryQueries';
  findAll?: Maybe<HealthArticleCategoryQueryResult>;
  findOne?: Maybe<HealthArticleCategory>;
};


export type HealthArticleCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthArticleCategoryQuerySortBy>;
  where?: InputMaybe<HealthArticleCategoryQueryFilter>;
};


export type HealthArticleCategoryQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthArticleCategoryQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleCategoryQueryResult = {
  __typename?: 'HealthArticleCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthArticleCategory>>>;
};

export type HealthArticleCategoryQuerySortBy = {
  name?: InputMaybe<SortDirection>;
};

export type HealthArticleForm = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyphrase?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleMutations = {
  __typename?: 'HealthArticleMutations';
  Category?: Maybe<HealthArticleCategoryMutations>;
  SubCategory?: Maybe<HealthArticleSubCategoryMutations>;
  Viewer?: Maybe<HealthArticleViewerMutations>;
  add?: Maybe<HealthArticle>;
  archive?: Maybe<HealthArticle>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthArticle>;
};


export type HealthArticleMutationsAddArgs = {
  form?: InputMaybe<HealthArticleForm>;
};


export type HealthArticleMutationsArchiveArgs = {
  id: Scalars['Int']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HealthArticleMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthArticleMutationsEditArgs = {
  form?: InputMaybe<HealthArticleForm>;
  id: Scalars['Int']['input'];
};

export type HealthArticleQueries = {
  __typename?: 'HealthArticleQueries';
  Category?: Maybe<HealthArticleCategoryQueries>;
  SubCategory?: Maybe<HealthArticleSubCategoryQueries>;
  Viewer?: Maybe<HealthArticleViewerQueries>;
  findAll?: Maybe<HealthArticleQueryResult>;
  findMostViewed?: Maybe<Array<Maybe<HealthArticle>>>;
  findOne?: Maybe<HealthArticle>;
  findOneBySlug?: Maybe<HealthArticle>;
  search?: Maybe<HealthArticleQueryResult>;
};


export type HealthArticleQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthArticleQuerySortBy>;
  where?: InputMaybe<HealthArticleQueryFilter>;
};


export type HealthArticleQueriesFindMostViewedArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type HealthArticleQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};


export type HealthArticleQueriesFindOneBySlugArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type HealthArticleQueriesSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthArticleQuerySortBy>;
};

export type HealthArticleQueryFilter = {
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  journalList?: InputMaybe<Scalars['Boolean']['input']>;
  mobileList?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subCategoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleQueryResult = {
  __typename?: 'HealthArticleQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthArticle>>>;
};

export type HealthArticleQuerySortBy = {
  category?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  nViewers?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type HealthArticleSubCategory = {
  __typename?: 'HealthArticleSubCategory';
  articles?: Maybe<Array<Maybe<HealthArticle>>>;
  category?: Maybe<HealthArticleCategory>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAssociated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HealthArticleSubCategoryForm = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleSubCategoryMutations = {
  __typename?: 'HealthArticleSubCategoryMutations';
  add?: Maybe<HealthArticleSubCategory>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthArticleSubCategory>;
};


export type HealthArticleSubCategoryMutationsAddArgs = {
  form?: InputMaybe<HealthArticleSubCategoryForm>;
};


export type HealthArticleSubCategoryMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthArticleSubCategoryMutationsEditArgs = {
  form?: InputMaybe<HealthArticleSubCategoryForm>;
  id: Scalars['Int']['input'];
};

export type HealthArticleSubCategoryQueries = {
  __typename?: 'HealthArticleSubCategoryQueries';
  findAll?: Maybe<HealthArticleSubCategoryQueryResult>;
  findOne?: Maybe<HealthArticleSubCategory>;
};


export type HealthArticleSubCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthArticleSubCategoryQuerySortBy>;
  where?: InputMaybe<HealthArticleSubCategoryQueryFilter>;
};


export type HealthArticleSubCategoryQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthArticleSubCategoryQueryFilter = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleSubCategoryQueryResult = {
  __typename?: 'HealthArticleSubCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthArticleSubCategory>>>;
};

export type HealthArticleSubCategoryQuerySortBy = {
  category?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type HealthArticleViewer = {
  __typename?: 'HealthArticleViewer';
  articleId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  n_viewers?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HealthArticleViewerForm = {
  articleId?: InputMaybe<Scalars['Int']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleViewerMutations = {
  __typename?: 'HealthArticleViewerMutations';
  add?: Maybe<HealthArticleViewer>;
};


export type HealthArticleViewerMutationsAddArgs = {
  form?: InputMaybe<HealthArticleViewerForm>;
};

export type HealthArticleViewerQueries = {
  __typename?: 'HealthArticleViewerQueries';
  findAll?: Maybe<HealthArticleViewerQueryResult>;
  findOne?: Maybe<HealthArticleViewer>;
};


export type HealthArticleViewerQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthArticleViewerQuerySortBy>;
  where?: InputMaybe<HealthArticleViewerQueryFilter>;
};


export type HealthArticleViewerQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthArticleViewerQueryFilter = {
  articleId?: InputMaybe<Scalars['Int']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type HealthArticleViewerQueryResult = {
  __typename?: 'HealthArticleViewerQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthArticleViewer>>>;
};

export type HealthArticleViewerQuerySortBy = {
  identity?: InputMaybe<SortDirection>;
  n_viewers?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type HealthBackground = {
  __typename?: 'HealthBackground';
  asthma?: Maybe<Scalars['Boolean']['output']>;
  diabetes?: Maybe<Scalars['Boolean']['output']>;
  highBloodPressure?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  obesity?: Maybe<Scalars['Boolean']['output']>;
  smoker?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthBackgroundForm = {
  asthma?: InputMaybe<Scalars['Boolean']['input']>;
  diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  familyId?: InputMaybe<Scalars['Int']['input']>;
  highBloodPressure?: InputMaybe<Scalars['Boolean']['input']>;
  obesity?: InputMaybe<Scalars['Boolean']['input']>;
  smoker?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthBackgroundMutations = {
  __typename?: 'HealthBackgroundMutations';
  add?: Maybe<HealthBackground>;
};


export type HealthBackgroundMutationsAddArgs = {
  form?: InputMaybe<HealthBackgroundForm>;
};

export type HealthBackgroundQueries = {
  __typename?: 'HealthBackgroundQueries';
  findOne?: Maybe<HealthBackground>;
};


export type HealthBackgroundQueriesFindOneArgs = {
  familyId?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthFaq = {
  __typename?: 'HealthFAQ';
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type HealthGlossary = {
  __typename?: 'HealthGlossary';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meaning?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HealthGlossaryForm = {
  meaning?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HealthGlossaryMutations = {
  __typename?: 'HealthGlossaryMutations';
  add?: Maybe<HealthGlossary>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthGlossary>;
  init?: Maybe<Scalars['Boolean']['output']>;
};


export type HealthGlossaryMutationsAddArgs = {
  form?: InputMaybe<HealthGlossaryForm>;
};


export type HealthGlossaryMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthGlossaryMutationsEditArgs = {
  form?: InputMaybe<HealthGlossaryForm>;
  id: Scalars['Int']['input'];
};

export type HealthGlossaryQueries = {
  __typename?: 'HealthGlossaryQueries';
  findAll?: Maybe<HealthGlossaryQueryResult>;
  findOne?: Maybe<HealthGlossary>;
};


export type HealthGlossaryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthGlossaryQuerySortBy>;
  where?: InputMaybe<HealthGlossaryQueryFilter>;
};


export type HealthGlossaryQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthGlossaryQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  meaning?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HealthGlossaryQueryResult = {
  __typename?: 'HealthGlossaryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthGlossary>>>;
};

export type HealthGlossaryQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  meaning?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type HealthInformation = {
  __typename?: 'HealthInformation';
  height?: Maybe<Scalars['Float']['output']>;
  heightUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnit?: Maybe<Scalars['String']['output']>;
};

export type HealthInformationForm = {
  height?: InputMaybe<Scalars['Float']['input']>;
  heightUnit?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnit?: InputMaybe<Scalars['String']['input']>;
};

export type HealthInformationMutations = {
  __typename?: 'HealthInformationMutations';
  add?: Maybe<HealthInformation>;
};


export type HealthInformationMutationsAddArgs = {
  form?: InputMaybe<HealthInformationForm>;
};

export type HealthInformationQueries = {
  __typename?: 'HealthInformationQueries';
  findOne?: Maybe<HealthInformation>;
};

export type HealthMedical = {
  __typename?: 'HealthMedical';
  id?: Maybe<Scalars['Int']['output']>;
  isMasterData?: Maybe<Scalars['Boolean']['output']>;
  isOther?: Maybe<Scalars['Boolean']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MedicalType>;
};

export type HealthMedicalForm = {
  isOther?: InputMaybe<Scalars['Boolean']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MedicalType>;
};

export type HealthMedicalHistory = {
  __typename?: 'HealthMedicalHistory';
  id?: Maybe<Scalars['Int']['output']>;
  medical?: Maybe<HealthMedical>;
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HealthMedicalHistoryForm = {
  medicalId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type HealthMedicalHistoryMutations = {
  __typename?: 'HealthMedicalHistoryMutations';
  add?: Maybe<HealthMedicalHistory>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthMedicalHistory>;
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type HealthMedicalHistoryMutationsAddArgs = {
  form?: InputMaybe<HealthMedicalHistoryForm>;
};


export type HealthMedicalHistoryMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthMedicalHistoryMutationsEditArgs = {
  form?: InputMaybe<HealthMedicalHistoryForm>;
  id: Scalars['Int']['input'];
};


export type HealthMedicalHistoryMutationsUpdateArgs = {
  form?: InputMaybe<Array<InputMaybe<HealthMedicalHistoryForm>>>;
};

export type HealthMedicalHistoryQueries = {
  __typename?: 'HealthMedicalHistoryQueries';
  findAll?: Maybe<HealthMedicalHistoryQueryResult>;
  findOne?: Maybe<HealthMedicalHistory>;
};


export type HealthMedicalHistoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthMedicalHistoryQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthMedicalHistoryQueryResult = {
  __typename?: 'HealthMedicalHistoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthMedicalHistory>>>;
};

export type HealthMedicalMutations = {
  __typename?: 'HealthMedicalMutations';
  History?: Maybe<HealthMedicalHistoryMutations>;
  add?: Maybe<HealthMedical>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthMedical>;
};


export type HealthMedicalMutationsAddArgs = {
  form?: InputMaybe<HealthMedicalForm>;
};


export type HealthMedicalMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthMedicalMutationsEditArgs = {
  form?: InputMaybe<HealthMedicalForm>;
  id: Scalars['Int']['input'];
};

export type HealthMedicalQueries = {
  __typename?: 'HealthMedicalQueries';
  History?: Maybe<HealthMedicalHistoryQueries>;
  findAll?: Maybe<HealthMedicalQueryResult>;
  findOne?: Maybe<HealthMedical>;
};


export type HealthMedicalQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MedicalQueryFilter>;
};


export type HealthMedicalQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthMedicalQueryResult = {
  __typename?: 'HealthMedicalQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthMedical>>>;
};

export type HealthMedication = {
  __typename?: 'HealthMedication';
  drug?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  permanently?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthMedicationForm = {
  drug?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  permanently?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthMedicationMutations = {
  __typename?: 'HealthMedicationMutations';
  add?: Maybe<HealthMedication>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthMedication>;
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type HealthMedicationMutationsAddArgs = {
  form?: InputMaybe<HealthMedicationForm>;
};


export type HealthMedicationMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthMedicationMutationsEditArgs = {
  form?: InputMaybe<HealthMedicationForm>;
  id: Scalars['Int']['input'];
};


export type HealthMedicationMutationsUpdateArgs = {
  form?: InputMaybe<Array<InputMaybe<HealthMedicationForm>>>;
};

export type HealthMedicationQueries = {
  __typename?: 'HealthMedicationQueries';
  findAll?: Maybe<HealthMedicationQueryResult>;
  findOne?: Maybe<HealthMedication>;
};


export type HealthMedicationQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthMedicationQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type HealthMedicationQueryResult = {
  __typename?: 'HealthMedicationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthMedication>>>;
};

export type HealthMutations = {
  __typename?: 'HealthMutations';
  Allergy?: Maybe<HealthAllergyMutations>;
  Article?: Maybe<HealthArticleMutations>;
  Background?: Maybe<HealthBackgroundMutations>;
  Glossary?: Maybe<HealthGlossaryMutations>;
  Information?: Maybe<HealthInformationMutations>;
  Medical?: Maybe<HealthMedicalMutations>;
  Medication?: Maybe<HealthMedicationMutations>;
};

export type HealthQueries = {
  __typename?: 'HealthQueries';
  Allergy?: Maybe<HealthAllergyQueries>;
  Article?: Maybe<HealthArticleQueries>;
  Background?: Maybe<HealthBackgroundQueries>;
  Glossary?: Maybe<HealthGlossaryQueries>;
  Information?: Maybe<HealthInformationQueries>;
  Medical?: Maybe<HealthMedicalQueries>;
  Medication?: Maybe<HealthMedicationQueries>;
  faq?: Maybe<Array<Maybe<HealthFaq>>>;
  setting?: Maybe<SettingPayload>;
};

export type HealthScore = {
  __typename?: 'HealthScore';
  createdAt?: Maybe<Scalars['Date']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  healthScoreReport?: Maybe<HealthScoreReport>;
  id?: Maybe<Scalars['ID']['output']>;
  input?: Maybe<HealthScoreInput>;
  output?: Maybe<HelathScoreOutput>;
  ownerId?: Maybe<Scalars['String']['output']>;
  partnershipId?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type HealthScoreAscvdForm = {
  HDLCholesterol?: InputMaybe<Scalars['Float']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  diabetesStatus?: InputMaybe<Scalars['Int']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['Int']['input']>;
  totalCholesterol?: InputMaybe<Scalars['Float']['input']>;
  treatedSystolicBloodPressure?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<HealthScoreTypeCode>;
  untreatedSystolicBloodPressure?: InputMaybe<Scalars['Float']['input']>;
};

export type HealthScoreAscvdInput = {
  __typename?: 'HealthScoreASCVDInput';
  HDLCholesterol?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  diabetesStatus?: Maybe<Scalars['Int']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  smokingStatus?: Maybe<Scalars['Int']['output']>;
  totalCholesterol?: Maybe<Scalars['Float']['output']>;
  treatedSystolicBloodPressure?: Maybe<Scalars['Float']['output']>;
  untreatedSystolicBloodPressure?: Maybe<Scalars['Float']['output']>;
};

export type HealthScoreCkdForm = {
  age?: InputMaybe<Scalars['Int']['input']>;
  diabetesStatus?: InputMaybe<Scalars['Int']['input']>;
  dyslipidemia?: InputMaybe<Scalars['Int']['input']>;
  eGFR?: InputMaybe<Scalars['Float']['input']>;
  hypertension?: InputMaybe<Scalars['Int']['input']>;
  hyperuricemia?: InputMaybe<Scalars['Int']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};

export type HealthScoreDiabetesForm = {
  age?: InputMaybe<Scalars['Int']['input']>;
  bmi?: InputMaybe<Scalars['Float']['input']>;
  familyHistory?: InputMaybe<Scalars['Int']['input']>;
  hypertension?: InputMaybe<Scalars['Int']['input']>;
  physicalActivity?: InputMaybe<Scalars['Int']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};

export type HealthScoreDiabetesInput = {
  __typename?: 'HealthScoreDiabetesInput';
  age?: Maybe<Scalars['Int']['output']>;
  bmi?: Maybe<Scalars['Float']['output']>;
  familyHistory?: Maybe<Scalars['Int']['output']>;
  hypertension?: Maybe<Scalars['Int']['output']>;
  physicalActivity?: Maybe<Scalars['Int']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreHypertensionForm = {
  age?: InputMaybe<Scalars['Int']['input']>;
  bmi?: InputMaybe<Scalars['Float']['input']>;
  diastolicBloodPressure?: InputMaybe<Scalars['Int']['input']>;
  parentalHypertension?: InputMaybe<Scalars['Int']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['Int']['input']>;
  systolicBloodPressure?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthScoreHypertensionInput = {
  __typename?: 'HealthScoreHypertensionInput';
  age?: Maybe<Scalars['Int']['output']>;
  bmi?: Maybe<Scalars['Float']['output']>;
  diastolicBloodPressure?: Maybe<Scalars['Int']['output']>;
  parentalHypertension?: Maybe<Scalars['Int']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  smokingStatus?: Maybe<Scalars['Int']['output']>;
  systolicBloodPressure?: Maybe<Scalars['Int']['output']>;
};

export type HealthScoreInput = HealthScoreAscvdInput | HealthScoreDiabetesInput | HealthScoreHypertensionInput | HealthScoreLwbInput | HealthScoreNafldInput;

export type HealthScoreLwbForm = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  downhearted?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  feelTired?: InputMaybe<Scalars['String']['input']>;
  fruitServingPerDays?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  insomnia?: InputMaybe<Scalars['String']['input']>;
  lifeCondition?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mcuPointer?: InputMaybe<Scalars['String']['input']>;
  numberOfPreexistingDisease?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentHasBeenDiagnosed?: InputMaybe<Lwb_Parent_Has_Been_Diagnosed>;
  parentHistoryOfDisease?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalActivities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalActivity?: InputMaybe<Scalars['String']['input']>;
  primaryHealthGoals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sex?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['String']['input']>;
  sugaryProduct?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<HealthScoreReportTrigger>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type HealthScoreLwbInput = {
  __typename?: 'HealthScoreLWBInput';
  age?: Maybe<Scalars['Int']['output']>;
  bmiCategory?: Maybe<Scalars['String']['output']>;
  downhearted?: Maybe<Scalars['String']['output']>;
  feelTired?: Maybe<Scalars['String']['output']>;
  fruitServingPerDays?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  insomnia?: Maybe<Scalars['String']['output']>;
  lifeCondition?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  numberOfPreexistingDisease?: Maybe<Scalars['String']['output']>;
  parentHistoryOfDisease?: Maybe<Scalars['String']['output']>;
  physicalActivity?: Maybe<Scalars['String']['output']>;
  primaryHealthGoals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sex?: Maybe<Scalars['String']['output']>;
  smokingStatus?: Maybe<Scalars['String']['output']>;
  sugaryProduct?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type HealthScoreMutations = {
  __typename?: 'HealthScoreMutations';
  Report?: Maybe<HealthScoreReportMutations>;
  Type?: Maybe<HealthScoreTypeMutations>;
  addASCVD?: Maybe<HealthScore>;
  addCKD?: Maybe<HealthScore>;
  addDiabetes?: Maybe<HealthScore>;
  addHypertension?: Maybe<HealthScore>;
  addNAFLD?: Maybe<HealthScore>;
  calculateLWB?: Maybe<HealthScore>;
  recalculateLWB?: Maybe<Scalars['Boolean']['output']>;
  syncHealthScore?: Maybe<SyncHealthScoreResult>;
};


export type HealthScoreMutationsAddAscvdArgs = {
  form: HealthScoreAscvdForm;
};


export type HealthScoreMutationsAddCkdArgs = {
  form: HealthScoreCkdForm;
};


export type HealthScoreMutationsAddDiabetesArgs = {
  form: HealthScoreDiabetesForm;
};


export type HealthScoreMutationsAddHypertensionArgs = {
  form: HealthScoreHypertensionForm;
};


export type HealthScoreMutationsAddNafldArgs = {
  form: HealthScoreNafldForm;
};


export type HealthScoreMutationsCalculateLwbArgs = {
  form: HealthScoreLwbForm;
};


export type HealthScoreMutationsSyncHealthScoreArgs = {
  form?: InputMaybe<SyncHealthScoreForm>;
};

export type HealthScoreNafldForm = {
  age?: InputMaybe<Scalars['Int']['input']>;
  bmi?: InputMaybe<Scalars['Float']['input']>;
  gammaGlutamyltransferase?: InputMaybe<Scalars['Float']['input']>;
  parentalHypertension?: InputMaybe<Scalars['Int']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['String']['input']>;
  triglycerides?: InputMaybe<Scalars['Int']['input']>;
  typeTwoDiabetes?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthScoreNafldInput = {
  __typename?: 'HealthScoreNAFLDInput';
  age?: Maybe<Scalars['Int']['output']>;
  bmi?: Maybe<Scalars['Float']['output']>;
  gammaGlutamyltransferase?: Maybe<Scalars['Float']['output']>;
  parentalHypertension?: Maybe<Scalars['Int']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  smokingStatus?: Maybe<Scalars['String']['output']>;
  triglycerides?: Maybe<Scalars['Int']['output']>;
  typeTwoDiabetes?: Maybe<Scalars['Int']['output']>;
};

export type HealthScoreQueries = {
  __typename?: 'HealthScoreQueries';
  Report?: Maybe<HealthScoreReportQueries>;
  Type?: Maybe<HealthScoreTypeQueries>;
};

export type HealthScoreReport = {
  __typename?: 'HealthScoreReport';
  age?: Maybe<HealthScoreReportAge>;
  calculatedReport?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<HealthScoreReportDetail>>>;
  deviceId?: Maybe<Scalars['String']['output']>;
  healthScore?: Maybe<HealthScore>;
  healthScoreId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interpretation?: Maybe<HealthScoreReportInterpretationValue>;
  isCalculating?: Maybe<Scalars['Boolean']['output']>;
  isRecommendationGenerated?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  predictiveStrength?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Array<Maybe<HealthScoreReportRecommendation>>>;
  score?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Array<Maybe<HealthScoreReportSource>>>;
  summary?: Maybe<HealthScoreReportSummary>;
  trigger?: Maybe<HealthScoreReportTrigger>;
  type?: Maybe<HealthScoreType>;
  typeId?: Maybe<Scalars['String']['output']>;
  uncalculatedSource?: Maybe<Array<Maybe<HealthScoreReportSource>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userLWB?: Maybe<UserLwb>;
};

export type HealthScoreReportAge = {
  __typename?: 'HealthScoreReportAge';
  chronologicalAge?: Maybe<Scalars['String']['output']>;
  chronologicalAgeFull?: Maybe<HealthScoreReportAgeDetail>;
  differenceAge?: Maybe<Scalars['String']['output']>;
  estimatedBiologicalAge?: Maybe<Scalars['String']['output']>;
  estimatedBiologicalAgeFull?: Maybe<HealthScoreReportAgeDetail>;
  id?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportAgeDataCompletion = {
  __typename?: 'HealthScoreReportAgeDataCompletion';
  completed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HealthScoreReportAgeDetail = {
  __typename?: 'HealthScoreReportAgeDetail';
  days?: Maybe<Scalars['Int']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type HealthScoreReportAgeMutations = {
  __typename?: 'HealthScoreReportAgeMutations';
  generateOnDemand: Scalars['Boolean']['output'];
};

export type HealthScoreReportAgeOverview = {
  __typename?: 'HealthScoreReportAgeOverview';
  contentDescription?: Maybe<Scalars['String']['output']>;
  dataCompletion: HealthScoreReportAgeDataCompletion;
  dataSource: Array<HealthScoreReportDataSourceDetail>;
  detailAsaAge?: Maybe<HealthScoreReportAge>;
  eligibilityDescription?: Maybe<Scalars['String']['output']>;
  eligibleToGenerateAt?: Maybe<Scalars['Date']['output']>;
  isAsaAgeVisible: Scalars['Boolean']['output'];
  isEligibleToGenerate: Scalars['Boolean']['output'];
  isFirstGeneration: Scalars['Boolean']['output'];
  lastGenerationAt?: Maybe<Scalars['Date']['output']>;
};

export type HealthScoreReportDataSourceDetail = {
  __typename?: 'HealthScoreReportDataSourceDetail';
  code: HealthScoreReportSource;
  description?: Maybe<Scalars['String']['output']>;
  isAsaAgeCalculated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type HealthScoreReportDetail = {
  __typename?: 'HealthScoreReportDetail';
  analysis?: Maybe<Scalars['String']['output']>;
  healthScoreId?: Maybe<Scalars['String']['output']>;
  healthScoreReportId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<HealthScoreReportDetailType>;
};

export enum HealthScoreReportDetailType {
  BloodMarkers = 'BLOOD_MARKERS',
  Explanation = 'EXPLANATION',
  GeneticFactors = 'GENETIC_FACTORS',
  Questionnaires = 'QUESTIONNAIRES',
  References = 'REFERENCES',
  SynthesisAndConsidetaions = 'SYNTHESIS_AND_CONSIDETAIONS'
}

export enum HealthScoreReportInterpretationValue {
  Borderline = 'BORDERLINE',
  CriticalHealth = 'CRITICAL_HEALTH',
  Excellent = 'EXCELLENT',
  Fair = 'FAIR',
  Good = 'GOOD',
  High = 'HIGH',
  Intermediate = 'INTERMEDIATE',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Moderate = 'MODERATE',
  OptimalHealth = 'OPTIMAL_HEALTH',
  Poor = 'POOR',
  PoorHealth = 'POOR_HEALTH',
  Transition = 'TRANSITION',
  VeryGood = 'VERY_GOOD'
}

export type HealthScoreReportLatestQueryFilter = {
  healthScoreTypeCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  healthScoreTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum HealthScoreReportLatestQueryInclude {
  HealthscoreType = 'HEALTHSCORE_TYPE'
}

export type HealthScoreReportMutations = {
  __typename?: 'HealthScoreReportMutations';
  Age?: Maybe<HealthScoreReportAgeMutations>;
  Recommendation?: Maybe<HealthScoreReportRecommendationMutations>;
};

export type HealthScoreReportNotification = {
  __typename?: 'HealthScoreReportNotification';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  healthScore?: Maybe<HealthScore>;
  healthScoreId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interpretation?: Maybe<HealthScoreReportInterpretationValue>;
  isCalculating?: Maybe<Scalars['Boolean']['output']>;
  isRecommendationGenerated?: Maybe<Scalars['Boolean']['output']>;
  recommendation?: Maybe<Array<Maybe<HealthScoreReportRecommendation>>>;
  score?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Array<Maybe<HealthScoreReportSource>>>;
  trigger?: Maybe<HealthScoreReportTrigger>;
  type?: Maybe<HealthScoreType>;
  typeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userLWB?: Maybe<UserLwb>;
};

export type HealthScoreReportQueries = {
  __typename?: 'HealthScoreReportQueries';
  Age?: Maybe<HealthScoreReportAgeMutations>;
  Recommendation?: Maybe<HealthScoreReportRecommendationQueries>;
  findAgeOverview?: Maybe<HealthScoreReportAgeOverview>;
  findAll?: Maybe<HealthScoreReportQueryResult>;
  findAllLatest?: Maybe<HealthScoreReportQueryResult>;
  findMonthlyReport?: Maybe<Array<Maybe<FindWeeklyReportResult>>>;
  findOne?: Maybe<HealthScoreReport>;
  findOneLatest?: Maybe<HealthScoreReport>;
  findWeeklyReport?: Maybe<Array<Maybe<FindWeeklyReportResult>>>;
};


export type HealthScoreReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthScoreReportQuerySortBy>;
  where?: InputMaybe<HealthScoreReportQueryFilter>;
};


export type HealthScoreReportQueriesFindAllLatestArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  include?: InputMaybe<Array<InputMaybe<HealthScoreReportLatestQueryInclude>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthScoreReportLatestQueryFilter>;
};


export type HealthScoreReportQueriesFindMonthlyReportArgs = {
  where: FindWeeklyReportResultFilter;
};


export type HealthScoreReportQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};


export type HealthScoreReportQueriesFindOneLatestArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type HealthScoreReportQueryFilter = {
  healthScoreId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HealthScoreReportQueryResult = {
  __typename?: 'HealthScoreReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthScoreReport>>>;
};

export type HealthScoreReportQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type HealthScoreReportRecommendation = {
  __typename?: 'HealthScoreReportRecommendation';
  category?: Maybe<Health_Score_Report_Recommendation_Category>;
  consultationRecommendation?: Maybe<Array<Maybe<HealthScoreReportRecommendationConsultationRecommendation>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  donts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  evidences?: Maybe<Array<Maybe<HealthScoreReportRecommendationEvidence>>>;
  finding?: Maybe<HealthScoreReportRecommendationFinding>;
  healthScoreId?: Maybe<Scalars['String']['output']>;
  healthScoreReportId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  objective?: Maybe<Scalars['String']['output']>;
  product?: Maybe<PurchaseProduct>;
  profileId?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  relatedDNATraits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subCategory?: Maybe<Health_Score_Report_Recommendation_Sub_Category>;
  suggestions?: Maybe<Array<Maybe<HealthScoreReportRecommendationSuggestion>>>;
  testRecommendation?: Maybe<Array<Maybe<HealthScoreReportRecommendationTestRecommendation>>>;
  type?: Maybe<Health_Score_Report_Recommendation_Type>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type HealthScoreReportRecommendationConsultationRecommendation = {
  __typename?: 'HealthScoreReportRecommendationConsultationRecommendation';
  description?: Maybe<Scalars['String']['output']>;
  specialist?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportRecommendationEvidence = {
  __typename?: 'HealthScoreReportRecommendationEvidence';
  donts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  finding?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  healthScoreReportRecommendationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  relatedDNATraits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HealthScoreReportRecommendationEvidenceBloodMarker = {
  __typename?: 'HealthScoreReportRecommendationEvidenceBloodMarker';
  healthScoreReportId?: Maybe<Scalars['String']['output']>;
  healthScoreReportRecommendationEvidenceId?: Maybe<Scalars['String']['output']>;
  healthScoreReportRecommendationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportRecommendationEvidenceBloodMarkerQueries = {
  __typename?: 'HealthScoreReportRecommendationEvidenceBloodMarkerQueries';
  findAll?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthScoreReportRecommendationEvidenceQueries = {
  __typename?: 'HealthScoreReportRecommendationEvidenceQueries';
  BloodMarker?: Maybe<HealthScoreReportRecommendationEvidenceBloodMarkerQueries>;
  Trait?: Maybe<HealthScoreReportRecommendationTraitQueries>;
  findAll?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthScoreReportRecommendationFilter = {
  category?: InputMaybe<Array<InputMaybe<Health_Score_Report_Recommendation_Category>>>;
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  healthScoreId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  healthScoreReportId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isRelevant?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  profileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory?: InputMaybe<Array<InputMaybe<Health_Score_Report_Recommendation_Sub_Category>>>;
  type?: InputMaybe<Array<InputMaybe<Health_Score_Report_Recommendation_Type>>>;
};

export type HealthScoreReportRecommendationFinding = {
  __typename?: 'HealthScoreReportRecommendationFinding';
  geneticAnalysis?: Maybe<Scalars['String']['output']>;
  medicalTest?: Maybe<Scalars['String']['output']>;
  selfAssessment?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportRecommendationMutations = {
  __typename?: 'HealthScoreReportRecommendationMutations';
  generate?: Maybe<Scalars['Boolean']['output']>;
  tagAsRelevant?: Maybe<HealthScoreReportRecommendation>;
};


export type HealthScoreReportRecommendationMutationsTagAsRelevantArgs = {
  id: Scalars['String']['input'];
  isRelevant: Scalars['Boolean']['input'];
};

export type HealthScoreReportRecommendationQueries = {
  __typename?: 'HealthScoreReportRecommendationQueries';
  Evidence?: Maybe<HealthScoreReportRecommendationEvidenceQueries>;
  findAll?: Maybe<HealthScoreReportRecommendationResult>;
};


export type HealthScoreReportRecommendationQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthScoreReportRecommendationSortBy>;
  where?: InputMaybe<HealthScoreReportRecommendationFilter>;
};

export type HealthScoreReportRecommendationResult = {
  __typename?: 'HealthScoreReportRecommendationResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthScoreReportRecommendation>>>;
};

export type HealthScoreReportRecommendationSortBy = {
  category?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  subCategory?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type HealthScoreReportRecommendationSuggestion = {
  __typename?: 'HealthScoreReportRecommendationSuggestion';
  descriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  protocolCategories?: Maybe<Array<Maybe<HealthScoreReportRecommendationSuggestionSub>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportRecommendationSuggestionSub = {
  __typename?: 'HealthScoreReportRecommendationSuggestionSub';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportRecommendationTestRecommendation = {
  __typename?: 'HealthScoreReportRecommendationTestRecommendation';
  description?: Maybe<Scalars['String']['output']>;
  testName?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportRecommendationTrait = {
  __typename?: 'HealthScoreReportRecommendationTrait';
  genoType?: Maybe<Array<Maybe<HealthScoreReportRecommendationTraitGenotypes>>>;
  healthScoreReportId?: Maybe<Scalars['String']['output']>;
  healthScoreReportRecommendationEvidenceId?: Maybe<Scalars['String']['output']>;
  healthScoreReportRecommendationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  traitName?: Maybe<Scalars['String']['output']>;
};

export type HealthScoreReportRecommendationTraitGenotypes = {
  __typename?: 'HealthScoreReportRecommendationTraitGenotypes';
  geneName?: Maybe<Scalars['String']['output']>;
  genotype?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HealthScoreReportRecommendationTraitQueries = {
  __typename?: 'HealthScoreReportRecommendationTraitQueries';
  findAll?: Maybe<Scalars['Boolean']['output']>;
};

export enum HealthScoreReportSource {
  DailyActivities = 'DAILY_ACTIVITIES',
  DailyJournals = 'DAILY_JOURNALS',
  DnaReport = 'DNA_REPORT',
  Mcu = 'MCU',
  SelfAssestment = 'SELF_ASSESTMENT',
  Wearable = 'WEARABLE'
}

export type HealthScoreReportSummary = {
  __typename?: 'HealthScoreReportSummary';
  createdAt?: Maybe<Scalars['Date']['output']>;
  explorePotential?: Maybe<Array<Maybe<HealthScoreReportSummaryExplorePotential>>>;
  healthScoreId?: Maybe<Scalars['ID']['output']>;
  healthScoreReportId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  nextStep?: Maybe<Scalars['String']['output']>;
  opportunities?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['String']['output']>;
  supportingReferences?: Maybe<Array<Maybe<HealthScoreReportSummaryReferences>>>;
  topLifestyleBoosts?: Maybe<Array<Maybe<HealthScoreReportSummaryLifestyleBoost>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type HealthScoreReportSummaryExplorePotential = {
  __typename?: 'HealthScoreReportSummaryExplorePotential';
  aspect?: Maybe<Scalars['String']['output']>;
  benefit?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  healthScoreId?: Maybe<Scalars['ID']['output']>;
  healthScoreReportId?: Maybe<Scalars['ID']['output']>;
  healthScoreReportSummaryId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type HealthScoreReportSummaryLifestyleBoost = {
  __typename?: 'HealthScoreReportSummaryLifestyleBoost';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  factor?: Maybe<Scalars['String']['output']>;
  healthScoreId?: Maybe<Scalars['ID']['output']>;
  healthScoreReportId?: Maybe<Scalars['ID']['output']>;
  healthScoreReportSummaryId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  takeaway?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type HealthScoreReportSummaryReferences = {
  __typename?: 'HealthScoreReportSummaryReferences';
  link?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export enum HealthScoreReportTrigger {
  CronRecalculation = 'CRON_RECALCULATION',
  DnaReport = 'DNA_REPORT',
  ManualRecalculation = 'MANUAL_RECALCULATION',
  Mcu = 'MCU',
  Onboarding = 'ONBOARDING',
  OnDemand = 'ON_DEMAND',
  Recalibrate = 'RECALIBRATE',
  SelfAssestment = 'SELF_ASSESTMENT',
  Wearable = 'WEARABLE'
}

export type HealthScoreType = {
  __typename?: 'HealthScoreType';
  available?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  report?: Maybe<HealthScoreReport>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  show?: Maybe<Scalars['Boolean']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum HealthScoreTypeCode {
  Ascvd = 'ASCVD',
  Ckd = 'CKD',
  Diabetes = 'DIABETES',
  Hypertension = 'HYPERTENSION',
  Nafld = 'NAFLD'
}

export type HealthScoreTypeForm = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HealthScoreTypeMutations = {
  __typename?: 'HealthScoreTypeMutations';
  add?: Maybe<HealthScoreType>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<HealthScoreType>;
};


export type HealthScoreTypeMutationsAddArgs = {
  form?: InputMaybe<HealthScoreTypeForm>;
};


export type HealthScoreTypeMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type HealthScoreTypeMutationsEditArgs = {
  form?: InputMaybe<HealthScoreTypeForm>;
  id: Scalars['ID']['input'];
};

export type HealthScoreTypeQueries = {
  __typename?: 'HealthScoreTypeQueries';
  findAll?: Maybe<HealthScoreTypeQueryResult>;
  findOne?: Maybe<HealthScoreType>;
};


export type HealthScoreTypeQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HealthScoreTypeQuerySortBy>;
  where?: InputMaybe<HealthScoreTypeQueryFilter>;
};


export type HealthScoreTypeQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type HealthScoreTypeQueryFilter = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthScoreTypeQueryResult = {
  __typename?: 'HealthScoreTypeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HealthScoreType>>>;
};

export type HealthScoreTypeQuerySortBy = {
  position?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type HealthSetting = {
  __typename?: 'HealthSetting';
  callAppointment?: Maybe<Scalars['String']['output']>;
  callcenter?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  helpline?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type HelathScoreOutput = {
  __typename?: 'HelathScoreOutput';
  recommendation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  riskScore?: Maybe<Scalars['Float']['output']>;
};

export type HighlightPanel = {
  __typename?: 'HighlightPanel';
  code?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dPanelFigure?: Maybe<Array<Maybe<PanelFigure>>>;
  dPanelTranslation?: Maybe<Array<Maybe<DnaPanelTranslation>>>;
  description?: Maybe<Scalars['String']['output']>;
  favourableDescription?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unfavourableDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type HighlightQueryResult = {
  __typename?: 'HighlightQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HighlightPanel>>>;
};

export type InputWherePurchaseOrderFindAll = {
  status?: InputMaybe<PurchaseOrderStatus>;
};

export type InteractomeArticle = {
  __typename?: 'InteractomeArticle';
  article?: Maybe<HealthArticle>;
  articleId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dInteractome?: Maybe<DnaInteractome>;
  dnaInteractomeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type InteractomeCounselor = {
  __typename?: 'InteractomeCounselor';
  counselor?: Maybe<UserCounselor>;
  counselorId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dInteractome?: Maybe<DnaInteractome>;
  dnaInteractomeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type InteractomeReport = {
  __typename?: 'InteractomeReport';
  id?: Maybe<Scalars['String']['output']>;
};

export type Kit = {
  __typename?: 'Kit';
  batchId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  partnershipId?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<KitReport>>>;
  verifiedAt?: Maybe<Scalars['Date']['output']>;
};

export type KitActivateKitManuallyForm = {
  activatorProfileId?: InputMaybe<Scalars['String']['input']>;
  consentForm: Scalars['Upload']['input'];
  createNewProfile?: InputMaybe<Scalars['Boolean']['input']>;
  createNewSubProfile?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  kitCode: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  masterProfileId?: InputMaybe<Scalars['String']['input']>;
};

export type KitActivation = {
  __typename?: 'KitActivation';
  birthday?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCollected?: Maybe<Scalars['Boolean']['output']>;
  isProfileDeleted?: Maybe<Scalars['Boolean']['output']>;
  kit?: Maybe<Kit>;
  kitId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productKitPickupId?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sampleId?: Maybe<Scalars['String']['output']>;
  tutorialWatchedAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<KitActivationType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type KitActivationQueryFilter = {
  isPickedUpOrCollected?: InputMaybe<Scalars['Boolean']['input']>;
  isSampled?: InputMaybe<Scalars['Boolean']['input']>;
  reportTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type KitActivationQueryResult = {
  __typename?: 'KitActivationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<KitActivation>>>;
};

export type KitActivationQuestionnaire = {
  __typename?: 'KitActivationQuestionnaire';
  ethnic?: Maybe<Array<Maybe<ProfileEthnicityGroup>>>;
  identityNumber?: Maybe<Scalars['String']['output']>;
  parentalMedicalHistory?: Maybe<ParentalMedicalHistory>;
  physicalActivityLevel?: Maybe<PhysicalActivityLevel>;
};

export type KitActivationQuestionnaireMutations = {
  __typename?: 'KitActivationQuestionnaireMutations';
  create?: Maybe<KitActivationQuestionnaire>;
};


export type KitActivationQuestionnaireMutationsCreateArgs = {
  form?: InputMaybe<CreateKitActivationQuestionnaireAnswerForm>;
};

export type KitActivationQuestionnaireQueries = {
  __typename?: 'KitActivationQuestionnaireQueries';
  find?: Maybe<KitActivationQuestionnaire>;
};

export enum KitActivationType {
  Manual = 'MANUAL',
  Regular = 'REGULAR'
}

export enum KitCheckActivationAvailabilityErrorCodeEnum {
  Err1 = 'ERR1',
  Err2 = 'ERR2',
  Err3 = 'ERR3',
  Err4 = 'ERR4',
  Err5 = 'ERR5'
}

export type KitCheckActivationAvailabilityQuery = {
  kitcode: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export type KitCheckActivationAvailabilityResult = {
  __typename?: 'KitCheckActivationAvailabilityResult';
  ableToActivate?: Maybe<Scalars['Boolean']['output']>;
  errorCode?: Maybe<KitCheckActivationAvailabilityErrorCodeEnum>;
  message?: Maybe<Scalars['String']['output']>;
};

export type KitCheckManualActivationAvailabilityForm = {
  email?: InputMaybe<Scalars['String']['input']>;
  kitcode: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export enum KitProcessStatus {
  Activated = 'ACTIVATED',
  Collected = 'COLLECTED',
  OnLab = 'ON_LAB',
  PickupRequested = 'PICKUP_REQUESTED',
  ReportReleased = 'REPORT_RELEASED',
  TutorialWatched = 'TUTORIAL_WATCHED'
}

export type KitProcessStatusQueryResult = {
  __typename?: 'KitProcessStatusQueryResult';
  kit?: Maybe<PurchaseProductKit>;
  kitActivation?: Maybe<KitActivation>;
  status?: Maybe<KitProcessStatus>;
};

export type KitRelated = {
  __typename?: 'KitRelated';
  activationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labTrackingIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  processStatus?: Maybe<Scalars['String']['output']>;
  sampleId?: Maybe<Scalars['String']['output']>;
};

export type KitReport = {
  __typename?: 'KitReport';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interpretedAt?: Maybe<Scalars['Date']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum Lwb_Parent_Has_Been_Diagnosed {
  Both = 'BOTH',
  FatherOrMother = 'FATHER_OR_MOTHER',
  None = 'NONE'
}

export enum LabExtractionMethod {
  Beckman = 'BECKMAN',
  Genotek = 'GENOTEK',
  Qiasymphony = 'QIASYMPHONY',
  Tianglong = 'TIANGLONG'
}

export type LabMutations = {
  __typename?: 'LabMutations';
  Process?: Maybe<LabProcessMutations>;
  Sample?: Maybe<LabSampleMutations>;
  Setting?: Maybe<LabSettingMutations>;
  User?: Maybe<LabUserMutations>;
};

export type LabProcess = {
  __typename?: 'LabProcess';
  createdAt?: Maybe<Scalars['Date']['output']>;
  extraction?: Maybe<LabProcessExtraction>;
  id?: Maybe<Scalars['String']['output']>;
  infinium?: Maybe<LabProcessInfinium>;
  iscan?: Maybe<LabProcessIscan>;
  sample?: Maybe<LabSample>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabProcessExtraction = {
  __typename?: 'LabProcessExtraction';
  concentration?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labProcess?: Maybe<LabProcess>;
  method?: Maybe<LabExtractionMethod>;
  sample?: Maybe<LabSample>;
  status?: Maybe<LabProcessStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabProcessExtractionAddForm = {
  concentration?: InputMaybe<Scalars['Float']['input']>;
  kitCode: Scalars['String']['input'];
  method?: InputMaybe<LabExtractionMethod>;
};

export type LabProcessExtractionEditForm = {
  concentration?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  finishedAt?: InputMaybe<Scalars['Date']['input']>;
  method?: InputMaybe<LabExtractionMethod>;
  status?: InputMaybe<LabProcessStatus>;
};

export type LabProcessExtractionMutations = {
  __typename?: 'LabProcessExtractionMutations';
  add?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<LabProcessExtraction>;
  exportExcel?: Maybe<Scalars['String']['output']>;
};


export type LabProcessExtractionMutationsAddArgs = {
  forms: Array<LabProcessExtractionAddForm>;
};


export type LabProcessExtractionMutationsEditArgs = {
  form?: InputMaybe<LabProcessExtractionEditForm>;
  id: Scalars['String']['input'];
};


export type LabProcessExtractionMutationsExportExcelArgs = {
  sort?: InputMaybe<LabProcessExtractionSortBy>;
  where?: InputMaybe<LabProcessExtractionQueryFilter>;
};

export type LabProcessExtractionQueries = {
  __typename?: 'LabProcessExtractionQueries';
  findAll?: Maybe<LabProcessExtractionQueryResult>;
  findOne?: Maybe<LabProcessExtraction>;
  findOneByKitCode?: Maybe<LabProcessExtraction>;
};


export type LabProcessExtractionQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabProcessExtractionSortBy>;
  where?: InputMaybe<LabProcessExtractionQueryFilter>;
};


export type LabProcessExtractionQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type LabProcessExtractionQueriesFindOneByKitCodeArgs = {
  code: Scalars['String']['input'];
};

export type LabProcessExtractionQueryFilter = {
  concentrations?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  kitCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  methods?: InputMaybe<Array<InputMaybe<LabExtractionMethod>>>;
  status?: InputMaybe<Array<InputMaybe<LabProcessStatus>>>;
};

export type LabProcessExtractionQueryResult = {
  __typename?: 'LabProcessExtractionQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LabProcessExtraction>>>;
};

export type LabProcessExtractionSortBy = {
  concentration?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  finishedAt?: InputMaybe<SortDirection>;
  method?: InputMaybe<SortDirection>;
};

export type LabProcessInfinium = {
  __typename?: 'LabProcessInfinium';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labProcess?: Maybe<LabProcess>;
  position?: Maybe<Scalars['String']['output']>;
  sample?: Maybe<LabSample>;
  status?: Maybe<LabProcessStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabProcessInfiniumAddForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  kitCode: Scalars['String']['input'];
};

export type LabProcessInfiniumEditForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  finishedAt?: InputMaybe<Scalars['Date']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LabProcessStatus>;
};

export type LabProcessInfiniumMutation = {
  __typename?: 'LabProcessInfiniumMutation';
  add?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<LabProcessInfinium>;
  exportExcel?: Maybe<Scalars['String']['output']>;
};


export type LabProcessInfiniumMutationAddArgs = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  forms: Array<InputMaybe<LabProcessInfiniumAddForm>>;
};


export type LabProcessInfiniumMutationEditArgs = {
  form?: InputMaybe<LabProcessInfiniumEditForm>;
  id: Scalars['String']['input'];
};


export type LabProcessInfiniumMutationExportExcelArgs = {
  sort?: InputMaybe<LabProcessInfiniumSortBy>;
  where?: InputMaybe<LabProcessInfiniumQueryFilter>;
};

export type LabProcessInfiniumQueries = {
  __typename?: 'LabProcessInfiniumQueries';
  findAll?: Maybe<LabProcessInfiniumQueryResult>;
  findOne?: Maybe<LabProcessInfinium>;
  findOneByKitCode?: Maybe<LabProcessInfinium>;
};


export type LabProcessInfiniumQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabProcessInfiniumSortBy>;
  where?: InputMaybe<LabProcessInfiniumQueryFilter>;
};


export type LabProcessInfiniumQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type LabProcessInfiniumQueriesFindOneByKitCodeArgs = {
  code: Scalars['String']['input'];
};

export type LabProcessInfiniumQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<LabProcessStatus>>>;
};

export type LabProcessInfiniumQueryResult = {
  __typename?: 'LabProcessInfiniumQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LabProcessInfinium>>>;
};

export type LabProcessInfiniumSortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  finishedAt?: InputMaybe<SortDirection>;
  sample?: InputMaybe<LabSampleQuerySortBy>;
};

export type LabProcessIscan = {
  __typename?: 'LabProcessIscan';
  callRate?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labProcess?: Maybe<LabProcess>;
  result?: Maybe<LabProcessIscanResult>;
  sample?: Maybe<LabSample>;
  status?: Maybe<LabProcessStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabProcessIscanAddForm = {
  callRate?: InputMaybe<Scalars['Float']['input']>;
  kitCode: Scalars['String']['input'];
  result?: InputMaybe<LabProcessIscanResult>;
};

export type LabProcessIscanEditForm = {
  callRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  finishedAt?: InputMaybe<Scalars['Date']['input']>;
  result?: InputMaybe<LabProcessIscanResult>;
  status?: InputMaybe<LabProcessStatus>;
};

export type LabProcessIscanMutations = {
  __typename?: 'LabProcessIscanMutations';
  add?: Maybe<Scalars['Boolean']['output']>;
  confirmReswab?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<LabProcessIscan>;
  exportExcel?: Maybe<Scalars['String']['output']>;
  importCSV?: Maybe<Scalars['Boolean']['output']>;
  reextraction?: Maybe<Scalars['Boolean']['output']>;
  reswab?: Maybe<Scalars['Boolean']['output']>;
};


export type LabProcessIscanMutationsAddArgs = {
  forms: Array<InputMaybe<LabProcessIscanAddForm>>;
};


export type LabProcessIscanMutationsConfirmReswabArgs = {
  id: Scalars['String']['input'];
};


export type LabProcessIscanMutationsEditArgs = {
  form?: InputMaybe<LabProcessIscanEditForm>;
  id: Scalars['String']['input'];
};


export type LabProcessIscanMutationsExportExcelArgs = {
  sort?: InputMaybe<LabProcessIscanSortBy>;
  where?: InputMaybe<LabProcessIscanQueryFilter>;
};


export type LabProcessIscanMutationsImportCsvArgs = {
  file: Scalars['Upload']['input'];
};


export type LabProcessIscanMutationsReextractionArgs = {
  id: Scalars['String']['input'];
};


export type LabProcessIscanMutationsReswabArgs = {
  id: Scalars['String']['input'];
};

export type LabProcessIscanQueries = {
  __typename?: 'LabProcessIscanQueries';
  findAll?: Maybe<LabProcessIscanQueryResult>;
  findOne?: Maybe<LabProcessIscan>;
  findOneByKitCode?: Maybe<LabProcessIscan>;
};


export type LabProcessIscanQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabProcessIscanSortBy>;
  where?: InputMaybe<LabProcessIscanQueryFilter>;
};


export type LabProcessIscanQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type LabProcessIscanQueriesFindOneByKitCodeArgs = {
  code: Scalars['String']['input'];
};

export type LabProcessIscanQueryFilter = {
  callRate?: InputMaybe<Scalars['Float']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Array<InputMaybe<LabProcessIscanResult>>>;
  status?: InputMaybe<Array<InputMaybe<LabProcessStatus>>>;
};

export type LabProcessIscanQueryResult = {
  __typename?: 'LabProcessIscanQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LabProcessIscan>>>;
};

export enum LabProcessIscanResult {
  Fail = 'FAIL',
  Pass = 'PASS'
}

export type LabProcessIscanSortBy = {
  callRate?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  result?: InputMaybe<SortDirection>;
  sample?: InputMaybe<LabSampleQuerySortBy>;
  status?: InputMaybe<SortDirection>;
};

export type LabProcessMutations = {
  __typename?: 'LabProcessMutations';
  Extraction?: Maybe<LabProcessExtractionMutations>;
  Infinium?: Maybe<LabProcessInfiniumMutation>;
  Iscan?: Maybe<LabProcessIscanMutations>;
};

export type LabProcessQueries = {
  __typename?: 'LabProcessQueries';
  Extraction?: Maybe<LabProcessExtractionQueries>;
  Infinium?: Maybe<LabProcessInfiniumQueries>;
  Iscan?: Maybe<LabProcessIscanQueries>;
  findAll?: Maybe<LabProcessQueryResult>;
  findOne?: Maybe<LabProcess>;
};


export type LabProcessQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabProcessSortBy>;
  where?: InputMaybe<LabProcessQueryFilter>;
};


export type LabProcessQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type LabProcessQueryFilter = {
  sampleId?: InputMaybe<Scalars['String']['input']>;
};

export type LabProcessQueryResult = {
  __typename?: 'LabProcessQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LabProcess>>>;
};

export type LabProcessSortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export enum LabProcessStatus {
  Finished = 'FINISHED',
  Processed = 'PROCESSED',
  WaitingToScan = 'WAITING_TO_SCAN'
}

export type LabQueries = {
  __typename?: 'LabQueries';
  Process?: Maybe<LabProcessQueries>;
  Sample?: Maybe<LabSampleQueries>;
  Setting?: Maybe<LabSettingQueries>;
  Tracking?: Maybe<LabTrackingQueries>;
  User?: Maybe<LabUserQueries>;
};

export type LabSample = {
  __typename?: 'LabSample';
  attachment?: Maybe<Scalars['String']['output']>;
  batch?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  histories?: Maybe<Array<Maybe<LabSampleHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  kit?: Maybe<PurchaseProductKit>;
  labId?: Maybe<Scalars['String']['output']>;
  process?: Maybe<LabProcess>;
  receivedAt?: Maybe<Scalars['Date']['output']>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reswabShipment?: Maybe<ReswabShipmentResult>;
  status?: Maybe<LabSampleStatus>;
  totalReextraction?: Maybe<Scalars['Int']['output']>;
  totalReswab?: Maybe<Scalars['Int']['output']>;
  trackHistory?: Maybe<Array<Maybe<TrackHistoryQueryResult>>>;
  turnAroundAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserProfile>;
};


export type LabSampleTrackHistoryArgs = {
  sort?: InputMaybe<TrackHistoryQuerySortBy>;
  where?: InputMaybe<TrackHistoryQueryFilter>;
};

export type LabSampleForm = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  batch?: InputMaybe<Scalars['Int']['input']>;
  kitId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  receivedAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<LabSampleStatus>;
};

export type LabSampleHistory = {
  __typename?: 'LabSampleHistory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LabSampleStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabSampleMutations = {
  __typename?: 'LabSampleMutations';
  add?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<LabSample>;
  exportExcel?: Maybe<Scalars['String']['output']>;
  exportIscan?: Maybe<Scalars['String']['output']>;
};


export type LabSampleMutationsAddArgs = {
  form?: InputMaybe<Array<InputMaybe<LabSampleForm>>>;
};


export type LabSampleMutationsEditArgs = {
  form?: InputMaybe<LabSampleForm>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type LabSampleMutationsExportExcelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabSampleQuerySortBy>;
  where?: InputMaybe<LabSampleQueryFilter>;
};


export type LabSampleMutationsExportIscanArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabSampleQuerySortBy>;
  where?: InputMaybe<LabSampleQueryFilter>;
};

export type LabSampleQueries = {
  __typename?: 'LabSampleQueries';
  findAll?: Maybe<LabSampleQueryResult>;
  findBatch?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  findByKitCode?: Maybe<LabSample>;
  findLatestChipType?: Maybe<Scalars['String']['output']>;
  findOne?: Maybe<LabSample>;
  reswab?: Maybe<LabSampleQueryResult>;
  statistics?: Maybe<LabSampleStatistics>;
  trackHistory?: Maybe<Array<Maybe<TrackHistoryQueryResult>>>;
};


export type LabSampleQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabSampleQuerySortBy>;
  where?: InputMaybe<LabSampleQueryFilter>;
};


export type LabSampleQueriesFindBatchArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabSampleQuerySortBy>;
};


export type LabSampleQueriesFindByKitCodeArgs = {
  code: Scalars['String']['input'];
};


export type LabSampleQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type LabSampleQueriesReswabArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabSampleQuerySortBy>;
  where?: InputMaybe<LabSampleQueryFilter>;
};


export type LabSampleQueriesTrackHistoryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TrackHistoryQuerySortBy>;
  where?: InputMaybe<TrackHistoryQueryFilter>;
};

export type LabSampleQueryFilter = {
  batch?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<Array<InputMaybe<UserGender>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  kit?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  receivedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<LabSampleStatus>>>;
  totalReextraction?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LabSampleQueryResult = {
  __typename?: 'LabSampleQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LabSample>>>;
};

export type LabSampleQuerySortBy = {
  batch?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  finishedAt?: InputMaybe<SortDirection>;
  kit?: InputMaybe<PurchaseProductKitQuerySortBy>;
  labId?: InputMaybe<SortDirection>;
  receivedAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  turnAroundAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  user?: InputMaybe<UserQuerySortBy>;
};

export type LabSampleStatistics = {
  __typename?: 'LabSampleStatistics';
  extraction?: Maybe<Scalars['Int']['output']>;
  iScanFail?: Maybe<Scalars['Int']['output']>;
  iScanPass?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  infinium?: Maybe<Scalars['Int']['output']>;
  received?: Maybe<Scalars['Int']['output']>;
  reextraction?: Maybe<Scalars['Int']['output']>;
  reswab?: Maybe<Scalars['Int']['output']>;
};


export type LabSampleStatisticsExtractionArgs = {
  where?: InputMaybe<LabSampleStatisticsQueryFilter>;
};


export type LabSampleStatisticsIScanFailArgs = {
  where?: InputMaybe<LabSampleStatisticsQueryFilter>;
};


export type LabSampleStatisticsIScanPassArgs = {
  where?: InputMaybe<LabSampleStatisticsQueryFilter>;
};


export type LabSampleStatisticsInfiniumArgs = {
  where?: InputMaybe<LabSampleStatisticsQueryFilter>;
};


export type LabSampleStatisticsReceivedArgs = {
  where?: InputMaybe<LabSampleStatisticsQueryFilter>;
};


export type LabSampleStatisticsReextractionArgs = {
  where?: InputMaybe<LabSampleStatisticsQueryFilter>;
};


export type LabSampleStatisticsReswabArgs = {
  where?: InputMaybe<LabSampleStatisticsQueryFilter>;
};

export type LabSampleStatisticsQueryFilter = {
  durations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum LabSampleStatus {
  Extraction = 'EXTRACTION',
  Infinium = 'INFINIUM',
  Iscan = 'ISCAN',
  IscanFail = 'ISCAN_FAIL',
  IscanPass = 'ISCAN_PASS',
  OnHold = 'ON_HOLD',
  Received = 'RECEIVED',
  Reextraction = 'REEXTRACTION',
  ReportOut = 'REPORT_OUT',
  ReswabConfirmed = 'RESWAB_CONFIRMED',
  ReswabRequested = 'RESWAB_REQUESTED'
}

export type LabSetting = {
  __typename?: 'LabSetting';
  batch?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<LabSettingPayload>;
  turnAroundTime?: Maybe<Scalars['Float']['output']>;
  turnAroundTimeUnlock?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabSettingForm = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<LabSettingPayloadForm>;
  turnAroundTime?: InputMaybe<Scalars['Float']['input']>;
};

export type LabSettingMutations = {
  __typename?: 'LabSettingMutations';
  edit?: Maybe<LabSetting>;
};


export type LabSettingMutationsEditArgs = {
  form?: InputMaybe<LabSettingForm>;
};

export type LabSettingPayload = {
  __typename?: 'LabSettingPayload';
  iscan?: Maybe<LabSettingPayloadIscan>;
};

export type LabSettingPayloadForm = {
  iscan?: InputMaybe<LabSettingPayloadIscanForm>;
};

export type LabSettingPayloadIscan = {
  __typename?: 'LabSettingPayloadIscan';
  treshold?: Maybe<Scalars['Float']['output']>;
};

export type LabSettingPayloadIscanForm = {
  treshold?: InputMaybe<Scalars['Float']['input']>;
};

export type LabSettingQueries = {
  __typename?: 'LabSettingQueries';
  findOne?: Maybe<LabSetting>;
  findOneV2?: Maybe<LabSetting>;
};

export type LabTracking = {
  __typename?: 'LabTracking';
  createdAt?: Maybe<Scalars['Date']['output']>;
  history?: Maybe<Array<Maybe<LabTrackingHistory>>>;
  id?: Maybe<Scalars['ID']['output']>;
  isReportOut?: Maybe<Scalars['Boolean']['output']>;
  kit?: Maybe<Kit>;
  kitActivation?: Maybe<KitActivation>;
  orderUnlock?: Maybe<OrderUnlock>;
  orderUnlockHistories?: Maybe<Array<Maybe<OrderUnlockHistory>>>;
  reportTypeTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sample?: Maybe<LabSample>;
  sampleHistories?: Maybe<Array<Maybe<LabSampleHistory>>>;
  status?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Array<Maybe<LabTrackingTimeLine>>>;
  turnAroundAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<LabTrackingType>;
};

export type LabTrackingEvent = {
  __typename?: 'LabTrackingEvent';
  profileId?: Maybe<Scalars['String']['output']>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sampleId?: Maybe<Scalars['String']['output']>;
};

export type LabTrackingHistory = {
  __typename?: 'LabTrackingHistory';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  iteration?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabTrackingQueries = {
  __typename?: 'LabTrackingQueries';
  findAll?: Maybe<LabTrackingQueryResult>;
  findOne?: Maybe<LabTracking>;
};


export type LabTrackingQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabTrackingQuerySortBy>;
  where?: InputMaybe<LabTrackingQueryFilter>;
};


export type LabTrackingQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type LabTrackingQueryFilter = {
  sampleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LabTrackingQueryResult = {
  __typename?: 'LabTrackingQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LabTracking>>>;
};

export type LabTrackingQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type LabTrackingTimeLine = {
  __typename?: 'LabTrackingTimeLine';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export enum LabTrackingType {
  OrderUnlock = 'ORDER_UNLOCK',
  OrderUnlockNochip = 'ORDER_UNLOCK_NOCHIP',
  Sample = 'SAMPLE'
}

export type LabUser = {
  __typename?: 'LabUser';
  access?: Maybe<LabUserAccess>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<LabUserRole>;
  status?: Maybe<LabUserStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type LabUserAccess = {
  __typename?: 'LabUserAccess';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LabUserAccessForm = {
  modules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LabUserForm = {
  access?: InputMaybe<LabUserAccessForm>;
  password?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<LabUserRole>;
  status?: InputMaybe<LabUserStatus>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LabUserMutations = {
  __typename?: 'LabUserMutations';
  add?: Maybe<LabUser>;
  edit?: Maybe<LabUser>;
};


export type LabUserMutationsAddArgs = {
  form?: InputMaybe<LabUserForm>;
};


export type LabUserMutationsEditArgs = {
  form?: InputMaybe<LabUserForm>;
  id: Scalars['String']['input'];
};

export type LabUserQueries = {
  __typename?: 'LabUserQueries';
  findAll?: Maybe<LabUserQueryResult>;
  findOne?: Maybe<LabUser>;
  profile?: Maybe<LabUser>;
};


export type LabUserQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LabUserQuerySortBy>;
  where?: InputMaybe<LabUserQueryFilter>;
};


export type LabUserQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type LabUserQueryFilter = {
  roles?: InputMaybe<Array<InputMaybe<LabUserRole>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LabUserQueryResult = {
  __typename?: 'LabUserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LabUser>>>;
};

export type LabUserQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  username?: InputMaybe<SortDirection>;
};

export enum LabUserRole {
  Editor = 'EDITOR',
  Master = 'MASTER',
  Viewer = 'VIEWER'
}

export enum LabUserStatus {
  Active = 'ACTIVE',
  NotActive = 'NOT_ACTIVE'
}

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nativeName: Scalars['String']['output'];
  onesignalCode: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum LanguageCode {
  En = 'EN',
  Id = 'ID'
}

export type LanguageForm = {
  code: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nativeName: Scalars['String']['input'];
  onesignalCode: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type LanguageMutations = {
  __typename?: 'LanguageMutations';
  add?: Maybe<Language>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Language>;
};


export type LanguageMutationsAddArgs = {
  form: LanguageForm;
};


export type LanguageMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type LanguageMutationsEditArgs = {
  form: LanguageForm;
  id: Scalars['String']['input'];
};

export type LanguageQueries = {
  __typename?: 'LanguageQueries';
  findAll?: Maybe<LanguageQueryResult>;
  findOne?: Maybe<Language>;
};


export type LanguageQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LanguageQuerySortBy>;
  where?: InputMaybe<LanguageQueryFilter>;
};


export type LanguageQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type LanguageQueryFilter = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nativeName?: InputMaybe<Scalars['String']['input']>;
  onesignalCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LanguageQueryResult = {
  __typename?: 'LanguageQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Language>>>;
};

export type LanguageQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  nativeName?: InputMaybe<SortDirection>;
  sortOrder?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type LifestyleRiskFactors = {
  __typename?: 'LifestyleRiskFactors';
  age: Scalars['Int']['output'];
  bmi: Scalars['Float']['output'];
  diet: Scalars['String']['output'];
  exercise: Scalars['String']['output'];
};

export type Mcu = {
  __typename?: 'MCU';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creationType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  laboratorium?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<PurchaseOrder>;
  ownerProfile?: Maybe<UserProfile>;
  ownerProfileId?: Maybe<Scalars['String']['output']>;
  resultType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<McuStatus>;
  type?: Maybe<PurchaseOrderType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visitedAt?: Maybe<Scalars['Date']['output']>;
};

export type McuAddManualForm = {
  email?: InputMaybe<Scalars['String']['input']>;
  ownerProfileId?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  visitedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type McuMutations = {
  __typename?: 'MCUMutations';
  Patient?: Maybe<McuPatientMutations>;
  addManual?: Maybe<Mcu>;
};


export type McuMutationsAddManualArgs = {
  form?: InputMaybe<McuAddManualForm>;
};

export type McuPatient = {
  __typename?: 'MCUPatient';
  attachment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  laboratorium?: Maybe<Scalars['String']['output']>;
  mcu?: Maybe<Mcu>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type McuPatientForm = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  laboratorium?: InputMaybe<Scalars['String']['input']>;
  mcuId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type McuPatientMutations = {
  __typename?: 'MCUPatientMutations';
  add?: Maybe<McuPatient>;
  edit?: Maybe<McuPatient>;
};


export type McuPatientMutationsAddArgs = {
  form?: InputMaybe<McuPatientForm>;
};


export type McuPatientMutationsEditArgs = {
  form?: InputMaybe<McuPatientForm>;
  id: Scalars['ID']['input'];
};

export type McuPatientQueries = {
  __typename?: 'MCUPatientQueries';
  findAll?: Maybe<McuPatientQueryResult>;
  findOne?: Maybe<McuPatient>;
};


export type McuPatientQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<McuPatientQuerySortBy>;
  where?: InputMaybe<McuPatientQueryFilter>;
};


export type McuPatientQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type McuPatientQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  mcu?: InputMaybe<Scalars['ID']['input']>;
};

export type McuPatientQueryResult = {
  __typename?: 'MCUPatientQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<McuPatient>>>;
};

export type McuPatientQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  laboratorium?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
};

export type McuQueries = {
  __typename?: 'MCUQueries';
  Patient?: Maybe<McuPatientQueries>;
  findAll?: Maybe<McuQueryResult>;
  findOne?: Maybe<Mcu>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type McuQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<McuQuerySortBy>;
  where?: InputMaybe<McuQueryFilter>;
};


export type McuQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type McuQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<McuStatus>>>;
  visitedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type McuQueryResult = {
  __typename?: 'MCUQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Mcu>>>;
};

export type McuQuerySortBy = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<SortDirection>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<Scalars['String']['input']>;
  visitedAt?: InputMaybe<SortDirection>;
};

export enum McuStatus {
  Complete = 'COMPLETE',
  WaitingForResult = 'WAITING_FOR_RESULT',
  WaitingForVisit = 'WAITING_FOR_VISIT'
}

export type ManualBulkActivationForm = {
  domain: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};

export type MarkNotificationWearableClickedResult = {
  __typename?: 'MarkNotificationWearableClickedResult';
  message: Scalars['String']['output'];
  notification?: Maybe<NotificationWearable>;
  success: Scalars['Boolean']['output'];
};

export type MasterDictionaryMutations = {
  __typename?: 'MasterDictionaryMutations';
  ContentManagement?: Maybe<ContentManagementMutations>;
};

export type MasterDictionaryQueries = {
  __typename?: 'MasterDictionaryQueries';
  ContentManagement?: Maybe<ContentManagementQueries>;
};

export type MasterHormoneSymptom = {
  __typename?: 'MasterHormoneSymptom';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MasterMedicalCondition = {
  __typename?: 'MasterMedicalCondition';
  applicableParent?: Maybe<Array<Maybe<MasterMedicalConditionApplicableParentType>>>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isContagious?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Array<Maybe<MasterMedicalConditionType>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum MasterMedicalConditionApplicableParentType {
  Both = 'BOTH',
  Father = 'FATHER',
  Mother = 'MOTHER'
}

export type MasterMedicalConditionQueries = {
  __typename?: 'MasterMedicalConditionQueries';
  findAll?: Maybe<MasterMedicalConditionResult>;
  findOne?: Maybe<MasterMedicalCondition>;
};


export type MasterMedicalConditionQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MasterMedicalConditionQuerySortBy>;
  where?: InputMaybe<MasterMedicalConditionQueryFilter>;
};


export type MasterMedicalConditionQueriesFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MasterMedicalConditionQueryFilter = {
  applicableParent?: InputMaybe<Array<InputMaybe<MasterMedicalConditionApplicableParentType>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isContagious?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<MasterMedicalConditionType>>>;
};

export type MasterMedicalConditionQuerySortBy = {
  category?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type MasterMedicalConditionResult = {
  __typename?: 'MasterMedicalConditionResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MasterMedicalCondition>>>;
};

export enum MasterMedicalConditionType {
  Disease = 'DISEASE',
  Illness = 'ILLNESS',
  Surgical = 'SURGICAL'
}

export type MasterMedication = {
  __typename?: 'MasterMedication';
  applicableGender?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MasterMedicationQueries = {
  __typename?: 'MasterMedicationQueries';
  findAll?: Maybe<MasterMedicationResult>;
  findOne?: Maybe<MasterMedication>;
};


export type MasterMedicationQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MasterMedicationQuerySortBy>;
  where?: InputMaybe<MasterMedicationQueryFilter>;
};


export type MasterMedicationQueriesFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MasterMedicationQueryFilter = {
  applicableGender?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameId?: InputMaybe<Scalars['String']['input']>;
};

export type MasterMedicationQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type MasterMedicationResult = {
  __typename?: 'MasterMedicationResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MasterMedication>>>;
};

export type MasterQueries = {
  __typename?: 'MasterQueries';
  MedicalCondition?: Maybe<MasterMedicalConditionQueries>;
  Medication?: Maybe<MasterMedicationQueries>;
};

export type MediaMutations = {
  __typename?: 'MediaMutations';
  Banner?: Maybe<BannerMutations>;
  Music?: Maybe<MusicMutations>;
  Podcast?: Maybe<PodcastMutations>;
};

export type MediaQueries = {
  __typename?: 'MediaQueries';
  Banner?: Maybe<BannerQueries>;
  Music?: Maybe<MusicQueries>;
  Podcast?: Maybe<PodcastQueries>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MedicalQueryFilter = {
  isMasterData?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MedicalType {
  Clinical = 'CLINICAL',
  Disease = 'DISEASE',
  Illness = 'ILLNESS',
  Surgical = 'SURGICAL'
}

export type Merchant = {
  __typename?: 'Merchant';
  address?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<MerchantCategory>>>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picName?: Maybe<Scalars['String']['output']>;
  picPhone?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  vouchers?: Maybe<Array<Maybe<MerchantVoucher>>>;
};

export type MerchantBanner = {
  __typename?: 'MerchantBanner';
  bannerPlacement?: Maybe<MerchantBannerPlacement>;
  bannerPlacementId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  merchantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type MerchantBannerForm = {
  bannerPlacementId: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};

export type MerchantBannerMutations = {
  __typename?: 'MerchantBannerMutations';
  add?: Maybe<MerchantBanner>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<MerchantBanner>;
};


export type MerchantBannerMutationsAddArgs = {
  req?: InputMaybe<MerchantBannerForm>;
};


export type MerchantBannerMutationsDeleteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MerchantBannerMutationsEditArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  req?: InputMaybe<MerchantBannerForm>;
};

export type MerchantBannerPlacement = {
  __typename?: 'MerchantBannerPlacement';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  placementName?: Maybe<Scalars['String']['output']>;
};

export type MerchantBannerPlacementForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  placementName: Scalars['String']['input'];
};

export type MerchantBannerPlacementQueries = {
  __typename?: 'MerchantBannerPlacementQueries';
  findAll?: Maybe<MerchantBannerPlacementQueryResult>;
};


export type MerchantBannerPlacementQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantBannerPlacementQuerySortBy>;
  where?: InputMaybe<MerchantBannerPlacementQueryFilter>;
};

export type MerchantBannerPlacementQueryFilter = {
  placementName?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantBannerPlacementQueryResult = {
  __typename?: 'MerchantBannerPlacementQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MerchantBannerPlacement>>>;
};

export type MerchantBannerPlacementQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  placementName?: InputMaybe<SortDirection>;
};

export type MerchantBannerQueries = {
  __typename?: 'MerchantBannerQueries';
  findAll?: Maybe<MerchantBannerQueryResult>;
  findOne?: Maybe<MerchantBanner>;
  id?: Maybe<Scalars['String']['output']>;
};


export type MerchantBannerQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantBannerQuerySortBy>;
  where?: InputMaybe<MerchantBannerQueryFilter>;
};


export type MerchantBannerQueriesFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantBannerQuery = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantBannerQuerySortBy>;
  where?: InputMaybe<MerchantBannerQueryFilter>;
};

export type MerchantBannerQueryFilter = {
  bannerPlacementId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  periodeDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MerchantBannerQueryResult = {
  __typename?: 'MerchantBannerQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MerchantBanner>>>;
};

export type MerchantBannerQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type MerchantCategory = {
  __typename?: 'MerchantCategory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MerchantCategoryForm = {
  name: Scalars['String']['input'];
};

export type MerchantCategoryMutations = {
  __typename?: 'MerchantCategoryMutations';
  add?: Maybe<MerchantCategory>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<MerchantCategory>;
};


export type MerchantCategoryMutationsAddArgs = {
  req?: InputMaybe<MerchantCategoryForm>;
};


export type MerchantCategoryMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MerchantCategoryMutationsEditArgs = {
  id: Scalars['String']['input'];
  req?: InputMaybe<MerchantCategoryForm>;
};

export type MerchantCategoryQueries = {
  __typename?: 'MerchantCategoryQueries';
  findAll?: Maybe<MerchantCategoryQueryResult>;
  findOne?: Maybe<MerchantCategory>;
  id?: Maybe<Scalars['String']['output']>;
};


export type MerchantCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantCategoryQuerySortBy>;
  where?: InputMaybe<MerchantCategoryQueryFilter>;
};


export type MerchantCategoryQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type MerchantCategoryQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantCategoryQueryResult = {
  __typename?: 'MerchantCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MerchantCategory>>>;
};

export type MerchantCategoryQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type MerchantExposure = {
  __typename?: 'MerchantExposure';
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userChatId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MerchantExposureChart = {
  __typename?: 'MerchantExposureChart';
  details?: Maybe<Array<Maybe<MerchantExposureChartDetail>>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type MerchantExposureChartDetail = {
  __typename?: 'MerchantExposureChartDetail';
  description?: Maybe<Scalars['String']['output']>;
  totalActiveUser?: Maybe<Scalars['Int']['output']>;
  totalContentGenerated?: Maybe<Scalars['Int']['output']>;
  totalExposedUser?: Maybe<Scalars['Int']['output']>;
  totalFollowUpQuestion?: Maybe<Scalars['Int']['output']>;
};

export type MerchantExposureChartSummary = {
  __typename?: 'MerchantExposureChartSummary';
  chart?: Maybe<MerchantExposureChart>;
  summary?: Maybe<MerchantExposureSummary>;
};

export type MerchantExposureDistinctByDay = {
  __typename?: 'MerchantExposureDistinctByDay';
  date?: Maybe<Scalars['String']['output']>;
  totalActiveUser?: Maybe<Scalars['Int']['output']>;
  totalContentGenerated?: Maybe<Scalars['Int']['output']>;
  totalExposedUser?: Maybe<Scalars['Int']['output']>;
  totalFollowUpQuestion?: Maybe<Scalars['Int']['output']>;
};

export type MerchantExposureDistinctByDayResult = {
  __typename?: 'MerchantExposureDistinctByDayResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MerchantExposureDistinctByDay>>>;
};

export type MerchantExposureFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  merchantIds: Array<InputMaybe<Scalars['String']['input']>>;
  startDate: Scalars['Date']['input'];
};

export type MerchantExposureQueries = {
  __typename?: 'MerchantExposureQueries';
  findAllChartAndSummary?: Maybe<Array<Maybe<MerchantExposureChartSummary>>>;
  findAllDistinctByDay?: Maybe<MerchantExposureDistinctByDayResult>;
};


export type MerchantExposureQueriesFindAllChartAndSummaryArgs = {
  where?: InputMaybe<MerchantExposureFilter>;
};


export type MerchantExposureQueriesFindAllDistinctByDayArgs = {
  where?: InputMaybe<MerchantExposureFilter>;
};

export type MerchantExposureSummary = {
  __typename?: 'MerchantExposureSummary';
  totalActiveUser?: Maybe<Scalars['Int']['output']>;
  totalContentGenerated?: Maybe<Scalars['Int']['output']>;
  totalExposedUser?: Maybe<Scalars['Int']['output']>;
  totalFollowUpQuestion?: Maybe<Scalars['Int']['output']>;
};

export type MerchantForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  categories: Array<InputMaybe<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  logoUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhone: Scalars['String']['input'];
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantFormV2 = {
  address?: InputMaybe<Scalars['String']['input']>;
  categories: Array<InputMaybe<Scalars['String']['input']>>;
  city: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  district: Scalars['String']['input'];
  internalRepresentative: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  keyword?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  logoUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  partnershipDurationEndAt?: InputMaybe<Scalars['Date']['input']>;
  partnershipDurationStartAt: Scalars['Date']['input'];
  partnershipType: Array<InputMaybe<MerchantPartnershipType>>;
  picEmail: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  province: Scalars['String']['input'];
  relationshipSince?: InputMaybe<Scalars['Date']['input']>;
  subdistrict?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantMutations = {
  __typename?: 'MerchantMutations';
  MerchantBanner?: Maybe<MerchantBannerMutations>;
  MerchantCategory?: Maybe<MerchantCategoryMutations>;
  MerchantVoucher?: Maybe<MerchantVoucherMutations>;
  add?: Maybe<Merchant>;
  addV2?: Maybe<MerchantV2>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Merchant>;
  editV2?: Maybe<MerchantV2>;
};


export type MerchantMutationsAddArgs = {
  req: MerchantForm;
};


export type MerchantMutationsAddV2Args = {
  req: MerchantFormV2;
};


export type MerchantMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MerchantMutationsEditArgs = {
  id: Scalars['String']['input'];
  req?: InputMaybe<MerchantForm>;
};


export type MerchantMutationsEditV2Args = {
  id: Scalars['String']['input'];
  req?: InputMaybe<MerchantFormV2>;
};

export enum MerchantPartnershipType {
  Merchant = 'MERCHANT',
  Sponsorship = 'SPONSORSHIP'
}

export type MerchantQueries = {
  __typename?: 'MerchantQueries';
  MerchantBanner?: Maybe<MerchantBannerQueries>;
  MerchantBannerPlacement?: Maybe<MerchantBannerPlacementQueries>;
  MerchantCategory?: Maybe<MerchantCategoryQueries>;
  MerchantExposure?: Maybe<MerchantExposureQueries>;
  MerchantVoucher?: Maybe<MerchantVoucherQueries>;
  findAll?: Maybe<MerchantQueryResult>;
  findAllV2?: Maybe<MerchantQueryResultV2>;
  findByCode?: Maybe<Merchant>;
  findByCodeV2?: Maybe<MerchantV2>;
  findOne?: Maybe<Merchant>;
  findOneV2?: Maybe<MerchantV2>;
  id?: Maybe<Scalars['String']['output']>;
};


export type MerchantQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantQuerySortBy>;
  where?: InputMaybe<MerchantQueryFilter>;
};


export type MerchantQueriesFindAllV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantQuerySortBy>;
  where?: InputMaybe<MerchantQueryFilter>;
};


export type MerchantQueriesFindByCodeArgs = {
  code: Scalars['String']['input'];
};


export type MerchantQueriesFindByCodeV2Args = {
  code: Scalars['String']['input'];
};


export type MerchantQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type MerchantQueriesFindOneV2Args = {
  id: Scalars['String']['input'];
};

export type MerchantQueryFilter = {
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnershipType?: InputMaybe<Array<InputMaybe<MerchantPartnershipType>>>;
};

export type MerchantQueryResult = {
  __typename?: 'MerchantQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Merchant>>>;
};

export type MerchantQueryResultV2 = {
  __typename?: 'MerchantQueryResultV2';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MerchantV2>>>;
};

export type MerchantQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum MerchantType {
  Asaren = 'ASAREN',
  Sponsorship = 'SPONSORSHIP'
}

export type MerchantV2 = {
  __typename?: 'MerchantV2';
  address?: Maybe<Scalars['String']['output']>;
  banners?: Maybe<Array<Maybe<MerchantBanner>>>;
  categories?: Maybe<Array<Maybe<MerchantCategory>>>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalRepresentative?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnershipDurationEndAt?: Maybe<Scalars['Date']['output']>;
  partnershipDurationStartAt?: Maybe<Scalars['Date']['output']>;
  partnershipType?: Maybe<Array<Maybe<MerchantPartnershipType>>>;
  picEmail?: Maybe<Scalars['String']['output']>;
  picName?: Maybe<Scalars['String']['output']>;
  picPhone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  relationshipSince?: Maybe<Scalars['Date']['output']>;
  subdistrict?: Maybe<Scalars['String']['output']>;
  vouchers?: Maybe<Array<Maybe<MerchantVoucher>>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type MerchantVoucher = {
  __typename?: 'MerchantVoucher';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expireDate?: Maybe<Scalars['Date']['output']>;
  failedTransactionCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isOneTimeUse?: Maybe<Scalars['Boolean']['output']>;
  isUserEligible?: Maybe<Scalars['Boolean']['output']>;
  merchant?: Maybe<Merchant>;
  merchantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  successfullTransactionCount?: Maybe<Scalars['Int']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<MerchantVoucherType>;
};

export type MerchantVoucherForm = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  expireDate: Scalars['Date']['input'];
  isActive: Scalars['Boolean']['input'];
  isOneTimeUse: Scalars['Boolean']['input'];
  merchantId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  type: MerchantVoucherType;
};

export type MerchantVoucherMutations = {
  __typename?: 'MerchantVoucherMutations';
  MerchantVoucherUser?: Maybe<MerchantVoucherUserMutations>;
  add?: Maybe<MerchantVoucher>;
  available?: Maybe<Scalars['Int']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<MerchantVoucher>;
};


export type MerchantVoucherMutationsAddArgs = {
  req?: InputMaybe<MerchantVoucherForm>;
};


export type MerchantVoucherMutationsAvailableArgs = {
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type MerchantVoucherMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MerchantVoucherMutationsEditArgs = {
  id: Scalars['String']['input'];
  req?: InputMaybe<MerchantVoucherForm>;
};

export type MerchantVoucherQueries = {
  __typename?: 'MerchantVoucherQueries';
  MerchantVoucherUser?: Maybe<MerchantVoucherUserQueries>;
  findAll?: Maybe<MerchantVoucherQueryResult>;
  findByCode?: Maybe<MerchantVoucher>;
  findOne?: Maybe<MerchantVoucher>;
  id?: Maybe<Scalars['String']['output']>;
};


export type MerchantVoucherQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantVoucherQuerySortBy>;
  where?: InputMaybe<MerchantVoucherQueryFilter>;
};


export type MerchantVoucherQueriesFindByCodeArgs = {
  code: Scalars['String']['input'];
};


export type MerchantVoucherQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type MerchantVoucherQueryFilter = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expireDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<MerchantVoucherStatusEnum>>>;
  transactionCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<MerchantVoucherType>>>;
};

export type MerchantVoucherQueryResult = {
  __typename?: 'MerchantVoucherQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MerchantVoucher>>>;
};

export type MerchantVoucherQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  isUserEligible?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum MerchantVoucherStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export enum MerchantVoucherStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export enum MerchantVoucherType {
  Bundle = 'BUNDLE',
  Cashback = 'CASHBACK',
  Discount = 'DISCOUNT',
  Free = 'FREE',
  FreebiesItems = 'FREEBIES_ITEMS',
  Voucher = 'VOUCHER'
}

export type MerchantVoucherUser = {
  __typename?: 'MerchantVoucherUser';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  profileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MerchantVoucherStatus>;
  voucher?: Maybe<MerchantVoucher>;
  voucherId?: Maybe<Scalars['String']['output']>;
};

export type MerchantVoucherUserForm = {
  merchantId: Scalars['String']['input'];
  voucherId: Scalars['String']['input'];
};

export type MerchantVoucherUserMutations = {
  __typename?: 'MerchantVoucherUserMutations';
  add?: Maybe<MerchantVoucherUser>;
};


export type MerchantVoucherUserMutationsAddArgs = {
  req?: InputMaybe<MerchantVoucherUserForm>;
};

export type MerchantVoucherUserQueries = {
  __typename?: 'MerchantVoucherUserQueries';
  findAll?: Maybe<MerchantVoucherUserQueryResult>;
  findOne?: Maybe<MerchantVoucherUser>;
  id?: Maybe<Scalars['String']['output']>;
};


export type MerchantVoucherUserQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MerchantVoucherUserQuerySortBy>;
  where?: InputMaybe<MerchantVoucherUserQueryFilter>;
};


export type MerchantVoucherUserQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type MerchantVoucherUserQueryFilter = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<MerchantVoucherStatus>>>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantVoucherUserQueryResult = {
  __typename?: 'MerchantVoucherUserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MerchantVoucherUser>>>;
};

export type MerchantVoucherUserQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type MinMaxOrder = {
  __typename?: 'MinMaxOrder';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type Music = {
  __typename?: 'Music';
  category?: Maybe<MusicCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MusicCategory = {
  __typename?: 'MusicCategory';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MusicCategoryForm = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MusicCategoryMutations = {
  __typename?: 'MusicCategoryMutations';
  add?: Maybe<MusicCategory>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<MusicCategory>;
};


export type MusicCategoryMutationsAddArgs = {
  form?: InputMaybe<MusicCategoryForm>;
};


export type MusicCategoryMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MusicCategoryMutationsEditArgs = {
  form?: InputMaybe<MusicCategoryForm>;
  id: Scalars['String']['input'];
};

export type MusicCategoryQueries = {
  __typename?: 'MusicCategoryQueries';
  findAll?: Maybe<MusicCategoryQueryResult>;
  findOne?: Maybe<MusicCategory>;
};


export type MusicCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MusicCategoryQuerySortBy>;
  where?: InputMaybe<MusicCategoryQueryFilter>;
};


export type MusicCategoryQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type MusicCategoryQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MusicCategoryQueryResult = {
  __typename?: 'MusicCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MusicCategory>>>;
};

export type MusicCategoryQuerySortBy = {
  name?: InputMaybe<SortDirection>;
};

export type MusicForm = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<Scalars['Upload']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MusicMutations = {
  __typename?: 'MusicMutations';
  Category?: Maybe<MusicCategoryMutations>;
  add?: Maybe<Music>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Music>;
};


export type MusicMutationsAddArgs = {
  form?: InputMaybe<MusicForm>;
};


export type MusicMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MusicMutationsEditArgs = {
  form?: InputMaybe<MusicForm>;
  id: Scalars['String']['input'];
};

export type MusicQueries = {
  __typename?: 'MusicQueries';
  Category?: Maybe<MusicCategoryQueries>;
  findAll?: Maybe<MusicQueryResult>;
  findOne?: Maybe<Music>;
};


export type MusicQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MusicQuerySortBy>;
  where?: InputMaybe<MusicQueryFilter>;
};


export type MusicQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type MusicQueryFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MusicQueryResult = {
  __typename?: 'MusicQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Music>>>;
};

export type MusicQuerySortBy = {
  category?: InputMaybe<MusicCategoryQuerySortBy>;
  createdAt?: InputMaybe<SortDirection>;
  duration?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type Mutation = {
  __typename?: 'Mutation';
  Admin?: Maybe<AdminMutations>;
  AnterAja?: Maybe<AnterAjaMutation>;
  Bioinformatic?: Maybe<BioinformaticMutations>;
  Career?: Maybe<CareerMutations>;
  Country?: Maybe<CountryMutations>;
  DNA?: Maybe<DnaMutations>;
  EHR?: Maybe<EhrMutations>;
  Ethnicity?: Maybe<EthnicityMutations>;
  Event?: Maybe<EventMutations>;
  Health?: Maybe<HealthMutations>;
  HealthScore?: Maybe<HealthScoreMutations>;
  Lab?: Maybe<LabMutations>;
  Language?: Maybe<LanguageMutations>;
  MCU?: Maybe<McuMutations>;
  Media?: Maybe<MediaMutations>;
  Merchant?: Maybe<MerchantMutations>;
  News?: Maybe<NewsMutations>;
  OCRProcess?: Maybe<OcrProcessMutations>;
  Partner?: Maybe<PartnerMutations>;
  Payment?: Maybe<PaymentMutations>;
  PgX?: Maybe<PgXMutations>;
  Prodigy?: Maybe<ProdigyMutations>;
  Promo?: Maybe<PromoMutations>;
  Purchase?: Maybe<PurchaseMutations>;
  Questionnaire?: Maybe<QuestionnaireMutations>;
  Report?: Maybe<ReportMutations>;
  Sales?: Maybe<SalesMutations>;
  Setting?: Maybe<SettingMutations>;
  Tracker?: Maybe<TrackerMutations>;
  User?: Maybe<UserMutations>;
  VendorBioIt?: Maybe<VendorBioItMutations>;
  Voucher?: Maybe<VoucherMutations>;
  hello?: Maybe<Scalars['String']['output']>;
};


export type MutationHelloArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type MyKitProcessStatusQueryFilter = {
  activationType?: InputMaybe<KitActivationType>;
  onlyShowBeforeStatus?: InputMaybe<KitProcessStatus>;
};

export type MyKitProcessStatusQueryFilterFindOne = {
  activationType?: InputMaybe<KitActivationType>;
  onlyShowBeforeStatus?: InputMaybe<KitProcessStatus>;
  reportType: Report_Type;
};

export type News = {
  __typename?: 'News';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NewsForm = {
  content?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsMutations = {
  __typename?: 'NewsMutations';
  add?: Maybe<News>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<News>;
};


export type NewsMutationsAddArgs = {
  form?: InputMaybe<NewsForm>;
};


export type NewsMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type NewsMutationsEditArgs = {
  form?: InputMaybe<NewsForm>;
  id: Scalars['Int']['input'];
};

export type NewsQueries = {
  __typename?: 'NewsQueries';
  findAll?: Maybe<NewsQueryResult>;
  findOne?: Maybe<News>;
  id?: Maybe<Scalars['ID']['output']>;
};


export type NewsQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NewsQuerySortBy>;
  where?: InputMaybe<NewsQueryFilter>;
};


export type NewsQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type NewsQueryFilter = {
  link?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsQueryResult = {
  __typename?: 'NewsQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<News>>>;
};

export type NewsQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  link?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type NotificationSettingWearable = {
  __typename?: 'NotificationSettingWearable';
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  maxRetryAttempts: Scalars['Int']['output'];
  messageTemplate: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  metricRequirements?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  notificationType: NotificationWearableType;
  priority: Scalars['Int']['output'];
  retryDelaySeconds: Scalars['Int']['output'];
  scheduleCron?: Maybe<Scalars['String']['output']>;
  scheduleDayOfMonth?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  scheduleDayOfWeek?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  scheduleTime?: Maybe<Scalars['Date']['output']>;
  scheduleType?: Maybe<ScheduleType>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  titleTemplate: Scalars['String']['output'];
  triggerConditions?: Maybe<Scalars['JSON']['output']>;
  triggerEnabled: Scalars['Boolean']['output'];
  triggerType?: Maybe<TriggerType>;
  ttlSeconds: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type NotificationSettingWearableQueries = {
  __typename?: 'NotificationSettingWearableQueries';
  findAll?: Maybe<NotificationSettingWearableQueryResult>;
  findByCode?: Maybe<NotificationSettingWearable>;
  findOne?: Maybe<NotificationSettingWearable>;
};


export type NotificationSettingWearableQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NotificationSettingWearableQuerySortBy>;
  where?: InputMaybe<NotificationSettingWearableQueryFilter>;
};


export type NotificationSettingWearableQueriesFindByCodeArgs = {
  code: Scalars['String']['input'];
};


export type NotificationSettingWearableQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type NotificationSettingWearableQueryFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationType?: InputMaybe<Array<InputMaybe<NotificationWearableType>>>;
};

export type NotificationSettingWearableQueryResult = {
  __typename?: 'NotificationSettingWearableQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<NotificationSettingWearable>>>;
};

export type NotificationSettingWearableQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  priority?: InputMaybe<SortDirection>;
};

export type NotificationWearable = {
  __typename?: 'NotificationWearable';
  actionButtons?: Maybe<Scalars['JSON']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  clickedAt?: Maybe<Scalars['Date']['output']>;
  contextData?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Date']['output'];
  dailyKey?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  deviceInfo?: Maybe<Scalars['JSON']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  externalReferenceId?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['Date']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastRetryAt?: Maybe<Scalars['Date']['output']>;
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  notifWearSettingId: Scalars['ID']['output'];
  notificationType: NotificationWearableType;
  onesignalNotificationId?: Maybe<Scalars['String']['output']>;
  profileId: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  scheduledFor?: Maybe<Scalars['Date']['output']>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  status: NotificationWearableStatus;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templateVariables?: Maybe<Scalars['JSON']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type NotificationWearableMutations = {
  __typename?: 'NotificationWearableMutations';
  markAsClicked: MarkNotificationWearableClickedResult;
};


export type NotificationWearableMutationsMarkAsClickedArgs = {
  notificationId: Scalars['ID']['input'];
};

export type NotificationWearableQueries = {
  __typename?: 'NotificationWearableQueries';
  Setting?: Maybe<NotificationSettingWearableQueries>;
  findAll?: Maybe<NotificationWearableQueryResult>;
  findOne?: Maybe<NotificationWearable>;
};


export type NotificationWearableQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NotificationWearableQuerySortBy>;
  where?: InputMaybe<NotificationWearableQueryFilter>;
};


export type NotificationWearableQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type NotificationWearableQueryFilter = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  notificationTypes?: InputMaybe<Array<InputMaybe<NotificationWearableType>>>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<NotificationWearableStatus>>>;
};

export type NotificationWearableQueryResult = {
  __typename?: 'NotificationWearableQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<NotificationWearable>>>;
};

export type NotificationWearableQuerySortBy = {
  clickedAt?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  sentAt?: InputMaybe<SortDirection>;
};

export enum NotificationWearableStatus {
  Cancelled = 'CANCELLED',
  Clicked = 'CLICKED',
  Delivered = 'DELIVERED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export enum NotificationWearableType {
  GeneralReminder = 'GENERAL_REMINDER',
  JournalReminder = 'JOURNAL_REMINDER',
  Predictive = 'PREDICTIVE',
  WearableHealth = 'WEARABLE_HEALTH'
}

export type NourishQuestionnaire = {
  __typename?: 'NourishQuestionnaire';
  answers?: Maybe<Array<Maybe<NourishQuestionnaireAnswer>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NourishQuestionnaireAnswer = {
  __typename?: 'NourishQuestionnaireAnswer';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NourishQuestionnaireAnswerForm = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type NourishQuestionnaireForm = {
  answers?: InputMaybe<Array<InputMaybe<NourishQuestionnaireAnswerForm>>>;
};

export type NourishQuestionnaireMutations = {
  __typename?: 'NourishQuestionnaireMutations';
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type NourishQuestionnaireMutationsUpdateArgs = {
  form?: InputMaybe<NourishQuestionnaireForm>;
};

export type NourishQuestionnaireQueries = {
  __typename?: 'NourishQuestionnaireQueries';
  find?: Maybe<NourishQuestionnaire>;
};

export type OcrMeasurement = {
  __typename?: 'OCRMeasurement';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameEng?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  referenceValue?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type OcrProcess = {
  __typename?: 'OCRProcess';
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  ehrLabAttachmentId?: Maybe<Scalars['ID']['output']>;
  ehrLabId?: Maybe<Scalars['ID']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ownerProfileId?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<OcrStatusEnum>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OcrProcessDetailsTemp = {
  __typename?: 'OCRProcessDetailsTemp';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isClinicalData?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ocrProcessId?: Maybe<Scalars['ID']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  referenceValue?: Maybe<Scalars['String']['output']>;
  standardizedName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OcrProcessDetailsTempForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  isClinicalData?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ocrProcessId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  referenceValue?: InputMaybe<Scalars['String']['input']>;
  standardizedName?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OcrProcessDetailsTempMutations = {
  __typename?: 'OCRProcessDetailsTempMutations';
  add?: Maybe<Array<Maybe<OcrProcessDetailsTemp>>>;
};


export type OcrProcessDetailsTempMutationsAddArgs = {
  forms?: InputMaybe<Array<InputMaybe<OcrProcessDetailsTempForm>>>;
};

export type OcrProcessDetailsTempQueries = {
  __typename?: 'OCRProcessDetailsTempQueries';
  findAll?: Maybe<OcrProcessDetailsTempQueryResult>;
};


export type OcrProcessDetailsTempQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OcrProcessDetailsTempQueryFilter>;
};

export type OcrProcessDetailsTempQueryFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  isClinicalData?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ocrProcessId: Scalars['ID']['input'];
};

export type OcrProcessDetailsTempQueryResult = {
  __typename?: 'OCRProcessDetailsTempQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<OcrProcessDetailsTemp>>>;
};

export type OcrProcessForm = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  ehrLabAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  ehrLabId?: InputMaybe<Scalars['ID']['input']>;
  expiredAt?: InputMaybe<Scalars['Date']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  ownerProfileId?: InputMaybe<Scalars['String']['input']>;
  pointer?: InputMaybe<Scalars['String']['input']>;
  reviewedAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<OcrStatusEnum>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

export type OcrProcessMutations = {
  __typename?: 'OCRProcessMutations';
  DetailsTemp?: Maybe<OcrProcessDetailsTempMutations>;
  add?: Maybe<OcrProcess>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<OcrProcess>;
};


export type OcrProcessMutationsAddArgs = {
  form?: InputMaybe<OcrProcessForm>;
};


export type OcrProcessMutationsDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type OcrProcessMutationsEditArgs = {
  form?: InputMaybe<OcrProcessForm>;
  id: Scalars['ID']['input'];
};

export type OcrProcessQueries = {
  __typename?: 'OCRProcessQueries';
  DetailsTemp?: Maybe<OcrProcessDetailsTempQueries>;
  findAll?: Maybe<OcrProcessQueryResult>;
  findOne?: Maybe<OcrProcess>;
};


export type OcrProcessQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OcrProcessQuerySortBy>;
  where?: InputMaybe<OcrProcessQueryFilter>;
};


export type OcrProcessQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type OcrProcessQueryFilter = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  ownerProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OcrStatusEnum>;
};

export type OcrProcessQueryResult = {
  __typename?: 'OCRProcessQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<OcrProcess>>>;
};

export type OcrProcessQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  currentPage?: InputMaybe<SortDirection>;
  deviceId?: InputMaybe<SortDirection>;
  total?: InputMaybe<SortDirection>;
};

export enum OcrStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Progress = 'PROGRESS'
}

export type OcrProcessNotification = {
  __typename?: 'OcrProcessNotification';
  data?: Maybe<Array<Maybe<OcrProcessResult>>>;
  deviceId?: Maybe<Scalars['String']['output']>;
  ehrLabAttachmentId?: Maybe<Scalars['String']['output']>;
  ehrLabId?: Maybe<Scalars['String']['output']>;
  ownerProfileId?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OcrProcessResult = {
  __typename?: 'OcrProcessResult';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  referenceValue?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OnboardingQuestionnaire = {
  __typename?: 'OnboardingQuestionnaire';
  alcoholHabits?: Maybe<AlcoholHabits>;
  allergyHistories?: Maybe<Array<Maybe<HealthAllergy>>>;
  exerciseLevelPerWeek?: Maybe<Scalars['String']['output']>;
  exerciseLevelPerWeekCompleted?: Maybe<Scalars['String']['output']>;
  healthMedicalHistories?: Maybe<Array<Maybe<HealthMedicalHistory>>>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sleepHabits?: Maybe<SleepHabits>;
  smokingHabits?: Maybe<SmokingHabits>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OnboardingQuestionnaireCompletedV3 = {
  __typename?: 'OnboardingQuestionnaireCompletedV3';
  alcoholHabits?: Maybe<AlcoholHabits>;
  allergyHistories?: Maybe<Array<Maybe<HealthAllergy>>>;
  currentHealthGoals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exerciseLevelPerWeek?: Maybe<Scalars['String']['output']>;
  exerciseLevelPerWeekCompleted?: Maybe<Scalars['String']['output']>;
  healthMedicalHistories?: Maybe<Array<Maybe<HealthMedicalHistory>>>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFormOnboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  lifestyleHabits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sleepHabits?: Maybe<SleepHabits>;
  smokingHabits?: Maybe<SmokingHabits>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OnboardingQuestionnaireMutations = {
  __typename?: 'OnboardingQuestionnaireMutations';
  create?: Maybe<OnboardingQuestionnaire>;
  createV3?: Maybe<OnboardingQuestionnaireV3>;
  update?: Maybe<UserLwb>;
  updateV2?: Maybe<OnboardingQuestionnaire>;
  updateV3?: Maybe<OnboardingQuestionnaireCompletedV3>;
};


export type OnboardingQuestionnaireMutationsCreateArgs = {
  form?: InputMaybe<CreateOnboardingQuestionnaireForm>;
};


export type OnboardingQuestionnaireMutationsCreateV3Args = {
  form?: InputMaybe<CreateOnboardingQuestionnaireFormV3>;
};


export type OnboardingQuestionnaireMutationsUpdateArgs = {
  form?: InputMaybe<UserLwbForm>;
};


export type OnboardingQuestionnaireMutationsUpdateV2Args = {
  form?: InputMaybe<UpdateOnboardingQuestionnaireForm>;
};


export type OnboardingQuestionnaireMutationsUpdateV3Args = {
  form?: InputMaybe<UpdateOnboardingQuestionnaireFormV3>;
};

export type OnboardingQuestionnaireQueries = {
  __typename?: 'OnboardingQuestionnaireQueries';
  find?: Maybe<UserLwb>;
  findV2?: Maybe<OnboardingQuestionnaire>;
  findV3?: Maybe<OnboardingQuestionnaireCompletedV3>;
};

export type OnboardingQuestionnaireV3 = {
  __typename?: 'OnboardingQuestionnaireV3';
  allergyHistories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currentHealthGoals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  healthMedicalHistories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lifestyleHabits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum OncoRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE',
  VeryHigh = 'VERY_HIGH'
}

export type OncoRiskReport = {
  __typename?: 'OncoRiskReport';
  accessedAt?: Maybe<Scalars['Date']['output']>;
  allowToRelease: Scalars['Boolean']['output'];
  analyzedGenesCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  generatedAt?: Maybe<Scalars['Date']['output']>;
  highRiskCancersCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isQualityControl: Scalars['Boolean']['output'];
  kitId?: Maybe<Scalars['String']['output']>;
  overallRiskLevel?: Maybe<OncoRiskLevel>;
  overallRiskScore?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  profileId: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['Date']['output']>;
  reportData?: Maybe<OncoRiskReportData>;
  unlockProductId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  variantsFoundCount?: Maybe<Scalars['Int']['output']>;
};

export type OncoRiskReportData = {
  __typename?: 'OncoRiskReportData';
  analysisVersion: Scalars['String']['output'];
  cancerAssessments: Array<CancerRiskAssessment>;
  dataVersion: Scalars['String']['output'];
  geneAnalysis: Array<GeneAnalysisResult>;
  generatedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kitId?: Maybe<Scalars['String']['output']>;
  overallRiskLevel: OncoRiskLevel;
  overallRiskScore: Scalars['Int']['output'];
  profileId: Scalars['String']['output'];
  qualityMetrics: QualityMetrics;
  recommendations: Array<RecommendationCategory>;
  reportType: Scalars['String']['output'];
  riskFactors: RiskFactors;
  summary: OncoRiskSummary;
};

export type OncoRiskReportForm = {
  allowToRelease?: InputMaybe<Scalars['Boolean']['input']>;
  kitId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
  reportData: Scalars['String']['input'];
  unlockProductId?: InputMaybe<Scalars['String']['input']>;
};

export type OncoRiskReportMutations = {
  __typename?: 'OncoRiskReportMutations';
  create: OncoRiskReport;
  createMockReport: OncoRiskReport;
  delete: Scalars['Boolean']['output'];
  markAsAccessed: OncoRiskReport;
  release: OncoRiskReport;
  update: OncoRiskReport;
};


export type OncoRiskReportMutationsCreateArgs = {
  form: OncoRiskReportForm;
};


export type OncoRiskReportMutationsCreateMockReportArgs = {
  kitId?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
};


export type OncoRiskReportMutationsDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type OncoRiskReportMutationsMarkAsAccessedArgs = {
  id: Scalars['ID']['input'];
};


export type OncoRiskReportMutationsReleaseArgs = {
  id: Scalars['ID']['input'];
};


export type OncoRiskReportMutationsUpdateArgs = {
  form: OncoRiskReportUpdateForm;
  id: Scalars['ID']['input'];
};

export type OncoRiskReportQueries = {
  __typename?: 'OncoRiskReportQueries';
  findAll: OncoRiskReportQueryResult;
  findByKitId?: Maybe<OncoRiskReport>;
  findByProfileId: Array<OncoRiskReport>;
  findOne?: Maybe<OncoRiskReport>;
  generateMockReport: OncoRiskReportData;
};


export type OncoRiskReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OncoRiskReportQueryFilter>;
};


export type OncoRiskReportQueriesFindByKitIdArgs = {
  kitId: Scalars['String']['input'];
};


export type OncoRiskReportQueriesFindByProfileIdArgs = {
  profileId: Scalars['String']['input'];
};


export type OncoRiskReportQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};


export type OncoRiskReportQueriesGenerateMockReportArgs = {
  kitId?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
};

export type OncoRiskReportQueryFilter = {
  allowToRelease?: InputMaybe<Scalars['Boolean']['input']>;
  cancerType?: InputMaybe<Array<CancerType>>;
  dateRange?: InputMaybe<DateRangeInput>;
  geneName?: InputMaybe<Array<Scalars['String']['input']>>;
  isQualityControl?: InputMaybe<Scalars['Boolean']['input']>;
  kitId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Array<OncoRiskLevel>>;
};

export type OncoRiskReportQueryResult = {
  __typename?: 'OncoRiskReportQueryResult';
  count: Scalars['Int']['output'];
  pagination?: Maybe<Pagination>;
  results: Array<OncoRiskReport>;
};

export type OncoRiskReportUpdateForm = {
  allowToRelease?: InputMaybe<Scalars['Boolean']['input']>;
  isQualityControl?: InputMaybe<Scalars['Boolean']['input']>;
  reportData?: InputMaybe<Scalars['String']['input']>;
};

export type OncoRiskSummary = {
  __typename?: 'OncoRiskSummary';
  highRiskCancers: Array<CancerType>;
  keyFindings: Array<Scalars['String']['output']>;
  nextSteps: Array<Scalars['String']['output']>;
};

export type OrderQueryFilter = {
  buyer?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  homeservice?: InputMaybe<Scalars['Boolean']['input']>;
  isInternationalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantType?: InputMaybe<Array<InputMaybe<MerchantType>>>;
  orderPaymentId?: InputMaybe<Scalars['String']['input']>;
  orderSubscription?: InputMaybe<OrderSubscriptionFilter>;
  paidAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseType?: InputMaybe<Array<InputMaybe<PurchaseOrderPurchaseType>>>;
  qty?: InputMaybe<Scalars['String']['input']>;
  shipmentAddressFormStatus?: InputMaybe<Array<InputMaybe<PurchaseOrderShipmentFormStatus>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrderQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subscriptionEndDate?: InputMaybe<SortDirection>;
  subscriptionStartDate?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type OrderSubscription = {
  __typename?: 'OrderSubscription';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeKit?: Maybe<Scalars['Boolean']['output']>;
  kitPrice?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<OrderSubscriptionSource>;
  subscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionName?: Maybe<Scalars['String']['output']>;
  subscriptionStartDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<OrderSubscriptionType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userKitcodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OrderSubscriptionFilter = {
  includeKit?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Array<InputMaybe<OrderSubscriptionSource>>>;
  subscriptionEndDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscriptionName?: InputMaybe<Scalars['String']['input']>;
  subscriptionStartDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum OrderSubscriptionSource {
  Apps = 'APPS',
  Dashboard = 'DASHBOARD'
}

export enum OrderSubscriptionType {
  Extend = 'EXTEND',
  Initiate = 'INITIATE',
  Renewal = 'RENEWAL',
  Upgrade = 'UPGRADE'
}

export type OrderUnlock = {
  __typename?: 'OrderUnlock';
  TAT?: Maybe<Scalars['Date']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  kit?: Maybe<Kit>;
  profile?: Maybe<UserProfile>;
  purchaseType?: Maybe<OrderUnlockPurchaseType>;
  reportType?: Maybe<ReportType>;
  sample?: Maybe<LabSample>;
  status?: Maybe<OrderUnlockStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OrderUnlockHistory = {
  __typename?: 'OrderUnlockHistory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<OrderUnlockStatus>;
};

export enum OrderUnlockPurchaseType {
  UnlockKit = 'UNLOCK_KIT',
  UnlockReport = 'UNLOCK_REPORT'
}

export enum OrderUnlockStatus {
  OrderConfirmed = 'ORDER_CONFIRMED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  ProcessingReport = 'PROCESSING_REPORT',
  ReportOut = 'REPORT_OUT'
}

export type OrderVoucherQueryFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum Paid_Product_Code {
  AsaPeriscopeCalibration = 'ASA_PERISCOPE_CALIBRATION',
  EternalAllInOne = 'ETERNAL_ALL_IN_ONE',
  EternalBalance = 'ETERNAL_BALANCE',
  EternalCardio = 'ETERNAL_CARDIO',
  EternalHydration = 'ETERNAL_HYDRATION',
  EternalMacronutrient = 'ETERNAL_MACRONUTRIENT',
  EternalMicronutrient = 'ETERNAL_MICRONUTRIENT',
  EternalMobility = 'ETERNAL_MOBILITY',
  EternalSleep = 'ETERNAL_SLEEP',
  EternalStrength = 'ETERNAL_STRENGTH',
  EternalStressManagement = 'ETERNAL_STRESS_MANAGEMENT',
  UnlockProtocolAllHealth = 'UNLOCK_PROTOCOL_ALL_HEALTH',
  UnlockProtocolBloodPressureManagement = 'UNLOCK_PROTOCOL_BLOOD_PRESSURE_MANAGEMENT',
  UnlockProtocolDetoxAndCleansing = 'UNLOCK_PROTOCOL_DETOX_AND_CLEANSING',
  UnlockProtocolEnergyAndVitality = 'UNLOCK_PROTOCOL_ENERGY_AND_VITALITY',
  UnlockProtocolFocusAndProductivity = 'UNLOCK_PROTOCOL_FOCUS_AND_PRODUCTIVITY',
  UnlockProtocolHydration = 'UNLOCK_PROTOCOL_HYDRATION',
  UnlockProtocolLongevity = 'UNLOCK_PROTOCOL_LONGEVITY',
  UnlockProtocolPostureImprovement = 'UNLOCK_PROTOCOL_POSTURE_IMPROVEMENT',
  UnlockProtocolSleepEnhancementSystem = 'UNLOCK_PROTOCOL_SLEEP_ENHANCEMENT_SYSTEM',
  UnlockProtocolStressReduction = 'UNLOCK_PROTOCOL_STRESS_REDUCTION',
  RecalibrateSummaryV_1_0 = 'recalibrate_summary_v_1_0',
  UnlockProtocolAntiInflammation = 'unlock_protocol_ANTI_INFLAMMATION'
}

export type Pagination = {
  __typename?: 'Pagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PanelFigure = {
  __typename?: 'PanelFigure';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaPanelId?: Maybe<Scalars['String']['output']>;
  favourableFigurePin?: Maybe<Array<Maybe<PanelFigurePin>>>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  unfavourableFigurePin?: Maybe<Array<Maybe<PanelFigurePin>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PanelFigurePin = {
  __typename?: 'PanelFigurePin';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dPanelPinCategory?: Maybe<Array<Maybe<PanelFigurePinCategory>>>;
  dnaPanelFigureId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PanelFigurePinCategory = {
  __typename?: 'PanelFigurePinCategory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaCategory?: Maybe<DnaCategory>;
  dnaCategoryId?: Maybe<Scalars['Int']['output']>;
  dnaPanelFigurePinId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ParentalMedicalHistory = {
  __typename?: 'ParentalMedicalHistory';
  father?: Maybe<Scalars['String']['output']>;
  mother?: Maybe<Scalars['String']['output']>;
};

export type ParentalMedicalHistoryInput = {
  father?: InputMaybe<Scalars['String']['input']>;
  mother?: InputMaybe<Scalars['String']['input']>;
};

export type Partner = {
  __typename?: 'Partner';
  allowManualKitActivation?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latestTransaction?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pics?: Maybe<Array<Maybe<PartnerPic>>>;
  reseller?: Maybe<PartnerReseller>;
  role?: Maybe<PartnerRole>;
  shippingAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerAuth = {
  __typename?: 'PartnerAuth';
  createdAt?: Maybe<Scalars['Date']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PartnerAuthForm = {
  host?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerAuthMutations = {
  __typename?: 'PartnerAuthMutations';
  add?: Maybe<Scalars['Boolean']['output']>;
};


export type PartnerAuthMutationsAddArgs = {
  form?: InputMaybe<PartnerAuthForm>;
};

export type PartnerAuthQueries = {
  __typename?: 'PartnerAuthQueries';
  findOne?: Maybe<PartnerAuth>;
};


export type PartnerAuthQueriesFindOneArgs = {
  partnershipId: Scalars['String']['input'];
};

export type PartnerBank = {
  __typename?: 'PartnerBank';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerBankForm = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerBankMutations = {
  __typename?: 'PartnerBankMutations';
  add?: Maybe<PartnerBank>;
};


export type PartnerBankMutationsAddArgs = {
  form?: InputMaybe<PartnerBankForm>;
};

export type PartnerBankQueries = {
  __typename?: 'PartnerBankQueries';
  findAll?: Maybe<PartnerBankQueryResult>;
  findOne?: Maybe<PartnerBank>;
};


export type PartnerBankQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerBankQuerySortBy>;
  where?: InputMaybe<PartnerBankQueryFilter>;
};


export type PartnerBankQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PartnerBankQueryFilter = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerBankQueryResult = {
  __typename?: 'PartnerBankQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PartnerBank>>>;
};

export type PartnerBankQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PartnerBatch = {
  __typename?: 'PartnerBatch';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kit?: Maybe<PartnerKit>;
  number?: Maybe<Scalars['Int']['output']>;
  partnershipId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<PartnerProduct>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerBatchForm = {
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerBatchMutations = {
  __typename?: 'PartnerBatchMutations';
  exportExcel?: Maybe<Scalars['String']['output']>;
  generate?: Maybe<Scalars['Boolean']['output']>;
  verify?: Maybe<Scalars['Boolean']['output']>;
};


export type PartnerBatchMutationsExportExcelArgs = {
  sort?: InputMaybe<PartnerBatchQuerySortBy>;
  where?: InputMaybe<PartnerBatchQueryFilter>;
};


export type PartnerBatchMutationsGenerateArgs = {
  form?: InputMaybe<PartnerBatchForm>;
};


export type PartnerBatchMutationsVerifyArgs = {
  form?: InputMaybe<PartnerBatchVerificationForm>;
};

export type PartnerBatchQueries = {
  __typename?: 'PartnerBatchQueries';
  findAll?: Maybe<PartnerBatchQueryResult>;
  findOne?: Maybe<PartnerBatch>;
  verify?: Maybe<Scalars['Boolean']['output']>;
};


export type PartnerBatchQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerBatchQuerySortBy>;
  where?: InputMaybe<PartnerBatchQueryFilter>;
};


export type PartnerBatchQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type PartnerBatchQueriesVerifyArgs = {
  form?: InputMaybe<PartnerBatchVerificationForm>;
};

export type PartnerBatchQueryFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  kitCode?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerBatchQueryResult = {
  __typename?: 'PartnerBatchQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PartnerBatch>>>;
};

export type PartnerBatchQuerySortBy = {
  activatedAt?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  number?: InputMaybe<SortDirection>;
};

export type PartnerBatchVerificationForm = {
  batch?: InputMaybe<Scalars['String']['input']>;
  kit?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerForm = {
  allowManualKitActivation?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pics?: InputMaybe<Array<InputMaybe<PartnerPicForm>>>;
  reseller?: InputMaybe<PartnerResellerForm>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerKit = {
  __typename?: 'PartnerKit';
  activation?: Maybe<PartnerKitActivation>;
  batch?: Maybe<PartnerBatch>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partnershipId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  verifiedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerKitActivation = {
  __typename?: 'PartnerKitActivation';
  birthday?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerKitForm = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerKitMutations = {
  __typename?: 'PartnerKitMutations';
  exportExcel?: Maybe<Scalars['String']['output']>;
  generate?: Maybe<Scalars['Boolean']['output']>;
};


export type PartnerKitMutationsExportExcelArgs = {
  sort?: InputMaybe<PartnerKitQuerySortBy>;
  where?: InputMaybe<PartnerKitQueryFilter>;
};


export type PartnerKitMutationsGenerateArgs = {
  form?: InputMaybe<PartnerKitForm>;
};

export type PartnerKitQueries = {
  __typename?: 'PartnerKitQueries';
  findAll?: Maybe<PartnerKitQueryResult>;
  findOne?: Maybe<PartnerKit>;
};


export type PartnerKitQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerKitQuerySortBy>;
  where?: InputMaybe<PartnerKitQueryFilter>;
};


export type PartnerKitQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PartnerKitQueryFilter = {
  activatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  hasBatch?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerKitQueryResult = {
  __typename?: 'PartnerKitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PartnerKit>>>;
};

export type PartnerKitQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  verifiedAt?: InputMaybe<SortDirection>;
};

export type PartnerMutations = {
  __typename?: 'PartnerMutations';
  Auth?: Maybe<PartnerAuthMutations>;
  Bank?: Maybe<PartnerBankMutations>;
  Batch?: Maybe<PartnerBatchMutations>;
  Kit?: Maybe<PartnerKitMutations>;
  Order?: Maybe<PartnerOrderMutations>;
  Product?: Maybe<PartnerProductMutations>;
  Reseller?: Maybe<PartnerResellerMutations>;
  Role?: Maybe<PartnerRoleMutations>;
  add?: Maybe<Partner>;
  edit?: Maybe<Partner>;
  resetPasswordResellerAccount?: Maybe<Scalars['Boolean']['output']>;
};


export type PartnerMutationsAddArgs = {
  form?: InputMaybe<PartnerForm>;
};


export type PartnerMutationsEditArgs = {
  form?: InputMaybe<PartnerForm>;
  id: Scalars['String']['input'];
};


export type PartnerMutationsResetPasswordResellerAccountArgs = {
  partnershipId: Scalars['ID']['input'];
};

export type PartnerOrder = {
  __typename?: 'PartnerOrder';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  item?: Maybe<PartnerOrderItemQueryResult>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  itemDeletedCount?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  profit?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerOrderForm = {
  batch?: InputMaybe<Scalars['String']['input']>;
  batchId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
};

export type PartnerOrderFormVerify = {
  batchNumber: Scalars['ID']['input'];
  partnershipId: Scalars['ID']['input'];
};

export type PartnerOrderItem = {
  __typename?: 'PartnerOrderItem';
  batch?: Maybe<PartnerBatch>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<PartnerOrder>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerOrderItemMutations = {
  __typename?: 'PartnerOrderItemMutations';
  exportExcel?: Maybe<Scalars['String']['output']>;
};


export type PartnerOrderItemMutationsExportExcelArgs = {
  sort?: InputMaybe<PartnerOrderItemQuerySortBy>;
  where?: InputMaybe<PartnerOrderItemQueryFilter>;
};

export type PartnerOrderItemQueries = {
  __typename?: 'PartnerOrderItemQueries';
  findAll?: Maybe<PartnerOrderItemQueryResult>;
};


export type PartnerOrderItemQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerOrderItemQuerySortBy>;
  where?: InputMaybe<PartnerOrderItemQueryFilter>;
};

export type PartnerOrderItemQueryFilter = {
  batch?: InputMaybe<Scalars['String']['input']>;
  kit?: InputMaybe<PartnerKitQueryFilter>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerOrderItemQueryResult = {
  __typename?: 'PartnerOrderItemQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  countActivation?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PartnerOrderItem>>>;
};

export type PartnerOrderItemQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type PartnerOrderMutations = {
  __typename?: 'PartnerOrderMutations';
  Item?: Maybe<PartnerOrderItemMutations>;
  add?: Maybe<PartnerOrder>;
};


export type PartnerOrderMutationsAddArgs = {
  form?: InputMaybe<PartnerOrderForm>;
};

export type PartnerOrderQueries = {
  __typename?: 'PartnerOrderQueries';
  Item?: Maybe<PartnerOrderItemQueries>;
  findAll?: Maybe<PartnerOrderQueryResult>;
  findOne?: Maybe<PartnerOrder>;
  verify?: Maybe<PartnerOrderVerifyResult>;
};


export type PartnerOrderQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerOrderQuerySortBy>;
  where?: InputMaybe<PartnerOrderQueryFilter>;
};


export type PartnerOrderQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type PartnerOrderQueriesVerifyArgs = {
  form?: InputMaybe<PartnerOrderFormVerify>;
};

export type PartnerOrderQueryFilter = {
  partnership?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerOrderQueryResult = {
  __typename?: 'PartnerOrderQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PartnerOrder>>>;
};

export type PartnerOrderQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  profit?: InputMaybe<SortDirection>;
};

export type PartnerOrderVerifyResult = {
  __typename?: 'PartnerOrderVerifyResult';
  allow?: Maybe<Scalars['Boolean']['output']>;
  partnerBatch?: Maybe<PartnerBatch>;
  partnerBatchOriginalPartnership?: Maybe<Partner>;
  partnerBatchOriginalPartnershipId?: Maybe<Scalars['ID']['output']>;
  partnerBatchTargetPartnership?: Maybe<Partner>;
  partnerBatchTargetPartnershipId?: Maybe<Scalars['ID']['output']>;
};

export type PartnerPic = {
  __typename?: 'PartnerPic';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerPicForm = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerProduct = {
  __typename?: 'PartnerProduct';
  code?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type PartnerProductForm = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PartnerProductMutations = {
  __typename?: 'PartnerProductMutations';
  add?: Maybe<PartnerProduct>;
};


export type PartnerProductMutationsAddArgs = {
  form?: InputMaybe<PartnerProductForm>;
};

export type PartnerProductQueries = {
  __typename?: 'PartnerProductQueries';
  findAll?: Maybe<PartnerProductQueryResult>;
  findOne?: Maybe<PartnerProduct>;
};


export type PartnerProductQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerProductQuerySortBy>;
  where?: InputMaybe<PartnerProductQueryFilter>;
};


export type PartnerProductQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PartnerProductQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  partnership?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerProductQueryResult = {
  __typename?: 'PartnerProductQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PartnerProduct>>>;
};

export type PartnerProductQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  cost?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  height?: InputMaybe<SortDirection>;
  length?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
  weight?: InputMaybe<SortDirection>;
  width?: InputMaybe<SortDirection>;
};

export type PartnerQueries = {
  __typename?: 'PartnerQueries';
  Auth?: Maybe<PartnerAuthQueries>;
  Bank?: Maybe<PartnerBankQueries>;
  Batch?: Maybe<PartnerBatchQueries>;
  Kit?: Maybe<PartnerKitQueries>;
  Order?: Maybe<PartnerOrderQueries>;
  Product?: Maybe<PartnerProductQueries>;
  Reseller?: Maybe<PartnerResellerQueries>;
  Role?: Maybe<PartnerRoleQueries>;
  checkEmailAvailability?: Maybe<CheckEmailAvailabilityResult>;
  findAll?: Maybe<PartnerQueryResult>;
  findOne?: Maybe<Partner>;
};


export type PartnerQueriesCheckEmailAvailabilityArgs = {
  where?: InputMaybe<CheckEmailAvailabilityQueryFilter>;
};


export type PartnerQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<PartnerQueryInclude>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerQuerySortBy>;
  where?: InputMaybe<PartnerQueryFilter>;
};


export type PartnerQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  include?: InputMaybe<Array<InputMaybe<PartnerQueryInclude>>>;
};

export type PartnerQueryFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PartnerQueryInclude {
  PartnerReseller = 'PARTNER_RESELLER'
}

export type PartnerQueryResult = {
  __typename?: 'PartnerQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Partner>>>;
};

export type PartnerQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PartnerReseller = {
  __typename?: 'PartnerReseller';
  address?: Maybe<Scalars['String']['output']>;
  allowManualKitActivation?: Maybe<Scalars['Boolean']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankId?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nik?: Maybe<Scalars['String']['output']>;
  npwp?: Maybe<Scalars['String']['output']>;
  partnerBank?: Maybe<PartnerBank>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerStatus?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<PartnerUserType>;
};

export type PartnerResellerForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowManualKitActivation?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['String']['input']>;
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  nik?: InputMaybe<Scalars['String']['input']>;
  npwp?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<PartnerUserType>;
};

export type PartnerResellerMutations = {
  __typename?: 'PartnerResellerMutations';
  add?: Maybe<PartnerReseller>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PartnerReseller>;
};


export type PartnerResellerMutationsAddArgs = {
  form?: InputMaybe<PartnerResellerForm>;
};


export type PartnerResellerMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type PartnerResellerMutationsEditArgs = {
  form?: InputMaybe<PartnerResellerForm>;
  id: Scalars['Int']['input'];
};

export type PartnerResellerQueries = {
  __typename?: 'PartnerResellerQueries';
  findOne?: Maybe<PartnerReseller>;
};


export type PartnerResellerQueriesFindOneArgs = {
  partnershipId: Scalars['String']['input'];
};

export type PartnerRole = {
  __typename?: 'PartnerRole';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnerRoleForm = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRoleMutations = {
  __typename?: 'PartnerRoleMutations';
  add?: Maybe<PartnerRole>;
};


export type PartnerRoleMutationsAddArgs = {
  form?: InputMaybe<PartnerRoleForm>;
};

export type PartnerRoleQueries = {
  __typename?: 'PartnerRoleQueries';
  findAll?: Maybe<PartnerRoleQueryResult>;
  findOne?: Maybe<PartnerRole>;
};


export type PartnerRoleQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerRoleQuerySortBy>;
  where?: InputMaybe<PartnerRoleQueryFilter>;
};


export type PartnerRoleQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PartnerRoleQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRoleQueryResult = {
  __typename?: 'PartnerRoleQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PartnerRole>>>;
};

export type PartnerRoleQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum PartnerUserType {
  Counselor = 'COUNSELOR',
  Doctor = 'DOCTOR',
  Partner = 'PARTNER'
}

export type Partnership = {
  __typename?: 'Partnership';
  account?: Maybe<PartnershipAccount>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profit?: Maybe<Scalars['Float']['output']>;
  totalActivatedKit?: Maybe<Scalars['Int']['output']>;
  totalKit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PartnershipAccount = {
  __typename?: 'PartnershipAccount';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PartnershipAccountAddForm = {
  email: Scalars['String']['input'];
  partnershipId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PartnershipAccountEditForm = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type PartnershipAccountForm = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PartnershipAccountMutations = {
  __typename?: 'PartnershipAccountMutations';
  add?: Maybe<Scalars['Boolean']['output']>;
  deactivate?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Scalars['Boolean']['output']>;
};


export type PartnershipAccountMutationsAddArgs = {
  form: PartnershipAccountAddForm;
};


export type PartnershipAccountMutationsDeactivateArgs = {
  id: Scalars['String']['input'];
};


export type PartnershipAccountMutationsEditArgs = {
  form: PartnershipAccountEditForm;
  id: Scalars['String']['input'];
};

export type PartnershipAddProductForm = {
  batch: Array<InputMaybe<Scalars['String']['input']>>;
};

export type PartnershipForm = {
  account?: InputMaybe<PartnershipAccountForm>;
  batch?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
};

export type PartnershipMutations = {
  __typename?: 'PartnershipMutations';
  Account?: Maybe<PartnershipAccountMutations>;
  add?: Maybe<Scalars['Boolean']['output']>;
  addProduct?: Maybe<Scalars['Boolean']['output']>;
  export?: Maybe<Scalars['String']['output']>;
};


export type PartnershipMutationsAddArgs = {
  form?: InputMaybe<PartnershipForm>;
};


export type PartnershipMutationsAddProductArgs = {
  form: PartnershipAddProductForm;
  id: Scalars['String']['input'];
};


export type PartnershipMutationsExportArgs = {
  sort?: InputMaybe<PurchaseProductKitBatchQuerySortBy>;
  where?: InputMaybe<PartnershipProductsQueryFilter>;
};

export type PartnershipProductsQueryFilter = {
  activatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PartnershipQueries = {
  __typename?: 'PartnershipQueries';
  findAll?: Maybe<PartnershipQueryResult>;
  findAllProduct?: Maybe<PurchaseProductKitBatchQueryResult>;
  findOne?: Maybe<Partnership>;
};


export type PartnershipQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnershipQuerySortBy>;
  where?: InputMaybe<PartnershipQueryFilter>;
};


export type PartnershipQueriesFindAllProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductKitBatchQuerySortBy>;
  where?: InputMaybe<PartnershipProductsQueryFilter>;
};


export type PartnershipQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PartnershipQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PartnershipQueryResult = {
  __typename?: 'PartnershipQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Partnership>>>;
};

export type PartnershipQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type Payment = {
  __typename?: 'Payment';
  createdAt?: Maybe<Scalars['Date']['output']>;
  gateway?: Maybe<PaymentGateway>;
  id?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<PaymentPayload>;
  status?: Maybe<PaymentStatus>;
  type?: Maybe<PaymentType>;
  voucher?: Maybe<PaymentVoucher>;
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  authorizedAmount?: Maybe<Scalars['Int']['output']>;
  captureAmount?: Maybe<Scalars['String']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  chargeType?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PaymentEWallet = {
  __typename?: 'PaymentEWallet';
  actions?: Maybe<PaymentEwalletPayloadActions>;
  amount?: Maybe<Scalars['Int']['output']>;
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  ewalletType?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PaymentEwalletPayloadActions = {
  __typename?: 'PaymentEwalletPayloadActions';
  desktop_web_checkout_url?: Maybe<Scalars['String']['output']>;
  mobile_web_checkout_url?: Maybe<Scalars['String']['output']>;
};

export type PaymentForm = {
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentType>;
  voucherId?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentGateway = {
  __typename?: 'PaymentGateway';
  createdAt?: Maybe<Scalars['Date']['output']>;
  guide?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<PaymentType>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PaymentGatewayType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PaymentGatewayMutations = {
  __typename?: 'PaymentGatewayMutations';
  PayLater?: Maybe<PaymentGatewayPayLaterMutations>;
};

export type PaymentGatewayPayLaterMutations = {
  __typename?: 'PaymentGatewayPayLaterMutations';
  payLaterPlan?: Maybe<PaymentGatewayPayLaterPlan>;
  payLaterPlanV2?: Maybe<PaymentGatewayPayLaterPlan>;
};


export type PaymentGatewayPayLaterMutationsPayLaterPlanArgs = {
  form: PaymentGatewayPayLaterPlanForm;
};


export type PaymentGatewayPayLaterMutationsPayLaterPlanV2Args = {
  form: PaymentGatewayPayLaterPlanFormV2;
};

export type PaymentGatewayPayLaterPlan = {
  __typename?: 'PaymentGatewayPayLaterPlan';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<PaymentGatewayPayLaterPlanOptions>>>;
};

export type PaymentGatewayPayLaterPlanForm = {
  carts?: InputMaybe<Array<Scalars['String']['input']>>;
  homeservice?: InputMaybe<PurchaseOrderHomeserviceForm>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  payment: PurchaseOrderPaymentForm;
  shipment: PurchaseOrderShipmentForm;
};

export type PaymentGatewayPayLaterPlanFormV2 = {
  homeservice?: InputMaybe<PurchaseOrderHomeserviceForm>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  payment: PurchaseOrderPaymentForm;
  productOrders?: InputMaybe<Array<ProductOrderForm>>;
  shipment: PurchaseOrderShipmentForm;
};

export type PaymentGatewayPayLaterPlanOptions = {
  __typename?: 'PaymentGatewayPayLaterPlanOptions';
  description?: Maybe<Scalars['String']['output']>;
  downpaymentAmount?: Maybe<Scalars['Float']['output']>;
  installmentAmount?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  intervalCount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalRecurrence?: Maybe<Scalars['Float']['output']>;
};

export type PaymentGatewayQueries = {
  __typename?: 'PaymentGatewayQueries';
  findAll?: Maybe<PaymentGatewayQueryResult>;
  findOne?: Maybe<PaymentGateway>;
};


export type PaymentGatewayQueriesFindAllArgs = {
  where?: InputMaybe<PaymentGatewayQueryFilter>;
};


export type PaymentGatewayQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type PaymentGatewayQueryFilter = {
  purchaseType?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentGatewayQueryResult = {
  __typename?: 'PaymentGatewayQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PaymentGateway>>>;
};

export enum PaymentGatewayType {
  CreditCard = 'CREDIT_CARD',
  Ewallet = 'EWALLET',
  Paylater = 'PAYLATER',
  Qr = 'QR',
  VirtualAccount = 'VIRTUAL_ACCOUNT'
}

export type PaymentMutations = {
  __typename?: 'PaymentMutations';
  Gateway?: Maybe<PaymentGatewayMutations>;
  add?: Maybe<Payment>;
};


export type PaymentMutationsAddArgs = {
  form?: InputMaybe<PaymentForm>;
};

export type PaymentPayload = PaymentCard | PaymentEWallet | PaymentQr | PaymentVa;

export type PaymentQr = {
  __typename?: 'PaymentQR';
  amount?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  qrString?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type PaymentQueries = {
  __typename?: 'PaymentQueries';
  Gateway?: Maybe<PaymentGatewayQueries>;
  Voucher?: Maybe<PaymentVoucherQueries>;
  findAll?: Maybe<PaymentQueryResult>;
  findOne?: Maybe<Payment>;
};


export type PaymentQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PaymentQueryResult = {
  __typename?: 'PaymentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Payment>>>;
};

export enum PaymentStatus {
  Paid = 'PAID',
  PaymentExpired = 'PAYMENT_EXPIRED',
  Pending = 'PENDING',
  Unpaid = 'UNPAID'
}

export enum PaymentType {
  ApplePay = 'APPLE_PAY',
  Bca = 'BCA',
  Bjb = 'BJB',
  Bni = 'BNI',
  Bri = 'BRI',
  Bsi = 'BSI',
  Cimb = 'CIMB',
  CreditCard = 'CREDIT_CARD',
  Dana = 'DANA',
  Free = 'FREE',
  GooglePay = 'GOOGLE_PAY',
  Kredivo = 'KREDIVO',
  Linkaja = 'LINKAJA',
  Mandiri = 'MANDIRI',
  Ovo = 'OVO',
  Permata = 'PERMATA',
  Qris = 'QRIS',
  Shopeepay = 'SHOPEEPAY',
  Blu = 'blu'
}

export type PaymentVa = {
  __typename?: 'PaymentVA';
  accountNumber?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  expectedAmount?: Maybe<Scalars['Int']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  merchantCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  suggestedAmount?: Maybe<Scalars['Int']['output']>;
};

export type PaymentVoucher = {
  __typename?: 'PaymentVoucher';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PaymentVoucherQueries = {
  __typename?: 'PaymentVoucherQueries';
  findAll?: Maybe<PaymentVoucherQueryResult>;
  findOne?: Maybe<PaymentVoucher>;
};


export type PaymentVoucherQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type PaymentVoucherQueryResult = {
  __typename?: 'PaymentVoucherQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PaymentVoucher>>>;
};

export enum Period {
  Annual = 'ANNUAL',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Semester = 'SEMESTER',
  Week = 'WEEK'
}

export type PgXClassMutations = {
  __typename?: 'PgXClassMutations';
  Drug?: Maybe<PgXDrugMutations>;
  createOrUpdate?: Maybe<Array<Maybe<PgxClass>>>;
  export?: Maybe<Scalars['Boolean']['output']>;
};


export type PgXClassMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<PgxClassForm>>;
};


export type PgXClassMutationsExportArgs = {
  where?: InputMaybe<PgxClassQueryFilter>;
};

export type PgXClassQueries = {
  __typename?: 'PgXClassQueries';
  Drug?: Maybe<PgXDrugQueries>;
  findAll?: Maybe<PgxClassQueryResult>;
  findOne?: Maybe<PgxClass>;
};


export type PgXClassQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PgxClassQuerySortBy>;
  where?: InputMaybe<PgxClassQueryFilter>;
};


export type PgXClassQueriesFindOneArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PgXDrugMutations = {
  __typename?: 'PgXDrugMutations';
  createOrUpdate?: Maybe<Array<Maybe<PgxDrug>>>;
  export?: Maybe<Scalars['Boolean']['output']>;
};


export type PgXDrugMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<PgxDrugForm>>;
};


export type PgXDrugMutationsExportArgs = {
  include?: InputMaybe<PgxDrugQueryInclude>;
  where?: InputMaybe<PgxDrugQueryFilter>;
};

export type PgXDrugQueries = {
  __typename?: 'PgXDrugQueries';
  findAll?: Maybe<PgxDrugQueryResult>;
  findOne?: Maybe<PgxDrug>;
};


export type PgXDrugQueriesFindAllArgs = {
  include?: InputMaybe<PgxDrugQueryInclude>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PgxDrugQuerySortBy>;
  where?: InputMaybe<PgxDrugQueryFilter>;
};


export type PgXDrugQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type PgXGlossaryMutations = {
  __typename?: 'PgXGlossaryMutations';
  createOrUpdate?: Maybe<Array<Maybe<PgxGlossary>>>;
  export?: Maybe<Scalars['Boolean']['output']>;
};


export type PgXGlossaryMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<PgxGlossaryForm>>;
};


export type PgXGlossaryMutationsExportArgs = {
  where?: InputMaybe<PgxGlossaryQueryFilter>;
};

export type PgXGlossaryQueries = {
  __typename?: 'PgXGlossaryQueries';
  findAll?: Maybe<PgxGlossaryQueryResult>;
  findOne?: Maybe<PgxGlossary>;
};


export type PgXGlossaryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PgxGlossaryQuerySortBy>;
  where?: InputMaybe<PgxGlossaryQueryFilter>;
};


export type PgXGlossaryQueriesFindOneArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PgXMutations = {
  __typename?: 'PgXMutations';
  Class?: Maybe<PgXClassMutations>;
  Glossary?: Maybe<PgXGlossaryMutations>;
};

export type PgXQueries = {
  __typename?: 'PgXQueries';
  Class?: Maybe<PgXClassQueries>;
  Glossary?: Maybe<PgXGlossaryQueries>;
  Report?: Maybe<PgXReportQueries>;
};

export type PgXReportQueries = {
  __typename?: 'PgXReportQueries';
  findAll?: Maybe<PgxReportQueryResult>;
};


export type PgXReportQueriesFindAllArgs = {
  include?: InputMaybe<PgxReportQueryInclude>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PgxReportQuerySortBy>;
  where?: InputMaybe<PgxReportQueryFilter>;
};

export type PgxClass = {
  __typename?: 'PgxClass';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionId?: Maybe<Scalars['String']['output']>;
  dnaOwnerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PgxClassForm = {
  descriptionEn: Scalars['String']['input'];
  descriptionId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type PgxClassQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type PgxClassQueryResult = {
  __typename?: 'PgxClassQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PgxClass>>>;
};

export type PgxClassQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PgxDrug = {
  __typename?: 'PgxDrug';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionId?: Maybe<Scalars['String']['output']>;
  dnaOwnerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pgxDrugClass?: Maybe<PgxClass>;
  pgxDrugClassId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PgxDrugForm = {
  descriptionEn: Scalars['String']['input'];
  descriptionId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pgxDrugClassId: Scalars['String']['input'];
};

export type PgxDrugQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pgxDrugClassId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PgxDrugQueryInclude = {
  pgxDrugClass?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PgxDrugQueryResult = {
  __typename?: 'PgxDrugQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PgxDrug>>>;
};

export type PgxDrugQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  pgxDrugClassName?: InputMaybe<SortDirection>;
};

export type PgxGlossary = {
  __typename?: 'PgxGlossary';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionId?: Maybe<Scalars['String']['output']>;
  dnaOwnerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PgxGlossaryForm = {
  descriptionEn: Scalars['String']['input'];
  descriptionId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type PgxGlossaryQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type PgxGlossaryQueryResult = {
  __typename?: 'PgxGlossaryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PgxGlossary>>>;
};

export type PgxGlossaryQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PgxReport = {
  __typename?: 'PgxReport';
  alternativeDrugs?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clinicalOutcome?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  detailInformation?: Maybe<Scalars['String']['output']>;
  dnaUserId?: Maybe<Scalars['String']['output']>;
  dosageRequirement?: Maybe<Scalars['String']['output']>;
  drugs?: Maybe<Scalars['String']['output']>;
  geneHaps?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interpretation?: Maybe<Scalars['String']['output']>;
  pgxDrug?: Maybe<PgxDrug>;
  pgxDrugClass?: Maybe<PgxClass>;
  pgxDrugClassId?: Maybe<Scalars['String']['output']>;
  pgxDrugId?: Maybe<Scalars['String']['output']>;
  rsidCustGenotype?: Maybe<Scalars['String']['output']>;
  scientificActions?: Maybe<Scalars['String']['output']>;
  specializedRecommendation?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PgxReportQueryFilter = {
  dnaUserId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyCode?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pgxDrugClassId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pgxDrugId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PgxReportQueryInclude = {
  pgxDrug?: InputMaybe<Scalars['Boolean']['input']>;
  pgxDrugClass?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PgxReportQueryResult = {
  __typename?: 'PgxReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PgxReport>>>;
};

export type PgxReportQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  drugClassName?: InputMaybe<SortDirection>;
  drugName?: InputMaybe<SortDirection>;
};

export type PhysicalActivityLevel = {
  __typename?: 'PhysicalActivityLevel';
  amountOfExercisePerWeek?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  timePerExerciseSession?: Maybe<Scalars['String']['output']>;
};

export type PhysicalActivityLevelInput = {
  amountOfExercisePerWeek?: InputMaybe<Scalars['String']['input']>;
  exerciseLevelPerWeek?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  timePerExerciseSession?: InputMaybe<Scalars['String']['input']>;
};

export type PickupKitShipment = {
  __typename?: 'PickupKitShipment';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  shipmentCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProductKitPickupStatus>;
  waybill?: Maybe<Scalars['String']['output']>;
};

export type Place = {
  __typename?: 'Place';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PlanIncludeContent = {
  __typename?: 'PlanIncludeContent';
  detail?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type PlanIncludeItem = {
  __typename?: 'PlanIncludeItem';
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<Maybe<PlanIncludeContent>>>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  position?: Maybe<Scalars['Int']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum Platform {
  Mobile = 'MOBILE',
  Website = 'WEBSITE'
}

export type Podcast = {
  __typename?: 'Podcast';
  category?: Maybe<PodcastCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<PodcastKind>;
  source?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PodcastType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PodcastCategory = {
  __typename?: 'PodcastCategory';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PodcastCategoryForm = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastCategoryMutations = {
  __typename?: 'PodcastCategoryMutations';
  add?: Maybe<PodcastCategory>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PodcastCategory>;
};


export type PodcastCategoryMutationsAddArgs = {
  form?: InputMaybe<PodcastCategoryForm>;
};


export type PodcastCategoryMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PodcastCategoryMutationsEditArgs = {
  form?: InputMaybe<PodcastCategoryForm>;
  id: Scalars['String']['input'];
};

export type PodcastCategoryQueries = {
  __typename?: 'PodcastCategoryQueries';
  findAll?: Maybe<PodcastCategoryQueryResult>;
  findOne?: Maybe<PodcastCategory>;
};


export type PodcastCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PodcastCategoryQuerySortBy>;
  where?: InputMaybe<PodcastCategoryQueryFilter>;
};


export type PodcastCategoryQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PodcastCategoryQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastCategoryQueryResult = {
  __typename?: 'PodcastCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PodcastCategory>>>;
};

export type PodcastCategoryQuerySortBy = {
  name?: InputMaybe<SortDirection>;
};

export type PodcastForm = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  kind?: InputMaybe<PodcastKind>;
  source?: InputMaybe<Scalars['Upload']['input']>;
  sourceLink?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PodcastType>;
};

export enum PodcastKind {
  Podcast = 'PODCAST',
  Video = 'VIDEO'
}

export type PodcastMutations = {
  __typename?: 'PodcastMutations';
  Category?: Maybe<PodcastCategoryMutations>;
  add?: Maybe<Podcast>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Podcast>;
};


export type PodcastMutationsAddArgs = {
  form?: InputMaybe<PodcastForm>;
};


export type PodcastMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PodcastMutationsEditArgs = {
  form?: InputMaybe<PodcastForm>;
  id: Scalars['String']['input'];
};

export type PodcastQueries = {
  __typename?: 'PodcastQueries';
  Category?: Maybe<PodcastCategoryQueries>;
  findAll?: Maybe<PodcastQueryResult>;
  findOne?: Maybe<Podcast>;
};


export type PodcastQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PodcastQuerySortBy>;
  where?: InputMaybe<PodcastQueryFilter>;
};


export type PodcastQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PodcastQueryFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kind?: InputMaybe<Array<InputMaybe<PodcastKind>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastQueryResult = {
  __typename?: 'PodcastQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Podcast>>>;
};

export type PodcastQuerySortBy = {
  category?: InputMaybe<PodcastCategoryQuerySortBy>;
  createdAt?: InputMaybe<SortDirection>;
  duration?: InputMaybe<SortDirection>;
  kind?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum PodcastType {
  Audio = 'AUDIO',
  AudioUrl = 'AUDIO_URL',
  Video = 'VIDEO',
  VideoUrl = 'VIDEO_URL'
}

export type PreviewReportProcessForm = {
  file: Scalars['Upload']['input'];
  type: ReportProcessType;
  vendorBioItId: Scalars['String']['input'];
};

export type PriceRangeFilter = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProcessDetailMapType {
  DnaMapping = 'DNA_MAPPING',
  PdfGeneration = 'PDF_GENERATION',
  UspGeneration = 'USP_GENERATION'
}

export type ProcessResult = {
  __typename?: 'ProcessResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProdigyCategory = {
  __typename?: 'ProdigyCategory';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  localization?: Maybe<ProdigyCategoryLocalization>;
  name?: Maybe<Scalars['String']['output']>;
  panel?: Maybe<ProdigyPanel>;
  panelId?: Maybe<Scalars['String']['output']>;
  preset?: Maybe<ProdigyCategoryPreset>;
  status?: Maybe<ProdigyCategoryStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type ProdigyCategoryLocalizationArgs = {
  where?: InputMaybe<ProdigyCategoryLocalizationQueryFilter>;
};

export type ProdigyCategoryForm = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  localization?: InputMaybe<ProdigyCategoryLocalizationForm>;
  localizations?: InputMaybe<Array<InputMaybe<ProdigyCategoryLocalizationForm>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Scalars['ID']['input']>;
  preset?: InputMaybe<ProdigyCategoryPresetForm>;
};

export enum ProdigyCategoryInclude {
  Localization = 'LOCALIZATION'
}

export type ProdigyCategoryLocalization = {
  __typename?: 'ProdigyCategoryLocalization';
  alias?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyCategoryLocalizationForm = {
  alias?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyCategoryLocalizationQueryFilter = {
  defaultIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyCategoryLocalizationQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ProdigyCategoryMutations = {
  __typename?: 'ProdigyCategoryMutations';
  create?: Maybe<ProdigyCategory>;
  export?: Maybe<Scalars['String']['output']>;
  update?: Maybe<ProdigyCategory>;
};


export type ProdigyCategoryMutationsCreateArgs = {
  form?: InputMaybe<ProdigyCategoryForm>;
};


export type ProdigyCategoryMutationsExportArgs = {
  sort?: InputMaybe<ProdigyCategoryQuerySortBy>;
  where?: InputMaybe<ProdigyCategoryQueryFilter>;
};


export type ProdigyCategoryMutationsUpdateArgs = {
  form?: InputMaybe<ProdigyCategoryForm>;
  id: Scalars['ID']['input'];
};

export type ProdigyCategoryPreset = {
  __typename?: 'ProdigyCategoryPreset';
  bgColors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailAge1?: Maybe<Scalars['String']['output']>;
  thumbnailAge2?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyCategoryPresetForm = {
  bgColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  thumbnailAge1?: InputMaybe<Scalars['Upload']['input']>;
  thumbnailAge2?: InputMaybe<Scalars['Upload']['input']>;
};

export type ProdigyCategoryQueries = {
  __typename?: 'ProdigyCategoryQueries';
  findAll?: Maybe<ProdigyCategoryQueryResult>;
  findAllByReportPanel?: Maybe<ProdigyCategoryQueryResult>;
  findOne?: Maybe<ProdigyCategory>;
};


export type ProdigyCategoryQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<ProdigyCategoryInclude>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyCategoryQuerySortBy>;
  where?: InputMaybe<ProdigyCategoryQueryFilter>;
};


export type ProdigyCategoryQueriesFindAllByReportPanelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyCategoryQuerySortBy>;
  where?: InputMaybe<ProdigyCategoryQueryFilter>;
};


export type ProdigyCategoryQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
  include?: InputMaybe<Array<InputMaybe<ProdigyCategoryInclude>>>;
};

export type ProdigyCategoryQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  panels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  reportEvaluationStatus?: InputMaybe<Array<InputMaybe<ReportEvaluationStatus>>>;
  status?: InputMaybe<Array<InputMaybe<ProdigyCategoryStatus>>>;
};

export type ProdigyCategoryQueryResult = {
  __typename?: 'ProdigyCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyCategory>>>;
};

export type ProdigyCategoryQuerySortBy = {
  active?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  localization_en?: InputMaybe<ProdigyCategoryLocalizationQuerySortBy>;
  localization_id?: InputMaybe<ProdigyCategoryLocalizationQuerySortBy>;
  name?: InputMaybe<SortDirection>;
  panel?: InputMaybe<ProdigyPanelQuerySortBy>;
};

export enum ProdigyCategoryStatus {
  Active = 'ACTIVE',
  NotActive = 'NOT_ACTIVE'
}

export type ProdigyFigure = {
  __typename?: 'ProdigyFigure';
  createdAt?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  pinPanels?: Maybe<Array<Maybe<ProdigyFigurePinPanel>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ProdigyFigureForm = {
  gender?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['Upload']['input']>;
  pinPanels?: InputMaybe<Array<InputMaybe<ProdigyFigurePinPanelForm>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ProdigyFigureMutations = {
  __typename?: 'ProdigyFigureMutations';
  update?: Maybe<ProdigyFigure>;
};


export type ProdigyFigureMutationsUpdateArgs = {
  form?: InputMaybe<ProdigyFigureForm>;
  id: Scalars['ID']['input'];
};

export type ProdigyFigurePinPanel = {
  __typename?: 'ProdigyFigurePinPanel';
  createdAt?: Maybe<Scalars['Date']['output']>;
  figureId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  panel?: Maybe<ProdigyPanel>;
  panelId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyFigurePinPanelForm = {
  figureId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type ProdigyFigurePinPanelQueryFilter = {
  figureId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  panelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProdigyFigurePinPanelQueryResult = {
  __typename?: 'ProdigyFigurePinPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyFigurePinPanel>>>;
};

export type ProdigyFigurePinPanelQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
};

export type ProdigyFigureQueries = {
  __typename?: 'ProdigyFigureQueries';
  findAll?: Maybe<ProdigyFigureQueryResult>;
};


export type ProdigyFigureQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyFigureQuerySortBy>;
  where?: InputMaybe<ProdigyFigureQueryFilter>;
};

export type ProdigyFigureQueryFilter = {
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProdigyFigureQueryResult = {
  __typename?: 'ProdigyFigureQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyFigure>>>;
};

export type ProdigyFigureQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
};

export type ProdigyGrowthProfile = {
  __typename?: 'ProdigyGrowthProfile';
  category?: Maybe<ProdigyGrowthProfileCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endGenerationAt?: Maybe<Scalars['Date']['output']>;
  generationStatus?: Maybe<TrainingPlanGenerationStatus>;
  id?: Maybe<Scalars['String']['output']>;
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  prodigyUspId?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  startDate?: Maybe<Scalars['String']['output']>;
  startGenerationAt?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ProdigyGrowthProfileCategory {
  Strength = 'STRENGTH',
  Weakness = 'WEAKNESS'
}

export type ProdigyGrowthProfileQueries = {
  __typename?: 'ProdigyGrowthProfileQueries';
  findByUser?: Maybe<Array<Maybe<ProdigyGrowthProfile>>>;
};


export type ProdigyGrowthProfileQueriesFindByUserArgs = {
  profileId: Scalars['String']['input'];
};

export type ProdigyGuideline = {
  __typename?: 'ProdigyGuideline';
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ProdigyGuidelineType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyGuidelineForm = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ProdigyGuidelineType>;
};

export type ProdigyGuidelineMutations = {
  __typename?: 'ProdigyGuidelineMutations';
  create?: Maybe<ProdigyGuideline>;
};


export type ProdigyGuidelineMutationsCreateArgs = {
  form?: InputMaybe<ProdigyGuidelineForm>;
};

export type ProdigyGuidelineQueries = {
  __typename?: 'ProdigyGuidelineQueries';
  find?: Maybe<ProdigyGuideline>;
  findOne?: Maybe<ProdigyGuideline>;
};


export type ProdigyGuidelineQueriesFindArgs = {
  where?: InputMaybe<ProdigyGuidelineQueryFilter>;
};


export type ProdigyGuidelineQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type ProdigyGuidelineQueryFilter = {
  type?: InputMaybe<ProdigyGuidelineType>;
};

export enum ProdigyGuidelineType {
  Category = 'CATEGORY',
  General = 'GENERAL',
  Mapper = 'MAPPER',
  Panel = 'PANEL',
  ScoreType = 'SCORE_TYPE',
  Trait = 'TRAIT',
  TraitLocalization = 'TRAIT_LOCALIZATION'
}

export type ProdigyMapper = {
  __typename?: 'ProdigyMapper';
  asaTrait?: Maybe<ProdigyTrait>;
  bioItSource?: Maybe<ReportGivenBioIt>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  panel?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<ReportMapperSex>;
  trait?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyMapperMutations = {
  __typename?: 'ProdigyMapperMutations';
  export?: Maybe<Scalars['String']['output']>;
  exportLocalization?: Maybe<Scalars['String']['output']>;
  exportV2?: Maybe<Scalars['String']['output']>;
  import?: Maybe<Scalars['Boolean']['output']>;
  importLocalization?: Maybe<Scalars['Boolean']['output']>;
  importV2?: Maybe<Scalars['Boolean']['output']>;
  importV3?: Maybe<Scalars['Boolean']['output']>;
};


export type ProdigyMapperMutationsExportArgs = {
  sort?: InputMaybe<ProdigyMapperQuerySortBy>;
  where?: InputMaybe<ProdigyMapperQueryFilter>;
};


export type ProdigyMapperMutationsExportV2Args = {
  sort?: InputMaybe<ProdigyMapperQuerySortBy>;
  where?: InputMaybe<ProdigyMapperQueryFilter>;
};


export type ProdigyMapperMutationsImportArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type ProdigyMapperMutationsImportLocalizationArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type ProdigyMapperMutationsImportV2Args = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type ProdigyMapperMutationsImportV3Args = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  vendorBioItId?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyMapperQueries = {
  __typename?: 'ProdigyMapperQueries';
  findAll?: Maybe<ProdigyMapperQueryResult>;
  findOne?: Maybe<ProdigyMapper>;
};


export type ProdigyMapperQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyMapperQuerySortBy>;
  where?: InputMaybe<ProdigyMapperQueryFilter>;
};


export type ProdigyMapperQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type ProdigyMapperQueryFilter = {
  bioItSource?: InputMaybe<Array<InputMaybe<ReportGivenBioIt>>>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  panel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scoreType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sex?: InputMaybe<Array<InputMaybe<ReportMapperSex>>>;
  trait?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorBioItIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProdigyMapperQueryResult = {
  __typename?: 'ProdigyMapperQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyMapper>>>;
};

export type ProdigyMapperQuerySortBy = {
  asaTrait?: InputMaybe<ProdigyTraitQuerySortBy>;
  category?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  panel?: InputMaybe<SortDirection>;
  sex?: InputMaybe<SortDirection>;
  trait?: InputMaybe<SortDirection>;
};

export type ProdigyMilestone = {
  __typename?: 'ProdigyMilestone';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endGenerationAt?: Maybe<Scalars['Date']['output']>;
  generationStatus?: Maybe<TrainingPlanGenerationStatus>;
  id?: Maybe<Scalars['String']['output']>;
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ProdigyMilestoneItem>>>;
  prodigyUspId?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  recommendation?: Maybe<Array<Maybe<ProdigyMilestoneRecommendation>>>;
  startDate?: Maybe<Scalars['String']['output']>;
  startGenerationAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyMilestoneItem = {
  __typename?: 'ProdigyMilestoneItem';
  category?: Maybe<ProdigyMilestoneItemCategory>;
  children?: Maybe<Array<Maybe<ProdigyMilestoneItem>>>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  milestoneId?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ProdigyMilestoneItem>;
  parentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ProdigyMilestoneItemCategory {
  Activity = 'ACTIVITY',
  Learning = 'LEARNING',
  Nutrition = 'NUTRITION'
}

export type ProdigyMilestoneItemMutations = {
  __typename?: 'ProdigyMilestoneItemMutations';
  completeItem?: Maybe<Array<Maybe<ProdigyMilestoneItem>>>;
};


export type ProdigyMilestoneItemMutationsCompleteItemArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProdigyMilestoneItemQueries = {
  __typename?: 'ProdigyMilestoneItemQueries';
  findByMilestone?: Maybe<Array<Maybe<ProdigyMilestoneItem>>>;
};


export type ProdigyMilestoneItemQueriesFindByMilestoneArgs = {
  milestoneId: Scalars['String']['input'];
};

export type ProdigyMilestoneMutations = {
  __typename?: 'ProdigyMilestoneMutations';
  Item?: Maybe<ProdigyMilestoneItemMutations>;
};

export type ProdigyMilestoneQueries = {
  __typename?: 'ProdigyMilestoneQueries';
  Item?: Maybe<ProdigyMilestoneItemQueries>;
  Recommendation?: Maybe<ProdigyMilestoneRecommendationQueries>;
  findByUser?: Maybe<ProdigyMilestone>;
};


export type ProdigyMilestoneQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId: Scalars['String']['input'];
};

export type ProdigyMilestoneRecommendation = {
  __typename?: 'ProdigyMilestoneRecommendation';
  category?: Maybe<ProdigyMilestoneRecommendationCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  milestoneId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ProdigyMilestoneRecommendationCategory {
  Avoid = 'AVOID',
  Recommended = 'RECOMMENDED'
}

export type ProdigyMilestoneRecommendationQueries = {
  __typename?: 'ProdigyMilestoneRecommendationQueries';
  findByMilestone?: Maybe<Array<Maybe<ProdigyMilestoneRecommendation>>>;
};


export type ProdigyMilestoneRecommendationQueriesFindByMilestoneArgs = {
  milestoneId?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyMutations = {
  __typename?: 'ProdigyMutations';
  Category?: Maybe<ProdigyCategoryMutations>;
  Figure?: Maybe<ProdigyFigureMutations>;
  Guideline?: Maybe<ProdigyGuidelineMutations>;
  Mapper?: Maybe<ProdigyMapperMutations>;
  Panel?: Maybe<ProdigyPanelMutations>;
  Score?: Maybe<ProdigyScoreMutations>;
  Trait?: Maybe<ProdigyTraitMutations>;
};

export type ProdigyPanel = {
  __typename?: 'ProdigyPanel';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  localization?: Maybe<ProdigyPanelLocalization>;
  name?: Maybe<Scalars['String']['output']>;
  preset?: Maybe<ProdigyPanelPreset>;
  presetPdf?: Maybe<ProdigyPanelPresetPdf>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type ProdigyPanelLocalizationArgs = {
  where?: InputMaybe<ProdigyPanelLocalizationQueryFilter>;
};


export type ProdigyPanelPresetPdfArgs = {
  where?: InputMaybe<ProdigyPanelPresetPdfQueryFilter>;
};

export type ProdigyPanelForm = {
  localization?: InputMaybe<ProdigyPanelLocalizationForm>;
  name?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<ProdigyPanelPresetForm>;
  presetPdf?: InputMaybe<ProdigyPanelPresetPdfForm>;
};

export enum ProdigyPanelInclude {
  Localization = 'LOCALIZATION'
}

export type ProdigyPanelLocalization = {
  __typename?: 'ProdigyPanelLocalization';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyPanelLocalizationForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyPanelLocalizationQueryFilter = {
  defaultIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyPanelLocalizationQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ProdigyPanelMutations = {
  __typename?: 'ProdigyPanelMutations';
  create?: Maybe<ProdigyPanel>;
  export?: Maybe<Scalars['String']['output']>;
  update?: Maybe<ProdigyPanel>;
};


export type ProdigyPanelMutationsCreateArgs = {
  form?: InputMaybe<CreateProdigyPanelForm>;
};


export type ProdigyPanelMutationsExportArgs = {
  sort?: InputMaybe<ProdigyPanelQuerySortBy>;
  where?: InputMaybe<ProdigyPanelQueryFilter>;
};


export type ProdigyPanelMutationsUpdateArgs = {
  form?: InputMaybe<ProdigyPanelForm>;
  id: Scalars['ID']['input'];
};

export type ProdigyPanelPreset = {
  __typename?: 'ProdigyPanelPreset';
  bgColors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyPanelPresetForm = {
  bgColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProdigyPanelPresetPdf = {
  __typename?: 'ProdigyPanelPresetPdf';
  age?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyPanelPresetPdfForm = {
  age?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['Upload']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyPanelPresetPdfQueryFilter = {
  age?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyPanelQueries = {
  __typename?: 'ProdigyPanelQueries';
  findAll?: Maybe<ProdigyPanelQueryResult>;
  findAllByReportPanel?: Maybe<ProdigyPanelQueryResult>;
  findOne?: Maybe<ProdigyPanel>;
};


export type ProdigyPanelQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<ProdigyPanelInclude>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyPanelQuerySortBy>;
  where?: InputMaybe<ProdigyPanelQueryFilter>;
};


export type ProdigyPanelQueriesFindAllByReportPanelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyPanelQuerySortBy>;
  where?: InputMaybe<ProdigyPanelQueryFilter>;
};


export type ProdigyPanelQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
  include?: InputMaybe<Array<InputMaybe<ProdigyPanelInclude>>>;
};

export type ProdigyPanelQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyPanelQueryResult = {
  __typename?: 'ProdigyPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyPanel>>>;
};

export type ProdigyPanelQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  localization_en?: InputMaybe<ProdigyPanelLocalizationQuerySortBy>;
  localization_id?: InputMaybe<ProdigyPanelLocalizationQuerySortBy>;
  name?: InputMaybe<SortDirection>;
};

export type ProdigyQueries = {
  __typename?: 'ProdigyQueries';
  Category?: Maybe<ProdigyCategoryQueries>;
  Figure?: Maybe<ProdigyFigureQueries>;
  Guideline?: Maybe<ProdigyGuidelineQueries>;
  Mapper?: Maybe<ProdigyMapperQueries>;
  Panel?: Maybe<ProdigyPanelQueries>;
  Report?: Maybe<ProdigyReportQueries>;
  Score?: Maybe<ProdigyScoreQueries>;
  Trait?: Maybe<ProdigyTraitQueries>;
  User?: Maybe<ProdigyUserQueries>;
};

export type ProdigyReport = {
  __typename?: 'ProdigyReport';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyReportPanel = {
  __typename?: 'ProdigyReportPanel';
  actualScore?: Maybe<Scalars['Float']['output']>;
  barIndex?: Maybe<Scalars['Float']['output']>;
  biScore?: Maybe<BioinformaticScore>;
  category?: Maybe<ProdigyCategory>;
  genes?: Maybe<Array<Maybe<BioinformaticGene>>>;
  genotypes?: Maybe<Array<Maybe<BioinformaticReportGenoType>>>;
  id?: Maybe<Scalars['String']['output']>;
  isHigherBetter?: Maybe<Scalars['Boolean']['output']>;
  mappedScore?: Maybe<Scalars['Int']['output']>;
  panel?: Maybe<ProdigyPanel>;
  report?: Maybe<ProdigyReport>;
  response?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Array<Maybe<ProdigyReportPanelResponse>>>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  scoreDetails?: Maybe<Array<Maybe<ProdigyScore>>>;
  scoreRangeFrom?: Maybe<Scalars['Float']['output']>;
  scoreRangeTo?: Maybe<Scalars['Float']['output']>;
  trait?: Maybe<ProdigyTrait>;
  traitScore?: Maybe<ProdigyScore>;
  traitScoreReport?: Maybe<ProdigyScoreReport>;
  traitScores?: Maybe<Array<Maybe<ProdigyScore>>>;
};


export type ProdigyReportPanelTraitScoreReportArgs = {
  where?: InputMaybe<ProdigyScoreReportQueryFilter>;
};

export type ProdigyReportPanelGenoType = {
  __typename?: 'ProdigyReportPanelGenoType';
  geneId?: Maybe<Scalars['String']['output']>;
  genoTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ProdigyReportPanelInclude {
  Category = 'CATEGORY',
  Panel = 'PANEL',
  Trait = 'TRAIT'
}

export type ProdigyReportPanelQueries = {
  __typename?: 'ProdigyReportPanelQueries';
  findAll?: Maybe<ProdigyReportPanelQueryResult>;
  findOne?: Maybe<ProdigyReportPanel>;
};


export type ProdigyReportPanelQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<ProdigyReportPanelInclude>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyReportPanelSortBy>;
  where?: InputMaybe<ProdigyReportPanelQueryFilter>;
};


export type ProdigyReportPanelQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  include?: InputMaybe<Array<InputMaybe<ProdigyReportPanelInclude>>>;
};

export type ProdigyReportPanelQueryFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  evaluationStatus?: InputMaybe<Array<InputMaybe<ReportEvaluationStatus>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  panel?: InputMaybe<Scalars['String']['input']>;
  panelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusCategoryAndTrait>;
  trait?: InputMaybe<Scalars['String']['input']>;
  traitId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProdigyReportPanelQueryResult = {
  __typename?: 'ProdigyReportPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyReportPanel>>>;
};

export type ProdigyReportPanelResponse = {
  __typename?: 'ProdigyReportPanelResponse';
  language?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type ProdigyReportPanelSortBy = {
  actualScore?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  score?: InputMaybe<SortDirection>;
};

export type ProdigyReportQueries = {
  __typename?: 'ProdigyReportQueries';
  Panel?: Maybe<ProdigyReportPanelQueries>;
  findAll?: Maybe<ProdigyReportQueryResult>;
  findOne?: Maybe<ProdigyReport>;
};


export type ProdigyReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyReportQuerySortBy>;
  where?: InputMaybe<ProdigyReportQueryFilter>;
};


export type ProdigyReportQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type ProdigyReportQueryFilter = {
  code: Scalars['String']['input'];
};

export type ProdigyReportQueryResult = {
  __typename?: 'ProdigyReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyReport>>>;
};

export type ProdigyReportQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type ProdigyScore = {
  __typename?: 'ProdigyScore';
  createdAt?: Maybe<Scalars['Date']['output']>;
  from?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  scoreMapped?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyScoreForm = {
  from?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
  scoreMapped?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type ProdigyScoreMutations = {
  __typename?: 'ProdigyScoreMutations';
  Type?: Maybe<ProdigyScoreTypeMutations>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type ProdigyScoreMutationsDeleteArgs = {
  id: Scalars['ID']['input'];
};

export type ProdigyScoreQueries = {
  __typename?: 'ProdigyScoreQueries';
  Type?: Maybe<ProdigyScoreTypeQueries>;
  findAll?: Maybe<ProdigyScoreQueryResult>;
};


export type ProdigyScoreQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyScoreQuerySortBy>;
  where?: InputMaybe<ProdigyScoreQueryFilter>;
};

export type ProdigyScoreQueryFilter = {
  scoreTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traitId?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyScoreQueryResult = {
  __typename?: 'ProdigyScoreQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyScore>>>;
};

export type ProdigyScoreQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  from?: InputMaybe<SortDirection>;
  response?: InputMaybe<SortDirection>;
  riskLevel?: InputMaybe<SortDirection>;
  scoreMapped?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<SortDirection>;
};

export type ProdigyScoreReport = {
  __typename?: 'ProdigyScoreReport';
  age?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interpretation?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteInList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  score?: Maybe<ProdigyScore>;
  shortInterpretation?: Maybe<Scalars['String']['output']>;
  significance?: Maybe<Scalars['String']['output']>;
  significanceInList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyScoreReportForm = {
  age?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interpretation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  scoreId?: InputMaybe<Scalars['ID']['input']>;
  shortInterpretation?: InputMaybe<Scalars['String']['input']>;
  significance?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyScoreReportQueryFilter = {
  defaultIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyScoreType = {
  __typename?: 'ProdigyScoreType';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHigherBetter?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scores?: Maybe<ProdigyScoreQueryResult>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyScoreTypeForm = {
  isHigherBetter?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scores?: InputMaybe<Array<InputMaybe<ProdigyScoreForm>>>;
};

export type ProdigyScoreTypeMutations = {
  __typename?: 'ProdigyScoreTypeMutations';
  create?: Maybe<ProdigyScoreType>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<ProdigyScoreType>;
};


export type ProdigyScoreTypeMutationsCreateArgs = {
  form?: InputMaybe<ProdigyScoreTypeForm>;
};


export type ProdigyScoreTypeMutationsDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type ProdigyScoreTypeMutationsUpdateArgs = {
  form?: InputMaybe<ProdigyScoreTypeForm>;
  id: Scalars['ID']['input'];
};

export type ProdigyScoreTypeQueries = {
  __typename?: 'ProdigyScoreTypeQueries';
  findAll?: Maybe<ProdigyScoreTypeQueryResult>;
  findOne?: Maybe<ProdigyScoreType>;
};


export type ProdigyScoreTypeQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyScoreTypeQuerySortBy>;
  where?: InputMaybe<ProdigyScoreTypeQueryFilter>;
};


export type ProdigyScoreTypeQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
};

export type ProdigyScoreTypeQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyScoreTypeQueryResult = {
  __typename?: 'ProdigyScoreTypeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyScoreType>>>;
};

export type ProdigyScoreTypeQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ProdigyTrait = {
  __typename?: 'ProdigyTrait';
  active?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<ProdigyCategory>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  localization?: Maybe<ProdigyTraitLocalization>;
  name?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<ProdigyScoreType>;
  status?: Maybe<ProdigyTraitStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type ProdigyTraitLocalizationArgs = {
  where?: InputMaybe<ProdigyTraitLocalizationQueryFilter>;
};

export type ProdigyTraitForm = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  localization?: InputMaybe<ProdigyTraitLocalizationForm>;
  localizations?: InputMaybe<Array<InputMaybe<ProdigyTraitLocalizationForm>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ProdigyTraitInclude {
  Category = 'CATEGORY',
  Localization = 'LOCALIZATION',
  ScoreType = 'SCORE_TYPE',
  Status = 'STATUS'
}

export type ProdigyTraitLocalization = {
  __typename?: 'ProdigyTraitLocalization';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<ProdigyScoreReport>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyTraitLocalizationForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reports?: InputMaybe<Array<InputMaybe<ProdigyScoreReportForm>>>;
};

export type ProdigyTraitLocalizationQueryFilter = {
  defaultIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type ProdigyTraitLocalizationQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ProdigyTraitMutations = {
  __typename?: 'ProdigyTraitMutations';
  create?: Maybe<ProdigyTrait>;
  export?: Maybe<Scalars['String']['output']>;
  update?: Maybe<ProdigyTrait>;
};


export type ProdigyTraitMutationsCreateArgs = {
  form?: InputMaybe<ProdigyTraitForm>;
};


export type ProdigyTraitMutationsExportArgs = {
  sort?: InputMaybe<ProdigyTraitQuerySortBy>;
  where?: InputMaybe<ProdigyTraitQueryFilter>;
};


export type ProdigyTraitMutationsUpdateArgs = {
  form?: InputMaybe<ProdigyTraitForm>;
  id: Scalars['ID']['input'];
};

export type ProdigyTraitQueries = {
  __typename?: 'ProdigyTraitQueries';
  findAll?: Maybe<ProdigyTraitQueryResult>;
  findAllByReportPanel?: Maybe<ProdigyTraitQueryResult>;
  findOne?: Maybe<ProdigyTrait>;
};


export type ProdigyTraitQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<ProdigyTraitInclude>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyTraitQuerySortBy>;
  where?: InputMaybe<ProdigyTraitQueryFilter>;
};


export type ProdigyTraitQueriesFindAllByReportPanelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProdigyTraitQuerySortBy>;
  where?: InputMaybe<ProdigyTraitQueryFilter>;
};


export type ProdigyTraitQueriesFindOneArgs = {
  id: Scalars['ID']['input'];
  include?: InputMaybe<Array<InputMaybe<ProdigyTraitInclude>>>;
};

export type ProdigyTraitQueryFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  localization?: InputMaybe<Scalars['Boolean']['input']>;
  panels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<ProdigyTraitStatus>>>;
};

export type ProdigyTraitQueryResult = {
  __typename?: 'ProdigyTraitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProdigyTrait>>>;
};

export type ProdigyTraitQuerySortBy = {
  active?: InputMaybe<SortDirection>;
  category?: InputMaybe<ProdigyCategoryQuerySortBy>;
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  localization_en?: InputMaybe<ProdigyTraitLocalizationQuerySortBy>;
  localization_id?: InputMaybe<ProdigyTraitLocalizationQuerySortBy>;
  name?: InputMaybe<SortDirection>;
  scoreType?: InputMaybe<ProdigyScoreTypeQuerySortBy>;
};

export enum ProdigyTraitStatus {
  Active = 'ACTIVE',
  NotActive = 'NOT_ACTIVE',
  NotMapped = 'NOT_MAPPED'
}

export type ProdigyUserQueries = {
  __typename?: 'ProdigyUserQueries';
  findAll?: Maybe<ProdigyUserQueryResult>;
};


export type ProdigyUserQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserQuerySortBy>;
  where?: InputMaybe<UserQueryFilter>;
};

export type ProdigyUserQueryResult = {
  __typename?: 'ProdigyUserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserProfile>>>;
};

export type ProdigyWeeklyActivity = {
  __typename?: 'ProdigyWeeklyActivity';
  activities?: Maybe<Array<Maybe<ProdigyWeeklyActivityItem>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endGenerationAt?: Maybe<Scalars['Date']['output']>;
  generationStatus?: Maybe<TrainingPlanGenerationStatus>;
  id?: Maybe<Scalars['String']['output']>;
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  prodigyUspId?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  startDate?: Maybe<Scalars['String']['output']>;
  startGenerationAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProdigyWeeklyActivityItem = {
  __typename?: 'ProdigyWeeklyActivityItem';
  category?: Maybe<ProdigyWeeklyActivityItemCategory>;
  code?: Maybe<ProdigyWeeklyActivityItemCode>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isTickable?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weeklyActivityId?: Maybe<Scalars['String']['output']>;
};

export enum ProdigyWeeklyActivityItemCategory {
  Avoid = 'AVOID',
  Recommended = 'RECOMMENDED',
  Tickable = 'TICKABLE'
}

export enum ProdigyWeeklyActivityItemCode {
  Activity = 'ACTIVITY',
  Learning = 'LEARNING',
  Nutrition = 'NUTRITION',
  Tickable = 'TICKABLE'
}

export type ProdigyWeeklyActivityItemMutations = {
  __typename?: 'ProdigyWeeklyActivityItemMutations';
  tickItem?: Maybe<ProdigyWeeklyActivityItem>;
};


export type ProdigyWeeklyActivityItemMutationsTickItemArgs = {
  id: Scalars['String']['input'];
};

export type ProdigyWeeklyActivityItemQueries = {
  __typename?: 'ProdigyWeeklyActivityItemQueries';
  findByWeeklyActivity?: Maybe<Array<Maybe<ProdigyWeeklyActivityItem>>>;
};


export type ProdigyWeeklyActivityItemQueriesFindByWeeklyActivityArgs = {
  weeklyActivityId: Scalars['String']['input'];
};

export type ProdigyWeeklyActivityMutations = {
  __typename?: 'ProdigyWeeklyActivityMutations';
  Item?: Maybe<ProdigyWeeklyActivityItemMutations>;
  generate?: Maybe<ProdigyWeeklyActivity>;
  recommend?: Maybe<ProdigyWeeklyActivity>;
};


export type ProdigyWeeklyActivityMutationsGenerateArgs = {
  date: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};


export type ProdigyWeeklyActivityMutationsRecommendArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProdigyWeeklyActivityQueries = {
  __typename?: 'ProdigyWeeklyActivityQueries';
  Item?: Maybe<ProdigyWeeklyActivityItemQueries>;
  findByUser?: Maybe<ProdigyWeeklyActivity>;
};


export type ProdigyWeeklyActivityQueriesFindByUserArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId: Scalars['String']['input'];
};

export type ProductKitPickupHistory = {
  __typename?: 'ProductKitPickupHistory';
  bookingId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  trackingCode?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  waybill?: Maybe<Scalars['String']['output']>;
};

export type ProductKitPickupHistoryForm = {
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductKitPickupStatus>;
};

export type ProductKitPickupHistoryMutations = {
  __typename?: 'ProductKitPickupHistoryMutations';
  edit?: Maybe<Scalars['Boolean']['output']>;
};


export type ProductKitPickupHistoryMutationsEditArgs = {
  form?: InputMaybe<ProductKitPickupHistoryForm>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductKitPickupStatus {
  KitpickupConfirmed = 'KITPICKUP_CONFIRMED',
  KitpickupReceived = 'KITPICKUP_RECEIVED',
  OnKitdelivery = 'ON_KITDELIVERY',
  OnKitpickup = 'ON_KITPICKUP',
  WaitingKitpickupConfirmed = 'WAITING_KITPICKUP_CONFIRMED'
}

export type ProductOrderForm = {
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantity?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPickupForm = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPurchaseReport = {
  __typename?: 'ProductPurchaseReport';
  buyer?: Maybe<UserProfile>;
  category?: Maybe<PurchaseProductCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  report?: Maybe<PurchaseProductReport>;
  status?: Maybe<ProductPurchaseReportStatus>;
  type?: Maybe<PurchaseProduct>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProductPurchaseReportForm = {
  traitId: Scalars['Int']['input'];
};

export type ProductPurchaseReportMutations = {
  __typename?: 'ProductPurchaseReportMutations';
  add?: Maybe<ProductPurchaseReport>;
};


export type ProductPurchaseReportMutationsAddArgs = {
  form?: InputMaybe<ProductPurchaseReportForm>;
};

export type ProductPurchaseReportQueries = {
  __typename?: 'ProductPurchaseReportQueries';
  findAll?: Maybe<ProductPurchaseReportQueryResult>;
  findOne?: Maybe<ProductPurchaseReport>;
  findOneMaxPrice?: Maybe<Scalars['Int']['output']>;
  findOneMinPrice?: Maybe<Scalars['Int']['output']>;
};


export type ProductPurchaseReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductPurchaseReportQuerySortBy>;
  where?: InputMaybe<ProductPurchaseReportQueryFilter>;
};


export type ProductPurchaseReportQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type ProductPurchaseReportQueryFilter = {
  buyer?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateRangeFilter>;
  price?: InputMaybe<PriceRangeFilter>;
  report?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<ProductPurchaseReportStatus>>>;
  trait?: InputMaybe<Scalars['String']['input']>;
  traits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProductPurchaseReportQueryResult = {
  __typename?: 'ProductPurchaseReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ProductPurchaseReport>>>;
};

export type ProductPurchaseReportQuerySortBy = {
  buyer?: InputMaybe<SortDirection>;
  category?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  trait?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum ProductPurchaseReportStatus {
  PaymentExpired = 'PAYMENT_EXPIRED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export type ProfileEthnicity = {
  __typename?: 'ProfileEthnicity';
  father?: Maybe<Array<Maybe<ProfileEthnicityGroup>>>;
  id?: Maybe<Scalars['ID']['output']>;
  mother?: Maybe<Array<Maybe<ProfileEthnicityGroup>>>;
  name?: Maybe<Array<Maybe<ProfileEthnicityGroup>>>;
};

export type ProfileEthnicityForm = {
  father?: InputMaybe<Array<InputMaybe<ProfileEthnicityGroupForm>>>;
  mother?: InputMaybe<Array<InputMaybe<ProfileEthnicityGroupForm>>>;
  name?: InputMaybe<Array<InputMaybe<ProfileEthnicityGroupForm>>>;
};

export type ProfileEthnicityGroup = {
  __typename?: 'ProfileEthnicityGroup';
  group?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProfileEthnicityGroupForm = {
  group?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileMedical = {
  __typename?: 'ProfileMedical';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProfileMedicalForm = {
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Promo = {
  __typename?: 'Promo';
  address?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PromoStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PromoForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['Date']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
};

export type PromoMutations = {
  __typename?: 'PromoMutations';
  Referral?: Maybe<PromoReferralMutations>;
  Visitor?: Maybe<PromoVisitorMutations>;
  add?: Maybe<Promo>;
};


export type PromoMutationsAddArgs = {
  form?: InputMaybe<PromoForm>;
};

export type PromoQueries = {
  __typename?: 'PromoQueries';
  Referral?: Maybe<PromoReferralQueries>;
};

export type PromoQueryFilter = {
  status?: InputMaybe<Array<InputMaybe<PromoStatus>>>;
};

export type PromoQueryResult = {
  __typename?: 'PromoQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Promo>>>;
};

export type PromoReferral = {
  __typename?: 'PromoReferral';
  baseUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<PromoQueryResult>;
  rate?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visitors?: Maybe<PromoVisitorQueryResult>;
};


export type PromoReferralOrdersArgs = {
  where?: InputMaybe<PromoQueryFilter>;
};

export type PromoReferralForm = {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PromoReferralMutations = {
  __typename?: 'PromoReferralMutations';
  add?: Maybe<PromoReferral>;
};


export type PromoReferralMutationsAddArgs = {
  form?: InputMaybe<PromoReferralForm>;
};

export type PromoReferralQueries = {
  __typename?: 'PromoReferralQueries';
  findAll?: Maybe<PromoReferralQueryResult>;
  findByCode?: Maybe<PromoReferral>;
  findOne?: Maybe<PromoReferral>;
};


export type PromoReferralQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PromoReferralQuerySortBy>;
  where?: InputMaybe<PromoReferralQueryFilter>;
};


export type PromoReferralQueriesFindByCodeArgs = {
  code: Scalars['String']['input'];
};


export type PromoReferralQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PromoReferralQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type PromoReferralQueryResult = {
  __typename?: 'PromoReferralQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PromoReferral>>>;
};

export type PromoReferralQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  link?: InputMaybe<SortDirection>;
};

export enum PromoStatus {
  PaymentExpired = 'PAYMENT_EXPIRED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export type PromoVisitor = {
  __typename?: 'PromoVisitor';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<PromoReferral>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PromoVisitorForm = {
  referral?: InputMaybe<Scalars['String']['input']>;
};

export type PromoVisitorMutations = {
  __typename?: 'PromoVisitorMutations';
  add?: Maybe<PromoVisitor>;
};


export type PromoVisitorMutationsAddArgs = {
  form?: InputMaybe<PromoVisitorForm>;
};

export type PromoVisitorQueryResult = {
  __typename?: 'PromoVisitorQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PromoVisitor>>>;
};

export type PurchaseCart = {
  __typename?: 'PurchaseCart';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  product?: Maybe<PurchaseProduct>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseCartForm = {
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseCartMutations = {
  __typename?: 'PurchaseCartMutations';
  add?: Maybe<PurchaseCart>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseCart>;
};


export type PurchaseCartMutationsAddArgs = {
  form?: InputMaybe<PurchaseCartForm>;
};


export type PurchaseCartMutationsDeleteArgs = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PurchaseCartMutationsEditArgs = {
  form?: InputMaybe<PurchaseCartForm>;
  id: Scalars['String']['input'];
};

export type PurchaseCartQueries = {
  __typename?: 'PurchaseCartQueries';
  findAll?: Maybe<PurchaseCartQueryResult>;
  findOne?: Maybe<PurchaseCart>;
};


export type PurchaseCartQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PurchaseCartQueryFilter>;
};


export type PurchaseCartQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseCartQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseCartQueryResult = {
  __typename?: 'PurchaseCartQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseCart>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseConfirmOrderForm = {
  id?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<PurchaseOrderShipmentForm>;
};

export type PurchaseInstallmentQueryResult = {
  __typename?: 'PurchaseInstallmentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseOrderInstallment>>>;
};

export type PurchaseMutations = {
  __typename?: 'PurchaseMutations';
  Cart?: Maybe<PurchaseCartMutations>;
  Order?: Maybe<PurchaseOrderMutations>;
  Product?: Maybe<PurchaseProductMutations>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  attachment?: Maybe<Scalars['String']['output']>;
  buyOneGetOneDiscount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  histories?: Maybe<Array<Maybe<PurchaseOrderHistory>>>;
  homeservice?: Maybe<PurchaseOrderHomeservice>;
  id?: Maybe<Scalars['String']['output']>;
  installment?: Maybe<PurchaseOrderInstallment>;
  invoice?: Maybe<PurchaseOrderInvoice>;
  isInternationalOrder?: Maybe<Scalars['Boolean']['output']>;
  isUpsell?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PurchaseOrderItem>>>;
  merchant?: Maybe<MerchantV2>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantType?: Maybe<MerchantType>;
  payment?: Maybe<PurchaseOrderPayment>;
  preOrderFullfillmentDate?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  promoDiscount?: Maybe<Scalars['Float']['output']>;
  purchaseType?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['Date']['output']>;
  shipment?: Maybe<PurchaseOrderShipment>;
  shipmentAddressFormStatus?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Platform>;
  status?: Maybe<PurchaseOrderStatus>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  subscription?: Maybe<OrderSubscription>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<PurchaseOrderType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseOrderDelivery = {
  __typename?: 'PurchaseOrderDelivery';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderDeliveryForm = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderDeliveryMutations = {
  __typename?: 'PurchaseOrderDeliveryMutations';
  add?: Maybe<PurchaseOrderDelivery>;
  resend?: Maybe<PurchaseOrderDelivery>;
};


export type PurchaseOrderDeliveryMutationsAddArgs = {
  form?: InputMaybe<PurchaseOrderDeliveryForm>;
};


export type PurchaseOrderDeliveryMutationsResendArgs = {
  form?: InputMaybe<PurchaseOrderDeliveryForm>;
};

export type PurchaseOrderForm = {
  carts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  exchangeRate?: InputMaybe<Scalars['String']['input']>;
  homeservice?: InputMaybe<PurchaseOrderHomeserviceForm>;
  installment?: InputMaybe<PurchaseOrderInstallmentForm>;
  isInternationalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  payment?: InputMaybe<PurchaseOrderPaymentForm>;
  shipment?: InputMaybe<PurchaseOrderShipmentForm>;
  type?: InputMaybe<PurchaseOrderType>;
};

export type PurchaseOrderFormShipping = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PurchaseOrderShipmentType>;
};

export type PurchaseOrderFormV2 = {
  homeservice?: InputMaybe<PurchaseOrderHomeserviceForm>;
  installment?: InputMaybe<PurchaseOrderInstallmentForm>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  payment?: InputMaybe<PurchaseOrderPaymentForm>;
  productOrders?: InputMaybe<Array<InputMaybe<ProductOrderForm>>>;
  shipment?: InputMaybe<PurchaseOrderShipmentForm>;
  shipping?: InputMaybe<PurchaseOrderFormShipping>;
  type?: InputMaybe<PurchaseOrderType>;
};

export type PurchaseOrderHistory = {
  __typename?: 'PurchaseOrderHistory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PurchaseOrderStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PurchaseOrderHomeServicePurchaseType {
  Preorder = 'PREORDER',
  Stock = 'STOCK'
}

export type PurchaseOrderHomeservice = {
  __typename?: 'PurchaseOrderHomeservice';
  additionalPax?: Maybe<Scalars['Int']['output']>;
  additionalPrice?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<PurchaseOrder>;
  pax?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PurchaseOrderStatus>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visitedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseOrderHomeserviceForm = {
  additionalPax?: InputMaybe<Scalars['Int']['input']>;
  additionalPrice?: InputMaybe<Scalars['Int']['input']>;
  pax?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PurchaseOrderStatus>;
  visitedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type PurchaseOrderHomeserviceMutations = {
  __typename?: 'PurchaseOrderHomeserviceMutations';
  Setting?: Maybe<PurchaseOrderHomeserviceSettingMutations>;
  edit?: Maybe<PurchaseOrderHomeservice>;
  exportExcel?: Maybe<Scalars['String']['output']>;
};


export type PurchaseOrderHomeserviceMutationsEditArgs = {
  form?: InputMaybe<PurchaseOrderHomeserviceForm>;
  id: Scalars['String']['input'];
};


export type PurchaseOrderHomeserviceMutationsExportExcelArgs = {
  sort?: InputMaybe<PurchaseOrderHomeserviceQuerySortBy>;
  where?: InputMaybe<PurchaseOrderHomeserviceQueryFilter>;
};

export type PurchaseOrderHomeserviceQueries = {
  __typename?: 'PurchaseOrderHomeserviceQueries';
  Setting?: Maybe<PurchaseOrderHomeserviceSettingQueries>;
  findAll?: Maybe<PurchaseOrderHomeserviceQueryResult>;
  findOne?: Maybe<PurchaseOrderHomeservice>;
};


export type PurchaseOrderHomeserviceQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseOrderHomeserviceQuerySortBy>;
  where?: InputMaybe<PurchaseOrderHomeserviceQueryFilter>;
};


export type PurchaseOrderHomeserviceQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseOrderHomeserviceQueryFilter = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  purchaseType?: InputMaybe<Array<InputMaybe<PurchaseOrderHomeServicePurchaseType>>>;
  status?: InputMaybe<Array<InputMaybe<PurchaseOrderStatus>>>;
  totalKit?: InputMaybe<Scalars['Int']['input']>;
  totalPax?: InputMaybe<Scalars['Int']['input']>;
  visitedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseOrderHomeserviceQueryResult = {
  __typename?: 'PurchaseOrderHomeserviceQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseOrderHomeservice>>>;
};

export type PurchaseOrderHomeserviceQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  visitedAt?: InputMaybe<SortDirection>;
};

export type PurchaseOrderHomeserviceSetting = {
  __typename?: 'PurchaseOrderHomeserviceSetting';
  additionalPrice?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseOrderHomeserviceSettingForm = {
  additionalPrice?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseOrderHomeserviceSettingMutations = {
  __typename?: 'PurchaseOrderHomeserviceSettingMutations';
  edit?: Maybe<PurchaseOrderHomeserviceSetting>;
};


export type PurchaseOrderHomeserviceSettingMutationsEditArgs = {
  form?: InputMaybe<PurchaseOrderHomeserviceSettingForm>;
};

export type PurchaseOrderHomeserviceSettingQueries = {
  __typename?: 'PurchaseOrderHomeserviceSettingQueries';
  findOne?: Maybe<PurchaseOrderHomeserviceSetting>;
};

export type PurchaseOrderInstallment = {
  __typename?: 'PurchaseOrderInstallment';
  amount?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interest?: Maybe<Scalars['Float']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  order?: Maybe<PurchaseOrder>;
  payload?: Maybe<PaymentPayload>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseOrderInstallmentForm = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  interest?: InputMaybe<Scalars['Float']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderInstallmentQueries = {
  __typename?: 'PurchaseOrderInstallmentQueries';
  checkZeroInterestWithBIN?: Maybe<Scalars['Boolean']['output']>;
  findAll?: Maybe<PurchaseInstallmentQueryResult>;
  findOne?: Maybe<PurchaseOrderInstallment>;
};


export type PurchaseOrderInstallmentQueriesCheckZeroInterestWithBinArgs = {
  bin: Scalars['String']['input'];
};


export type PurchaseOrderInstallmentQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PurchaseOrderInstallmentQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseOrderInvoice = {
  __typename?: 'PurchaseOrderInvoice';
  attachment?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isUpsell?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<PurchaseProduct>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseOrderMutations = {
  __typename?: 'PurchaseOrderMutations';
  Delivery?: Maybe<PurchaseOrderDeliveryMutations>;
  Homeservice?: Maybe<PurchaseOrderHomeserviceMutations>;
  Reminder?: Maybe<PurchaseOrderReminderMutations>;
  Shipment?: Maybe<PurchaseOrderShipmentMutations>;
  add?: Maybe<PurchaseOrder>;
  addUnlock?: Maybe<PurchaseOrder>;
  addV2?: Maybe<PurchaseOrder>;
  complete?: Maybe<PurchaseOrder>;
  confirmOrder?: Maybe<PurchaseOrder>;
  export?: Maybe<Scalars['String']['output']>;
  exportReport?: Maybe<Scalars['String']['output']>;
  exportSubscription?: Maybe<Scalars['String']['output']>;
};


export type PurchaseOrderMutationsAddArgs = {
  form?: InputMaybe<PurchaseOrderForm>;
};


export type PurchaseOrderMutationsAddUnlockArgs = {
  form?: InputMaybe<PurchaseOrderUnlockForm>;
};


export type PurchaseOrderMutationsAddV2Args = {
  form?: InputMaybe<PurchaseOrderFormV2>;
};


export type PurchaseOrderMutationsCompleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseOrderMutationsConfirmOrderArgs = {
  form?: InputMaybe<PurchaseConfirmOrderForm>;
};


export type PurchaseOrderMutationsExportArgs = {
  sort?: InputMaybe<OrderQuerySortBy>;
  where?: InputMaybe<OrderQueryFilter>;
};


export type PurchaseOrderMutationsExportReportArgs = {
  createdAt?: InputMaybe<SortDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  partnershipId: Scalars['String']['input'];
  where?: InputMaybe<OrderVoucherQueryFilter>;
};


export type PurchaseOrderMutationsExportSubscriptionArgs = {
  sort?: InputMaybe<OrderQuerySortBy>;
  where?: InputMaybe<OrderQueryFilter>;
};

export type PurchaseOrderPayment = {
  __typename?: 'PurchaseOrderPayment';
  createdAt?: Maybe<Scalars['Date']['output']>;
  gateway?: Maybe<PaymentGateway>;
  id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<PurchaseOrder>;
  paidAt?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<PaymentPayload>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  type?: Maybe<PaymentType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  voucher?: Maybe<Voucher>;
};

export type PurchaseOrderPaymentForm = {
  payLaterPlanId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentType>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderPaymentQueries = {
  __typename?: 'PurchaseOrderPaymentQueries';
  findAll?: Maybe<PurchasePaymentQueryResult>;
  findLatestMethod?: Maybe<Scalars['String']['output']>;
  findOne?: Maybe<PurchaseOrderPayment>;
};


export type PurchaseOrderPaymentQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PurchaseOrderPaymentQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export enum PurchaseOrderPurchaseType {
  Preorder = 'PREORDER',
  Stock = 'STOCK',
  Subscription = 'SUBSCRIPTION',
  UnlockKit = 'UNLOCK_KIT',
  UnlockProtocol = 'UNLOCK_PROTOCOL',
  UnlockReport = 'UNLOCK_REPORT'
}

export type PurchaseOrderQueries = {
  __typename?: 'PurchaseOrderQueries';
  Homeservice?: Maybe<PurchaseOrderHomeserviceQueries>;
  Installment?: Maybe<PurchaseOrderInstallmentQueries>;
  Payment?: Maybe<PurchaseOrderPaymentQueries>;
  Shipment?: Maybe<PurchaseOrderShipmentQueries>;
  findAll?: Maybe<PurchaseOrderQueryResult>;
  findByVoucher?: Maybe<PurchaseOrderQueryResult>;
  findLatestPaidOrderWithoutShipment?: Maybe<PurchaseOrderQueryResult>;
  findOne?: Maybe<PurchaseOrder>;
};


export type PurchaseOrderQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrderQuerySortBy>;
  where?: InputMaybe<OrderQueryFilter>;
};


export type PurchaseOrderQueriesFindByVoucherArgs = {
  createdAt?: InputMaybe<SortDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  partnershipId: Scalars['String']['input'];
  where?: InputMaybe<OrderVoucherQueryFilter>;
};


export type PurchaseOrderQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseOrderQueryResult = {
  __typename?: 'PurchaseOrderQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseOrder>>>;
};

export type PurchaseOrderReminder = {
  __typename?: 'PurchaseOrderReminder';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseOrderReminderMutations = {
  __typename?: 'PurchaseOrderReminderMutations';
  add?: Maybe<PurchaseOrderReminder>;
};

export type PurchaseOrderShipment = {
  __typename?: 'PurchaseOrderShipment';
  address?: Maybe<Scalars['String']['output']>;
  anterAjaCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  courier?: Maybe<PurchaseOrderShipmentCourier>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  histories?: Maybe<Array<Maybe<PurchaseOrderShipmentHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  shipmentCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PurchaseOrderShipmentType>;
  waybill?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderShipmentCourier = {
  __typename?: 'PurchaseOrderShipmentCourier';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderShipmentCourierQueries = {
  __typename?: 'PurchaseOrderShipmentCourierQueries';
  findAll?: Maybe<PurchaseOrderShipmentCourierQueryResult>;
  findOne?: Maybe<PurchaseOrderShipmentCourier>;
};


export type PurchaseOrderShipmentCourierQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PurchaseOrderShipmentCourierQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseOrderShipmentCourierQueryResult = {
  __typename?: 'PurchaseOrderShipmentCourierQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseOrderShipmentCourier>>>;
};

export type PurchaseOrderShipmentForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courier?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PurchaseOrderShipmentType>;
};

export enum PurchaseOrderShipmentFormStatus {
  Complete = 'COMPLETE',
  NotComplete = 'NOT_COMPLETE'
}

export type PurchaseOrderShipmentHistory = {
  __typename?: 'PurchaseOrderShipmentHistory';
  bookingId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  trackingCode?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  waybill?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderShipmentHistoryForm = {
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PurchaseOrderStatus>;
};

export type PurchaseOrderShipmentHistoryMutations = {
  __typename?: 'PurchaseOrderShipmentHistoryMutations';
  edit?: Maybe<Scalars['Boolean']['output']>;
};


export type PurchaseOrderShipmentHistoryMutationsEditArgs = {
  form?: InputMaybe<PurchaseOrderShipmentHistoryForm>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderShipmentMutations = {
  __typename?: 'PurchaseOrderShipmentMutations';
  History?: Maybe<PurchaseOrderShipmentHistoryMutations>;
  edit?: Maybe<Scalars['Boolean']['output']>;
  editWaybill?: Maybe<Scalars['Boolean']['output']>;
};


export type PurchaseOrderShipmentMutationsEditArgs = {
  form?: InputMaybe<EditPurchaseOrderShipmentForm>;
};


export type PurchaseOrderShipmentMutationsEditWaybillArgs = {
  form?: InputMaybe<EditPurchaseOrderShipmentWaybillForm>;
};

export type PurchaseOrderShipmentQueries = {
  __typename?: 'PurchaseOrderShipmentQueries';
  Courier?: Maybe<PurchaseOrderShipmentCourierQueries>;
};

export enum PurchaseOrderShipmentType {
  HomeService = 'HOME_SERVICE',
  Regular = 'REGULAR',
  WalkIn = 'WALK_IN'
}

export enum PurchaseOrderStatus {
  Cancelled = 'CANCELLED',
  DateSet = 'DATE_SET',
  HomeVisited = 'HOME_VISITED',
  OnDelivery = 'ON_DELIVERY',
  OnPickup = 'ON_PICKUP',
  OrderConfirmed = 'ORDER_CONFIRMED',
  OrderReceived = 'ORDER_RECEIVED',
  PaymentExpired = 'PAYMENT_EXPIRED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  WaitingForPayment = 'WAITING_FOR_PAYMENT',
  WaitingOrderConfirmed = 'WAITING_ORDER_CONFIRMED'
}

export enum PurchaseOrderType {
  HomeService = 'HOME_SERVICE',
  Regular = 'REGULAR',
  Subscription = 'SUBSCRIPTION',
  Unlock = 'UNLOCK',
  UnlockHealthProtocol = 'UNLOCK_HEALTH_PROTOCOL',
  WalkIn = 'WALK_IN'
}

export type PurchaseOrderUnlockForm = {
  code?: InputMaybe<Paid_Product_Code>;
  currency?: InputMaybe<Scalars['String']['input']>;
  exchangeRate?: InputMaybe<Scalars['String']['input']>;
  isInternationalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  paymentCode?: InputMaybe<PaymentType>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchasePaymentQueryResult = {
  __typename?: 'PurchasePaymentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseOrderPayment>>>;
};

export type PurchaseProduct = {
  __typename?: 'PurchaseProduct';
  activatedReportTypeRequirement?: Maybe<PurchaseProductRequirement>;
  bgImage?: Maybe<Scalars['String']['output']>;
  bundling?: Maybe<Array<Maybe<PurchaseProductBundling>>>;
  bundlingId?: Maybe<Scalars['String']['output']>;
  buyOneMultiplier?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<Array<Maybe<PurchaseProductCategory>>>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<PurchaseProductDiscount>;
  displayPrice?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imageApp?: Maybe<Scalars['String']['output']>;
  imageWeb?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<PurchaseProductImage>>>;
  internationalDiscount?: Maybe<PurchaseProductDiscount>;
  internationalPrice?: Maybe<Scalars['Int']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  isBuyOneGetOne?: Maybe<Scalars['Boolean']['output']>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  isFreeHomeService?: Maybe<Scalars['Boolean']['output']>;
  isUpsell?: Maybe<Scalars['Boolean']['output']>;
  isUserEligibleForUpsell?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  merchant?: Maybe<MerchantV2>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantType?: Maybe<MerchantType>;
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  periodFrom?: Maybe<Scalars['Date']['output']>;
  periodTo?: Maybe<Scalars['Date']['output']>;
  preOrderExpiredAt?: Maybe<Scalars['Date']['output']>;
  preOrderFullfillmentDate?: Maybe<Scalars['String']['output']>;
  preOrderFullfillmentDuration?: Maybe<Scalars['Int']['output']>;
  preOrderFullfillmentInterval?: Maybe<Scalars['String']['output']>;
  preOrderType?: Maybe<PurchaseProductPreorderType>;
  price?: Maybe<Scalars['Int']['output']>;
  productGroup?: Maybe<PurchaseProductGroup>;
  productGroupId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  promoPrice?: Maybe<Scalars['Int']['output']>;
  purchaseType?: Maybe<PurchaseProductPurchaseType>;
  reportTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reports?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  serviceMethods?: Maybe<Array<Maybe<PurchaseProductServiceMethod>>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showOnInternationalShop?: Maybe<Scalars['Boolean']['output']>;
  showOnShop?: Maybe<Scalars['Boolean']['output']>;
  subscription?: Maybe<AppSubscription>;
  subtitle?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  totalInternationalDiscount?: Maybe<Scalars['Float']['output']>;
  totalInternationalPrice?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unlockProduct?: Maybe<Array<Maybe<PurchaseProduct>>>;
  unlockRequirementPrice?: Maybe<Array<Maybe<PurchaseProductUnlock>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  upsell?: Maybe<PurchaseProductUpsell>;
  upsellEligiblePurchaseTypes?: Maybe<Array<Maybe<PurchaseProductPurchaseType>>>;
  upsellProduct?: Maybe<Array<Maybe<PurchaseProduct>>>;
  upsellTag?: Maybe<PurchaseProductUpsellTag>;
  variant?: Maybe<PurchaseProductVariant>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseProductActivation = {
  __typename?: 'PurchaseProductActivation';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCollected?: Maybe<Scalars['Boolean']['output']>;
  isProfileDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productKitPickupId?: Maybe<Scalars['String']['output']>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sampleId?: Maybe<Scalars['String']['output']>;
  tutorialWatchedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductActivationForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  guardianId?: InputMaybe<Scalars['String']['input']>;
  reportTypes?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductActivationMutations = {
  __typename?: 'PurchaseProductActivationMutations';
  Consent?: Maybe<ConsentMutations>;
  activateKitManually?: Maybe<ProcessResult>;
  add?: Maybe<KitActivation>;
  addKitForWebView?: Maybe<KitActivation>;
  addWithReportTypes?: Maybe<KitActivation>;
  manualBulkActivation?: Maybe<Scalars['Boolean']['output']>;
  seeTutorial?: Maybe<KitActivation>;
};


export type PurchaseProductActivationMutationsActivateKitManuallyArgs = {
  form?: InputMaybe<KitActivateKitManuallyForm>;
};


export type PurchaseProductActivationMutationsAddArgs = {
  form?: InputMaybe<PurchaseProductActivationForm>;
};


export type PurchaseProductActivationMutationsAddKitForWebViewArgs = {
  form?: InputMaybe<PurchaseProductActivationWebviewForm>;
};


export type PurchaseProductActivationMutationsAddWithReportTypesArgs = {
  form?: InputMaybe<PurchaseProductActivationWithReportTypesForm>;
};


export type PurchaseProductActivationMutationsManualBulkActivationArgs = {
  domain: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type PurchaseProductActivationMutationsSeeTutorialArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductActivationQueries = {
  __typename?: 'PurchaseProductActivationQueries';
  Consent?: Maybe<ConsentQueries>;
  checkAvailableKit?: Maybe<Scalars['Boolean']['output']>;
  checkAvailableKitV2?: Maybe<CheckAvailableKitResult>;
  checkKitActivationAvailability?: Maybe<KitCheckActivationAvailabilityResult>;
  findAll?: Maybe<PurchaseProductActivationQueryResult>;
  findAllUnsent?: Maybe<Array<Maybe<KitActivation>>>;
  findAllWithReportTypes?: Maybe<KitActivationQueryResult>;
  findOne?: Maybe<PurchaseProductActivation>;
  findOneWithReportTypes?: Maybe<KitActivation>;
};


export type PurchaseProductActivationQueriesCheckAvailableKitArgs = {
  code: Scalars['String']['input'];
  reportTypes: Scalars['String']['input'];
};


export type PurchaseProductActivationQueriesCheckAvailableKitV2Args = {
  code: Scalars['String']['input'];
  reportTypes?: InputMaybe<Scalars['String']['input']>;
};


export type PurchaseProductActivationQueriesCheckKitActivationAvailabilityArgs = {
  where?: InputMaybe<KitCheckActivationAvailabilityQuery>;
};


export type PurchaseProductActivationQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PurchaseProductActivationQueriesFindAllUnsentArgs = {
  profileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PurchaseProductActivationQueriesFindAllWithReportTypesArgs = {
  where?: InputMaybe<KitActivationQueryFilter>;
};


export type PurchaseProductActivationQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductActivationQueriesFindOneWithReportTypesArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductActivationQueryResult = {
  __typename?: 'PurchaseProductActivationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductActivation>>>;
};

export type PurchaseProductActivationWebviewForm = {
  activationId: Scalars['String']['input'];
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  guardianId?: InputMaybe<Scalars['String']['input']>;
  reportTypes: Scalars['String']['input'];
};

export type PurchaseProductActivationWithReportTypesForm = {
  code: Scalars['String']['input'];
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  guardianId?: InputMaybe<Scalars['String']['input']>;
  reportTypes: Scalars['String']['input'];
};

export type PurchaseProductAnalytic = {
  __typename?: 'PurchaseProductAnalytic';
  action?: Maybe<PurchaseProductAnalyticAction>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isUpsell?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantType?: Maybe<Scalars['String']['output']>;
  productGroupId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  purchaseType?: Maybe<Scalars['String']['output']>;
  serviceMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<PurchaseProductAnalyticSource>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PurchaseProductAnalyticAction {
  AddToCart = 'ADD_TO_CART',
  Click = 'CLICK',
  Compare = 'COMPARE',
  Purchase = 'PURCHASE',
  SaveForLater = 'SAVE_FOR_LATER',
  Share = 'SHARE',
  View = 'VIEW'
}

export type PurchaseProductAnalyticClickSummary = {
  __typename?: 'PurchaseProductAnalyticClickSummary';
  lastClickAt?: Maybe<Scalars['Date']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productImage?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  totalClick?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseProductAnalyticClickSummaryResult = {
  __typename?: 'PurchaseProductAnalyticClickSummaryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductAnalyticClickSummary>>>;
};

export enum PurchaseProductAnalyticDateFilterType {
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK',
  Today = 'TODAY'
}

export type PurchaseProductAnalyticFilter = {
  dateFilter?: InputMaybe<PurchaseProductAnalyticDateFilterType>;
  end?: InputMaybe<Scalars['Date']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type PurchaseProductAnalyticMutations = {
  __typename?: 'PurchaseProductAnalyticMutations';
  add?: Maybe<PurchaseProductAnalytic>;
};


export type PurchaseProductAnalyticMutationsAddArgs = {
  form?: InputMaybe<AddProductAnalyticForm>;
};

export type PurchaseProductAnalyticQueries = {
  __typename?: 'PurchaseProductAnalyticQueries';
  findAllActionClick?: Maybe<PurchaseProductAnalyticClickSummaryResult>;
};


export type PurchaseProductAnalyticQueriesFindAllActionClickArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PurchaseProductAnalyticFilter>;
};

export enum PurchaseProductAnalyticSource {
  AsaxAssistant = 'ASAX_ASSISTANT',
  Campaign = 'CAMPAIGN',
  Email = 'EMAIL',
  GeneralShop = 'GENERAL_SHOP',
  Notification = 'NOTIFICATION',
  SearchResult = 'SEARCH_RESULT',
  SocialMedia = 'SOCIAL_MEDIA'
}

export type PurchaseProductBundling = {
  __typename?: 'PurchaseProductBundling';
  bundlingId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<PurchaseProduct>>>;
  promoPrice?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseProductBundlingFormAdd = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['String']['input'];
  promoPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseProductBundlingFormEdit = {
  bundlingId?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  promoPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseProductBundlingMutations = {
  __typename?: 'PurchaseProductBundlingMutations';
  add?: Maybe<PurchaseProductBundling>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseProductBundling>;
};


export type PurchaseProductBundlingMutationsAddArgs = {
  form?: InputMaybe<PurchaseProductBundlingFormAdd>;
};


export type PurchaseProductBundlingMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductBundlingMutationsEditArgs = {
  form?: InputMaybe<PurchaseProductBundlingFormEdit>;
  id: Scalars['String']['input'];
};

export type PurchaseProductBundlingQueries = {
  __typename?: 'PurchaseProductBundlingQueries';
  findAll?: Maybe<PurchaseProductBundlingQueryResult>;
  findOne?: Maybe<PurchaseProductBundling>;
};


export type PurchaseProductBundlingQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductBundlingQuerySortBy>;
  where?: InputMaybe<PurchaseProductBundlingQueryFilter>;
};


export type PurchaseProductBundlingQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductBundlingQueryFilter = {
  bundlingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseProductBundlingQueryResult = {
  __typename?: 'PurchaseProductBundlingQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductBundling>>>;
};

export type PurchaseProductBundlingQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type PurchaseProductCategory = {
  __typename?: 'PurchaseProductCategory';
  category?: Maybe<DnaCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PurchaseProduct>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductCategoryMutations = {
  __typename?: 'PurchaseProductCategoryMutations';
  add?: Maybe<Array<Maybe<PurchaseProductCategory>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseProductCategory>;
};


export type PurchaseProductCategoryMutationsAddArgs = {
  form?: InputMaybe<AddPurchaseProductCategoryForm>;
};


export type PurchaseProductCategoryMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductCategoryMutationsEditArgs = {
  form?: InputMaybe<EditPurchaseProductCategoryForm>;
  id: Scalars['String']['input'];
};

export type PurchaseProductCategoryQueries = {
  __typename?: 'PurchaseProductCategoryQueries';
  findAll?: Maybe<PurchaseProductCategoryQueryResult>;
  findOne?: Maybe<PurchaseProductCategory>;
};


export type PurchaseProductCategoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductCategoryQuerySortBy>;
  where?: InputMaybe<PurchaseProductCategoryQueryFilter>;
};


export type PurchaseProductCategoryQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductCategoryQueryFilter = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traits?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseProductCategoryQueryResult = {
  __typename?: 'PurchaseProductCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductCategory>>>;
};

export type PurchaseProductCategoryQuerySortBy = {
  category?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type PurchaseProductDiscount = {
  __typename?: 'PurchaseProductDiscount';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};


export type PurchaseProductDiscountPercentageArgs = {
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PurchaseProductDiscountForm = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseProductGroup = {
  __typename?: 'PurchaseProductGroup';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDNA?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductGroupMutations = {
  __typename?: 'PurchaseProductGroupMutations';
  add?: Maybe<PurchaseProductGroup>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseProductGroup>;
};


export type PurchaseProductGroupMutationsAddArgs = {
  form?: InputMaybe<AddPurchaseProductGroupForm>;
};


export type PurchaseProductGroupMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductGroupMutationsEditArgs = {
  form?: InputMaybe<EditPurchaseProductGroupForm>;
  id: Scalars['String']['input'];
};

export type PurchaseProductGroupQueries = {
  __typename?: 'PurchaseProductGroupQueries';
  findAll?: Maybe<PurchaseProductGroupQueryResult>;
  findOne?: Maybe<PurchaseProductGroup>;
};


export type PurchaseProductGroupQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductGroupQuerySortBy>;
  where?: InputMaybe<PurchaseProductGroupQueryFilter>;
};


export type PurchaseProductGroupQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductGroupQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDNA?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductGroupQueryResult = {
  __typename?: 'PurchaseProductGroupQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductGroup>>>;
};

export type PurchaseProductGroupQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
};

export type PurchaseProductImage = {
  __typename?: 'PurchaseProductImage';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductImageFormAdd = {
  pointer?: InputMaybe<Scalars['Upload']['input']>;
  position: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductImageFormEdit = {
  id?: InputMaybe<Scalars['String']['input']>;
  pointer?: InputMaybe<Scalars['Upload']['input']>;
  position: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductKit = {
  __typename?: 'PurchaseProductKit';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  activatedUser?: Maybe<UserProfile>;
  activatedUserStatus?: Maybe<UserStatus>;
  activation?: Maybe<PurchaseProductActivation>;
  attachment?: Maybe<Scalars['String']['output']>;
  batch?: Maybe<PurchaseProductKitBatch>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  bioinformatic?: Maybe<BioinformaticUser>;
  code?: Maybe<Scalars['String']['output']>;
  collectedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partnership?: Maybe<Partner>;
  partnershipId?: Maybe<Scalars['String']['output']>;
  pickupShipment?: Maybe<PickupKitShipment>;
  printedAt?: Maybe<Scalars['Date']['output']>;
  releasedReports?: Maybe<Array<Maybe<DnaReport>>>;
  report?: Maybe<DnaReport>;
  reportTypeTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reports?: Maybe<Array<Maybe<PurchaseProductKitReport>>>;
  requestPickupDate?: Maybe<Scalars['Date']['output']>;
  sample?: Maybe<LabSample>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type PurchaseProductKitReleasedReportsArgs = {
  reportType: Array<InputMaybe<Scalars['String']['input']>>;
};

export type PurchaseProductKitActivatedUserQuerySortBy = {
  gender?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PurchaseProductKitBatch = {
  __typename?: 'PurchaseProductKitBatch';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kit?: Maybe<PurchaseProductKit>;
  number?: Maybe<Scalars['Int']['output']>;
  partnership?: Maybe<Partnership>;
  price?: Maybe<Scalars['Int']['output']>;
  printedAt?: Maybe<Scalars['Date']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  quantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<PurchaseProduct>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductKitBatchForm = {
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum PurchaseProductKitBatchIncludeOptions {
  Activation = 'ACTIVATION',
  Kit = 'KIT',
  Product = 'PRODUCT'
}

export type PurchaseProductKitBatchMutations = {
  __typename?: 'PurchaseProductKitBatchMutations';
  generate?: Maybe<Scalars['Boolean']['output']>;
  print?: Maybe<PurchaseProductKitBatch>;
};


export type PurchaseProductKitBatchMutationsGenerateArgs = {
  form?: InputMaybe<Array<InputMaybe<PurchaseProductKitBatchForm>>>;
};


export type PurchaseProductKitBatchMutationsPrintArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductKitBatchQueries = {
  __typename?: 'PurchaseProductKitBatchQueries';
  findAll?: Maybe<PurchaseProductKitBatchQueryResult>;
  findOne?: Maybe<PurchaseProductKitBatch>;
  findOneByCode?: Maybe<PurchaseProductKitBatch>;
};


export type PurchaseProductKitBatchQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<PurchaseProductKitBatchIncludeOptions>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductKitBatchQuerySortBy>;
  where?: InputMaybe<PurchaseProductKitBatchQueryFilter>;
};


export type PurchaseProductKitBatchQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductKitBatchQueriesFindOneByCodeArgs = {
  code: Scalars['String']['input'];
};

export type PurchaseProductKitBatchQueryFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kit?: InputMaybe<PurchaseProductKitQueryFilter>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseProductKitBatchQueryResult = {
  __typename?: 'PurchaseProductKitBatchQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductKitBatch>>>;
};

export type PurchaseProductKitBatchQuerySortBy = {
  activatedAt?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  kit?: InputMaybe<SortKit>;
  number?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type PurchaseProductKitFilterQueryResult = {
  __typename?: 'PurchaseProductKitFilterQueryResult';
  activatedAtMax?: Maybe<Scalars['Date']['output']>;
  activatedAtMin?: Maybe<Scalars['Date']['output']>;
  requestPickupDateMax?: Maybe<Scalars['Date']['output']>;
  requestPickupDateMin?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductKitFindOneV2Form = {
  reportType?: InputMaybe<ReportType>;
};

export type PurchaseProductKitForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductKitMutations = {
  __typename?: 'PurchaseProductKitMutations';
  Batch?: Maybe<PurchaseProductKitBatchMutations>;
  Report?: Maybe<PurchaseProductKitReportMutations>;
  add?: Maybe<PurchaseProductKit>;
  changeOwnership?: Maybe<Scalars['Boolean']['output']>;
  collected?: Maybe<Scalars['Boolean']['output']>;
  deactivate?: Maybe<Scalars['Boolean']['output']>;
  export?: Maybe<Scalars['Boolean']['output']>;
  generate?: Maybe<Scalars['Boolean']['output']>;
  multipleCollected?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<PurchaseProductKit>;
  printed?: Maybe<Scalars['Boolean']['output']>;
  resend?: Maybe<PurchaseProductKit>;
  verification?: Maybe<Scalars['Boolean']['output']>;
};


export type PurchaseProductKitMutationsAddArgs = {
  form?: InputMaybe<PurchaseProductKitForm>;
};


export type PurchaseProductKitMutationsChangeOwnershipArgs = {
  form?: InputMaybe<PurchaseProductKitForm>;
  id: Scalars['ID']['input'];
};


export type PurchaseProductKitMutationsCollectedArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductKitMutationsDeactivateArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductKitMutationsExportArgs = {
  includeBatchCode?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<PurchaseProductKitQuerySortBy>;
  where?: InputMaybe<PurchaseProductKitQueryFilter>;
};


export type PurchaseProductKitMutationsGenerateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PurchaseProductKitMutationsMultipleCollectedArgs = {
  asarenKitIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type PurchaseProductKitMutationsPickupArgs = {
  form?: InputMaybe<ProductPickupForm>;
};


export type PurchaseProductKitMutationsPrintedArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductKitMutationsResendArgs = {
  form?: InputMaybe<ProductPickupForm>;
};


export type PurchaseProductKitMutationsVerificationArgs = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  kitCode?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductKitQueries = {
  __typename?: 'PurchaseProductKitQueries';
  Batch?: Maybe<PurchaseProductKitBatchQueries>;
  findAll?: Maybe<PurchaseProductKitQueryResult>;
  findAllMyKitProcessStatus?: Maybe<Array<Maybe<KitProcessStatusQueryResult>>>;
  findOne?: Maybe<PurchaseProductKit>;
  findOneMyKitProcessStatus?: Maybe<KitProcessStatusQueryResult>;
  findOneV2?: Maybe<PurchaseProductKit>;
  verification?: Maybe<Scalars['String']['output']>;
};


export type PurchaseProductKitQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductKitQuerySortBy>;
  where?: InputMaybe<PurchaseProductKitQueryFilter>;
};


export type PurchaseProductKitQueriesFindAllMyKitProcessStatusArgs = {
  where?: InputMaybe<MyKitProcessStatusQueryFilter>;
};


export type PurchaseProductKitQueriesFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type PurchaseProductKitQueriesFindOneMyKitProcessStatusArgs = {
  where: MyKitProcessStatusQueryFilterFindOne;
};


export type PurchaseProductKitQueriesFindOneV2Args = {
  where?: InputMaybe<PurchaseProductKitFindOneV2Form>;
};


export type PurchaseProductKitQueriesVerificationArgs = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  kitCode?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductKitQueryFilter = {
  activatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activatedBy?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestPickupDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseProductKitQueryResult = {
  __typename?: 'PurchaseProductKitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductKit>>>;
};

export type PurchaseProductKitQuerySortBy = {
  activatedAt?: InputMaybe<SortDirection>;
  activatedBy?: InputMaybe<SortDirection>;
  activatedUser?: InputMaybe<PurchaseProductKitActivatedUserQuerySortBy>;
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  requestPickupDate?: InputMaybe<SortDirection>;
};

export type PurchaseProductKitReport = {
  __typename?: 'PurchaseProductKitReport';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mappedAt?: Maybe<Scalars['Date']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductKitReportMutations = {
  __typename?: 'PurchaseProductKitReportMutations';
  add?: Maybe<Array<Maybe<PurchaseProductKitReport>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  export?: Maybe<Scalars['String']['output']>;
};


export type PurchaseProductKitReportMutationsAddArgs = {
  form?: InputMaybe<Array<InputMaybe<AddPurchaseProductKitReportForm>>>;
};


export type PurchaseProductKitReportMutationsDeleteArgs = {
  id?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type PurchaseProductKitReportMutationsExportArgs = {
  where?: InputMaybe<PurchaseProductKitReportQueryFilter>;
};

export type PurchaseProductKitReportQueryFilter = {
  kitId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kitcode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productKitId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PurchaseProductMerchantType {
  Asaren = 'ASAREN',
  Sponsorship = 'SPONSORSHIP'
}

export type PurchaseProductMultiplePickupForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  kitId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductMutations = {
  __typename?: 'PurchaseProductMutations';
  Activation?: Maybe<PurchaseProductActivationMutations>;
  Analytic?: Maybe<PurchaseProductAnalyticMutations>;
  Bundling?: Maybe<PurchaseProductBundlingMutations>;
  Category?: Maybe<PurchaseProductCategoryMutations>;
  Group?: Maybe<PurchaseProductGroupMutations>;
  Kit?: Maybe<PurchaseProductKitMutations>;
  Partnership?: Maybe<PartnershipMutations>;
  Pickup?: Maybe<PurchaseProductPickupMutations>;
  Report?: Maybe<PurchaseProductReportMutations>;
  Unlock?: Maybe<PurchaseProductUnlockMutations>;
  Upsell?: Maybe<PurchaseProductUpsellMutations>;
  add?: Maybe<PurchaseProduct>;
  addV2?: Maybe<PurchaseProduct>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  deleteV2?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseProduct>;
  editOrder?: Maybe<Scalars['Boolean']['output']>;
  editV2?: Maybe<PurchaseProduct>;
};


export type PurchaseProductMutationsAddArgs = {
  form?: InputMaybe<AddPurchaseProductForm>;
};


export type PurchaseProductMutationsAddV2Args = {
  form?: InputMaybe<AddPurchaseProductForm>;
};


export type PurchaseProductMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductMutationsDeleteV2Args = {
  id: Scalars['String']['input'];
};


export type PurchaseProductMutationsEditArgs = {
  form?: InputMaybe<EditPurchaseProductForm>;
  id: Scalars['String']['input'];
};


export type PurchaseProductMutationsEditOrderArgs = {
  forms?: InputMaybe<Array<InputMaybe<EditOrderPurchaseProductForm>>>;
};


export type PurchaseProductMutationsEditV2Args = {
  form?: InputMaybe<EditPurchaseProductForm>;
  id: Scalars['String']['input'];
};

export type PurchaseProductPickup = {
  __typename?: 'PurchaseProductPickup';
  code?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  histories?: Maybe<Array<Maybe<ProductKitPickupHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requestPickupDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<ProductKitPickupStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductPickupForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductPickupMutations = {
  __typename?: 'PurchaseProductPickupMutations';
  History?: Maybe<ProductKitPickupHistoryMutations>;
  add?: Maybe<PurchaseProductPickup>;
  addMultiple?: Maybe<PurchaseProductPickup>;
  edit?: Maybe<Scalars['Boolean']['output']>;
};


export type PurchaseProductPickupMutationsAddArgs = {
  form?: InputMaybe<PurchaseProductPickupForm>;
};


export type PurchaseProductPickupMutationsAddMultipleArgs = {
  form?: InputMaybe<PurchaseProductMultiplePickupForm>;
};


export type PurchaseProductPickupMutationsEditArgs = {
  form?: InputMaybe<EditPurchaseProductPickupForm>;
};

export type PurchaseProductPickupQueries = {
  __typename?: 'PurchaseProductPickupQueries';
  filter?: Maybe<PurchaseProductKitFilterQueryResult>;
  findAll?: Maybe<PurchaseProductPickupQueryResult>;
  findOne?: Maybe<PurchaseProductPickup>;
};


export type PurchaseProductPickupQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductPickupQuerySortBy>;
  where?: InputMaybe<PurchaseProductPickupQueryFilter>;
};


export type PurchaseProductPickupQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductPickupQueryFilter = {
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unscannedSamplesInLab?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PurchaseProductPickupQueryResult = {
  __typename?: 'PurchaseProductPickupQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductPickup>>>;
};

export type PurchaseProductPickupQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export enum PurchaseProductPreorderType {
  Date = 'DATE',
  Time = 'TIME'
}

export enum PurchaseProductPurchaseType {
  Bundling = 'BUNDLING',
  Preorder = 'PREORDER',
  Stock = 'STOCK',
  Subscription = 'SUBSCRIPTION',
  Unlock = 'UNLOCK'
}

export type PurchaseProductQueries = {
  __typename?: 'PurchaseProductQueries';
  Activation?: Maybe<PurchaseProductActivationQueries>;
  Analytic?: Maybe<PurchaseProductAnalyticQueries>;
  Bundling?: Maybe<PurchaseProductBundlingQueries>;
  Category?: Maybe<PurchaseProductCategoryQueries>;
  Group?: Maybe<PurchaseProductGroupQueries>;
  Kit?: Maybe<PurchaseProductKitQueries>;
  Partnership?: Maybe<PartnershipQueries>;
  Pickup?: Maybe<PurchaseProductPickupQueries>;
  Report?: Maybe<PurchaseProductReportQueries>;
  Unlock?: Maybe<PurchaseProductUnlockQueries>;
  Upsell?: Maybe<PurchaseProductUpsellQueries>;
  checkAvailabilityUnlockProduct?: Maybe<CheckAvailabilityUnlockProductQueryResult>;
  findAll?: Maybe<PurchaseProductQueryResult>;
  findAllBatchProduct?: Maybe<PurchaseProductQueryResult>;
  findAllForVoucherManagement?: Maybe<Array<Maybe<PurchaseProduct>>>;
  findAllShopProduct?: Maybe<PurchaseProductQueryResult>;
  findOne?: Maybe<PurchaseProduct>;
  findOneByProtocolCategory?: Maybe<PurchaseProduct>;
  minMaxOrder?: Maybe<MinMaxOrder>;
};


export type PurchaseProductQueriesCheckAvailabilityUnlockProductArgs = {
  where?: InputMaybe<CheckAvailabilityUnlockProductQuery>;
};


export type PurchaseProductQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductQuerySortBy>;
  where?: InputMaybe<PurchaseProductQueryFilter>;
};


export type PurchaseProductQueriesFindAllBatchProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductQuerySortBy>;
  where?: InputMaybe<PurchaseProductQueryFilter>;
};


export type PurchaseProductQueriesFindAllForVoucherManagementArgs = {
  voucherConditionType?: InputMaybe<VoucherConditionType>;
};


export type PurchaseProductQueriesFindAllShopProductArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PurchaseProductQuerySortBy>;
  where?: InputMaybe<PurchaseProductShopProductQuery>;
  whereProduct?: InputMaybe<PurchaseProductQueryFilter>;
};


export type PurchaseProductQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PurchaseProductQueriesFindOneByProtocolCategoryArgs = {
  code: Paid_Product_Code;
};


export type PurchaseProductQueriesMinMaxOrderArgs = {
  purchaseType?: InputMaybe<Array<PurchaseProductPurchaseType>>;
};

export type PurchaseProductQueryFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeHomeService?: InputMaybe<Scalars['Boolean']['input']>;
  isPeriodActive?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantType?: InputMaybe<Array<InputMaybe<MerchantType>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  periodFrom?: InputMaybe<Scalars['Date']['input']>;
  periodTo?: InputMaybe<Scalars['Date']['input']>;
  priceRange?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  productGroupId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseType?: InputMaybe<Array<InputMaybe<PurchaseProductPurchaseType>>>;
  reports?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showOnShop?: InputMaybe<Scalars['Boolean']['input']>;
  subscription?: InputMaybe<SubscriptionQueryFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductQueryResult = {
  __typename?: 'PurchaseProductQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProduct>>>;
};

export type PurchaseProductQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  isAvailable?: InputMaybe<SortDirection>;
  isFreeHomeService?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
  recommendation?: InputMaybe<SortDirection>;
  showOnShop?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type PurchaseProductReport = {
  __typename?: 'PurchaseProductReport';
  category?: Maybe<PurchaseProductCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PurchaseProductReportStatus>;
  trait?: Maybe<DnaTrait>;
  type?: Maybe<PurchaseProduct>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductReportMutations = {
  __typename?: 'PurchaseProductReportMutations';
  Purchase?: Maybe<ProductPurchaseReportMutations>;
  add?: Maybe<PurchaseProductReportQueryResult>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseProductReport>;
};


export type PurchaseProductReportMutationsAddArgs = {
  form?: InputMaybe<AddPurchaseProductReportForm>;
};


export type PurchaseProductReportMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductReportMutationsEditArgs = {
  form?: InputMaybe<EditPurchaseProductReportForm>;
  id: Scalars['String']['input'];
};

export type PurchaseProductReportQueries = {
  __typename?: 'PurchaseProductReportQueries';
  Purchase?: Maybe<ProductPurchaseReportQueries>;
  findAll?: Maybe<PurchaseProductReportQueryResult>;
  findOne?: Maybe<PurchaseProductReport>;
  findOneMaxPrice?: Maybe<Scalars['Int']['output']>;
  findOneMinPrice?: Maybe<Scalars['Int']['output']>;
};


export type PurchaseProductReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductReportQuerySortBy>;
  where?: InputMaybe<PurchaseProductReportQueryFilter>;
};


export type PurchaseProductReportQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductReportQueryFilter = {
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateRangeFilter>;
  endDate?: InputMaybe<DateRangeFilter>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<PriceRangeFilter>;
  status?: InputMaybe<Array<InputMaybe<PurchaseProductReportStatus>>>;
  trait?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseProductReportQueryResult = {
  __typename?: 'PurchaseProductReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductReport>>>;
};

export type PurchaseProductReportQuerySortBy = {
  category?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  trait?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum PurchaseProductReportStatus {
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED'
}

export type PurchaseProductRequirement = {
  __typename?: 'PurchaseProductRequirement';
  createdAt?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PurchaseProductRequirementForm = {
  activatedReportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PurchaseProductServiceMethod {
  HomeService = 'HOME_SERVICE',
  Regular = 'REGULAR',
  WalkIn = 'WALK_IN'
}

export type PurchaseProductShopProductQuery = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  priceRange?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  productGroupId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shopTypes?: InputMaybe<Array<InputMaybe<PurchaseProductShopType>>>;
  showOnInternationalShop?: InputMaybe<Scalars['Boolean']['input']>;
  showOnShop?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: PurchaseProductShopType;
};

export enum PurchaseProductShopType {
  Regular = 'REGULAR',
  Unlock = 'UNLOCK'
}

export enum PurchaseProductType {
  Active = 'ACTIVE',
  Ancestry = 'ANCESTRY',
  Dna_360 = 'DNA_360',
  DnaPremium = 'DNA_PREMIUM',
  Hormone = 'HORMONE',
  LabTest = 'LAB_TEST',
  Mcu = 'MCU',
  Nutrigenetic = 'NUTRIGENETIC',
  Oncorisk = 'ONCORISK',
  Personality = 'PERSONALITY',
  Prodigy = 'PRODIGY',
  Product = 'PRODUCT',
  Service = 'SERVICE',
  Skin = 'SKIN',
  Sportgenomic = 'SPORTGENOMIC',
  TenX = 'TEN_X',
  UnlockEternalRecommendation = 'UNLOCK_ETERNAL_RECOMMENDATION',
  VirtualAssistance = 'VIRTUAL_ASSISTANCE'
}

export type PurchaseProductUnlock = {
  __typename?: 'PurchaseProductUnlock';
  chipType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseProductUnlockMutations = {
  __typename?: 'PurchaseProductUnlockMutations';
  add?: Maybe<PurchaseProductUnlock>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseProductUnlock>;
};


export type PurchaseProductUnlockMutationsAddArgs = {
  form?: InputMaybe<AddPurchaseProductUnlockForm>;
};


export type PurchaseProductUnlockMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductUnlockMutationsEditArgs = {
  form?: InputMaybe<EditPurchaseProductUnlockForm>;
  id: Scalars['String']['input'];
};

export type PurchaseProductUnlockQueries = {
  __typename?: 'PurchaseProductUnlockQueries';
  findAll?: Maybe<PurchaseProductUnlockQueryResult>;
  findOne?: Maybe<PurchaseProductUnlock>;
};


export type PurchaseProductUnlockQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductUnlockQuerySortBy>;
  where?: InputMaybe<PurchaseProductUnlockQueryFilter>;
};


export type PurchaseProductUnlockQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductUnlockQueryFilter = {
  id?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseProductUnlockQueryResult = {
  __typename?: 'PurchaseProductUnlockQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductUnlock>>>;
};

export type PurchaseProductUnlockQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
};

export type PurchaseProductUpsell = {
  __typename?: 'PurchaseProductUpsell';
  bundlingId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Array<Maybe<PurchaseProductUpsellConditionEnum>>>;
  id?: Maybe<Scalars['String']['output']>;
  isOneTimePerUser?: Maybe<Scalars['Boolean']['output']>;
  isSelectiveCondition?: Maybe<Scalars['Boolean']['output']>;
  products?: Maybe<Array<Maybe<PurchaseProductUpsellProduct>>>;
  promoPrice?: Maybe<Scalars['Int']['output']>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalDiscount?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
};

export enum PurchaseProductUpsellConditionEnum {
  Activated = 'ACTIVATED',
  Purchased = 'PURCHASED'
}

export type PurchaseProductUpsellFormAdd = {
  bundlingId?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Array<InputMaybe<PurchaseProductUpsellConditionEnum>>>;
  isOneTimePerUser?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectiveCondition?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<Array<InputMaybe<PurchaseProductUpsellProductFormAdd>>>;
  reportTypes?: InputMaybe<Array<InputMaybe<Report_Type>>>;
};

export type PurchaseProductUpsellFormEdit = {
  bundlingId?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Array<InputMaybe<PurchaseProductUpsellConditionEnum>>>;
  isOneTimePerUser?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectiveCondition?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<Array<InputMaybe<PurchaseProductUpsellProductFormEdit>>>;
  promoPrice?: InputMaybe<Scalars['Int']['input']>;
  reportTypes?: InputMaybe<Array<InputMaybe<Report_Type>>>;
  totalDiscount?: InputMaybe<Scalars['Float']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseProductUpsellMutations = {
  __typename?: 'PurchaseProductUpsellMutations';
  UpsellProduct?: Maybe<PurchaseProductUpsellProductMutations>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type PurchaseProductUpsellMutationsDeleteArgs = {
  bundlingId: Scalars['String']['input'];
};

export type PurchaseProductUpsellProduct = {
  __typename?: 'PurchaseProductUpsellProduct';
  bundlingId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<PurchaseProduct>>>;
  promoPrice?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseProductUpsellProductFormAdd = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['String']['input'];
  promoPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseProductUpsellProductFormEdit = {
  bundlingId?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  promoPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseProductUpsellProductMutations = {
  __typename?: 'PurchaseProductUpsellProductMutations';
  add?: Maybe<PurchaseProductUpsellProduct>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<PurchaseProductUpsellProduct>;
};


export type PurchaseProductUpsellProductMutationsAddArgs = {
  form?: InputMaybe<PurchaseProductUpsellProductFormAdd>;
};


export type PurchaseProductUpsellProductMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type PurchaseProductUpsellProductMutationsEditArgs = {
  form?: InputMaybe<PurchaseProductUpsellProductFormEdit>;
  id: Scalars['String']['input'];
};

export type PurchaseProductUpsellProductQueries = {
  __typename?: 'PurchaseProductUpsellProductQueries';
  findAll?: Maybe<PurchaseProductUpsellProductQueryResult>;
  findOne?: Maybe<PurchaseProductUpsellProduct>;
};


export type PurchaseProductUpsellProductQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchaseProductUpsellProductQuerySortBy>;
  where?: InputMaybe<PurchaseProductUpsellProductQueryFilter>;
};


export type PurchaseProductUpsellProductQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type PurchaseProductUpsellProductQueryFilter = {
  bundlingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseProductUpsellProductQueryResult = {
  __typename?: 'PurchaseProductUpsellProductQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductUpsellProduct>>>;
};

export type PurchaseProductUpsellProductQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type PurchaseProductUpsellQueries = {
  __typename?: 'PurchaseProductUpsellQueries';
  UpsellProduct?: Maybe<PurchaseProductUpsellProductQueries>;
};

export type PurchaseProductUpsellQueryFilter = {
  bundlingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PurchaseProductUpsellQueryResult = {
  __typename?: 'PurchaseProductUpsellQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PurchaseProductUpsell>>>;
};

export type PurchaseProductUpsellQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export enum PurchaseProductUpsellTag {
  LimitedOffer = 'LIMITED_OFFER',
  OneTimeOffer = 'ONE_TIME_OFFER'
}

export type PurchaseProductVariant = {
  __typename?: 'PurchaseProductVariant';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum PurchaseProductpreOrderFullfillmentInterval {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type PurchaseQueries = {
  __typename?: 'PurchaseQueries';
  Cart?: Maybe<PurchaseCartQueries>;
  Order?: Maybe<PurchaseOrderQueries>;
  Product?: Maybe<PurchaseProductQueries>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type QualityMetrics = {
  __typename?: 'QualityMetrics';
  callRate: Scalars['Float']['output'];
  coverageDepth: Scalars['Int']['output'];
  qualityScore: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  Admin?: Maybe<AdminQueries>;
  AnterAja?: Maybe<AnterAjaQueries>;
  Bioinformatic?: Maybe<BioinformaticQueries>;
  Channel?: Maybe<ChannelQueries>;
  Country?: Maybe<CountryQueries>;
  Currency?: Maybe<CurrencyQueries>;
  DNA?: Maybe<DnaQueries>;
  EHR?: Maybe<EhrQueries>;
  Ethnicity?: Maybe<EthnicityQueries>;
  Event?: Maybe<EventQueries>;
  Health?: Maybe<HealthQueries>;
  HealthScore?: Maybe<HealthScoreQueries>;
  Lab?: Maybe<LabQueries>;
  Language?: Maybe<LanguageQueries>;
  MCU?: Maybe<McuQueries>;
  Master?: Maybe<MasterQueries>;
  Media?: Maybe<MediaQueries>;
  Merchant?: Maybe<MerchantQueries>;
  News?: Maybe<NewsQueries>;
  OCRProcess?: Maybe<OcrProcessQueries>;
  Partner?: Maybe<PartnerQueries>;
  Payment?: Maybe<PaymentQueries>;
  PgX?: Maybe<PgXQueries>;
  Prodigy?: Maybe<ProdigyQueries>;
  Promo?: Maybe<PromoQueries>;
  Purchase?: Maybe<PurchaseQueries>;
  Questionnaire?: Maybe<QuestionnaireQueries>;
  Report?: Maybe<ReportQueries>;
  Sales?: Maybe<SalesQueries>;
  Setting?: Maybe<SettingQueries>;
  Splash?: Maybe<SplashQueries>;
  Statistics?: Maybe<StatisticsQueries>;
  Subscription?: Maybe<SubscriptionQueries>;
  Tracker?: Maybe<TrackerQueries>;
  User?: Maybe<UserQueries>;
  VendorBioIt?: Maybe<VendorBioItQueries>;
  Voucher?: Maybe<VoucherQueries>;
};

export type QuestionnaireMutations = {
  __typename?: 'QuestionnaireMutations';
  Active?: Maybe<ActiveQuestionnaireMutations>;
  KitActivation?: Maybe<KitActivationQuestionnaireMutations>;
  Nourish?: Maybe<NourishQuestionnaireMutations>;
  Onboarding?: Maybe<OnboardingQuestionnaireMutations>;
  _10x?: Maybe<_10xQuestionnaireMutations>;
};

export type QuestionnaireQueries = {
  __typename?: 'QuestionnaireQueries';
  Active?: Maybe<ActiveQuestionnaireQueries>;
  KitActivation?: Maybe<KitActivationQuestionnaireQueries>;
  Nourish?: Maybe<NourishQuestionnaireQueries>;
  Onboarding?: Maybe<OnboardingQuestionnaireQueries>;
  _10x?: Maybe<_10xQuestionnaireQueries>;
};

export enum Relationship {
  Guardian = 'GUARDIAN',
  Parent = 'PARENT'
}

export enum Report_Type {
  Active = 'ACTIVE',
  Ancestry = 'ANCESTRY',
  Dna_360 = 'DNA_360',
  DnaPremium = 'DNA_PREMIUM',
  Hormone = 'HORMONE',
  Mcu = 'MCU',
  Nutrigenetic = 'NUTRIGENETIC',
  Prodigy = 'PRODIGY',
  Skin = 'SKIN',
  Sportgenomic = 'SPORTGENOMIC'
}

export type RecommendationCategory = {
  __typename?: 'RecommendationCategory';
  category: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  recommendations: Array<RecommendationItem>;
};

export type RecommendationItem = {
  __typename?: 'RecommendationItem';
  ageRange?: Maybe<AgeRange>;
  description: Scalars['String']['output'];
  frequency?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type RedeemReportAccessForm = {
  id: Scalars['String']['input'];
  reportType: Scalars['String']['input'];
};

export type ReportAncestryAncient = {
  __typename?: 'ReportAncestryAncient';
  charts?: Maybe<Array<Maybe<ReportAncestryAncientChart>>>;
  id?: Maybe<Scalars['String']['output']>;
  maps?: Maybe<Array<Maybe<ReportAncestryAncientMap>>>;
};


export type ReportAncestryAncientChartsArgs = {
  options?: InputMaybe<ReportAncestryAncientChartQueryOptions>;
};

export type ReportAncestryAncientChart = {
  __typename?: 'ReportAncestryAncientChart';
  age?: Maybe<Scalars['String']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  estimates?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  region_pop?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestryAncientChartFindOneQueryFilter = {
  age?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ReportAncestryAncientChartQueries = {
  __typename?: 'ReportAncestryAncientChartQueries';
  find?: Maybe<ReportAncestryAncientChart>;
  findOne?: Maybe<ReportAncestryAncientChart>;
};


export type ReportAncestryAncientChartQueriesFindArgs = {
  options?: InputMaybe<ReportAncestryAncientChartQueryOptions>;
  where?: InputMaybe<ReportAncestryAncientChartFindOneQueryFilter>;
};


export type ReportAncestryAncientChartQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  options?: InputMaybe<ReportAncestryAncientChartQueryOptions>;
};

export type ReportAncestryAncientChartQueryOptions = {
  showAverage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportAncestryAncientMap = {
  __typename?: 'ReportAncestryAncientMap';
  age?: Maybe<Scalars['String']['output']>;
  ancestry_ancient_id?: Maybe<Scalars['String']['output']>;
  estimates?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestryAncientQueries = {
  __typename?: 'ReportAncestryAncientQueries';
  Chart?: Maybe<ReportAncestryAncientChartQueries>;
  findOne?: Maybe<ReportAncestryAncient>;
};

export type ReportAncestryCheckStatusQueryFilter = {
  clientProfileId?: InputMaybe<Scalars['String']['input']>;
};

export type ReportAncestryLineage = {
  __typename?: 'ReportAncestryLineage';
  id?: Maybe<Scalars['String']['output']>;
  mtdna?: Maybe<Array<Maybe<ReportAncestryLineageDna>>>;
  mtdna_belong_to?: Maybe<ReportAncestryLineageDnaBelongTo>;
  user_id?: Maybe<Scalars['String']['output']>;
  ydna?: Maybe<Array<Maybe<ReportAncestryLineageDna>>>;
  ydna_belong_to?: Maybe<ReportAncestryLineageDnaBelongTo>;
};

export type ReportAncestryLineageDna = {
  __typename?: 'ReportAncestryLineageDNA';
  from_lat?: Maybe<Scalars['String']['output']>;
  from_long?: Maybe<Scalars['String']['output']>;
  haplogroup?: Maybe<Scalars['String']['output']>;
  to_lat?: Maybe<Scalars['String']['output']>;
  to_long?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestryLineageDnaBelongTo = {
  __typename?: 'ReportAncestryLineageDNABelongTo';
  description?: Maybe<Scalars['String']['output']>;
  haplogroup?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestryLineageQueries = {
  __typename?: 'ReportAncestryLineageQueries';
  findOne?: Maybe<ReportAncestryLineage>;
};

export type ReportAncestryModern = {
  __typename?: 'ReportAncestryModern';
  continents?: Maybe<Array<Maybe<ReportAncestryModernContinents>>>;
  id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};


export type ReportAncestryModernContinentsArgs = {
  options?: InputMaybe<ReportAncestryModernContinentsQueryOptions>;
};

export type ReportAncestryModernContinents = {
  __typename?: 'ReportAncestryModernContinents';
  ancestry_modern_id?: Maybe<Scalars['String']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  continents?: Maybe<Scalars['String']['output']>;
  continents_code?: Maybe<Scalars['String']['output']>;
  continents_prop?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_delete?: Maybe<Scalars['String']['output']>;
  subcontinents?: Maybe<Array<Maybe<ReportAncestryModernSubContinents>>>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestryModernContinentsQueries = {
  __typename?: 'ReportAncestryModernContinentsQueries';
  findOne?: Maybe<ReportAncestryModernContinents>;
};


export type ReportAncestryModernContinentsQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  options?: InputMaybe<ReportAncestryModernContinentsQueryOptions>;
};

export type ReportAncestryModernContinentsQueryOptions = {
  showAverage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportAncestryModernCountries = {
  __typename?: 'ReportAncestryModernCountries';
  countries?: Maybe<Scalars['String']['output']>;
  countries_code?: Maybe<Scalars['String']['output']>;
  countries_prop?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_delete?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestryModernQueries = {
  __typename?: 'ReportAncestryModernQueries';
  Continents?: Maybe<ReportAncestryModernContinentsQueries>;
  findOne?: Maybe<ReportAncestryModern>;
};

export type ReportAncestryModernSubContinents = {
  __typename?: 'ReportAncestryModernSubContinents';
  countries?: Maybe<Array<Maybe<ReportAncestryModernCountries>>>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_delete?: Maybe<Scalars['String']['output']>;
  sub_continents?: Maybe<Scalars['String']['output']>;
  sub_continents_code?: Maybe<Scalars['String']['output']>;
  sub_continents_prop?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestryQueries = {
  __typename?: 'ReportAncestryQueries';
  Ancient?: Maybe<ReportAncestryAncientQueries>;
  Lineage?: Maybe<ReportAncestryLineageQueries>;
  Modern?: Maybe<ReportAncestryModernQueries>;
  Setting?: Maybe<ReportAncestrySettingQueries>;
  checkStatus?: Maybe<Scalars['Boolean']['output']>;
};


export type ReportAncestryQueriesCheckStatusArgs = {
  where?: InputMaybe<ReportAncestryCheckStatusQueryFilter>;
};

export type ReportAncestrySetting = {
  __typename?: 'ReportAncestrySetting';
  id?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vendorBioItId?: Maybe<Scalars['String']['output']>;
};

export type ReportAncestrySettingFilter = {
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorBioItId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportAncestrySettingQueries = {
  __typename?: 'ReportAncestrySettingQueries';
  findAll?: Maybe<ReportAncestrySettingQueryResult>;
};


export type ReportAncestrySettingQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportAncestrySettingFilter>;
};

export type ReportAncestrySettingQueryResult = {
  __typename?: 'ReportAncestrySettingQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ReportAncestrySetting>>>;
};

export enum ReportEvaluationStatus {
  Favourable = 'FAVOURABLE',
  Unfavourable = 'UNFAVOURABLE'
}

export enum ReportGivenBioIt {
  Ancestry = 'ANCESTRY',
  Dna = 'DNA',
  Kydz = 'KYDZ',
  Pgx = 'PGX'
}

export enum ReportMapperSex {
  Both = 'BOTH',
  Female = 'FEMALE',
  Male = 'MALE'
}

export type ReportMutations = {
  __typename?: 'ReportMutations';
  OncoRisk?: Maybe<OncoRiskReportMutations>;
  Prodigy?: Maybe<ReportProdigyMutations>;
  ReportThreeSixty?: Maybe<ReportThreeSixtyMutations>;
  previewProcessReports?: Maybe<ReviewReportProcessResult>;
  processReports?: Maybe<Scalars['Boolean']['output']>;
  processReportsV2?: Maybe<Scalars['Boolean']['output']>;
};


export type ReportMutationsPreviewProcessReportsArgs = {
  form: PreviewReportProcessForm;
};


export type ReportMutationsProcessReportsArgs = {
  form: ReportProcessForm;
};


export type ReportMutationsProcessReportsV2Args = {
  form: ReportProcessFormV2;
};

export type ReportProcessForm = {
  file: Scalars['Upload']['input'];
  process?: InputMaybe<Array<InputMaybe<ProcessDetailMapType>>>;
  type: ReportProcessType;
};

export type ReportProcessFormV2 = {
  executedData?: InputMaybe<Array<InputMaybe<ExecutedDataInput>>>;
  file: Scalars['Upload']['input'];
  forceFetchKitcodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  process?: InputMaybe<Array<InputMaybe<ProcessDetailMapType>>>;
  type: ReportProcessType;
  vendorBioItId: Scalars['String']['input'];
};

export enum ReportProcessType {
  Fetch = 'FETCH',
  Map = 'MAP',
  Release = 'RELEASE'
}

export type ReportProdigyMutations = {
  __typename?: 'ReportProdigyMutations';
  sendSampleReport?: Maybe<Scalars['Boolean']['output']>;
};


export type ReportProdigyMutationsSendSampleReportArgs = {
  form?: InputMaybe<ReportProdigySendSampleReportForm>;
};

export type ReportProdigySendSampleReportForm = {
  email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type ReportQueries = {
  __typename?: 'ReportQueries';
  Ancestry?: Maybe<ReportAncestryQueries>;
  OncoRisk?: Maybe<OncoRiskReportQueries>;
  ReportThreeSixty?: Maybe<ReportThreeSixtyQueries>;
  findAllHighlightPanel?: Maybe<HighlightQueryResult>;
  findAllReportStatus?: Maybe<Array<Maybe<ReportStatusV2>>>;
  findOneLatestChipByReportStatus?: Maybe<ReportStatusV2>;
  reportStatus?: Maybe<ReportStatus>;
};


export type ReportQueriesFindAllHighlightPanelArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelQueryFilter>;
};


export type ReportQueriesFindAllReportStatusArgs = {
  where?: InputMaybe<ReportStatusQueryFilter>;
};


export type ReportQueriesReportStatusArgs = {
  where?: InputMaybe<ReportStatusQueryFilter>;
};

export type ReportStatus = {
  __typename?: 'ReportStatus';
  ACTIVE?: Maybe<Scalars['Boolean']['output']>;
  ANCESTRY?: Maybe<Scalars['Boolean']['output']>;
  DNA_360?: Maybe<Scalars['Boolean']['output']>;
  DNA_PREMIUM?: Maybe<Scalars['Boolean']['output']>;
  HORMONE?: Maybe<Scalars['Boolean']['output']>;
  NUTRIGENETIC?: Maybe<Scalars['Boolean']['output']>;
  ONCORISK?: Maybe<Scalars['Boolean']['output']>;
  PRODIGY?: Maybe<Scalars['Boolean']['output']>;
  SPORTGENOMIC?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportStatusQueryFilter = {
  clientProfileId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ReportStatusType {
  Activated = 'ACTIVATED',
  ReadyToUnlockKit = 'READY_TO_UNLOCK_KIT',
  ReadyToUnlockReport = 'READY_TO_UNLOCK_REPORT',
  ReportReleased = 'REPORT_RELEASED',
  Unlocked = 'UNLOCKED'
}

export type ReportStatusV2 = {
  __typename?: 'ReportStatusV2';
  chipType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReportStatusType>;
  type?: Maybe<ReportType>;
};

export type ReportThreeSixtyMutations = {
  __typename?: 'ReportThreeSixtyMutations';
  create?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportThreeSixtyQueries = {
  __typename?: 'ReportThreeSixtyQueries';
  findAll?: Maybe<BioinformaticReportQueryResult>;
  findAllCategory?: Maybe<DnaCategoryWithReportQueryResult>;
  findAllHighlightPanel?: Maybe<HighlightQueryResult>;
  findAllInteractome?: Maybe<DnaInteractomeQueryResult>;
  findAllPanel?: Maybe<DnaPanelWithReportQueryResult>;
  findAllReport?: Maybe<BioinformaticReportQueryResult>;
  findOne?: Maybe<BioinformaticReport>;
};


export type ReportThreeSixtyQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticReportQuerySortBy>;
  where?: InputMaybe<BioinformaticReportFilter>;
};


export type ReportThreeSixtyQueriesFindAllCategoryArgs = {
  where?: InputMaybe<DnaCategoryWithReportQueryFilter>;
};


export type ReportThreeSixtyQueriesFindAllHighlightPanelArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaPanelQueryFilter>;
};


export type ReportThreeSixtyQueriesFindAllInteractomeArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DnaInteractomeQueryFilter>;
};


export type ReportThreeSixtyQueriesFindAllPanelArgs = {
  where?: InputMaybe<DnaPanelWithReportQueryFilter>;
};


export type ReportThreeSixtyQueriesFindAllReportArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BioinformaticReportQuerySortBy>;
  where?: InputMaybe<BioinformaticReportFilter>;
};


export type ReportThreeSixtyQueriesFindOneArgs = {
  id: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<PurchaseProductType>;
};

export enum ReportType {
  Active = 'ACTIVE',
  Ancestry = 'ANCESTRY',
  Dna_360 = 'DNA_360',
  DnaPremium = 'DNA_PREMIUM',
  Hormone = 'HORMONE',
  Nutrigenetic = 'NUTRIGENETIC',
  Oncorisk = 'ONCORISK',
  Personality = 'PERSONALITY',
  Pgx = 'PGX',
  Prodigy = 'PRODIGY',
  Skin = 'SKIN',
  Sportgenomic = 'SPORTGENOMIC',
  TenX = 'TEN_X'
}

export type ReportTypeFigure = {
  __typename?: 'ReportTypeFigure';
  createdAt?: Maybe<Scalars['Date']['output']>;
  favourablePin?: Maybe<Array<Maybe<ReportTypeFigurePinPanel>>>;
  gender?: Maybe<Scalars['String']['output']>;
  generalPin?: Maybe<Array<Maybe<ReportTypeFigurePinPanel>>>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  pinPanel?: Maybe<Array<Maybe<ReportTypeFigurePinPanel>>>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  unfavourablePin?: Maybe<Array<Maybe<ReportTypeFigurePinPanel>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ReportTypeFigureForm = {
  gender: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  reportTypeId: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportTypeFigureMutations = {
  __typename?: 'ReportTypeFigureMutations';
  ReportTypeFigurePinPanel?: Maybe<ReportTypeFigurePinPanelMutations>;
  createOrUpdate?: Maybe<Array<Maybe<ReportTypeFigure>>>;
};


export type ReportTypeFigureMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<ReportTypeFigureForm>>;
};

export type ReportTypeFigurePinPanel = {
  __typename?: 'ReportTypeFigurePinPanel';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dCategory?: Maybe<Array<Maybe<DnaCategory>>>;
  dPanel?: Maybe<DnaPanel>;
  dnaPanelId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  reportTypeFigureId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ReportTypeFigurePinPanelDelete = {
  id: Scalars['String']['input'];
};

export type ReportTypeFigurePinPanelForm = {
  dnaPanelId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['String']['input'];
  long: Scalars['String']['input'];
  reportTypeFigureId: Scalars['String']['input'];
};

export type ReportTypeFigurePinPanelMutations = {
  __typename?: 'ReportTypeFigurePinPanelMutations';
  createOrUpdate?: Maybe<Array<Maybe<ReportTypeFigurePinPanel>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type ReportTypeFigurePinPanelMutationsCreateOrUpdateArgs = {
  forms: Array<InputMaybe<ReportTypeFigurePinPanelForm>>;
};


export type ReportTypeFigurePinPanelMutationsDeleteArgs = {
  forms: Array<InputMaybe<ReportTypeFigurePinPanelDelete>>;
};

export type ReportTypeFigurePinPanelQueries = {
  __typename?: 'ReportTypeFigurePinPanelQueries';
  findAll?: Maybe<ReportTypeFigurePinPanelQueryResult>;
};


export type ReportTypeFigurePinPanelQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ReportTypeFigurePinPanelQueryFilter>;
};

export type ReportTypeFigurePinPanelQueryFilter = {
  dnaPanelId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypeFigureId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportTypeFigurePinPanelQueryResult = {
  __typename?: 'ReportTypeFigurePinPanelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ReportTypeFigurePinPanel>>>;
};

export type ReportTypeFigureQueries = {
  __typename?: 'ReportTypeFigureQueries';
  ReportTypeFigurePinPanel?: Maybe<ReportTypeFigurePinPanelQueries>;
  findAll?: Maybe<ReportTypeFigureQueryResult>;
};


export type ReportTypeFigureQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ReportTypeFigureQueryFilter>;
};

export type ReportTypeFigureQueryFilter = {
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportTypeFigureQueryResult = {
  __typename?: 'ReportTypeFigureQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ReportTypeFigure>>>;
};

export type ReswabShipmentResult = {
  __typename?: 'ReswabShipmentResult';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  shipmentCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProductKitPickupStatus>;
  waybill?: Maybe<Scalars['String']['output']>;
};

export type ReviewReportProcessResult = {
  __typename?: 'ReviewReportProcessResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ReviewReportProcessResultData>>>;
};

export type ReviewReportProcessResultData = {
  __typename?: 'ReviewReportProcessResultData';
  kitCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<ReportType>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RiskFactors = {
  __typename?: 'RiskFactors';
  environmental: EnvironmentalRiskFactors;
  genetic: GeneticRiskFactors;
  lifestyle: LifestyleRiskFactors;
};

export type RiskTrait = {
  __typename?: 'RiskTrait';
  bReport?: Maybe<BioinformaticReport>;
  bioinformaticReportId?: Maybe<Scalars['String']['output']>;
  dInteractome?: Maybe<DnaInteractome>;
  dTrait?: Maybe<DnaTrait>;
  dnaInteractomeId?: Maybe<Scalars['String']['output']>;
  dnaTraitId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type Sales = {
  __typename?: 'Sales';
  ar?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  dpp?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  no?: Maybe<Scalars['Int']['output']>;
  paymentChannel?: Maybe<SalesPaymentChannel>;
  priceActivation?: Maybe<Scalars['Float']['output']>;
  priceBox?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
  transactionDateIn?: Maybe<Scalars['Date']['output']>;
  transactionIn?: Maybe<Scalars['Float']['output']>;
  transactionType?: Maybe<SalesTransactionType>;
  vat?: Maybe<Scalars['Float']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type SalesForm = {
  ar?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  dpp?: InputMaybe<Scalars['Float']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no?: InputMaybe<Scalars['Int']['input']>;
  paymentChannel?: InputMaybe<SalesPaymentChannel>;
  priceActivation?: InputMaybe<Scalars['Float']['input']>;
  priceBox?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  transactionDateIn?: InputMaybe<Scalars['Date']['input']>;
  transactionIn?: InputMaybe<Scalars['Float']['input']>;
  transactionType?: InputMaybe<SalesTransactionType>;
  vat?: InputMaybe<Scalars['Float']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type SalesMutations = {
  __typename?: 'SalesMutations';
  edit?: Maybe<Sales>;
  exportExcel?: Maybe<Scalars['String']['output']>;
  importExcel?: Maybe<Scalars['Boolean']['output']>;
};


export type SalesMutationsEditArgs = {
  form?: InputMaybe<SalesForm>;
  id: Scalars['String']['input'];
};


export type SalesMutationsExportExcelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SalesQuerySortBy>;
  where?: InputMaybe<SalesQueryFilter>;
};


export type SalesMutationsImportExcelArgs = {
  file: Scalars['Upload']['input'];
};

export enum SalesPaymentChannel {
  Apps = 'APPS',
  Manual = 'MANUAL'
}

export type SalesQueries = {
  __typename?: 'SalesQueries';
  findAll?: Maybe<SalesQueryResult>;
  findAllProduct?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  findAllVendor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  findOne?: Maybe<Sales>;
  id?: Maybe<Scalars['ID']['output']>;
  totalBox?: Maybe<Scalars['Float']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
};


export type SalesQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SalesQuerySortBy>;
  where?: InputMaybe<SalesQueryFilter>;
};


export type SalesQueriesFindAllProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SalesQueriesFindAllVendorArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SalesQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};


export type SalesQueriesTotalBoxArgs = {
  where?: InputMaybe<SalesQueryFilter>;
};


export type SalesQueriesTotalRevenueArgs = {
  where?: InputMaybe<SalesQueryFilter>;
};

export type SalesQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  maxTotal?: InputMaybe<Scalars['Float']['input']>;
  minTotal?: InputMaybe<Scalars['Float']['input']>;
  paymentChannels?: InputMaybe<Array<InputMaybe<SalesPaymentChannel>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  transactionDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionTypes?: InputMaybe<Array<InputMaybe<SalesTransactionType>>>;
  vendorNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SalesQueryResult = {
  __typename?: 'SalesQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Sales>>>;
};

export type SalesQuerySortBy = {
  ar?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  no?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  total?: InputMaybe<SortDirection>;
  transactionDate?: InputMaybe<SortDirection>;
};

export enum SalesTransactionType {
  B2B = 'B2B',
  D2C = 'D2C'
}

export enum ScheduleType {
  Cron = 'CRON',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY'
}

export type SendOtpToChangeEmailResult = {
  __typename?: 'SendOTPToChangeEmailResult';
  errors?: Maybe<Array<Maybe<SendOtpToChangeEmailResultError>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendOtpToChangeEmailResultError = {
  __typename?: 'SendOTPToChangeEmailResultError';
  key?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ServiceRateResult = {
  __typename?: 'ServiceRateResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<AnterAjaServicesRate>>>;
};

export type Setting = {
  __typename?: 'Setting';
  id?: Maybe<Scalars['Int']['output']>;
  payload?: Maybe<SettingPayload>;
};

export type SettingMutations = {
  __typename?: 'SettingMutations';
  edit?: Maybe<Setting>;
};


export type SettingMutationsEditArgs = {
  id: Scalars['Int']['input'];
  payload?: InputMaybe<SettingPayloadForm>;
};

export type SettingPayload = {
  __typename?: 'SettingPayload';
  app?: Maybe<SettingPayloadApp>;
  appointment?: Maybe<SettingPayloadAppointment>;
  consultationIncome?: Maybe<ConsultationIncome>;
  hotline?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<SettingPayloadInvoice>;
  support?: Maybe<SettingPayloadSupport>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SettingPayloadApp = {
  __typename?: 'SettingPayloadApp';
  latestVersion?: Maybe<Scalars['String']['output']>;
};

export type SettingPayloadAppointment = {
  __typename?: 'SettingPayloadAppointment';
  notificationEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type SettingPayloadAppointmentForm = {
  notificationEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export type SettingPayloadForm = {
  appointment?: InputMaybe<SettingPayloadAppointmentForm>;
  consultationIncome?: InputMaybe<ConsultationIncomeForm>;
  hotline?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<SettingPayloadInvoiceForm>;
  support?: InputMaybe<SettingPayloadSupportForm>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SettingPayloadInvoice = {
  __typename?: 'SettingPayloadInvoice';
  format?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type SettingPayloadInvoiceForm = {
  format?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type SettingPayloadSupport = {
  __typename?: 'SettingPayloadSupport';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SettingPayloadSupportForm = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SettingQueries = {
  __typename?: 'SettingQueries';
  VirtualAssistanceGreeting?: Maybe<VirtualAssistanceGreetingQueries>;
  findOne?: Maybe<Setting>;
};

export type SleepHabits = {
  __typename?: 'SleepHabits';
  sleepEachNightOnAverage?: Maybe<Scalars['String']['output']>;
  sleepEachNightOnAverageWeekday?: Maybe<Scalars['String']['output']>;
  sleepEachNightOnAverageWeekend?: Maybe<Scalars['String']['output']>;
};

export type SleepHabitsForm = {
  sleepEachNightOnAverage?: InputMaybe<Scalars['String']['input']>;
  sleepEachNightOnAverageWeekday?: InputMaybe<Scalars['String']['input']>;
  sleepEachNightOnAverageWeekend?: InputMaybe<Scalars['String']['input']>;
};

export type SmokingHabits = {
  __typename?: 'SmokingHabits';
  cigarettesType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dailyConsumption?: Maybe<Scalars['String']['output']>;
  smokingStatus?: Maybe<Scalars['String']['output']>;
  startSmoking?: Maybe<Scalars['String']['output']>;
};

export type SmokingHabitsForm = {
  cigarettesType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dailyConsumption?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['String']['input']>;
  startSmoking?: InputMaybe<Scalars['String']['input']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortKit = {
  activatedAt?: InputMaybe<SortDirection>;
  activatedUser?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
};

export type Splash = {
  __typename?: 'Splash';
  id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SplashQueries = {
  __typename?: 'SplashQueries';
  findAll?: Maybe<SplashQueryResult>;
  findOne?: Maybe<Splash>;
};


export type SplashQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type SplashQueryResult = {
  __typename?: 'SplashQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Splash>>>;
};

export type StatisticsQueries = {
  __typename?: 'StatisticsQueries';
  totalKitActivation?: Maybe<Scalars['Int']['output']>;
  totalOngoingReports?: Maybe<Scalars['Int']['output']>;
  totalOrder?: Maybe<Scalars['Int']['output']>;
  totalReportsReleased?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
};


export type StatisticsQueriesTotalKitActivationArgs = {
  where?: InputMaybe<TotalKitActivation>;
};


export type StatisticsQueriesTotalOngoingReportsArgs = {
  where?: InputMaybe<TotalOngoingReportsFilter>;
};


export type StatisticsQueriesTotalOrderArgs = {
  where?: InputMaybe<TotalOrderFilter>;
};


export type StatisticsQueriesTotalReportsReleasedArgs = {
  where?: InputMaybe<TotalReportsReleasedFilter>;
};


export type StatisticsQueriesTotalUsersArgs = {
  where?: InputMaybe<TotalUsersFilter>;
};

export type StatusCategoryAndTrait = {
  category?: InputMaybe<ProdigyCategoryStatus>;
  trait?: InputMaybe<ProdigyTraitStatus>;
};

export enum StatusEligibilitySkinFaceType {
  FailedAnalyze = 'FAILED_ANALYZE',
  FailedScan = 'FAILED_SCAN',
  FinishedAnalyze = 'FINISHED_ANALYZE',
  InProgressAnalyze = 'IN_PROGRESS_ANALYZE',
  InProgressScan = 'IN_PROGRESS_SCAN',
  NeedScan = 'NEED_SCAN',
  SuccessAnalyze = 'SUCCESS_ANALYZE',
  SuccessScan = 'SUCCESS_SCAN'
}

export type SubmitCareerForm = {
  email?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  job?: InputMaybe<CareerJobForm>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  CounselorNotificationCreated?: Maybe<CounselorNotification>;
  DNAGeneImportTranslationSucceed?: Maybe<Scalars['Boolean']['output']>;
  DNAGeneImportTranslationUploaded?: Maybe<Scalars['Boolean']['output']>;
  DNAHormoneGuidelinePerimenopauseUpdated?: Maybe<DnaHormoneGuidelinePerimenopauseEvent>;
  DNAHormoneGuidelineUpdated?: Maybe<DnaHormoneGuidelineEvent>;
  DNANutrigeneticPlusGuidelineUpdated?: Maybe<DnaNutritionGuidelineEvent>;
  DNAProdigyPlusGuidelineUpdated?: Maybe<DnaProdigyGuidelineEvent>;
  DNAReportCreated?: Maybe<UserNotification>;
  DNAReportImportTranslationSucceed?: Maybe<Scalars['Boolean']['output']>;
  DNAReportImportTranslationUploaded?: Maybe<Scalars['Boolean']['output']>;
  DNAReportTypePurchased?: Maybe<DnaReportType>;
  DNAReportTypeReleased?: Maybe<DnaReportType>;
  DNASkinFaceAnalyzeProcessUpdated?: Maybe<DnaSkinFaceAnalyzeProcessEvent>;
  DNASkinFaceScanProcessUpdated?: Maybe<DnaSkinFaceScanProcessEvent>;
  EHRLabAttachmentOcrProcess?: Maybe<OcrProcessNotification>;
  HealthScoreReportCreated?: Maybe<HealthScoreReportNotification>;
  HealthScoreReportRecommendationCreated?: Maybe<HealthScoreReportRecommendation>;
  HealthScoreReportRecommendationFailed?: Maybe<Scalars['Boolean']['output']>;
  HealthScoreReportUpdated?: Maybe<HealthScoreReportNotification>;
  LabTrackingUpdated?: Maybe<LabTrackingEvent>;
  PgXDrugClassExportFile?: Maybe<UserNotification>;
  PgXDrugExportFile?: Maybe<UserNotification>;
  PgXGlossaryExportFile?: Maybe<UserNotification>;
  PurchaseCartUpdated?: Maybe<PurchaseCart>;
  PurchaseProductKitExportFile?: Maybe<UserNotification>;
  PurchaseProductPickUpRequested?: Maybe<PurchaseProductKit>;
  PurchaseProductPickupHistoryUpdated?: Maybe<ProductKitPickupHistory>;
  UserCounselorBookCreated?: Maybe<UserCounselorBook>;
  UserCounselorBookDeleted?: Maybe<UserCounselorBook>;
  UserCounselorBookUpdated?: Maybe<UserCounselorBook>;
  UserCounselorChatCreated?: Maybe<UserCounselorChat>;
  UserCounselorChatUpdated?: Maybe<UserCounselorChat>;
  UserCounselorQueueCreated?: Maybe<UserCounselorQueue>;
  UserCounselorQueueUpdated?: Maybe<UserCounselorQueue>;
  UserCounselorQueueUpdatedAll?: Maybe<UserCounselorQueue>;
  UserCounselorStatusCreated?: Maybe<UserCounselorStatus>;
  UserCounselorStatusUpdated?: Maybe<UserCounselorStatus>;
  UserNotificationCreated?: Maybe<UserNotification>;
  UserNotificationUpdated?: Maybe<UserNotification>;
  UserSubcriptionCreated?: Maybe<UserSubscription>;
  UserSubcriptionUpdated?: Maybe<UserSubscription>;
  hello?: Maybe<Scalars['String']['output']>;
};


export type SubscriptionEhrLabAttachmentOcrProcessArgs = {
  deviceId: Scalars['String']['input'];
};


export type SubscriptionHealthScoreReportRecommendationCreatedArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionHealthScoreReportUpdatedArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionUserCounselorChatCreatedArgs = {
  queueId: Scalars['Int']['input'];
};


export type SubscriptionUserCounselorChatUpdatedArgs = {
  queueId?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionUserCounselorQueueUpdatedArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUserCounselorStatusUpdatedArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUserNotificationUpdatedArgs = {
  id: Scalars['Int']['input'];
};

export enum SubscriptionActionType {
  Extend = 'EXTEND',
  Initiate = 'INITIATE',
  Renewal = 'RENEWAL',
  Upgrade = 'UPGRADE'
}

export type SubscriptionContent = {
  __typename?: 'SubscriptionContent';
  points?: Maybe<Array<Maybe<SubscriptionContentPoint>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionContentForm = {
  points: Array<InputMaybe<SubscriptionContentPointForm>>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SubscriptionContentPoint = {
  __typename?: 'SubscriptionContentPoint';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionContentPointForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SubscriptionExtension = {
  __typename?: 'SubscriptionExtension';
  availableWhenRemainingDays?: Maybe<Scalars['Int']['output']>;
  channelSubscriptionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionExtensionEligibility = {
  __typename?: 'SubscriptionExtensionEligibility';
  detail?: Maybe<SubscriptionExtensionEligibilityDetail>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscriptionExtensionEligibilityDetail = {
  __typename?: 'SubscriptionExtensionEligibilityDetail';
  availableWhenRemainingDays?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  eligibleSubscription?: Maybe<AppSubscription>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  userSubscription?: Maybe<UserSubscription>;
};

export type SubscriptionExtensionForm = {
  availableWhenRemainingDays: Scalars['Int']['input'];
  discount: Scalars['Float']['input'];
  price: Scalars['Int']['input'];
  totalPrice: Scalars['Int']['input'];
};

export type SubscriptionExtensionQueries = {
  __typename?: 'SubscriptionExtensionQueries';
  findUserEligibility?: Maybe<SubscriptionExtensionEligibility>;
};

export type SubscriptionForm = {
  contentManagements: Array<InputMaybe<SubscriptionContentForm>>;
  duration: Scalars['Int']['input'];
  extensionPricings: Array<InputMaybe<SubscriptionExtensionForm>>;
  isEligibleToManualSubscription: Scalars['Boolean']['input'];
  isEligibleToUpgrade: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  productAccesses: Array<InputMaybe<Scalars['String']['input']>>;
  upgradeEligibilityPricings: Array<InputMaybe<SubscriptionUpgradeEligibilityForm>>;
};

export type SubscriptionQueries = {
  __typename?: 'SubscriptionQueries';
  Extension?: Maybe<SubscriptionExtensionQueries>;
  findAll?: Maybe<SubscriptionQueryResult>;
};


export type SubscriptionQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SubscriptionQuerySortBy>;
  where?: InputMaybe<SubscriptionQueryFilter>;
};

export type SubscriptionQueryFilter = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeKit?: InputMaybe<Scalars['Boolean']['input']>;
  isEligibleToManualSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  isGrantable?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showOnInternationalShop?: InputMaybe<Scalars['Boolean']['input']>;
  showOnShop?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscriptionName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<SubscriptionType>>>;
};

export type SubscriptionQueryResult = {
  __typename?: 'SubscriptionQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<AppSubscription>>>;
};

export type SubscriptionQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
};

export type SubscriptionReportAccess = {
  __typename?: 'SubscriptionReportAccess';
  channelSubscriptionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Stopped = 'STOPPED',
  Waiting = 'WAITING'
}

export enum SubscriptionType {
  VirtualAssistance = 'VIRTUAL_ASSISTANCE',
  VirtualAssistanceFree = 'VIRTUAL_ASSISTANCE_FREE',
  VirtualAssistanceFreeOneMonth = 'VIRTUAL_ASSISTANCE_FREE_ONE_MONTH'
}

export type SubscriptionUpgradeEligibility = {
  __typename?: 'SubscriptionUpgradeEligibility';
  createdAt?: Maybe<Scalars['Date']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  fromSubscriptionId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  toSubscriptionId?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionUpgradeEligibilityForm = {
  discount: Scalars['Float']['input'];
  price: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
  totalPrice: Scalars['Int']['input'];
};

export type SwitchUserProfileForm = {
  profileId: Scalars['String']['input'];
};

export type SyncHealthScoreForm = {
  data?: InputMaybe<Array<InputMaybe<SyncHealthScoreFormData>>>;
};

export type SyncHealthScoreFormData = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  healthScoreReport?: InputMaybe<SyncHealthScoreFormDataHealthScoreReport>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inputASCVD?: InputMaybe<SyncHealthScoreFormInputAscvd>;
  inputCKD?: InputMaybe<HealthScoreCkdForm>;
  inputDiabetes?: InputMaybe<SyncHealthScoreFormInputDiabetes>;
  inputHypertension?: InputMaybe<SyncHealthScoreFormInputHypertension>;
  inputNAFLD?: InputMaybe<HealthScoreNafldForm>;
  output?: InputMaybe<SyncHealthScoreFormOutput>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type SyncHealthScoreFormDataHealthScoreReport = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  healthScoreId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interpretation?: InputMaybe<HealthScoreReportInterpretationValue>;
  score?: InputMaybe<Scalars['Float']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type SyncHealthScoreFormInputAscvd = {
  HDLCholesterol?: InputMaybe<Scalars['Float']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  diabetesStatus?: InputMaybe<Scalars['Int']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['Int']['input']>;
  totalCholesterol?: InputMaybe<Scalars['Float']['input']>;
  treatedSystolicBloodPressure?: InputMaybe<Scalars['Float']['input']>;
  untreatedSystolicBloodPressure?: InputMaybe<Scalars['Float']['input']>;
};

export type SyncHealthScoreFormInputDiabetes = {
  age?: InputMaybe<Scalars['Int']['input']>;
  bmi?: InputMaybe<Scalars['Float']['input']>;
  familyHistory?: InputMaybe<Scalars['Int']['input']>;
  hypertension?: InputMaybe<Scalars['Int']['input']>;
  physicalActivity?: InputMaybe<Scalars['Int']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};

export type SyncHealthScoreFormInputHypertension = {
  age?: InputMaybe<Scalars['Int']['input']>;
  bmi?: InputMaybe<Scalars['Float']['input']>;
  diastolicBloodPressure?: InputMaybe<Scalars['Int']['input']>;
  parentalHypertension?: InputMaybe<Scalars['Int']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['Int']['input']>;
  systolicBloodPressure?: InputMaybe<Scalars['Int']['input']>;
};

export type SyncHealthScoreFormOutput = {
  recommendation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  riskScore?: InputMaybe<Scalars['Float']['input']>;
};

export type SyncHealthScoreResult = {
  __typename?: 'SyncHealthScoreResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncLocalDataForm = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  isSyncOCRAndClinicalData?: InputMaybe<Scalars['Boolean']['input']>;
  lwb?: InputMaybe<HealthScoreLwbForm>;
};

export type TotalKitActivation = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TotalOngoingReportsFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TotalOrderFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TotalReportsReleasedFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TotalUsersFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackHistoryQueryFilter = {
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TrackHistoryQueryResult = {
  __typename?: 'TrackHistoryQueryResult';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TrackHistoryQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type Tracker = {
  __typename?: 'Tracker';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackerBloodPressure = {
  __typename?: 'TrackerBloodPressure';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  startDate?: Maybe<Scalars['Date']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<TrackerBloodPressureValue>;
};

export type TrackerBloodPressureForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<TrackerSource>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TrackerBloodPressureMutations = {
  __typename?: 'TrackerBloodPressureMutations';
  create?: Maybe<TrackerBloodPressure>;
};


export type TrackerBloodPressureMutationsCreateArgs = {
  form?: InputMaybe<TrackerBloodPressureForm>;
};

export type TrackerBloodPressureQueries = {
  __typename?: 'TrackerBloodPressureQueries';
  findAll?: Maybe<TrackerBloodPressureQueryResult>;
};


export type TrackerBloodPressureQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TrackerBloodPressureQuerySorter>;
  where?: InputMaybe<TrackerBloodPressureQueryFilter>;
};

export type TrackerBloodPressureQueryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  sources?: InputMaybe<Array<InputMaybe<TrackerSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackerBloodPressureQueryResult = {
  __typename?: 'TrackerBloodPressureQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TrackerBloodPressure>>>;
};

export type TrackerBloodPressureQuerySorter = {
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
};

export type TrackerBloodPressureValue = {
  __typename?: 'TrackerBloodPressureValue';
  diastolic?: Maybe<Scalars['Float']['output']>;
  systolic?: Maybe<Scalars['Float']['output']>;
};

export type TrackerCalories = {
  __typename?: 'TrackerCalories';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  startDate?: Maybe<Scalars['Date']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrackerCaloriesForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<TrackerSource>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerCaloriesMutations = {
  __typename?: 'TrackerCaloriesMutations';
  Setting?: Maybe<TrackerCaloriesSettingMutations>;
  create?: Maybe<TrackerCalories>;
};


export type TrackerCaloriesMutationsCreateArgs = {
  form?: InputMaybe<TrackerCaloriesForm>;
};

export type TrackerCaloriesQueries = {
  __typename?: 'TrackerCaloriesQueries';
  Setting?: Maybe<TrackerCaloriesSettingQueries>;
  findAll?: Maybe<TrackerCaloriesQueryResult>;
};


export type TrackerCaloriesQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TrackerCaloriesQuerySorter>;
  where?: InputMaybe<TrackerCaloriesQueryFilter>;
};

export type TrackerCaloriesQueryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  sources?: InputMaybe<Array<InputMaybe<TrackerSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackerCaloriesQueryResult = {
  __typename?: 'TrackerCaloriesQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TrackerCalories>>>;
};

export type TrackerCaloriesQuerySorter = {
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TrackerCaloriesSetting = {
  __typename?: 'TrackerCaloriesSetting';
  createdAt?: Maybe<Scalars['Date']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackerCaloriesSettingForm = {
  goal?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerCaloriesSettingMutations = {
  __typename?: 'TrackerCaloriesSettingMutations';
  create?: Maybe<TrackerCaloriesSetting>;
};


export type TrackerCaloriesSettingMutationsCreateArgs = {
  form?: InputMaybe<TrackerCaloriesSettingForm>;
};

export type TrackerCaloriesSettingQueries = {
  __typename?: 'TrackerCaloriesSettingQueries';
  find?: Maybe<TrackerCaloriesSetting>;
};

export type TrackerDistance = {
  __typename?: 'TrackerDistance';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  startDate?: Maybe<Scalars['Date']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrackerDistanceForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<TrackerSource>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerDistanceMutations = {
  __typename?: 'TrackerDistanceMutations';
  Setting?: Maybe<TrackerDistanceSettingMutations>;
  create?: Maybe<TrackerDistance>;
};


export type TrackerDistanceMutationsCreateArgs = {
  form?: InputMaybe<TrackerDistanceForm>;
};

export type TrackerDistanceQueries = {
  __typename?: 'TrackerDistanceQueries';
  Setting?: Maybe<TrackerDistanceSettingQueries>;
  findAll?: Maybe<TrackerDistanceQueryResult>;
};


export type TrackerDistanceQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TrackerDistanceQuerySorter>;
  where?: InputMaybe<TrackerDistanceQueryFilter>;
};

export type TrackerDistanceQueryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  sources?: InputMaybe<Array<InputMaybe<TrackerSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackerDistanceQueryResult = {
  __typename?: 'TrackerDistanceQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TrackerDistance>>>;
};

export type TrackerDistanceQuerySorter = {
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TrackerDistanceSetting = {
  __typename?: 'TrackerDistanceSetting';
  createdAt?: Maybe<Scalars['Date']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackerDistanceSettingForm = {
  goal?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerDistanceSettingMutations = {
  __typename?: 'TrackerDistanceSettingMutations';
  create?: Maybe<TrackerDistanceSetting>;
};


export type TrackerDistanceSettingMutationsCreateArgs = {
  form?: InputMaybe<TrackerDistanceSettingForm>;
};

export type TrackerDistanceSettingQueries = {
  __typename?: 'TrackerDistanceSettingQueries';
  find?: Maybe<TrackerDistanceSetting>;
};

export type TrackerForm = {
  types?: InputMaybe<Array<InputMaybe<TrackerType>>>;
};

export type TrackerHeartRate = {
  __typename?: 'TrackerHeartRate';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  startDate?: Maybe<Scalars['Date']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrackerHeartRateForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<TrackerSource>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerHeartRateMutations = {
  __typename?: 'TrackerHeartRateMutations';
  create?: Maybe<TrackerHeartRate>;
};


export type TrackerHeartRateMutationsCreateArgs = {
  form?: InputMaybe<TrackerHeartRateForm>;
};

export type TrackerHeartRateQueries = {
  __typename?: 'TrackerHeartRateQueries';
  findAll?: Maybe<TrackerHeartRateQueryResult>;
};


export type TrackerHeartRateQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TrackerHeartRateQuerySorter>;
  where?: InputMaybe<TrackerHeartRateQueryFilter>;
};

export type TrackerHeartRateQueryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  sources?: InputMaybe<Array<InputMaybe<TrackerSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackerHeartRateQueryResult = {
  __typename?: 'TrackerHeartRateQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TrackerHeartRate>>>;
};

export type TrackerHeartRateQuerySorter = {
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TrackerMutations = {
  __typename?: 'TrackerMutations';
  BloodPressure?: Maybe<TrackerBloodPressureMutations>;
  Calories?: Maybe<TrackerCaloriesMutations>;
  Distance?: Maybe<TrackerDistanceMutations>;
  HeartRate?: Maybe<TrackerHeartRateMutations>;
  OxygenSaturation?: Maybe<TrackerOxygenSaturationMutations>;
  Setting?: Maybe<TrackerSettingMutations>;
  Sleep?: Maybe<TrackerSleepMutations>;
  Steps?: Maybe<TrackerStepsMutations>;
  create?: Maybe<Tracker>;
  sync?: Maybe<Scalars['Boolean']['output']>;
};


export type TrackerMutationsCreateArgs = {
  form?: InputMaybe<TrackerForm>;
};


export type TrackerMutationsSyncArgs = {
  form?: InputMaybe<Array<InputMaybe<TrackerSyncForm>>>;
};

export type TrackerOxygenSaturation = {
  __typename?: 'TrackerOxygenSaturation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  startDate?: Maybe<Scalars['Date']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrackerOxygenSaturationForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<TrackerSource>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerOxygenSaturationMutations = {
  __typename?: 'TrackerOxygenSaturationMutations';
  create?: Maybe<TrackerOxygenSaturation>;
};


export type TrackerOxygenSaturationMutationsCreateArgs = {
  form?: InputMaybe<TrackerOxygenSaturationForm>;
};

export type TrackerOxygenSaturationQueries = {
  __typename?: 'TrackerOxygenSaturationQueries';
  findAll?: Maybe<TrackerOxygenSaturationQueryResult>;
};


export type TrackerOxygenSaturationQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TrackerOxygenSaturationQuerySorter>;
  where?: InputMaybe<TrackerOxygenSaturationQueryFilter>;
};

export type TrackerOxygenSaturationQueryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  sources?: InputMaybe<Array<InputMaybe<TrackerSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackerOxygenSaturationQueryResult = {
  __typename?: 'TrackerOxygenSaturationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TrackerOxygenSaturation>>>;
};

export type TrackerOxygenSaturationQuerySorter = {
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TrackerQueries = {
  __typename?: 'TrackerQueries';
  BloodPressure?: Maybe<TrackerBloodPressureQueries>;
  Calories?: Maybe<TrackerCaloriesQueries>;
  Distance?: Maybe<TrackerDistanceQueries>;
  HeartRate?: Maybe<TrackerHeartRateQueries>;
  OxygenSaturation?: Maybe<TrackerOxygenSaturationQueries>;
  Setting?: Maybe<TrackerSettingQueries>;
  Sleep?: Maybe<TrackerSleepQueries>;
  Steps?: Maybe<TrackerStepsQueries>;
  find?: Maybe<Tracker>;
};

export type TrackerSetting = {
  __typename?: 'TrackerSetting';
  connectedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  disconnectedAt?: Maybe<Scalars['Date']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  types?: Maybe<Array<Maybe<TrackerType>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackerSettingForm = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<TrackerSource>;
  types?: InputMaybe<Array<InputMaybe<TrackerType>>>;
};

export type TrackerSettingMutations = {
  __typename?: 'TrackerSettingMutations';
  create?: Maybe<TrackerSetting>;
};


export type TrackerSettingMutationsCreateArgs = {
  form?: InputMaybe<TrackerSettingForm>;
};

export type TrackerSettingQueries = {
  __typename?: 'TrackerSettingQueries';
  find?: Maybe<TrackerSetting>;
  findAll?: Maybe<Array<Maybe<TrackerSetting>>>;
};


export type TrackerSettingQueriesFindArgs = {
  source?: InputMaybe<TrackerSource>;
};

export type TrackerSleep = {
  __typename?: 'TrackerSleep';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  startDate?: Maybe<Scalars['Date']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TrackerSleepForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<TrackerSource>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TrackerSleepMutations = {
  __typename?: 'TrackerSleepMutations';
  Setting?: Maybe<TrackerSleepSettingMutations>;
  create?: Maybe<TrackerSleep>;
};


export type TrackerSleepMutationsCreateArgs = {
  form?: InputMaybe<TrackerSleepForm>;
};

export type TrackerSleepQueries = {
  __typename?: 'TrackerSleepQueries';
  Setting?: Maybe<TrackerSleepSettingQueries>;
  findAll?: Maybe<TrackerSleepQueryResult>;
};


export type TrackerSleepQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TrackerSleepQuerySorter>;
  where?: InputMaybe<TrackerSleepQueryFilter>;
};

export type TrackerSleepQueryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  sources?: InputMaybe<Array<InputMaybe<TrackerSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TrackerSleepQueryResult = {
  __typename?: 'TrackerSleepQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TrackerSleep>>>;
};

export type TrackerSleepQuerySorter = {
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TrackerSleepSetting = {
  __typename?: 'TrackerSleepSetting';
  createdAt?: Maybe<Scalars['Date']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackerSleepSettingForm = {
  goal?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerSleepSettingMutations = {
  __typename?: 'TrackerSleepSettingMutations';
  create?: Maybe<TrackerSleepSetting>;
};


export type TrackerSleepSettingMutationsCreateArgs = {
  form?: InputMaybe<TrackerSleepSettingForm>;
};

export type TrackerSleepSettingQueries = {
  __typename?: 'TrackerSleepSettingQueries';
  find?: Maybe<TrackerSleepSetting>;
};

export enum TrackerSource {
  GoogleFit = 'GOOGLE_FIT',
  HealthKit = 'HEALTH_KIT',
  Manual = 'MANUAL'
}

export type TrackerSteps = {
  __typename?: 'TrackerSteps';
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<TrackerSource>;
  startDate?: Maybe<Scalars['Date']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrackerStepsForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<TrackerSource>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerStepsMutations = {
  __typename?: 'TrackerStepsMutations';
  Setting?: Maybe<TrackerStepsSettingMutations>;
  create?: Maybe<TrackerSteps>;
};


export type TrackerStepsMutationsCreateArgs = {
  form?: InputMaybe<TrackerStepsForm>;
};

export type TrackerStepsQueries = {
  __typename?: 'TrackerStepsQueries';
  Setting?: Maybe<TrackerStepsSettingQueries>;
  findAll?: Maybe<TrackerStepsQueryResult>;
};


export type TrackerStepsQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TrackerStepsQuerySorter>;
  where?: InputMaybe<TrackerStepsQueryFilter>;
};

export type TrackerStepsQueryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  sources?: InputMaybe<Array<InputMaybe<TrackerSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackerStepsQueryResult = {
  __typename?: 'TrackerStepsQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TrackerSteps>>>;
};

export type TrackerStepsQuerySorter = {
  createdAt?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TrackerStepsSetting = {
  __typename?: 'TrackerStepsSetting';
  createdAt?: Maybe<Scalars['Date']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackerStepsSettingForm = {
  goal?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackerStepsSettingMutations = {
  __typename?: 'TrackerStepsSettingMutations';
  create?: Maybe<TrackerStepsSetting>;
};


export type TrackerStepsSettingMutationsCreateArgs = {
  form?: InputMaybe<TrackerStepsSettingForm>;
};

export type TrackerStepsSettingQueries = {
  __typename?: 'TrackerStepsSettingQueries';
  find?: Maybe<TrackerStepsSetting>;
};

export type TrackerSyncForm = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sourceBundleId?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<TrackerType>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum TrackerType {
  BloodPressure = 'BLOOD_PRESSURE',
  Calories = 'CALORIES',
  Distance = 'DISTANCE',
  HeartRate = 'HEART_RATE',
  OxygenSaturation = 'OXYGEN_SATURATION',
  Sleep = 'SLEEP',
  Steps = 'STEPS'
}

export type TrackingResult = {
  __typename?: 'TrackingResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<AnterAjaTracking>>>;
};

export type TrainingPlan = {
  __typename?: 'TrainingPlan';
  createdAt?: Maybe<Scalars['Date']['output']>;
  daily?: Maybe<Array<Maybe<TrainingPlanDaily>>>;
  endDate?: Maybe<Scalars['String']['output']>;
  endGenerationAt?: Maybe<Scalars['Date']['output']>;
  exerciseGoal?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  generationStatus?: Maybe<TrainingPlanGenerationStatus>;
  id?: Maybe<Scalars['String']['output']>;
  sportGuidelineId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startGenerationAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrainingPlanDaily = {
  __typename?: 'TrainingPlanDaily';
  code?: Maybe<TrainingPlanDayCode>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exercises?: Maybe<Array<Maybe<TrainingPlanDailyItem>>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sportGuidelineTrainingPlanId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrainingPlanDailyItem = {
  __typename?: 'TrainingPlanDailyItem';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyActivityId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sportGuidelineTrainingPlanDailyId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TrainingPlanDayCode {
  Cardio = 'CARDIO',
  Recovery = 'RECOVERY',
  Sleep = 'SLEEP',
  Sports = 'SPORTS',
  Strength = 'STRENGTH',
  Wellbeing = 'WELLBEING'
}

export enum TrainingPlanGenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Inprogress = 'INPROGRESS'
}

export type TrainingPlanMutations = {
  __typename?: 'TrainingPlanMutations';
  generate?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<TrainingPlan>;
};


export type TrainingPlanMutationsGenerateArgs = {
  date: Scalars['String']['input'];
};


export type TrainingPlanMutationsUpdateArgs = {
  form: TrainingPlanUpdateForm;
};

export type TrainingPlanQueries = {
  __typename?: 'TrainingPlanQueries';
  findActive?: Maybe<TrainingPlan>;
  findByUser?: Maybe<TrainingPlan>;
};


export type TrainingPlanQueriesFindByUserArgs = {
  date: Scalars['String']['input'];
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TrainingPlanUpdateForm = {
  endGenerationAt?: InputMaybe<Scalars['Date']['input']>;
  exerciseGoal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generationStatus?: InputMaybe<TrainingPlanGenerationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  startGenerationAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TrainingReadiness = {
  __typename?: 'TrainingReadiness';
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exerciseGoal?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  focusOfTheWeek?: Maybe<Scalars['String']['output']>;
  generationStatus?: Maybe<TrainingReadinessGenerationStatus>;
  id?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  recoveryTips?: Maybe<Scalars['String']['output']>;
  sportGuidelineId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TrainingReadinessStatus>;
  suggestion?: Maybe<Array<Maybe<TrainingReadinessSuggestion>>>;
  tipsContent?: Maybe<Scalars['String']['output']>;
  tipsCtaText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TrainingReadinessGenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Inprogress = 'INPROGRESS'
}

export type TrainingReadinessMutations = {
  __typename?: 'TrainingReadinessMutations';
  generate?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<TrainingReadiness>;
};


export type TrainingReadinessMutationsGenerateArgs = {
  date: Scalars['String']['input'];
};


export type TrainingReadinessMutationsUpdateArgs = {
  form: TrainingReadinessUpdateForm;
};

export type TrainingReadinessQueries = {
  __typename?: 'TrainingReadinessQueries';
  findActive?: Maybe<TrainingReadiness>;
  findByUser?: Maybe<TrainingReadiness>;
};


export type TrainingReadinessQueriesFindByUserArgs = {
  date: Scalars['String']['input'];
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum TrainingReadinessStatus {
  Caution = 'CAUTION',
  Hold = 'HOLD',
  Ready = 'READY'
}

export type TrainingReadinessSuggestion = {
  __typename?: 'TrainingReadinessSuggestion';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sportGuidelineTrainingReadinessId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TrainingReadinessSuggestionType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TrainingReadinessSuggestionType {
  Avoid = 'AVOID',
  Recommended = 'RECOMMENDED'
}

export type TrainingReadinessUpdateForm = {
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exerciseGoal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focusOfTheWeek?: InputMaybe<Scalars['String']['input']>;
  generationStatus?: InputMaybe<TrainingReadinessGenerationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  recoveryTips?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrainingReadinessStatus>;
};

export type Trait = {
  __typename?: 'Trait';
  dataMissingAt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dataStatus?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<DnaScoreType>;
  status?: Maybe<Scalars['String']['output']>;
  traitScore?: Maybe<Array<Maybe<DnaTraitScore>>>;
  translation?: Maybe<Array<Maybe<DnaTraitTranslation>>>;
};

export type TraitForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  traitScore?: InputMaybe<Array<InputMaybe<DnaTraitScoreForm>>>;
  translation?: InputMaybe<DnaTraitTranslationForm>;
};

export type TraitQueryFilter = {
  dataStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dnaScoreTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scoreTranslationLang?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  translationLang?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TraitQueryResult = {
  __typename?: 'TraitQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Trait>>>;
};

export type TraitSortBy = {
  name?: InputMaybe<SortDirection>;
  scoreType?: InputMaybe<SortDirection>;
};

export enum TriggerType {
  EventBased = 'EVENT_BASED',
  Manual = 'MANUAL',
  MetricThreshold = 'METRIC_THRESHOLD',
  TimeBased = 'TIME_BASED'
}

export enum User_Counselor_Book_Status {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type UnlockPurchaseStatus = {
  __typename?: 'UnlockPurchaseStatus';
  available?: Maybe<Scalars['Boolean']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  unlockType?: Maybe<Scalars['String']['output']>;
};

export type UpdateOnboardingQuestionnaireForm = {
  alcoholHabits?: InputMaybe<AlcoholHabitsForm>;
  exerciseLevelPerWeek?: InputMaybe<Scalars['String']['input']>;
  exerciseLevelPerWeekCompleted?: InputMaybe<Scalars['String']['input']>;
  healthMedicalHistories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sleepHabits?: InputMaybe<SleepHabitsForm>;
  smokingHabits?: InputMaybe<SmokingHabitsForm>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOnboardingQuestionnaireFormV3 = {
  alcoholHabits?: InputMaybe<AlcoholHabitsForm>;
  allergyHistories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentHealthGoals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exerciseLevelPerWeek?: InputMaybe<Scalars['String']['input']>;
  exerciseLevelPerWeekCompleted?: InputMaybe<Scalars['String']['input']>;
  healthMedicalHistories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lifestyleHabits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sleepHabits?: InputMaybe<SleepHabitsForm>;
  smokingHabits?: InputMaybe<SmokingHabitsForm>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum UserAge {
  Adult = 'ADULT',
  Children = 'CHILDREN',
  Infant = 'INFANT',
  Infant_0_3Months = 'INFANT_0_3_MONTHS',
  Infant_4_6Months = 'INFANT_4_6_MONTHS',
  Infant_7_9Months = 'INFANT_7_9_MONTHS',
  Infant_10_12Months = 'INFANT_10_12_MONTHS',
  Preschool = 'PRESCHOOL',
  Toddler = 'TODDLER'
}

export type UserCounselor = {
  __typename?: 'UserCounselor';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  educations?: Maybe<UserCounselorEducationQueryResult>;
  expertises?: Maybe<UserCounselorExpertiseQueryResult>;
  id?: Maybe<Scalars['Int']['output']>;
  licenseIssuanceDate?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  performance?: Maybe<UserCounselorPerformance>;
  profession?: Maybe<UserCounselorProfession>;
  profile?: Maybe<UserProfile>;
  queues?: Maybe<UserCounselorQueueQueryResult>;
  rating?: Maybe<Scalars['Float']['output']>;
  reseller?: Maybe<Scalars['Boolean']['output']>;
  schedules?: Maybe<Array<Maybe<UserCounselorSchedule>>>;
  setting?: Maybe<UserCounselorSetting>;
  startedWorkingDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserCounselorStatus>;
  times?: Maybe<UserCounselorTimes>;
};


export type UserCounselorEducationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorEducationQuerySortBy>;
  where?: InputMaybe<UserCounselorEducationQueryFilter>;
};


export type UserCounselorExpertisesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorExpertiseQuerySortBy>;
  where?: InputMaybe<UserCounselorExpertiseQueryFilter>;
};


export type UserCounselorQueuesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorQueueQuerySortBy>;
  where?: InputMaybe<UserCounselorQueueQueryFilter>;
};


export type UserCounselorRatingArgs = {
  customRating?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCounselorBook = {
  __typename?: 'UserCounselorBook';
  categories?: Maybe<Array<Maybe<UserCounselorBookCategory>>>;
  code?: Maybe<Scalars['String']['output']>;
  counselor?: Maybe<UserCounselor>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  histories?: Maybe<Array<Maybe<UserCounselorBookHistory>>>;
  id?: Maybe<Scalars['Int']['output']>;
  income?: Maybe<UserCounselorIncome>;
  invoice?: Maybe<UserCounselorBookInvoice>;
  link?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<UserCounselorBookPayment>;
  price?: Maybe<Scalars['Int']['output']>;
  profile?: Maybe<UserProfile>;
  queue?: Maybe<UserCounselorQueue>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<UserCounselorBookStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<UserCounselorSettingConsultation>;
};

export type UserCounselorBookCategory = {
  __typename?: 'UserCounselorBookCategory';
  book?: Maybe<UserCounselorBook>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dnaCategory?: Maybe<DnaCategory>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorBookForm = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<UserCounselorBookPaymentForm>;
  price?: InputMaybe<Scalars['Int']['input']>;
  queueId?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<UserCounselorBookStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserCounselorSettingConsultation>;
};

export type UserCounselorBookHistory = {
  __typename?: 'UserCounselorBookHistory';
  counselorBookId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserCounselorBookStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorBookHistoryQueries = {
  __typename?: 'UserCounselorBookHistoryQueries';
  findAll?: Maybe<UserCounselorBookHistoryQueryResult>;
};


export type UserCounselorBookHistoryQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorBookHistoryQuerySortBy>;
  where?: InputMaybe<UserCounselorBookHistoryQueryFilter>;
};

export type UserCounselorBookHistoryQueryFilter = {
  counselorBookId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<UserCounselorBookStatus>>>;
};

export type UserCounselorBookHistoryQueryResult = {
  __typename?: 'UserCounselorBookHistoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorBookHistory>>>;
};

export type UserCounselorBookHistoryQuerySortBy = {
  counselorBookId?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type UserCounselorBookInvoice = {
  __typename?: 'UserCounselorBookInvoice';
  bookId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceNo?: Maybe<Scalars['String']['output']>;
  pointer?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorBookInvoiceForm = {
  bookId?: InputMaybe<Scalars['Int']['input']>;
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  invoiceNo?: InputMaybe<Scalars['String']['input']>;
  pointer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorBookInvoiceQueryResult = {
  __typename?: 'UserCounselorBookInvoiceQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorBookInvoice>>>;
};

export type UserCounselorBookMutations = {
  __typename?: 'UserCounselorBookMutations';
  Shadow?: Maybe<UserCounselorBookShadowMutations>;
  add?: Maybe<UserCounselorBook>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorBook>;
  exportExcel?: Maybe<Scalars['String']['output']>;
};


export type UserCounselorBookMutationsAddArgs = {
  form?: InputMaybe<UserCounselorBookForm>;
};


export type UserCounselorBookMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorBookMutationsEditArgs = {
  form?: InputMaybe<UserCounselorBookForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorBookPayment = {
  __typename?: 'UserCounselorBookPayment';
  book?: Maybe<UserCounselorBook>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  gateway?: Maybe<PaymentGateway>;
  id?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<PaymentPayload>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  type?: Maybe<PaymentType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  voucher?: Maybe<Voucher>;
};

export type UserCounselorBookPaymentForm = {
  phone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentType>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorBookPaymentQueryResult = {
  __typename?: 'UserCounselorBookPaymentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorBookPayment>>>;
};

export type UserCounselorBookQueries = {
  __typename?: 'UserCounselorBookQueries';
  History?: Maybe<UserCounselorBookHistoryQueries>;
  Shadow?: Maybe<UserCounselorBookShadowQueries>;
  filterPrice?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  findAll?: Maybe<UserCounselorBookQueryResult>;
  findOne?: Maybe<UserCounselorBook>;
};


export type UserCounselorBookQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorBookQuerySortBy>;
  where?: InputMaybe<UserCounselorBookQueryFilter>;
};


export type UserCounselorBookQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorBookQueryFilter = {
  counselor?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  queueStatus?: InputMaybe<Array<InputMaybe<UserCounselorQueueStatus>>>;
  startedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<UserCounselorBookStatus>>>;
  total?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<UserCounselorSettingConsultation>>>;
};

export type UserCounselorBookQueryResult = {
  __typename?: 'UserCounselorBookQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorBook>>>;
};

export type UserCounselorBookQuerySortBy = {
  code?: InputMaybe<SortDirection>;
  counselor?: InputMaybe<UserCounselorQuerySortBy>;
  createdAt?: InputMaybe<SortDirection>;
  duration?: InputMaybe<SortDirection>;
  note?: InputMaybe<SortDirection>;
  profile?: InputMaybe<UserQuerySortBy>;
  startedAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type UserCounselorBookShadow = {
  __typename?: 'UserCounselorBookShadow';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  batchId?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  counselorId?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kitActivation?: Maybe<KitActivation>;
  kitCode?: Maybe<Scalars['String']['output']>;
  kitId?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  resellerName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorBookShadowForm = {
  batchOrKitcode: Scalars['String']['input'];
  counselorId: Scalars['String']['input'];
};

export type UserCounselorBookShadowMutations = {
  __typename?: 'UserCounselorBookShadowMutations';
  add?: Maybe<Array<Maybe<UserCounselorBookShadow>>>;
};


export type UserCounselorBookShadowMutationsAddArgs = {
  forms?: InputMaybe<Array<InputMaybe<UserCounselorBookShadowForm>>>;
};

export type UserCounselorBookShadowQueries = {
  __typename?: 'UserCounselorBookShadowQueries';
  findAll?: Maybe<UserCounselorBookShadowQueryResult>;
};


export type UserCounselorBookShadowQueriesFindAllArgs = {
  include?: InputMaybe<Array<InputMaybe<UserCounselorBookShadowQueryInclude>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorBookShadowQuerySortBy>;
  where?: InputMaybe<UserCounselorBookShadowQueryFilter>;
};

export type UserCounselorBookShadowQueryFilter = {
  batchCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counselorId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kitCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resellerName?: InputMaybe<Scalars['String']['input']>;
};

export enum UserCounselorBookShadowQueryInclude {
  KitActivation = 'KIT_ACTIVATION'
}

export type UserCounselorBookShadowQueryResult = {
  __typename?: 'UserCounselorBookShadowQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorBookShadow>>>;
};

export type UserCounselorBookShadowQuerySortBy = {
  activatedAt?: InputMaybe<SortDirection>;
  batchId?: InputMaybe<SortDirection>;
  batchNumber?: InputMaybe<SortDirection>;
  counselorId?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  kitCode?: InputMaybe<SortDirection>;
  kitId?: InputMaybe<SortDirection>;
  profileId?: InputMaybe<SortDirection>;
  resellerName?: InputMaybe<SortDirection>;
};

export enum UserCounselorBookStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  PaymentExpired = 'PAYMENT_EXPIRED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  Pending = 'PENDING',
  Rescheduled = 'RESCHEDULED',
  Waiting = 'WAITING',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export type UserCounselorChat = {
  __typename?: 'UserCounselorChat';
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  from?: Maybe<UserProfile>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<UserCounselorQueue>;
  to?: Maybe<UserProfile>;
  unread?: Maybe<Scalars['Boolean']['output']>;
};

export type UserCounselorChatForm = {
  message?: InputMaybe<Scalars['String']['input']>;
  queueId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCounselorChatMutations = {
  __typename?: 'UserCounselorChatMutations';
  add?: Maybe<UserCounselorChat>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  deletes?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorChat>;
  read?: Maybe<Scalars['Boolean']['output']>;
};


export type UserCounselorChatMutationsAddArgs = {
  form?: InputMaybe<UserCounselorChatForm>;
};


export type UserCounselorChatMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorChatMutationsDeletesArgs = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserCounselorChatMutationsEditArgs = {
  form?: InputMaybe<UserCounselorChatForm>;
  id: Scalars['Int']['input'];
};


export type UserCounselorChatMutationsReadArgs = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  queueId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCounselorChatQueries = {
  __typename?: 'UserCounselorChatQueries';
  findAll?: Maybe<UserCounselorChatQueryResult>;
  findOne?: Maybe<UserCounselorChat>;
};


export type UserCounselorChatQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorChatQuerySortBy>;
  where?: InputMaybe<UserCounselorChatQueryFilter>;
};


export type UserCounselorChatQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorChatQueryFilter = {
  queueId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCounselorChatQueryResult = {
  __typename?: 'UserCounselorChatQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorChat>>>;
};

export type UserCounselorChatQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type UserCounselorCheckEmailAvailabilityQueryFilter = {
  email: Scalars['String']['input'];
  excludedEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorEducation = {
  __typename?: 'UserCounselorEducation';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type UserCounselorEducationForm = {
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCounselorEducationMutations = {
  __typename?: 'UserCounselorEducationMutations';
  add?: Maybe<UserCounselorEducation>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorEducation>;
};


export type UserCounselorEducationMutationsAddArgs = {
  form?: InputMaybe<UserCounselorEducationForm>;
};


export type UserCounselorEducationMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorEducationMutationsEditArgs = {
  form?: InputMaybe<UserCounselorEducationForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorEducationQueries = {
  __typename?: 'UserCounselorEducationQueries';
  findAll?: Maybe<UserCounselorEducationQueryResult>;
  findOne?: Maybe<UserCounselorEducation>;
};


export type UserCounselorEducationQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorEducationQuerySortBy>;
  where?: InputMaybe<UserCounselorEducationQueryFilter>;
};


export type UserCounselorEducationQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorEducationQueryFilter = {
  counselor?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorEducationQueryResult = {
  __typename?: 'UserCounselorEducationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorEducation>>>;
};

export type UserCounselorEducationQuerySortBy = {
  name?: InputMaybe<SortDirection>;
  year?: InputMaybe<SortDirection>;
};

export type UserCounselorExpertise = {
  __typename?: 'UserCounselorExpertise';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserCounselorExpertiseForm = {
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorExpertiseMutations = {
  __typename?: 'UserCounselorExpertiseMutations';
  add?: Maybe<UserCounselorExpertise>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorExpertise>;
};


export type UserCounselorExpertiseMutationsAddArgs = {
  form?: InputMaybe<UserCounselorExpertiseForm>;
};


export type UserCounselorExpertiseMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorExpertiseMutationsEditArgs = {
  form?: InputMaybe<UserCounselorExpertiseForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorExpertiseQueries = {
  __typename?: 'UserCounselorExpertiseQueries';
  findAll?: Maybe<UserCounselorExpertiseQueryResult>;
  findOne?: Maybe<UserCounselorExpertise>;
};


export type UserCounselorExpertiseQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorExpertiseQuerySortBy>;
  where?: InputMaybe<UserCounselorExpertiseQueryFilter>;
};


export type UserCounselorExpertiseQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorExpertiseQueryFilter = {
  counselor?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorExpertiseQueryResult = {
  __typename?: 'UserCounselorExpertiseQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorExpertise>>>;
};

export type UserCounselorExpertiseQuerySortBy = {
  name?: InputMaybe<SortDirection>;
};

export type UserCounselorForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  educations?: InputMaybe<Array<InputMaybe<UserCounselorEducationForm>>>;
  expertises?: InputMaybe<Array<InputMaybe<UserCounselorExpertiseForm>>>;
  licenseIssuanceDate?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  professionId?: InputMaybe<Scalars['Int']['input']>;
  profile?: InputMaybe<UserForm>;
  reseller?: InputMaybe<Scalars['Boolean']['input']>;
  setting?: InputMaybe<UserCounselorSettingForm>;
  startedWorkingDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserCounselorStatusForm>;
  times?: InputMaybe<UserCounselorTimesForm>;
};

export type UserCounselorIncome = {
  __typename?: 'UserCounselorIncome';
  amount?: Maybe<Scalars['Int']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  counselor?: Maybe<UserCounselor>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<UserCounselorQueue>;
  status?: Maybe<User_Counselor_Book_Status>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorIncomeMutationEdit = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<User_Counselor_Book_Status>;
};

export type UserCounselorIncomeMutations = {
  __typename?: 'UserCounselorIncomeMutations';
  edit?: Maybe<UserCounselorIncome>;
};


export type UserCounselorIncomeMutationsEditArgs = {
  form?: InputMaybe<UserCounselorIncomeMutationEdit>;
  id: Scalars['String']['input'];
};

export type UserCounselorIncomeQuery = {
  __typename?: 'UserCounselorIncomeQuery';
  findAll?: Maybe<UserCounselorIncomeQueryResults>;
  findOne?: Maybe<UserCounselorIncome>;
};


export type UserCounselorIncomeQueryFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorIncomeQuerySortBy>;
  where?: InputMaybe<UserCounselorIncomeQueryFilter>;
};


export type UserCounselorIncomeQueryFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorIncomeQueryFilter = {
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<User_Counselor_Book_Status>>>;
};

export type UserCounselorIncomeQueryResults = {
  __typename?: 'UserCounselorIncomeQueryResults';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorIncome>>>;
};

export type UserCounselorIncomeQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type UserCounselorMutations = {
  __typename?: 'UserCounselorMutations';
  Book?: Maybe<UserCounselorBookMutations>;
  Chat?: Maybe<UserCounselorChatMutations>;
  Education?: Maybe<UserCounselorEducationMutations>;
  Expertise?: Maybe<UserCounselorExpertiseMutations>;
  Income?: Maybe<UserCounselorIncomeMutations>;
  Notification?: Maybe<CounselorNotificationMutations>;
  Profession?: Maybe<UserCounselorProfessionMutations>;
  Queue?: Maybe<UserCounselorQueueMutations>;
  Schedule?: Maybe<UserCounselorScheduleMutations>;
  Setting?: Maybe<UserCounselorSettingMutations>;
  Status?: Maybe<UserCounselorStatusMutations>;
  Times?: Maybe<UserCounselorTimesMutations>;
  add?: Maybe<UserCounselor>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselor>;
};


export type UserCounselorMutationsAddArgs = {
  form?: InputMaybe<UserCounselorForm>;
};


export type UserCounselorMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorMutationsEditArgs = {
  form?: InputMaybe<UserCounselorForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorPerformance = {
  __typename?: 'UserCounselorPerformance';
  chat?: Maybe<Scalars['Float']['output']>;
  face_to_face?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  video_call?: Maybe<Scalars['Float']['output']>;
  voice_call?: Maybe<Scalars['Float']['output']>;
};

export type UserCounselorPerformanceQueryFilter = {
  duration?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorPerformanceQuerySortBy = {
  chat?: InputMaybe<SortDirection>;
  face_to_face?: InputMaybe<SortDirection>;
  profile?: InputMaybe<UserQuerySortBy>;
  total?: InputMaybe<SortDirection>;
  video_call?: InputMaybe<SortDirection>;
  voice_call?: InputMaybe<SortDirection>;
};

export type UserCounselorProfession = {
  __typename?: 'UserCounselorProfession';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_id?: Maybe<Scalars['String']['output']>;
  setting?: Maybe<UserCounselorProfessionSetting>;
};

export type UserCounselorProfessionForm = {
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_id?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorProfessionMutations = {
  __typename?: 'UserCounselorProfessionMutations';
  Setting?: Maybe<UserCounselorProfessionSettingMutations>;
  add?: Maybe<UserCounselorProfession>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorProfession>;
};


export type UserCounselorProfessionMutationsAddArgs = {
  form?: InputMaybe<UserCounselorProfessionForm>;
};


export type UserCounselorProfessionMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorProfessionMutationsEditArgs = {
  form?: InputMaybe<UserCounselorProfessionForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorProfessionQueries = {
  __typename?: 'UserCounselorProfessionQueries';
  Setting?: Maybe<UserCounselorProfessionSettingQueries>;
  findAll?: Maybe<UserCounselorProfessionQueryResult>;
  findOne?: Maybe<UserCounselorProfession>;
};


export type UserCounselorProfessionQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorProfessionQuerySortBy>;
  where?: InputMaybe<UserCounselorProfessionQueryFilter>;
};


export type UserCounselorProfessionQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorProfessionQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorProfessionQueryResult = {
  __typename?: 'UserCounselorProfessionQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorProfession>>>;
};

export type UserCounselorProfessionQuerySortBy = {
  name?: InputMaybe<SortDirection>;
  name_en?: InputMaybe<SortDirection>;
  name_id?: InputMaybe<SortDirection>;
};

export type UserCounselorProfessionSetting = {
  __typename?: 'UserCounselorProfessionSetting';
  id?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxUnit?: Maybe<UserCounselorProfessionSettingUnit>;
  min?: Maybe<Scalars['Float']['output']>;
  minUnit?: Maybe<UserCounselorProfessionSettingUnit>;
  profession?: Maybe<UserCounselorProfession>;
};

export type UserCounselorProfessionSettingForm = {
  max?: InputMaybe<Scalars['Float']['input']>;
  maxUnit?: InputMaybe<UserCounselorProfessionSettingUnit>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minUnit?: InputMaybe<UserCounselorProfessionSettingUnit>;
  professionId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCounselorProfessionSettingMutations = {
  __typename?: 'UserCounselorProfessionSettingMutations';
  add?: Maybe<UserCounselorProfessionSetting>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorProfessionSetting>;
};


export type UserCounselorProfessionSettingMutationsAddArgs = {
  form?: InputMaybe<UserCounselorProfessionSettingForm>;
};


export type UserCounselorProfessionSettingMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type UserCounselorProfessionSettingMutationsEditArgs = {
  form?: InputMaybe<UserCounselorProfessionSettingForm>;
  id: Scalars['String']['input'];
};

export type UserCounselorProfessionSettingQueries = {
  __typename?: 'UserCounselorProfessionSettingQueries';
  findAll?: Maybe<UserCounselorProfessionSettingQueryResult>;
  findOne?: Maybe<UserCounselorProfessionSetting>;
};


export type UserCounselorProfessionSettingQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorProfessionSettingQuerySortBy>;
  where?: InputMaybe<UserCounselorProfessionSettingQueryFilter>;
};


export type UserCounselorProfessionSettingQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type UserCounselorProfessionSettingQueryFilter = {
  professions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UserCounselorProfessionSettingQueryResult = {
  __typename?: 'UserCounselorProfessionSettingQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorProfessionSetting>>>;
};

export type UserCounselorProfessionSettingQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  max?: InputMaybe<SortDirection>;
  maxUnit?: InputMaybe<SortDirection>;
  min?: InputMaybe<SortDirection>;
  minUnit?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum UserCounselorProfessionSettingUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Weeks = 'WEEKS'
}

export type UserCounselorQueries = {
  __typename?: 'UserCounselorQueries';
  Book?: Maybe<UserCounselorBookQueries>;
  Chat?: Maybe<UserCounselorChatQueries>;
  Education?: Maybe<UserCounselorEducationQueries>;
  Expertise?: Maybe<UserCounselorExpertiseQueries>;
  Income?: Maybe<UserCounselorIncomeQuery>;
  Notification?: Maybe<CounselorNotificationQueries>;
  Profession?: Maybe<UserCounselorProfessionQueries>;
  Queue?: Maybe<UserCounselorQueueQueries>;
  Rating?: Maybe<UserCounselorRatingQueries>;
  Setting?: Maybe<UserCounselorSettingQueries>;
  Status?: Maybe<UserCounselorStatusQueries>;
  Times?: Maybe<UserCounselorTimesQueries>;
  checkEmailAvailability?: Maybe<CheckEmailAvailabilityResult>;
  findAll?: Maybe<UserCounselorQueryResult>;
  findOne?: Maybe<UserCounselor>;
  performance?: Maybe<UserCounselorQueryResult>;
};


export type UserCounselorQueriesCheckEmailAvailabilityArgs = {
  where?: InputMaybe<UserCounselorCheckEmailAvailabilityQueryFilter>;
};


export type UserCounselorQueriesFindAllArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorQuerySortBy>;
  where?: InputMaybe<UserCounselorQueryFilter>;
};


export type UserCounselorQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorQueriesPerformanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorPerformanceQuerySortBy>;
  where?: InputMaybe<UserCounselorPerformanceQueryFilter>;
};

export type UserCounselorQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  professions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reseller?: InputMaybe<Scalars['Boolean']['input']>;
  setting?: InputMaybe<UserCounselorSettingQueryFilter>;
  status?: InputMaybe<Array<InputMaybe<UserStatus>>>;
};

export type UserCounselorQueryResult = {
  __typename?: 'UserCounselorQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselor>>>;
};

export type UserCounselorQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  licenseIssuanceDate?: InputMaybe<SortDirection>;
  licenseNumber?: InputMaybe<SortDirection>;
  profession?: InputMaybe<UserCounselorProfessionQuerySortBy>;
  profile?: InputMaybe<UserQuerySortBy>;
  startedWorkingDate?: InputMaybe<SortDirection>;
};

export type UserCounselorQueue = {
  __typename?: 'UserCounselorQueue';
  book?: Maybe<UserCounselorBook>;
  counselor?: Maybe<UserCounselor>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  feedback?: Maybe<UserCounselorQueueFeedback>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<UserCounselorQueueStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserCounselorSettingConsultation>;
};

export type UserCounselorQueueFeedback = {
  __typename?: 'UserCounselorQueueFeedback';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  queueId?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorQueueFeedbackForm = {
  comments?: InputMaybe<Scalars['String']['input']>;
  queueId: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
};

export type UserCounselorQueueFeedbackMutations = {
  __typename?: 'UserCounselorQueueFeedbackMutations';
  add?: Maybe<UserCounselorQueueFeedback>;
};


export type UserCounselorQueueFeedbackMutationsAddArgs = {
  form?: InputMaybe<UserCounselorQueueFeedbackForm>;
};

export type UserCounselorQueueFeedbackQueries = {
  __typename?: 'UserCounselorQueueFeedbackQueries';
  findOne?: Maybe<UserCounselorQueueFeedback>;
};


export type UserCounselorQueueFeedbackQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorQueueForm = {
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  finishedAt?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<UserCounselorQueueStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserCounselorSettingConsultation>;
};

export type UserCounselorQueueMutations = {
  __typename?: 'UserCounselorQueueMutations';
  Feedback?: Maybe<UserCounselorQueueFeedbackMutations>;
  add?: Maybe<UserCounselorQueue>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorQueue>;
};


export type UserCounselorQueueMutationsAddArgs = {
  form?: InputMaybe<UserCounselorQueueForm>;
};


export type UserCounselorQueueMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorQueueMutationsEditArgs = {
  form?: InputMaybe<UserCounselorQueueForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorQueueQueries = {
  __typename?: 'UserCounselorQueueQueries';
  Feedback?: Maybe<UserCounselorQueueFeedbackQueries>;
  findAll?: Maybe<UserCounselorQueueQueryResult>;
  findOne?: Maybe<UserCounselorQueue>;
};


export type UserCounselorQueueQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorQueueQuerySortBy>;
  where?: InputMaybe<UserCounselorQueueQueryFilter>;
};


export type UserCounselorQueueQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorQueueQueryFilter = {
  counselor?: InputMaybe<Scalars['Int']['input']>;
  counselors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<UserCounselorQueueStatus>>>;
};

export type UserCounselorQueueQueryResult = {
  __typename?: 'UserCounselorQueueQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorQueue>>>;
};

export type UserCounselorQueueQuerySortBy = {
  counselor?: InputMaybe<UserCounselorQuerySortBy>;
  createdAt?: InputMaybe<SortDirection>;
  finishedAt?: InputMaybe<SortDirection>;
  profile?: InputMaybe<UserQuerySortBy>;
  startedAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum UserCounselorQueueStatus {
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Finished = 'FINISHED',
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Started = 'STARTED',
  Timeout = 'TIMEOUT',
  Waiting = 'WAITING'
}

export type UserCounselorRating = {
  __typename?: 'UserCounselorRating';
  book?: Maybe<UserCounselorBook>;
  bookId?: Maybe<Scalars['Int']['output']>;
  consultationBookType?: Maybe<UserCounselorSettingConsultation>;
  consultationFinishedAt?: Maybe<Scalars['Date']['output']>;
  consultationStartedAt?: Maybe<Scalars['Date']['output']>;
  counselor?: Maybe<UserCounselor>;
  counselorId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<UserProfile>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  topics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorRatingQueries = {
  __typename?: 'UserCounselorRatingQueries';
  findAll?: Maybe<UserCounselorRatingQueryResult>;
};


export type UserCounselorRatingQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorRatingQuerySortBy>;
  where?: InputMaybe<UserCounselorRatingQueryFilter>;
};

export type UserCounselorRatingQueryFilter = {
  consultationDate?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  counselorId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  professionId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rating?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UserCounselorRatingQueryResult = {
  __typename?: 'UserCounselorRatingQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorRating>>>;
};

export type UserCounselorRatingQuerySortBy = {
  consultationStartedAt?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
};

export type UserCounselorSchedule = {
  __typename?: 'UserCounselorSchedule';
  available?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  day?: Maybe<Day>;
  id?: Maybe<Scalars['String']['output']>;
  times?: Maybe<Array<Maybe<UserCounselorScheduleTime>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorScheduleForm = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<Day>;
  times?: InputMaybe<Array<InputMaybe<UserCounselorScheduleTimeForm>>>;
};

export type UserCounselorScheduleMutations = {
  __typename?: 'UserCounselorScheduleMutations';
  Time?: Maybe<UserCounselorScheduleTimeMutations>;
  add?: Maybe<UserCounselorSchedule>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorSchedule>;
};


export type UserCounselorScheduleMutationsAddArgs = {
  form?: InputMaybe<UserCounselorScheduleForm>;
};


export type UserCounselorScheduleMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type UserCounselorScheduleMutationsEditArgs = {
  form?: InputMaybe<UserCounselorScheduleForm>;
  id: Scalars['String']['input'];
};

export type UserCounselorScheduleTime = {
  __typename?: 'UserCounselorScheduleTime';
  createdAt?: Maybe<Scalars['Date']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorScheduleTimeForm = {
  finishedAt?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorScheduleTimeMutations = {
  __typename?: 'UserCounselorScheduleTimeMutations';
  add?: Maybe<UserCounselorScheduleTime>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorScheduleTime>;
};


export type UserCounselorScheduleTimeMutationsAddArgs = {
  form?: InputMaybe<UserCounselorScheduleTimeForm>;
};


export type UserCounselorScheduleTimeMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type UserCounselorScheduleTimeMutationsEditArgs = {
  form?: InputMaybe<UserCounselorScheduleTimeForm>;
  id: Scalars['String']['input'];
};

export type UserCounselorSetting = {
  __typename?: 'UserCounselorSetting';
  companyPercentage?: Maybe<Scalars['Int']['output']>;
  consultation?: Maybe<Array<Maybe<UserCounselorSettingConsultation>>>;
  counselorPercentage?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  membership?: Maybe<Array<Maybe<UserMembership>>>;
  pricePerSession?: Maybe<Scalars['Int']['output']>;
  timePerSession?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum UserCounselorSettingConsultation {
  Chat = 'CHAT',
  FaceToFace = 'FACE_TO_FACE',
  VideoCall = 'VIDEO_CALL',
  VoiceCall = 'VOICE_CALL'
}

export type UserCounselorSettingForm = {
  companyPercentage?: InputMaybe<Scalars['Int']['input']>;
  consultation?: InputMaybe<Array<InputMaybe<UserCounselorSettingConsultation>>>;
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  counselorPercentage?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  membership?: InputMaybe<Array<InputMaybe<UserMembership>>>;
  pricePerSession?: InputMaybe<Scalars['Int']['input']>;
  timePerSession?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCounselorSettingMutations = {
  __typename?: 'UserCounselorSettingMutations';
  add?: Maybe<UserCounselorSetting>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorSetting>;
  toggleVisibility?: Maybe<Scalars['Boolean']['output']>;
};


export type UserCounselorSettingMutationsAddArgs = {
  form?: InputMaybe<UserCounselorSettingForm>;
};


export type UserCounselorSettingMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorSettingMutationsEditArgs = {
  form?: InputMaybe<UserCounselorSettingForm>;
  id: Scalars['Int']['input'];
};


export type UserCounselorSettingMutationsToggleVisibilityArgs = {
  counselorId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type UserCounselorSettingQueries = {
  __typename?: 'UserCounselorSettingQueries';
  findAll?: Maybe<UserCounselorSettingQueryResult>;
  findOne?: Maybe<UserCounselorSetting>;
};


export type UserCounselorSettingQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorSettingQuerySortBy>;
  where?: InputMaybe<UserCounselorSettingQueryFilter>;
};


export type UserCounselorSettingQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorSettingQueryFilter = {
  consultation?: InputMaybe<Array<InputMaybe<UserCounselorSettingConsultation>>>;
  counselor?: InputMaybe<Scalars['Int']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  membership?: InputMaybe<Array<InputMaybe<UserMembership>>>;
};

export type UserCounselorSettingQueryResult = {
  __typename?: 'UserCounselorSettingQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorSetting>>>;
};

export type UserCounselorSettingQuerySortBy = {
  consultation?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  membership?: InputMaybe<SortDirection>;
};

export type UserCounselorStatus = {
  __typename?: 'UserCounselorStatus';
  autoUpdate?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserCounselorStatusType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserCounselorStatusForm = {
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserCounselorStatusType>;
};

export type UserCounselorStatusMutations = {
  __typename?: 'UserCounselorStatusMutations';
  add?: Maybe<UserCounselorStatus>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorStatus>;
};


export type UserCounselorStatusMutationsAddArgs = {
  form?: InputMaybe<UserCounselorStatusForm>;
};


export type UserCounselorStatusMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorStatusMutationsEditArgs = {
  form?: InputMaybe<UserCounselorStatusForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorStatusQueries = {
  __typename?: 'UserCounselorStatusQueries';
  findAll?: Maybe<UserCounselorStatusQueryResult>;
  findOne?: Maybe<UserCounselorStatus>;
};


export type UserCounselorStatusQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorStatusQuerySortBy>;
  where?: InputMaybe<UserCounselorStatusQueryFilter>;
};


export type UserCounselorStatusQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorStatusQueryFilter = {
  counselor?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UserCounselorStatusType>;
};

export type UserCounselorStatusQueryResult = {
  __typename?: 'UserCounselorStatusQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorStatus>>>;
};

export type UserCounselorStatusQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum UserCounselorStatusType {
  Break = 'BREAK',
  InConsultation = 'IN_CONSULTATION',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type UserCounselorTimes = {
  __typename?: 'UserCounselorTimes';
  days?: Maybe<Array<Maybe<UserCounselorTimesDay>>>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};

export enum UserCounselorTimesDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type UserCounselorTimesForm = {
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  days?: InputMaybe<Array<InputMaybe<UserCounselorTimesDay>>>;
  finishedAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export type UserCounselorTimesMutations = {
  __typename?: 'UserCounselorTimesMutations';
  add?: Maybe<UserCounselorTimes>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserCounselorTimes>;
};


export type UserCounselorTimesMutationsAddArgs = {
  form?: InputMaybe<UserCounselorTimesForm>;
};


export type UserCounselorTimesMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserCounselorTimesMutationsEditArgs = {
  form?: InputMaybe<UserCounselorTimesForm>;
  id: Scalars['Int']['input'];
};

export type UserCounselorTimesQueries = {
  __typename?: 'UserCounselorTimesQueries';
  findAll?: Maybe<UserCounselorTimesQueryResult>;
  findOne?: Maybe<UserCounselorTimes>;
};


export type UserCounselorTimesQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCounselorTimesQuerySortBy>;
  where?: InputMaybe<UserCounselorTimesQueryFilter>;
};


export type UserCounselorTimesQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserCounselorTimesQueryFilter = {
  counselor?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCounselorTimesQueryResult = {
  __typename?: 'UserCounselorTimesQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserCounselorTimes>>>;
};

export type UserCounselorTimesQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export type UserCustomerMutations = {
  __typename?: 'UserCustomerMutations';
  exportExcel?: Maybe<Scalars['String']['output']>;
};


export type UserCustomerMutationsExportExcelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCustomerQuerySortBy>;
  where?: InputMaybe<UserCustomerQueryFilter>;
};

export type UserCustomerQueries = {
  __typename?: 'UserCustomerQueries';
  findAll?: Maybe<UserCustomerQueryResult>;
  findAllV2?: Maybe<UserCustomerQueryResult>;
  findOne?: Maybe<UserProfile>;
};


export type UserCustomerQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCustomerQuerySortBy>;
  where?: InputMaybe<UserCustomerQueryFilter>;
};


export type UserCustomerQueriesFindAllV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserCustomerQuerySortByV2>;
  where?: InputMaybe<UserCustomerQueryFilterV2>;
};


export type UserCustomerQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type UserCustomerQueryFilter = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<Array<InputMaybe<UserGender>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<UserCustomerStatus>>>;
};

export type UserCustomerQueryFilterV2 = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<Array<InputMaybe<UserGender>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type UserCustomerQueryResult = {
  __typename?: 'UserCustomerQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserProfile>>>;
};

export type UserCustomerQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
  kit?: InputMaybe<PurchaseProductKitQuerySortBy>;
  name?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
};

export type UserCustomerQuerySortByV2 = {
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum UserCustomerStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type UserFamily = {
  __typename?: 'UserFamily';
  age?: Maybe<Scalars['Float']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<UserGender>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserFamilyForm = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserFamilyMutations = {
  __typename?: 'UserFamilyMutations';
  add?: Maybe<UserFamily>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserFamily>;
};


export type UserFamilyMutationsAddArgs = {
  form?: InputMaybe<UserFamilyForm>;
};


export type UserFamilyMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserFamilyMutationsEditArgs = {
  form?: InputMaybe<UserFamilyForm>;
  id: Scalars['Int']['input'];
};

export type UserFamilyQueries = {
  __typename?: 'UserFamilyQueries';
  findAll?: Maybe<UserFamilyQueryResult>;
  findOne?: Maybe<UserFamily>;
};


export type UserFamilyQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserFamilyQuerySortBy>;
  where?: InputMaybe<UserFamilyQueryFilter>;
};


export type UserFamilyQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserFamilyQueryFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserFamilyQueryResult = {
  __typename?: 'UserFamilyQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserFamily>>>;
};

export type UserFamilyQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type UserFeatureConsent = {
  __typename?: 'UserFeatureConsent';
  consentedAt?: Maybe<Scalars['Date']['output']>;
  featureCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
};

export type UserFeatureConsentAvailabilityResponse = {
  __typename?: 'UserFeatureConsentAvailabilityResponse';
  consentedAt?: Maybe<Scalars['Date']['output']>;
  status: UserFeatureConsentStatus;
};

export type UserFeatureConsentCheckFilter = {
  date?: InputMaybe<Scalars['String']['input']>;
  featureCode: Scalars['String']['input'];
};

export type UserFeatureConsentForm = {
  date?: InputMaybe<Scalars['String']['input']>;
  featureCode: Scalars['String']['input'];
};

export type UserFeatureConsentMutations = {
  __typename?: 'UserFeatureConsentMutations';
  save: UserFeatureConsent;
};


export type UserFeatureConsentMutationsSaveArgs = {
  form: UserFeatureConsentForm;
};

export type UserFeatureConsentQueries = {
  __typename?: 'UserFeatureConsentQueries';
  checkAvailability?: Maybe<UserFeatureConsentAvailabilityResponse>;
};


export type UserFeatureConsentQueriesCheckAvailabilityArgs = {
  where: UserFeatureConsentCheckFilter;
};

export enum UserFeatureConsentStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type UserFeedbackAvailabilityData = {
  __typename?: 'UserFeedbackAvailabilityData';
  choices?: Maybe<Array<Maybe<FeedbackChoice>>>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ratingEnabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<UserFeedbackStatus>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserFeedbackForm = {
  choice?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFeedbackResponse = {
  __typename?: 'UserFeedbackResponse';
  choice?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  externalId?: Maybe<Scalars['String']['output']>;
  feedbackForm?: Maybe<FeedbackForm>;
  formId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserFeedbackResponseMutations = {
  __typename?: 'UserFeedbackResponseMutations';
  save: UserFeedbackResponse;
};


export type UserFeedbackResponseMutationsSaveArgs = {
  form: UserFeedbackForm;
};

export type UserFeedbackResponseQueries = {
  __typename?: 'UserFeedbackResponseQueries';
  checkAllAvailability?: Maybe<Array<Maybe<UserFeedbackAvailabilityData>>>;
};

export enum UserFeedbackStatus {
  Available = 'AVAILABLE',
  Submitted = 'SUBMITTED'
}

export type UserForm = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnic?: InputMaybe<ProfileEthnicityForm>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  height?: InputMaybe<Scalars['Float']['input']>;
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicals?: InputMaybe<Array<InputMaybe<ProfileMedicalForm>>>;
  membership?: InputMaybe<UserMembership>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  photos?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UserFtue = {
  __typename?: 'UserFtue';
  ftueFeature?: Maybe<FtueFeature>;
  ftueFeatureId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['Date']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
};

export type UserFtueAvailabilityData = {
  __typename?: 'UserFtueAvailabilityData';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mediaPointer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserFtueStatus>;
};

export type UserFtueAvailabilityResponse = {
  __typename?: 'UserFtueAvailabilityResponse';
  data: DetailUserFtueAvailabilityData;
};

export type UserFtueCheckFilter = {
  featureCode: Scalars['String']['input'];
};

export type UserFtueForm = {
  ftueFeatureId: Scalars['String']['input'];
};

export type UserFtueMutations = {
  __typename?: 'UserFtueMutations';
  save: UserFtue;
};


export type UserFtueMutationsSaveArgs = {
  form: UserFtueForm;
};

export type UserFtueQueries = {
  __typename?: 'UserFtueQueries';
  checkAllAvailability?: Maybe<Array<Maybe<UserFtueAvailabilityData>>>;
  checkAvailability?: Maybe<UserFtueAvailabilityResponse>;
  checkKitActivationAvailability?: Maybe<FtueFeature>;
};


export type UserFtueQueriesCheckAvailabilityArgs = {
  where: UserFtueCheckFilter;
};

export enum UserFtueStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum UserGender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type UserLwb = {
  __typename?: 'UserLWB';
  comparison?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  downhearted?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  feelTired?: Maybe<Scalars['String']['output']>;
  fruitServingPerDays?: Maybe<Scalars['Int']['output']>;
  healthSummary?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insomnia?: Maybe<Scalars['String']['output']>;
  latestLWBReport?: Maybe<HealthScoreReport>;
  lifeCondition?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  numberOfPreexistingDisease?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parentHasBeenDiagnosed?: Maybe<Lwb_Parent_Has_Been_Diagnosed>;
  parentHistoryOfDisease?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  physicalActivities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  physicalActivity?: Maybe<Scalars['String']['output']>;
  previousScore?: Maybe<Scalars['String']['output']>;
  primaryHealthGoals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  score?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  smokingStatus?: Maybe<Scalars['String']['output']>;
  sugaryProduct?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<HealthScoreReportTrigger>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type UserLwbDaily = {
  __typename?: 'UserLWBDaily';
  changeInScore?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  downhearted?: Maybe<Scalars['String']['output']>;
  feelTired?: Maybe<Scalars['String']['output']>;
  fruitServingPerDays?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insomnia?: Maybe<Scalars['String']['output']>;
  parentHasBeenDiagnosed?: Maybe<Scalars['String']['output']>;
  physicalActivity?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  sugaryProduct?: Maybe<Scalars['String']['output']>;
  timeOfDayString?: Maybe<UserLwbDailyTimeOfDay>;
};

export type UserLwbDailyForm = {
  downhearted?: InputMaybe<Scalars['String']['input']>;
  feelTired?: InputMaybe<Scalars['String']['input']>;
  fruitServingPerDays?: InputMaybe<Scalars['Int']['input']>;
  insomnia?: InputMaybe<Scalars['String']['input']>;
  physicalActivity?: InputMaybe<Scalars['String']['input']>;
  sugaryProduct?: InputMaybe<Scalars['String']['input']>;
  timeOfDayString: UserLwbDailyTimeOfDay;
};

export type UserLwbDailyMutations = {
  __typename?: 'UserLWBDailyMutations';
  create?: Maybe<UserLwbDaily>;
};


export type UserLwbDailyMutationsCreateArgs = {
  form: UserLwbDailyForm;
};

export type UserLwbDailyQueries = {
  __typename?: 'UserLWBDailyQueries';
  findAll?: Maybe<UserLwbDailyQueryResult>;
  logFindAll?: Maybe<Array<Maybe<UserLwbLog>>>;
};


export type UserLwbDailyQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserLwbDailyQuerySortBy>;
  where?: InputMaybe<UserLwbDailyQueryFilter>;
};


export type UserLwbDailyQueriesLogFindAllArgs = {
  where?: InputMaybe<UserLwbLogQueryFilter>;
};

export type UserLwbDailyQueryFilter = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeOfDayString?: InputMaybe<Array<InputMaybe<UserLwbDailyTimeOfDay>>>;
};

export type UserLwbDailyQueryResult = {
  __typename?: 'UserLWBDailyQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserLwbDaily>>>;
};

export type UserLwbDailyQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  timeOfDayString?: InputMaybe<SortDirection>;
};

export enum UserLwbDailyTimeOfDay {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING'
}

export type UserLwbForm = {
  dob?: InputMaybe<Scalars['String']['input']>;
  downhearted?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  feelTired?: InputMaybe<Scalars['String']['input']>;
  fruitServingPerDays?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  insomnia?: InputMaybe<Scalars['String']['input']>;
  lifeCondition?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  numberOfPreexistingDisease?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentHasBeenDiagnosed?: InputMaybe<Lwb_Parent_Has_Been_Diagnosed>;
  physicalActivities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalActivity?: InputMaybe<Scalars['String']['input']>;
  primaryHealthGoals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sex?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['String']['input']>;
  sugaryProduct?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UserLwbLog = {
  __typename?: 'UserLWBLog';
  afternoon?: Maybe<Scalars['String']['output']>;
  changeInScore?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  evening?: Maybe<Scalars['String']['output']>;
  morning?: Maybe<Scalars['String']['output']>;
};

export type UserLwbLogQueryFilter = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserLwbMutations = {
  __typename?: 'UserLWBMutations';
  Daily?: Maybe<UserLwbDailyMutations>;
};

export type UserLwbQueries = {
  __typename?: 'UserLWBQueries';
  Daily?: Maybe<UserLwbDailyQueries>;
  findOne?: Maybe<UserLwb>;
  getDefaultQuestionnaireValues?: Maybe<UserLwb>;
};

export enum UserMembership {
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export type UserMutations = {
  __typename?: 'UserMutations';
  ClinicalData?: Maybe<ClinicalDataMutations>;
  Counselor?: Maybe<UserCounselorMutations>;
  Customer?: Maybe<UserCustomerMutations>;
  Family?: Maybe<UserFamilyMutations>;
  FeatureConsent?: Maybe<UserFeatureConsentMutations>;
  FeedbackResponse?: Maybe<UserFeedbackResponseMutations>;
  Ftue?: Maybe<UserFtueMutations>;
  LWB?: Maybe<UserLwbMutations>;
  Notification?: Maybe<UserNotificationMutations>;
  NotificationWearable?: Maybe<NotificationWearableMutations>;
  Quota?: Maybe<UserQuotaMutations>;
  ReportAccess?: Maybe<UserReportAccessMutations>;
  Setting?: Maybe<UserSettingMutations>;
  SubProfile?: Maybe<UserSubProfileMutations>;
  Subscription?: Maybe<UserSubscriptionMutations>;
  agreeWearable?: Maybe<UserProfile>;
  aiTermOfServiceAgreed?: Maybe<UserProfile>;
  changeEmail?: Maybe<SendOtpToChangeEmailResult>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  deleteMultiple?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserProfile>;
  editPassword?: Maybe<Scalars['Boolean']['output']>;
  editPhoto?: Maybe<Scalars['Boolean']['output']>;
  resendActivationToken?: Maybe<Scalars['Boolean']['output']>;
  resendPassword?: Maybe<Scalars['Boolean']['output']>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  sendOTPToChangeEmail?: Maybe<SendOtpToChangeEmailResult>;
  sendOnboardingEmail?: Maybe<Scalars['Boolean']['output']>;
  shipment?: Maybe<Scalars['Boolean']['output']>;
  softDelete?: Maybe<Scalars['Boolean']['output']>;
  syncLocalData?: Maybe<Scalars['Boolean']['output']>;
  validateSoftDelete?: Maybe<Scalars['Boolean']['output']>;
};


export type UserMutationsAgreeWearableArgs = {
  agreed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserMutationsAiTermOfServiceAgreedArgs = {
  agreed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserMutationsChangeEmailArgs = {
  newEmail?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type UserMutationsDeleteMultipleArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type UserMutationsEditArgs = {
  form?: InputMaybe<UserForm>;
};


export type UserMutationsEditPasswordArgs = {
  form?: InputMaybe<UserPasswordForm>;
};


export type UserMutationsEditPhotoArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsResendActivationTokenArgs = {
  id: Scalars['String']['input'];
};


export type UserMutationsResendPasswordArgs = {
  username: Scalars['String']['input'];
};


export type UserMutationsResetPasswordArgs = {
  username: Scalars['String']['input'];
};


export type UserMutationsSendOtpToChangeEmailArgs = {
  newEmail?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsShipmentArgs = {
  form?: InputMaybe<UserShipmentForm>;
};


export type UserMutationsSyncLocalDataArgs = {
  form?: InputMaybe<SyncLocalDataForm>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  createdAt?: Maybe<Scalars['Date']['output']>;
  from?: Maybe<UserProfile>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<UserProfile>;
  type?: Maybe<UserNotificationType>;
  unread?: Maybe<Scalars['Boolean']['output']>;
};

export type UserNotificationDevice = {
  __typename?: 'UserNotificationDevice';
  deviceId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  onesignalId?: Maybe<Scalars['String']['output']>;
  pushSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationDeviceForm = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  onesignalId?: InputMaybe<Scalars['String']['input']>;
  pushSubscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationDeviceMutations = {
  __typename?: 'UserNotificationDeviceMutations';
  create?: Maybe<UserNotificationDevice>;
};


export type UserNotificationDeviceMutationsCreateArgs = {
  form?: InputMaybe<UserNotificationDeviceForm>;
};

export type UserNotificationDeviceQueries = {
  __typename?: 'UserNotificationDeviceQueries';
  findAll?: Maybe<Array<Maybe<UserNotificationDevice>>>;
};

export type UserNotificationForm = {
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserNotificationMutations = {
  __typename?: 'UserNotificationMutations';
  Device?: Maybe<UserNotificationDeviceMutations>;
  Setting?: Maybe<UserNotificationSettingMutations>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<UserNotification>;
};


export type UserNotificationMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type UserNotificationMutationsEditArgs = {
  form?: InputMaybe<UserNotificationForm>;
  id: Scalars['Int']['input'];
};

export type UserNotificationQueries = {
  __typename?: 'UserNotificationQueries';
  Device?: Maybe<UserNotificationDeviceQueries>;
  Setting?: Maybe<UserNotificationSettingQueries>;
  findAll?: Maybe<UserNotificationQueryResult>;
  findOne?: Maybe<UserNotification>;
};


export type UserNotificationQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserNotificationQuerySortBy>;
  where?: InputMaybe<UserNotificationQueryFilter>;
};


export type UserNotificationQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserNotificationQueryFilter = {
  type?: InputMaybe<Array<InputMaybe<UserNotificationType>>>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserNotificationQueryResult = {
  __typename?: 'UserNotificationQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserNotification>>>;
};

export type UserNotificationQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  ancestry?: Maybe<Scalars['Boolean']['output']>;
  dailyHealthRecommendation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kydz?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationSettingForm = {
  ancestry?: InputMaybe<Scalars['Boolean']['input']>;
  dailyHealthRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  kydz?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationSettingMutations = {
  __typename?: 'UserNotificationSettingMutations';
  edit?: Maybe<UserNotificationSetting>;
};


export type UserNotificationSettingMutationsEditArgs = {
  form?: InputMaybe<UserNotificationSettingForm>;
};

export type UserNotificationSettingQueries = {
  __typename?: 'UserNotificationSettingQueries';
  findOne?: Maybe<UserNotificationSetting>;
};

export enum UserNotificationType {
  AppointmentBookUpdated = 'APPOINTMENT_BOOK_UPDATED',
  AppointmentReminder = 'APPOINTMENT_REMINDER',
  ArticleCreated = 'ARTICLE_CREATED',
  BulkManualActivation = 'BULK_MANUAL_ACTIVATION',
  BulkManualActivationFailed = 'BULK_MANUAL_ACTIVATION_FAILED',
  BulkManualActivationSucceed = 'BULK_MANUAL_ACTIVATION_SUCCEED',
  CartReminderDaily = 'CART_REMINDER_DAILY',
  CartReminderWeekly = 'CART_REMINDER_WEEKLY',
  ContentManagementImportTrait = 'CONTENT_MANAGEMENT_IMPORT_TRAIT',
  ContentManagementImportTraitFailed = 'CONTENT_MANAGEMENT_IMPORT_TRAIT_FAILED',
  ContentManagementImportTraitSucceed = 'CONTENT_MANAGEMENT_IMPORT_TRAIT_SUCCEED',
  ContentMapperExportExcelFailed = 'CONTENT_MAPPER_EXPORT_EXCEL_FAILED',
  ContentMapperExportExcelSucceed = 'CONTENT_MAPPER_EXPORT_EXCEL_SUCCEED',
  DnaGeneImportTranslationSucceed = 'DNA_GENE_IMPORT_TRANSLATION_SUCCEED',
  DnaGeneImportTranslationUploadFailed = 'DNA_GENE_IMPORT_TRANSLATION_UPLOAD_FAILED',
  DnaGeneImportTranslationUploadSucceed = 'DNA_GENE_IMPORT_TRANSLATION_UPLOAD_SUCCEED',
  DnaReportImportTranslationSucceed = 'DNA_REPORT_IMPORT_TRANSLATION_SUCCEED',
  DnaReportImportTranslationUploadFailed = 'DNA_REPORT_IMPORT_TRANSLATION_UPLOAD_FAILED',
  DnaReportImportTranslationUploadSucceed = 'DNA_REPORT_IMPORT_TRANSLATION_UPLOAD_SUCCEED',
  DnaReportMapperFailed = 'DNA_REPORT_MAPPER_FAILED',
  DnaReportMapperProcessed = 'DNA_REPORT_MAPPER_PROCESSED',
  DnaReportMapperSkipped = 'DNA_REPORT_MAPPER_SKIPPED',
  DnaReportMapperSucceed = 'DNA_REPORT_MAPPER_SUCCEED',
  DnaReportPdfFailed = 'DNA_REPORT_PDF_FAILED',
  DnaReportPdfSucceed = 'DNA_REPORT_PDF_SUCCEED',
  DnaReportResultNotification = 'DNA_REPORT_RESULT_NOTIFICATION',
  GrantUserSubscriptionByKitcodeExcelFailed = 'GRANT_USER_SUBSCRIPTION_BY_KITCODE_EXCEL_FAILED',
  GrantUserSubscriptionByKitcodeExcelSucceed = 'GRANT_USER_SUBSCRIPTION_BY_KITCODE_EXCEL_SUCCEED',
  KitExportFileFailed = 'KIT_EXPORT_FILE_FAILED',
  KitExportFileSucceed = 'KIT_EXPORT_FILE_SUCCEED',
  NutrigeneticCategoryExportExcelFailed = 'NUTRIGENETIC_CATEGORY_EXPORT_EXCEL_FAILED',
  NutrigeneticCategoryExportExcelSucceed = 'NUTRIGENETIC_CATEGORY_EXPORT_EXCEL_SUCCEED',
  NutrigeneticMapperExportExcelFailed = 'NUTRIGENETIC_MAPPER_EXPORT_EXCEL_FAILED',
  NutrigeneticMapperExportExcelSucceed = 'NUTRIGENETIC_MAPPER_EXPORT_EXCEL_SUCCEED',
  NutrigeneticPanelExportExcelFailed = 'NUTRIGENETIC_PANEL_EXPORT_EXCEL_FAILED',
  NutrigeneticPanelExportExcelSucceed = 'NUTRIGENETIC_PANEL_EXPORT_EXCEL_SUCCEED',
  NutrigeneticTraitExportExcelFailed = 'NUTRIGENETIC_TRAIT_EXPORT_EXCEL_FAILED',
  NutrigeneticTraitExportExcelSucceed = 'NUTRIGENETIC_TRAIT_EXPORT_EXCEL_SUCCEED',
  OrderCreated = 'ORDER_CREATED',
  OrderPaymentReceived = 'ORDER_PAYMENT_RECEIVED',
  OrderReminderDaily = 'ORDER_REMINDER_DAILY',
  OrderReminderWeekly = 'ORDER_REMINDER_WEEKLY',
  PgxDrugClassExcelFailed = 'PGX_DRUG_CLASS_EXCEL_FAILED',
  PgxDrugClassExcelSucceed = 'PGX_DRUG_CLASS_EXCEL_SUCCEED',
  PgxDrugExcelFailed = 'PGX_DRUG_EXCEL_FAILED',
  PgxDrugExcelSucceed = 'PGX_DRUG_EXCEL_SUCCEED',
  PgxGlossaryExcelFailed = 'PGX_GLOSSARY_EXCEL_FAILED',
  PgxGlossaryExcelSucceed = 'PGX_GLOSSARY_EXCEL_SUCCEED',
  PickupKitRequest = 'PICKUP_KIT_REQUEST',
  ProdigyImportUploadFailed = 'PRODIGY_IMPORT_UPLOAD_FAILED',
  ProdigyImportUploadSucceed = 'PRODIGY_IMPORT_UPLOAD_SUCCEED',
  SkinMapperExportExcelFailed = 'SKIN_MAPPER_EXPORT_EXCEL_FAILED',
  SkinMapperExportExcelSucceed = 'SKIN_MAPPER_EXPORT_EXCEL_SUCCEED',
  SportgenomicMapperExportExcelFailed = 'SPORTGENOMIC_MAPPER_EXPORT_EXCEL_FAILED',
  SportgenomicMapperExportExcelSucceed = 'SPORTGENOMIC_MAPPER_EXPORT_EXCEL_SUCCEED',
  ThreesixtyCategoryExportExcelFailed = 'THREESIXTY_CATEGORY_EXPORT_EXCEL_FAILED',
  ThreesixtyCategoryExportExcelSucceed = 'THREESIXTY_CATEGORY_EXPORT_EXCEL_SUCCEED',
  ThreesixtyMapperExportExcelFailed = 'THREESIXTY_MAPPER_EXPORT_EXCEL_FAILED',
  ThreesixtyMapperExportExcelSucceed = 'THREESIXTY_MAPPER_EXPORT_EXCEL_SUCCEED',
  ThreesixtyPanelExportExcelFailed = 'THREESIXTY_PANEL_EXPORT_EXCEL_FAILED',
  ThreesixtyPanelExportExcelSucceed = 'THREESIXTY_PANEL_EXPORT_EXCEL_SUCCEED',
  ThreesixtySubcategoryExportExcelFailed = 'THREESIXTY_SUBCATEGORY_EXPORT_EXCEL_FAILED',
  ThreesixtySubcategoryExportExcelSucceed = 'THREESIXTY_SUBCATEGORY_EXPORT_EXCEL_SUCCEED',
  ThreesixtyTraitExportExcelFailed = 'THREESIXTY_TRAIT_EXPORT_EXCEL_FAILED',
  ThreesixtyTraitExportExcelSucceed = 'THREESIXTY_TRAIT_EXPORT_EXCEL_SUCCEED',
  TraitDetailExportExcelFailed = 'TRAIT_DETAIL_EXPORT_EXCEL_FAILED',
  TraitDetailExportExcelSucceed = 'TRAIT_DETAIL_EXPORT_EXCEL_SUCCEED'
}

export type UserPasswordForm = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  newPasswordConfirmation?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  activeSubscription?: Maybe<UserSubscription>;
  age?: Maybe<Scalars['Float']['output']>;
  agreeWearableAt?: Maybe<Scalars['Date']['output']>;
  aiAssistantAgreedAt?: Maybe<Scalars['Date']['output']>;
  allergies?: Maybe<HealthAllergyQueryResult>;
  background?: Maybe<HealthBackground>;
  birthday?: Maybe<Scalars['String']['output']>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  clinicalData?: Maybe<Array<Maybe<ClinicalData>>>;
  counselor?: Maybe<UserCounselor>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ethnic?: Maybe<ProfileEthnicity>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  id?: Maybe<Scalars['String']['output']>;
  identityNumber?: Maybe<Scalars['String']['output']>;
  information?: Maybe<HealthInformation>;
  kit?: Maybe<PurchaseProductKit>;
  kits?: Maybe<Array<Maybe<PurchaseProductKit>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lwb?: Maybe<UserLwb>;
  master?: Maybe<UserProfile>;
  medicals?: Maybe<Array<Maybe<ProfileMedical>>>;
  medications?: Maybe<HealthMedicationQueryResult>;
  membership?: Maybe<UserMembership>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  quota?: Maybe<UserQuota>;
  report?: Maybe<UserProfileReport>;
  reportAccess?: Maybe<Array<Maybe<UserReportAccess>>>;
  reportStatus?: Maybe<UserCustomerStatus>;
  role?: Maybe<UserRole>;
  setting?: Maybe<UserSetting>;
  status?: Maybe<UserStatus>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum UserProfileCheckEmailAvailabilityQueryInclude {
  SubProfiles = 'SUB_PROFILES'
}

export type UserProfileCheckEmailAvailabilityQueryResult = {
  __typename?: 'UserProfileCheckEmailAvailabilityQueryResult';
  isProfileCreated?: Maybe<Scalars['Boolean']['output']>;
  masterProfile?: Maybe<UserProfile>;
  message?: Maybe<Scalars['String']['output']>;
  subProfileCount?: Maybe<Scalars['Int']['output']>;
  subProfileCreationQuota?: Maybe<Scalars['Int']['output']>;
  subProfileIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserProfileQueries = {
  __typename?: 'UserProfileQueries';
  checkEmailAvailability?: Maybe<UserProfileCheckEmailAvailabilityQueryResult>;
  findAll?: Maybe<UserProfileQueryResult>;
  isPersonalInfoComplete?: Maybe<Scalars['Boolean']['output']>;
  switchProfile?: Maybe<Scalars['String']['output']>;
};


export type UserProfileQueriesCheckEmailAvailabilityArgs = {
  email: Scalars['String']['input'];
};


export type UserProfileQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProfileQueryFilter>;
};


export type UserProfileQueriesSwitchProfileArgs = {
  form?: InputMaybe<SwitchUserProfileForm>;
};

export type UserProfileQueryFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  isMasterProfile?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  masterProfileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserProfileQueryResult = {
  __typename?: 'UserProfileQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserProfile>>>;
};

export type UserProfileQuerySortBy = {
  name?: InputMaybe<SortDirection>;
};

export type UserProfileReport = {
  __typename?: 'UserProfileReport';
  dna?: Maybe<DnaReport>;
  id?: Maybe<Scalars['ID']['output']>;
  isAncestryReady?: Maybe<Scalars['Boolean']['output']>;
};

export type UserProfileReportReady = {
  __typename?: 'UserProfileReportReady';
  ANCESTRY?: Maybe<Scalars['Boolean']['output']>;
  DNA_360?: Maybe<Scalars['Boolean']['output']>;
  DNA_PREMIUM?: Maybe<Scalars['Boolean']['output']>;
  HORMONE?: Maybe<Scalars['Boolean']['output']>;
  NUTRIGENETIC?: Maybe<Scalars['Boolean']['output']>;
  ONCORISK?: Maybe<Scalars['Boolean']['output']>;
  SKIN?: Maybe<Scalars['Boolean']['output']>;
  SPORTGENOMIC?: Maybe<Scalars['Boolean']['output']>;
};

export type UserQueries = {
  __typename?: 'UserQueries';
  ClinicalData?: Maybe<ClinicalDataQueries>;
  Counselor?: Maybe<UserCounselorQueries>;
  Customer?: Maybe<UserCustomerQueries>;
  Family?: Maybe<UserFamilyQueries>;
  FeatureConsent?: Maybe<UserFeatureConsentQueries>;
  FeedbackResponse?: Maybe<UserFeedbackResponseQueries>;
  Ftue?: Maybe<UserFtueQueries>;
  LWB?: Maybe<UserLwbQueries>;
  Notification?: Maybe<UserNotificationQueries>;
  NotificationWearable?: Maybe<NotificationWearableQueries>;
  Profile?: Maybe<UserProfileQueries>;
  Quota?: Maybe<UserQuotaQueries>;
  Report?: Maybe<UserReportQueries>;
  ReportAccess?: Maybe<UserReportAccessQueries>;
  SubProfile?: Maybe<UserSubProfileQueries>;
  Subscription?: Maybe<UserSubscriptionQueries>;
  findAll?: Maybe<UserQueryResult>;
  id?: Maybe<Scalars['ID']['output']>;
  latestSentTokenDate?: Maybe<Scalars['Date']['output']>;
  profile?: Maybe<UserProfile>;
  sentPassword?: Maybe<Scalars['Date']['output']>;
  shipment?: Maybe<UserShipment>;
  status?: Maybe<UserStatus>;
};


export type UserQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserQuerySortBy>;
  where?: InputMaybe<UserQueryFilter>;
};


export type UserQueriesLatestSentTokenDateArgs = {
  username: Scalars['String']['input'];
};


export type UserQueriesSentPasswordArgs = {
  username: Scalars['String']['input'];
};


export type UserQueriesStatusArgs = {
  username: Scalars['String']['input'];
};

export type UserQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<UserRole>>>;
  status?: InputMaybe<Array<InputMaybe<UserStatus>>>;
};

export type UserQueryResult = {
  __typename?: 'UserQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserProfile>>>;
};

export type UserQuerySortBy = {
  businessEmail?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type UserQuota = {
  __typename?: 'UserQuota';
  createdAt?: Maybe<Scalars['Date']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<Payment>;
  profile?: Maybe<UserProfile>;
  usage?: Maybe<Scalars['Int']['output']>;
};

export type UserQuotaForm = {
  usage?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQuotaMutations = {
  __typename?: 'UserQuotaMutations';
  edit?: Maybe<UserQuota>;
};


export type UserQuotaMutationsEditArgs = {
  form?: InputMaybe<UserQuotaForm>;
  id: Scalars['Int']['input'];
};

export type UserQuotaQueries = {
  __typename?: 'UserQuotaQueries';
  findAll?: Maybe<UserQuotaQueryResult>;
  findOne?: Maybe<UserQuota>;
};


export type UserQuotaQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserQuotaQueryResult = {
  __typename?: 'UserQuotaQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserQuota>>>;
};

export type UserReport = {
  __typename?: 'UserReport';
  category?: Maybe<DnaCategory>;
  id?: Maybe<Scalars['Int']['output']>;
  kit?: Maybe<PurchaseProductKit>;
  profile?: Maybe<UserProfile>;
  score?: Maybe<DnaScore>;
  trait?: Maybe<DnaTrait>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type UserReportAccess = {
  __typename?: 'UserReportAccess';
  createdAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastPurchaseType?: Maybe<UserReportAccessPurchaseType>;
  releasedAt?: Maybe<Scalars['Date']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  reportTypeId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserReportAccessType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserReportAccessMutations = {
  __typename?: 'UserReportAccessMutations';
  Redeem?: Maybe<UserReportAccessRedeemMutations>;
};

export enum UserReportAccessPurchaseType {
  CancelSubscription = 'CANCEL_SUBSCRIPTION',
  ExpireSubscription = 'EXPIRE_SUBSCRIPTION',
  KitActivation = 'KIT_ACTIVATION',
  ManualInject = 'MANUAL_INJECT',
  Preorder = 'PREORDER',
  RenewalSubscription = 'RENEWAL_SUBSCRIPTION',
  Stock = 'STOCK',
  Subscription = 'SUBSCRIPTION',
  UnlockKit = 'UNLOCK_KIT',
  UnlockReport = 'UNLOCK_REPORT'
}

export type UserReportAccessQueries = {
  __typename?: 'UserReportAccessQueries';
  Redeem?: Maybe<UserReportAccessRedeemQueries>;
};

export type UserReportAccessRedeem = {
  __typename?: 'UserReportAccessRedeem';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  redeemedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type UserReportAccessRedeemDetail = {
  __typename?: 'UserReportAccessRedeemDetail';
  eligibleReportAccess?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  subscription?: Maybe<AppSubscription>;
  userSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type UserReportAccessRedeemEligibility = {
  __typename?: 'UserReportAccessRedeemEligibility';
  eligible: Scalars['Boolean']['output'];
  redeems?: Maybe<Array<Maybe<UserReportAccessRedeemDetail>>>;
};

export type UserReportAccessRedeemMutations = {
  __typename?: 'UserReportAccessRedeemMutations';
  redeem?: Maybe<UserReportAccess>;
};


export type UserReportAccessRedeemMutationsRedeemArgs = {
  form: RedeemReportAccessForm;
};

export type UserReportAccessRedeemQueries = {
  __typename?: 'UserReportAccessRedeemQueries';
  findUserEligibility?: Maybe<UserReportAccessRedeemEligibility>;
};

export enum UserReportAccessType {
  Permanent = 'PERMANENT',
  Temporary = 'TEMPORARY'
}

export type UserReportByCategory = {
  __typename?: 'UserReportByCategory';
  average?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<UserReport>>>;
  response?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type UserReportByCategoryFilter = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserReportByCategoryQueryResult = {
  __typename?: 'UserReportByCategoryQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserReportByCategory>>>;
};

export type UserReportByCategorySortBy = {
  average?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type UserReportFilter = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  traits?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UserReportQueries = {
  __typename?: 'UserReportQueries';
  findAll?: Maybe<UserReportQueryResult>;
  findByCategory?: Maybe<UserReportByCategoryQueryResult>;
  findOne?: Maybe<UserReport>;
};


export type UserReportQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserReportSortBy>;
  where?: InputMaybe<UserReportFilter>;
};


export type UserReportQueriesFindByCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserReportByCategorySortBy>;
  where?: InputMaybe<UserReportByCategoryFilter>;
};


export type UserReportQueriesFindOneArgs = {
  id: Scalars['Int']['input'];
};

export type UserReportQueryResult = {
  __typename?: 'UserReportQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserReport>>>;
};

export type UserReportSortBy = {
  category?: InputMaybe<DnaCategorySortBy>;
  score?: InputMaybe<SortDirection>;
  trait?: InputMaybe<DnaTraitSortBy>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Counselor = 'COUNSELOR',
  Lab = 'LAB',
  Patient = 'PATIENT'
}

export type UserSetting = {
  __typename?: 'UserSetting';
  id?: Maybe<Scalars['String']['output']>;
  playOpeningSound?: Maybe<Scalars['Boolean']['output']>;
  playOpeningSoundAt?: Maybe<Scalars['Date']['output']>;
};

export type UserSettingForm = {
  playOpeningSound?: InputMaybe<Scalars['Boolean']['input']>;
  playOpeningSoundAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UserSettingMutations = {
  __typename?: 'UserSettingMutations';
  edit?: Maybe<UserSetting>;
};


export type UserSettingMutationsEditArgs = {
  form?: InputMaybe<UserSettingForm>;
};

export type UserShipment = {
  __typename?: 'UserShipment';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type UserShipmentForm = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  NotActive = 'NOT_ACTIVE',
  Pending = 'PENDING'
}

export type UserSubProfileAddForm = {
  birthday: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender: UserGender;
  height?: InputMaybe<Scalars['Float']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  masterProfileId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UserSubProfileMutations = {
  __typename?: 'UserSubProfileMutations';
  add?: Maybe<UserProfile>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  recover?: Maybe<Scalars['Boolean']['output']>;
};


export type UserSubProfileMutationsAddArgs = {
  form?: InputMaybe<UserSubProfileAddForm>;
};


export type UserSubProfileMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type UserSubProfileMutationsRecoverArgs = {
  id: Scalars['String']['input'];
};

export type UserSubProfileQueries = {
  __typename?: 'UserSubProfileQueries';
  findAll?: Maybe<UserSubProfileQueryResult>;
  findOne?: Maybe<UserProfile>;
};


export type UserSubProfileQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  masterProfileId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserProfileQuerySortBy>;
  where?: InputMaybe<UserSubProfileQueryFilter>;
};


export type UserSubProfileQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type UserSubProfileQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type UserSubProfileQueryResult = {
  __typename?: 'UserSubProfileQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserProfile>>>;
};

export type UserSubscribeForm = {
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  exchangeRate?: InputMaybe<Scalars['String']['input']>;
  installment?: InputMaybe<PurchaseOrderInstallmentForm>;
  isInternationalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PurchaseOrderPaymentForm>;
  paymentCode?: InputMaybe<PaymentType>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type UserSubscribeProductUpsellForm = {
  orderQuantity: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
};

export type UserSubscribeV2Form = {
  actionType: SubscriptionActionType;
  additionalId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  exchangeRate?: InputMaybe<Scalars['String']['input']>;
  installment?: InputMaybe<PurchaseOrderInstallmentForm>;
  isInternationalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PurchaseOrderPaymentForm>;
  paymentCode?: InputMaybe<PaymentType>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  productUpsell?: InputMaybe<Array<InputMaybe<UserSubscribeProductUpsellForm>>>;
  shipment?: InputMaybe<PurchaseOrderShipmentForm>;
  shipping?: InputMaybe<PurchaseOrderFormShipping>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  actionType?: Maybe<SubscriptionActionType>;
  additionalId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SubscriptionType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserSubscriptionChannel = {
  __typename?: 'UserSubscriptionChannel';
  baseDailyChatQuota?: Maybe<Scalars['Int']['output']>;
  chatQuota?: Maybe<Scalars['Int']['output']>;
  chatQuotaLeft?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyChatEligbileFromAt?: Maybe<Scalars['Date']['output']>;
  dailyChatEligbileUntilAt?: Maybe<Scalars['Date']['output']>;
  dailyChatQuota?: Maybe<Scalars['Int']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  firstMessageAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentType>;
  paymentStatus?: Maybe<PaymentStatus>;
  profileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SubscriptionType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type UserSubscriptionChannelQueries = {
  __typename?: 'UserSubscriptionChannelQueries';
  findAll?: Maybe<UserSubscriptionChannelQueryResult>;
};


export type UserSubscriptionChannelQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSubscriptionChannelQuerySortBy>;
  where?: InputMaybe<UserSubscriptionChannelQueryFilter>;
};

export type UserSubscriptionChannelQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<SubscriptionStatus>>>;
  subscriptionId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<SubscriptionType>>>;
  userSubscriptionId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserSubscriptionChannelQueryResult = {
  __typename?: 'UserSubscriptionChannelQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserSubscriptionChannel>>>;
};

export type UserSubscriptionChannelQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  expiredAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type UserSubscriptionMutations = {
  __typename?: 'UserSubscriptionMutations';
  UserSubscriptionPayment?: Maybe<UserSubscriptionPaymentMutations>;
  cancel?: Maybe<UserSubscription>;
  grantSubscriptionByKitCode?: Maybe<BioinformaticMapperImportNutriGeneticResult>;
  subscribe?: Maybe<UserSubscription>;
  subscribeV2?: Maybe<UserSubscription>;
};


export type UserSubscriptionMutationsCancelArgs = {
  id: Scalars['String']['input'];
};


export type UserSubscriptionMutationsGrantSubscriptionByKitCodeArgs = {
  channelSubscriptionId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type UserSubscriptionMutationsSubscribeArgs = {
  form: UserSubscribeForm;
};


export type UserSubscriptionMutationsSubscribeV2Args = {
  form: UserSubscribeV2Form;
};

export type UserSubscriptionPayment = {
  __typename?: 'UserSubscriptionPayment';
  actions?: Maybe<Array<Maybe<UserSubscriptionPaymentAction>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentTokenId?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  sessionTokenId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserSubscriptionPaymentStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserSubscriptionPaymentAction = {
  __typename?: 'UserSubscriptionPaymentAction';
  descriptor?: Maybe<UserSubscriptionPaymentActionDescriptor>;
  type?: Maybe<UserSubscriptionPaymentActionType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum UserSubscriptionPaymentActionDescriptor {
  CapturePayment = 'CAPTURE_PAYMENT',
  DeeplinkUrl = 'DEEPLINK_URL',
  PaymentCode = 'PAYMENT_CODE',
  QrString = 'QR_STRING',
  ResendOtp = 'RESEND_OTP',
  ValidateOtp = 'VALIDATE_OTP',
  VirtualAccountNumber = 'VIRTUAL_ACCOUNT_NUMBER',
  WebUrl = 'WEB_URL'
}

export enum UserSubscriptionPaymentActionType {
  ApiPostRequest = 'API_POST_REQUEST',
  PresentToCustomer = 'PRESENT_TO_CUSTOMER',
  RedirectCustomer = 'REDIRECT_CUSTOMER'
}

export type UserSubscriptionPaymentForm = {
  cardNumber: Scalars['String']['input'];
  cardholderEmail: Scalars['String']['input'];
  cardholderName: Scalars['String']['input'];
  cardholderPhoneNumber: Scalars['String']['input'];
  expiryMonth: Scalars['String']['input'];
  expiryYear: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UserSubscriptionPaymentMutations = {
  __typename?: 'UserSubscriptionPaymentMutations';
  create?: Maybe<UserSubscriptionPayment>;
  update?: Maybe<UserSubscriptionPayment>;
};


export type UserSubscriptionPaymentMutationsUpdateArgs = {
  form?: InputMaybe<UserSubscriptionPaymentForm>;
};

export type UserSubscriptionPaymentQueries = {
  __typename?: 'UserSubscriptionPaymentQueries';
  findAll?: Maybe<UserSubscriptionPaymentQueryResult>;
};


export type UserSubscriptionPaymentQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSubscriptionPaymentQuerySortBy>;
  where?: InputMaybe<UserSubscriptionPaymentQueryFilter>;
};

export type UserSubscriptionPaymentQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<UserSubscriptionPaymentStatus>>>;
};

export type UserSubscriptionPaymentQueryResult = {
  __typename?: 'UserSubscriptionPaymentQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserSubscriptionPayment>>>;
};

export type UserSubscriptionPaymentQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
};

export enum UserSubscriptionPaymentStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RequiresAction = 'REQUIRES_ACTION'
}

export type UserSubscriptionQueries = {
  __typename?: 'UserSubscriptionQueries';
  UserSubscriptionChannel?: Maybe<UserSubscriptionChannelQueries>;
  UserSubscriptionPayment?: Maybe<UserSubscriptionPaymentQueries>;
  findAll?: Maybe<UserSubscriptionQueryResult>;
};


export type UserSubscriptionQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSubscriptionQuerySortBy>;
  where?: InputMaybe<UserSubscriptionQueryFilter>;
};

export type UserSubscriptionQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<SubscriptionStatus>>>;
  subscriptionId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<SubscriptionType>>>;
};

export type UserSubscriptionQueryResult = {
  __typename?: 'UserSubscriptionQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserSubscription>>>;
};

export type UserSubscriptionQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type VendorBioIt = {
  __typename?: 'VendorBioIt';
  boundVendorBioIts?: Maybe<Array<Maybe<VendorBioIt>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VendorBioItType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vendorBioItIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VendorBioItFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<VendorBioItType>>>;
};

export type VendorBioItForm = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VendorBioItType>;
  vendorBioItIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VendorBioItMutations = {
  __typename?: 'VendorBioItMutations';
  create?: Maybe<VendorBioIt>;
  update?: Maybe<VendorBioIt>;
};


export type VendorBioItMutationsCreateArgs = {
  form: VendorBioItForm;
};


export type VendorBioItMutationsUpdateArgs = {
  form: VendorBioItForm;
  id: Scalars['String']['input'];
};

export type VendorBioItQueries = {
  __typename?: 'VendorBioItQueries';
  findAll?: Maybe<VendorBioItQueryResult>;
};


export type VendorBioItQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VendorBioItSortInput>;
  where?: InputMaybe<VendorBioItFilterInput>;
};

export type VendorBioItQueryResult = {
  __typename?: 'VendorBioItQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<VendorBioIt>>>;
};

export type VendorBioItSortInput = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum VendorBioItType {
  Multiple = 'MULTIPLE',
  Single = 'SINGLE'
}

export type VirtualAssistanceGreeting = {
  __typename?: 'VirtualAssistanceGreeting';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type VirtualAssistanceGreetingQueries = {
  __typename?: 'VirtualAssistanceGreetingQueries';
  findAll?: Maybe<VirtualAssistanceGreetingQueryResult>;
};


export type VirtualAssistanceGreetingQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VirtualAssistanceGreetingQuerySortBy>;
  where?: InputMaybe<VirtualAssistanceGreetingQueryFilter>;
};

export type VirtualAssistanceGreetingQueryFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDeleted?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type VirtualAssistanceGreetingQueryResult = {
  __typename?: 'VirtualAssistanceGreetingQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<VirtualAssistanceGreeting>>>;
};

export type VirtualAssistanceGreetingQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
};

export type Voucher = {
  __typename?: 'Voucher';
  amount?: Maybe<Scalars['Float']['output']>;
  amountType?: Maybe<VoucherAmountType>;
  bookPayments?: Maybe<UserCounselorBookPaymentQueryResult>;
  category?: Maybe<VoucherCategory>;
  code?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<VoucherCondition>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  kitcode?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkToKitcode?: Maybe<Scalars['Boolean']['output']>;
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<UserProfile>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantType?: Maybe<VoucherMerchantType>;
  name?: Maybe<Scalars['String']['output']>;
  onetimeUse?: Maybe<Scalars['Boolean']['output']>;
  orderPayments?: Maybe<PurchasePaymentQueryResult>;
  partnership?: Maybe<Partnership>;
  status?: Maybe<VoucherStatus>;
  subscription?: Maybe<VoucherSubscription>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum VoucherAmountType {
  Percentage = 'PERCENTAGE',
  Price = 'PRICE'
}

export enum VoucherCategory {
  Consultation = 'CONSULTATION',
  HomeService = 'HOME_SERVICE',
  Shop = 'SHOP',
  ShopUnlock = 'SHOP_UNLOCK',
  Subscription = 'SUBSCRIPTION',
  WalkIn = 'WALK_IN'
}

export type VoucherCondition = {
  __typename?: 'VoucherCondition';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<VoucherConditionPayload>;
  type?: Maybe<VoucherConditionType>;
};

export type VoucherConditionCounselorPayload = {
  __typename?: 'VoucherConditionCounselorPayload';
  counselor?: Maybe<UserCounselor>;
  id?: Maybe<Scalars['String']['output']>;
};

export type VoucherConditionCounselorPayloadForm = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type VoucherConditionForm = {
  description?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<VoucherConditionPayloadForm>;
  type?: InputMaybe<VoucherConditionType>;
};

export type VoucherConditionMutations = {
  __typename?: 'VoucherConditionMutations';
  edit?: Maybe<VoucherCondition>;
};


export type VoucherConditionMutationsEditArgs = {
  form?: InputMaybe<VoucherConditionForm>;
  id: Scalars['String']['input'];
};

export type VoucherConditionPayload = {
  __typename?: 'VoucherConditionPayload';
  counselors?: Maybe<Array<Maybe<VoucherConditionCounselorPayload>>>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<VoucherConditionProductPayload>>>;
  startedAt?: Maybe<Scalars['String']['output']>;
};

export type VoucherConditionPayloadForm = {
  counselors?: InputMaybe<Array<InputMaybe<VoucherConditionCounselorPayloadForm>>>;
  finishedAt?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<VoucherConditionProductPayloadForm>>>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherConditionProductPayload = {
  __typename?: 'VoucherConditionProductPayload';
  id?: Maybe<Scalars['String']['output']>;
  isUpsell?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<PurchaseProduct>;
};

export type VoucherConditionProductPayloadForm = {
  id?: InputMaybe<Scalars['String']['input']>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VoucherConditionType {
  Consultation = 'CONSULTATION',
  HomeService = 'HOME_SERVICE',
  ProductBuyer = 'PRODUCT_BUYER',
  Shop = 'SHOP',
  ShopUnlock = 'SHOP_UNLOCK',
  Subscription = 'SUBSCRIPTION',
  Users = 'USERS',
  WalkIn = 'WALK_IN'
}

export type VoucherForm = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountType?: InputMaybe<VoucherAmountType>;
  category?: InputMaybe<VoucherCategory>;
  code?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<VoucherConditionForm>;
  expiredAt?: InputMaybe<Scalars['Date']['input']>;
  kitcode?: InputMaybe<Scalars['String']['input']>;
  linkToKitcode?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantType?: InputMaybe<VoucherMerchantType>;
  name?: InputMaybe<Scalars['String']['input']>;
  onetimeUse?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<VoucherSubscriptionForm>;
  type?: InputMaybe<VoucherType>;
};

export enum VoucherMerchantType {
  Asaren = 'ASAREN',
  Sponsorship = 'SPONSORSHIP'
}

export type VoucherMutations = {
  __typename?: 'VoucherMutations';
  Condition?: Maybe<VoucherConditionMutations>;
  Subscription?: Maybe<VoucherSubscriptionMutations>;
  add?: Maybe<Voucher>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit?: Maybe<Voucher>;
  export?: Maybe<Scalars['String']['output']>;
};


export type VoucherMutationsAddArgs = {
  form?: InputMaybe<VoucherForm>;
};


export type VoucherMutationsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type VoucherMutationsEditArgs = {
  form?: InputMaybe<VoucherForm>;
  id: Scalars['String']['input'];
};


export type VoucherMutationsExportArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VoucherQuerySortBy>;
  where?: InputMaybe<VoucherQueryFilter>;
};

export type VoucherQueries = {
  __typename?: 'VoucherQueries';
  findAll?: Maybe<VoucherQueryResult>;
  findAllTypes?: Maybe<VoucherTypeQueryResult>;
  findByCode?: Maybe<Voucher>;
  findOne?: Maybe<Voucher>;
  id?: Maybe<Scalars['String']['output']>;
};


export type VoucherQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VoucherQuerySortBy>;
  where?: InputMaybe<VoucherQueryFilter>;
};


export type VoucherQueriesFindAllTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VoucherTypeQueryFilter>;
};


export type VoucherQueriesFindByCodeArgs = {
  category?: InputMaybe<VoucherCategory>;
  code: Scalars['String']['input'];
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type VoucherQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type VoucherQueryFilter = {
  categories?: InputMaybe<Array<InputMaybe<VoucherCategory>>>;
  expiredAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  merchantType?: InputMaybe<VoucherMerchantType>;
  partnershipId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<VoucherStatus>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VoucherQueryResult = {
  __typename?: 'VoucherQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Voucher>>>;
};

export type VoucherQuerySortBy = {
  amount?: InputMaybe<SortDirection>;
  category?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  expiredAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum VoucherStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type VoucherSubscription = {
  __typename?: 'VoucherSubscription';
  id?: Maybe<Scalars['String']['output']>;
  trialDuration?: Maybe<Scalars['Int']['output']>;
  voucherId?: Maybe<Scalars['String']['output']>;
};

export type VoucherSubscriptionForm = {
  trialDuration?: InputMaybe<Scalars['Int']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherSubscriptionMutations = {
  __typename?: 'VoucherSubscriptionMutations';
  add?: Maybe<VoucherSubscription>;
  edit?: Maybe<VoucherSubscription>;
};


export type VoucherSubscriptionMutationsAddArgs = {
  form?: InputMaybe<VoucherSubscriptionForm>;
};


export type VoucherSubscriptionMutationsEditArgs = {
  form?: InputMaybe<VoucherSubscriptionForm>;
  id: Scalars['String']['input'];
};

export type VoucherSubscriptionQueries = {
  __typename?: 'VoucherSubscriptionQueries';
  findAll?: Maybe<VoucherSubscriptionQueryResult>;
  findOne?: Maybe<VoucherSubscription>;
  id?: Maybe<Scalars['String']['output']>;
};


export type VoucherSubscriptionQueriesFindAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VoucherSubscriptionQuerySortBy>;
  where?: InputMaybe<VoucherSubscriptionQueryFilter>;
};


export type VoucherSubscriptionQueriesFindOneArgs = {
  id: Scalars['String']['input'];
};

export type VoucherSubscriptionQueryFilter = {
  trialDuration?: InputMaybe<Scalars['Int']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherSubscriptionQueryResult = {
  __typename?: 'VoucherSubscriptionQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<VoucherSubscriptionResult>>>;
};

export type VoucherSubscriptionQuerySortBy = {
  createdAt?: InputMaybe<SortDirection>;
  trialDuration?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  voucherId?: InputMaybe<SortDirection>;
};

export type VoucherSubscriptionResult = {
  __typename?: 'VoucherSubscriptionResult';
  id?: Maybe<Scalars['String']['output']>;
  trialDuration?: Maybe<Scalars['Int']['output']>;
  voucherId?: Maybe<Scalars['String']['output']>;
};

export enum VoucherType {
  Discount = 'DISCOUNT',
  Free = 'FREE',
  Partnership = 'PARTNERSHIP'
}

export type VoucherTypeQueryFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherTypeQueryResult = {
  __typename?: 'VoucherTypeQueryResult';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<VoucherTypeResult>>>;
};

export type VoucherTypeResult = {
  __typename?: 'VoucherTypeResult';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type _10xQuestionnaire = {
  __typename?: '_10xQuestionnaire';
  answers?: Maybe<Array<Maybe<_10xQuestionnaireAnswer>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type _10xQuestionnaireAnswer = {
  __typename?: '_10xQuestionnaireAnswer';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type _10xQuestionnaireAnswerForm = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type _10xQuestionnaireForm = {
  answers?: InputMaybe<Array<InputMaybe<_10xQuestionnaireAnswerForm>>>;
};

export type _10xQuestionnaireMutations = {
  __typename?: '_10xQuestionnaireMutations';
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type _10xQuestionnaireMutationsUpdateArgs = {
  form?: InputMaybe<_10xQuestionnaireForm>;
};

export type _10xQuestionnaireQueries = {
  __typename?: '_10xQuestionnaireQueries';
  find?: Maybe<_10xQuestionnaire>;
};
